var HW_VER = {"herald-rank-anim-bronze-0.webp":"95c17f59","herald-rank-anim-bronze-1.webp":"213d5a62","herald-rank-anim-bronze-2.webp":"cc2079bd","herald-rank-anim-bronze-3.webp":"5ed0ba9e","herald-rank-anim-bronze-4.webp":"918ef757","herald-rank-anim-bronze-5.webp":"5d15a61b","herald-rank-anim-bronze-6.webp":"6dfbefeb","herald-rank-anim-bronze-7.webp":"2e3807f4","herald-rank-anim-bronze-8.webp":"4757b1cb","herald-rank-anim-diamond-base.webp":"89704ede","herald-rank-anim-diamond-crown.webp":"729489c8","herald-rank-anim-diamond-frame.webp":"cbc27af3","herald-rank-anim-diamond-top.webp":"eab3ab93","herald-rank-anim-gold-base.webp":"11a4e6ea","herald-rank-anim-gold-crown.webp":"dd96daac","herald-rank-anim-gold-frame.webp":"170d3dd1","herald-rank-anim-gold-top.webp":"e79e5e33","herald-rank-anim-platinum-base.webp":"7774f3b9","herald-rank-anim-platinum-crown.webp":"30060c4d","herald-rank-anim-platinum-frame.webp":"a08370f7","herald-rank-anim-platinum-top.webp":"4c8dd0bf","herald-rank-anim-silver-base.webp":"a2dc5658","herald-rank-anim-silver-crown.webp":"726a231e","herald-rank-anim-silver-frame.webp":"cbc50544","herald-rank-anim-silver-top.webp":"055c7661","herald-rank-anim-unranked-0.webp":"707263f0","herald-rank-anim-unranked-1.webp":"8df38dc0","herald-rank-anim-unranked-2.webp":"3924b7ad","herald-rank-anim-unranked-3.webp":"84d33e64","herald-rank-anim-unranked-4.webp":"4ea4422d","herald-rank-anim-unranked-5.webp":"5888ce53","herald-rank-anim-unranked-6.webp":"a1af6854","herald-rank-badge-bronze.webp":"a02171a4","herald-rank-badge-diamond.webp":"cbdd6a52","herald-rank-badge-gold.webp":"2635aed9","herald-rank-badge-platinum.webp":"195177f5","herald-rank-badge-silver.webp":"fd620b88","herald-rank-badge-unranked.webp":"8bbe0703","herald-rank-border-bronze.webp":"7fffee37","herald-rank-border-diamond.webp":"8fa26832","herald-rank-border-gold.webp":"27e4aff2","herald-rank-border-platinum.webp":"fedb450c","herald-rank-border-silver.webp":"61e2b69f","herald-rank-border-unranked.webp":"c90cd63a","herald-card-ambush.webp":"89943d95","herald-card-arcane-sever.webp":"4c298356","herald-card-beast-slayer.webp":"143d2fff","herald-card-bramble.webp":"84d9482b","herald-card-couriers-dash.webp":"a2120278","herald-card-death-knight.webp":"24e93f5f","herald-card-deep-faerie.webp":"637dbbc8","herald-card-dogfolk-ranger.webp":"d6cfab8b","herald-card-dragon-keeper.webp":"4d27a6fa","herald-card-dragon-knight.webp":"9b91f5c9","herald-card-dragon-shield.webp":"adcaf82b","herald-card-dragon-spear.webp":"ee664a16","herald-card-elder-pegasus.webp":"8954add7","herald-card-fae-rose.webp":"a62cf012","herald-card-faerie-rogue.webp":"5db19fef","herald-card-ferretfolk-scout.webp":"c08587ee","herald-card-final-addendum.webp":"7850ab1e","herald-card-fire-knight.webp":"87c14a79","herald-card-fire-wyrm.webp":"797268d3","herald-card-glyphstorm.webp":"4ec580c1","herald-card-goblin-skirmisher.webp":"445a9b57","herald-card-great-axe.webp":"ca76fd87","herald-card-great-cat.webp":"40617df0","herald-card-grodyr-rider.webp":"8e2cc1f7","herald-card-guardian-spirit.webp":"881d67d8","herald-card-hedgehog-forager.webp":"0784b698","herald-card-hiro.webp":"ab00efde","herald-card-hollow-knight.webp":"623df12b","herald-card-iris-theo.webp":"75f2d4d6","herald-card-longsword.webp":"90cdd9ef","herald-card-mindbreak.webp":"df0f9333","herald-card-mirror-dragon.webp":"ac90c267","herald-card-moon-dragon.webp":"88a150ac","herald-card-moth-dragon.webp":"d6280118","herald-card-mountain-golem.webp":"7683d134","herald-card-nightmare-blade.webp":"60ffd988","herald-card-norag.webp":"b9884ea4","herald-card-paragons-mail.webp":"1dcce8e3","herald-card-path-cerevoker.webp":"70687c49","herald-card-path-mythweaver.webp":"541eb6aa","herald-card-path-oathbinder.webp":"75bf8d32","herald-card-path-oathless.webp":"4eefec72","herald-card-reavers-mail.webp":"a3658a20","herald-card-rune-golem.webp":"54a19841","herald-card-runeward-script.webp":"ec18dea1","herald-card-scrying-mirror.webp":"b7cb8115","herald-card-shadow-dragon.webp":"b95849e0","herald-card-shard-dragon.webp":"3395f0ba","herald-card-shard-wolf.webp":"09a89666","herald-card-star-dragon.webp":"e3e7e895","herald-card-star-glass-rings.webp":"242680ce","herald-card-stolen-moment.webp":"8f7a800b","herald-card-storm-wyrm.webp":"9ef0cc83","herald-card-study-the-stars.webp":"97a0ef5e","herald-card-sun-dragon.webp":"bf8f0529","herald-card-therabir.webp":"9ffdbda7","herald-card-travelling-cloak.webp":"8d90062d","herald-card-turn-back.webp":"fbbfb5c9","herald-card-vanguard.webp":"d3559caf","herald-card-wandering-ghost.webp":"2fc8d4e0","herald-card-whiskersworth.webp":"6b13d4c7","herald-card-winged-boots.webp":"8fab7810","herald-card-lg-ambush.webp":"f29bc249","herald-card-lg-arcane-sever.webp":"835f18d0","herald-card-lg-beast-slayer.webp":"6f71526c","herald-card-lg-bramble.webp":"529a8380","herald-card-lg-couriers-dash.webp":"bd3be985","herald-card-lg-death-knight.webp":"d714709e","herald-card-lg-deep-faerie.webp":"fa1191e5","herald-card-lg-dogfolk-ranger.webp":"b7c23a60","herald-card-lg-dragon-keeper.webp":"15e3de53","herald-card-lg-dragon-knight.webp":"2b39094f","herald-card-lg-dragon-shield.webp":"34aec799","herald-card-lg-dragon-spear.webp":"ca42c54f","herald-card-lg-elder-pegasus.webp":"0af252d2","herald-card-lg-fae-rose.webp":"a85c39fe","herald-card-lg-faerie-rogue.webp":"93d8e93c","herald-card-lg-ferretfolk-scout.webp":"884c2537","herald-card-lg-final-addendum.webp":"32ac3752","herald-card-lg-fire-knight.webp":"eaa1d3c8","herald-card-lg-fire-wyrm.webp":"0fbe5121","herald-card-lg-glyphstorm.webp":"bcff67db","herald-card-lg-goblin-skirmisher.webp":"c0c821ea","herald-card-lg-great-axe.webp":"d172d992","herald-card-lg-great-cat.webp":"9a7d9789","herald-card-lg-grodyr-rider.webp":"f9ccf25f","herald-card-lg-guardian-spirit.webp":"546e6940","herald-card-lg-hedgehog-forager.webp":"67fa32c8","herald-card-lg-hiro.webp":"8a7c8d7b","herald-card-lg-hollow-knight.webp":"83062501","herald-card-lg-iris-theo.webp":"2b84d5c1","herald-card-lg-longsword.webp":"498bdb86","herald-card-lg-mindbreak.webp":"a52b7b0e","herald-card-lg-mirror-dragon.webp":"7127cca3","herald-card-lg-moon-dragon.webp":"527d63ef","herald-card-lg-moth-dragon.webp":"fcb6eb07","herald-card-lg-mountain-golem.webp":"bcb5e0b4","herald-card-lg-nightmare-blade.webp":"742af961","herald-card-lg-norag.webp":"fb37a29c","herald-card-lg-paragons-mail.webp":"d81f22f0","herald-card-lg-path-cerevoker.webp":"ee4c9211","herald-card-lg-path-mythweaver.webp":"2fe560d5","herald-card-lg-path-oathbinder.webp":"92045e7f","herald-card-lg-path-oathless.webp":"482cd638","herald-card-lg-reavers-mail.webp":"77a6a8a0","herald-card-lg-rune-golem.webp":"54cbc6f8","herald-card-lg-runeward-script.webp":"7acea279","herald-card-lg-scrying-mirror.webp":"6a2cc424","herald-card-lg-shadow-dragon.webp":"4d9fa1d7","herald-card-lg-shard-dragon.webp":"4af5c275","herald-card-lg-shard-wolf.webp":"6c392582","herald-card-lg-star-dragon.webp":"39efa1e6","herald-card-lg-star-glass-rings.webp":"bfaced33","herald-card-lg-stolen-moment.webp":"6fd1c5fe","herald-card-lg-storm-wyrm.webp":"5aae1dd8","herald-card-lg-study-the-stars.webp":"12ef88a8","herald-card-lg-sun-dragon.webp":"b17cfc1a","herald-card-lg-therabir.webp":"b2af4fe4","herald-card-lg-travelling-cloak.webp":"3b890fc0","herald-card-lg-turn-back.webp":"ef713823","herald-card-lg-vanguard.webp":"f5a030fa","herald-card-lg-wandering-ghost.webp":"771d6b22","herald-card-lg-whiskersworth.webp":"6498333e","herald-card-lg-winged-boots.webp":"d218411f","herald-atlas-birth-of-akeroth.webp":"40841c16","herald-atlas-crowned-sky.webp":"06bf0c05","herald-atlas-dragonfall.webp":"ed21cbdf","herald-atlas-draviks-war.webp":"11ae6c36","herald-atlas-ekadells-gate.webp":"1400ac5a","herald-atlas-first-war.webp":"2d00ca66","herald-atlas-great-forest.webp":"d6827188","herald-atlas-midnight-court.webp":"f90c16fd","herald-atlas-mirenscar.webp":"22eb34ad","herald-atlas-morifex.webp":"b587a56c","herald-atlas-new-erwick.webp":"ceec9f60","herald-atlas-rabbit-hole.webp":"72e3e2ea","herald-atlas-shrinking-stone.webp":"133b552e","herald-atlas-sword-promised.webp":"2604012e","herald-atlas-the-sanctum.webp":"8286cc76","herald-atlas-the-shattering.webp":"27de7198","herald-atlas-the-tragedy.webp":"9ecbf09d","herald-atlas-unthroned-court.webp":"7c8c0629","herald-atlas-witheters.webp":"9f652a6e","herald-atlas-world-tree.webp":"d794497a","herald-atlas-lg-birth-of-akeroth.webp":"8872075e","herald-atlas-lg-crowned-sky.webp":"2885dbb7","herald-atlas-lg-dragonfall.webp":"76f4911d","herald-atlas-lg-draviks-war.webp":"e0d294a8","herald-atlas-lg-ekadells-gate.webp":"3c0f4565","herald-atlas-lg-first-war.webp":"095087dc","herald-atlas-lg-great-forest.webp":"8533c90e","herald-atlas-lg-midnight-court.webp":"d79a9e8c","herald-atlas-lg-mirenscar.webp":"6afc744b","herald-atlas-lg-morifex.webp":"dbf1082c","herald-atlas-lg-new-erwick.webp":"7ad8ff38","herald-atlas-lg-rabbit-hole.webp":"ab848d1f","herald-atlas-lg-shrinking-stone.webp":"07492293","herald-atlas-lg-sword-promised.webp":"43dbe897","herald-atlas-lg-the-sanctum.webp":"3fdb099c","herald-atlas-lg-the-shattering.webp":"6889d413","herald-atlas-lg-the-tragedy.webp":"f5670486","herald-atlas-lg-unthroned-court.webp":"ecde26a7","herald-atlas-lg-witheters.webp":"68418c6b","herald-atlas-lg-world-tree.webp":"9d68a683","herald-scene-dragonfall.webp":"dc76f2b3","herald-scene-draviks-war.webp":"0645d5f7","herald-scene-ekadells-gate.webp":"a2049014","herald-scene-first-war.webp":"d306c708","herald-scene-great-forest.webp":"92d02f16","herald-scene-midnight-court.webp":"f48b40c2","herald-scene-mirenscar.webp":"3c0afd2f","herald-scene-morifex.webp":"4cfc696a","herald-scene-new-erwick.webp":"836109dd","herald-scene-rabbit-hole.webp":"bc6a19b3","herald-scene-shrinking-stone.webp":"8f0419b4","herald-scene-sword-promised.webp":"35059241","herald-scene-the-sanctum.webp":"c2ba3516","herald-scene-the-shattering.webp":"65465b74","herald-scene-the-tragedy.webp":"5ec73704","herald-scene-unthroned-court.webp":"15389d1b","herald-scene-witheters.webp":"e00948cd","herald-scene-world-tree.webp":"f6837f3c","herald-hero-bramble.webp":"57fc835f","herald-hero-hiro.webp":"f13f48c5","herald-hero-iris-theo.webp":"cd444256","herald-hero-norag.webp":"1edd0468","herald-hero-therabir.webp":"c4e3a4ac","herald-art-arcane-sever.webp":"c85b48ae","herald-art-beast-slayer.webp":"aa9880f6","herald-art-bramble.webp":"46797a56","herald-art-couriers-dash.webp":"074786e3","herald-art-death-knight.webp":"9b462e25","herald-art-deep-faerie.webp":"23987655","herald-art-dogfolk-ranger.webp":"54dffb45","herald-art-dragon-keeper.webp":"60e5d935","herald-art-dragon-knight.webp":"3318c3e0","herald-art-dragonfall.webp":"d43e5aee","herald-art-draviks-war.webp":"655245ec","herald-art-ekadells-gate.webp":"6f14a07c","herald-art-elder-pegasus.webp":"096c3810","herald-art-faerie-rogue.webp":"0c410508","herald-art-ferretfolk-scout.webp":"682d9eef","herald-art-final-addendum.webp":"fa38a9da","herald-art-fire-knight.webp":"42d23085","herald-art-fire-wyrm.webp":"860f206f","herald-art-first-war.webp":"f413ac51","herald-art-glyphstorm.webp":"8477ecb1","herald-art-goblin-skirmisher.webp":"812f5dc9","herald-art-great-cat.webp":"34993894","herald-art-great-forest.webp":"e91efa8c","herald-art-grodyr-rider.webp":"c9b88c5d","herald-art-guardian-spirit.webp":"d5383499","herald-art-hiro.webp":"dbe2f88a","herald-art-iris-theo.webp":"bb43a5bd","herald-art-midnight-court.webp":"6d1f6984","herald-art-mindbreak.webp":"3b2be565","herald-art-mirenscar.webp":"669a0d66","herald-art-mirror-dragon.webp":"13c99d2b","herald-art-moon-dragon.webp":"6555f8fb","herald-art-morifex.webp":"5af4bb4b","herald-art-moth-dragon.webp":"7f34887f","herald-art-new-erwick.webp":"340905a4","herald-art-norag.webp":"cfc39450","herald-art-path-cerevoker.webp":"f08cac05","herald-art-path-mythweaver.webp":"efa21f4c","herald-art-path-oathbinder.webp":"02e91388","herald-art-path-oathless.webp":"8a7c9db9","herald-art-rabbit-hole.webp":"7afb7800","herald-art-rune-golem.webp":"32d4ea3c","herald-art-runeward-script.webp":"e0580368","herald-art-shadow-dragon.webp":"5442651f","herald-art-shard-dragon.webp":"ca9a59ae","herald-art-shard-wolf.webp":"950afcfe","herald-art-shrinking-stone.webp":"83dc5da2","herald-art-star-dragon.webp":"3a2590f2","herald-art-stolen-moment.webp":"163aa4a8","herald-art-storm-wyrm.webp":"e9f74237","herald-art-study-the-stars.webp":"84272e2b","herald-art-sun-dragon.webp":"9b054720","herald-art-sword-promised.webp":"23a061a1","herald-art-the-sanctum.webp":"8e23ae14","herald-art-the-shattering.webp":"5c9c2412","herald-art-the-tragedy.webp":"7bc28ddb","herald-art-therabir.webp":"c8fbd371","herald-art-turn-back.webp":"cb72f5b7","herald-art-unthroned-court.webp":"9479d5a7","herald-art-vanguard.webp":"fe05e4aa","herald-art-whiskersworth.webp":"459fe4a2","herald-art-witheters.webp":"f20416b4","herald-art-world-tree.webp":"811a3e1a","herald-token-ambush.webp":"4517ebe5","herald-token-arcane-sever.webp":"5288188d","herald-token-beast-slayer.webp":"b6363a6a","herald-token-bramble-face.webp":"b66068e1","herald-token-bramble.webp":"ee0969fa","herald-token-couriers-dash.webp":"04439f47","herald-token-death-knight.webp":"95eb6312","herald-token-deep-faerie.webp":"fcd60f28","herald-token-dogfolk-ranger.webp":"3a38264d","herald-token-dragon-keeper.webp":"dcc9baf7","herald-token-dragon-knight.webp":"6d354b73","herald-token-dragon-shield.webp":"ebde6d57","herald-token-dragon-spear.webp":"58981f76","herald-token-elder-pegasus.webp":"02407549","herald-token-fae-rose.webp":"73ab4463","herald-token-faerie-rogue.webp":"6bdac0d3","herald-token-ferretfolk-scout.webp":"575a8631","herald-token-final-addendum.webp":"bce33642","herald-token-fire-knight.webp":"6d064a10","herald-token-fire-wyrm.webp":"6850f869","herald-token-glyphstorm.webp":"49fe1466","herald-token-goblin-skirmisher.webp":"4989c540","herald-token-great-axe.webp":"5368edde","herald-token-great-cat.webp":"4277b46a","herald-token-grodyr-rider.webp":"e379d99c","herald-token-guardian-spirit.webp":"ad984d83","herald-token-hedgehog-forager.webp":"436165f4","herald-token-hiro-face.webp":"c8602717","herald-token-hiro.webp":"43deceb0","herald-token-hollow-knight.webp":"17adc20e","herald-token-iris-theo-face.webp":"3a6a27db","herald-token-iris-theo.webp":"f0f27062","herald-token-longsword.webp":"6ffe6b77","herald-token-mindbreak.webp":"8a52f100","herald-token-mirror-dragon.webp":"623dd563","herald-token-moon-dragon.webp":"6878be15","herald-token-moth-dragon.webp":"68ddb60a","herald-token-mountain-golem.webp":"ab923ba4","herald-token-nightmare-blade.webp":"5f2268e1","herald-token-norag-face.webp":"23f10a84","herald-token-norag.webp":"c886c17f","herald-token-paragons-mail.webp":"7eeb366f","herald-token-path-cerevoker.webp":"c77422d7","herald-token-path-mythweaver.webp":"9ed81542","herald-token-path-oathbinder.webp":"3c4f5d15","herald-token-path-oathless.webp":"75bf7d09","herald-token-reavers-mail.webp":"9f436ffe","herald-token-rune-golem.webp":"23b7ea90","herald-token-runeward-script.webp":"14073600","herald-token-scrying-mirror.webp":"c660ba0d","herald-token-shadow-dragon.webp":"9ba08504","herald-token-shard-dragon.webp":"90964dc3","herald-token-shard-wolf.webp":"a8c2bc5c","herald-token-star-dragon.webp":"512ba6c9","herald-token-star-glass-rings.webp":"9c0ca47d","herald-token-stolen-moment.webp":"e0182d67","herald-token-storm-wyrm.webp":"83efa687","herald-token-study-the-stars.webp":"845d5adc","herald-token-sun-dragon.webp":"7e1c4947","herald-token-therabir-face.webp":"ecf56031","herald-token-therabir.webp":"48545694","herald-token-travelling-cloak.webp":"727a7819","herald-token-turn-back.webp":"e137baf8","herald-token-vanguard.webp":"85265f9d","herald-token-wandering-ghost.webp":"5306da95","herald-token-whiskersworth.webp":"ba79003e","herald-token-winged-boots.webp":"a807c49d","herald-dice-bramble.png":"1d429225","herald-dice-hiro.png":"c4195f66","herald-dice-iris.png":"3b1d6096","herald-dice-norag.png":"9d9e026f","herald-dice-therabir.png":"4b6d21bc","herald-dice-world-tree.jpg":"a38ab936","herald-brand-backdrop.webp":"c9492e7a","herald-brand-crossed-paths.svg":"a368a558","herald-brand-logo.webp":"a1d3d028","herald-ui-divider-a.webp":"bf17dfef","herald-ui-emblem.webp":"16f97d56","herald-ui-orb-life.webp":"3ca59023","herald-ui-orb-mana.webp":"5db269d6","herald-ui-orb-power.webp":"4bcdbe8f","herald-ui-plate.webp":"c4436c4a","herald-ui-sym-cost.webp":"ab1d1d37","herald-ui-sym-life.webp":"9dd7a419","herald-ui-sym-power.webp":"99be1f1b","herald-ui-type-action.webp":"8fde1ab8","herald-ui-type-equipment.webp":"6554e4eb","herald-ui-type-event.webp":"15b7eefc","herald-ui-type-evolving.webp":"05a312c6","herald-ui-type-herald.webp":"20e3d153","herald-ui-type-path.webp":"26b04479","herald-ui-type-region.webp":"6d015b88","herald-ui-type-spell.webp":"e311dcdf","herald-ui-type-unit.webp":"1b9288f1","herald-card-back.webp":"60be3748","herald-audio-rankup-bronze.mp3":"1d5746a2","herald-audio-rankup-diamond.mp3":"221e9a7b","herald-audio-rankup-gold.mp3":"22aec61e","herald-audio-rankup-platinum.mp3":"1ca0d982","herald-audio-rankup-silver.mp3":"cbbbe6ab"};
window.DK_DICE_DESIGNS = 'none';
/* ..\drakonym\data\dice-logo.js */
window.DK = window.DK || {};
window.DK.diceLogo = { viewBox: "0 0 4075 4109", d: "M2039.58,4014.6c-2.291,-0.778 -11.198,-2.59 -19.791,-4.027c-27.699,-4.633 -16.676,-8.479 25.006,-8.726l40.619,-0.241l28.872,-9.43c71.417,-23.329 129.264,-67.249 154.324,-117.172c13.313,-26.52 20.46,-59.554 20.734,-95.833l0.236,-31.25l-11.886,-21.446c-17.3,-31.211 -33.769,-49.641 -60.387,-67.577c-29.084,-19.598 -44.192,-24.903 -80.544,-28.281c0,-0 1.094,-124.029 3.285,-126.219c4.89,-4.891 53.247,16.678 85.324,38.057l35.791,23.855l22.927,26.222c32.694,37.393 51.227,67 68.571,109.54l15.147,37.154l3.943,71.195l-9.106,26.835c-11.48,33.837 -38.219,75.334 -66.094,102.574l-21.568,21.076l-32.53,17.333l-32.531,17.333l-39.337,10.539l-39.338,10.539l-43.75,-0.319c-24.062,-0.175 -45.625,-0.954 -47.917,-1.731l0,-0Zm-24.154,-113.472c-10.673,-33.847 -23.231,-75.603 -27.907,-92.791l-8.501,-31.25l-4.078,-77.083c-2.242,-42.396 -5.935,-111.771 -8.205,-154.167c-2.271,-42.396 -4.148,-115.244 -4.172,-161.886l-0.042,-84.803l33.843,-65.05l29.941,-23.868c23.707,-18.898 83.07,-51.893 93.363,-51.893c1.08,0 0.737,19.219 -0.763,42.709c-1.5,23.489 -3.397,76.458 -4.216,117.708c-3.177,160.076 -11.033,352.755 -16.786,411.684l-6.021,61.685l-8.689,29.982c-14.014,48.353 -42.321,133.876 -45.465,137.357c-1.593,1.764 -11.629,-24.486 -22.302,-58.334Zm-86.262,-276.629c-5.729,-1.606 -19.702,-5.056 -31.051,-7.666c-23.449,-5.395 -87.147,-39.804 -114.015,-61.589c-24.894,-20.184 -36.375,-39.457 -45.885,-77.025c-11.879,-46.924 -38.121,-86.548 -57.318,-86.548l-5.479,-0l-4.949,25.156l-4.949,25.156l-4.521,-1.507c-6.946,-2.315 -10.13,-18.611 -10.585,-54.189l-0.415,-32.468l6.633,-32.116c23.564,-114.093 83.686,-223.275 192.829,-350.182c21.76,-25.302 73.245,-72.736 97.976,-90.267c27.314,-19.363 55.779,-42.093 72.028,-57.514l17.383,-16.499l11.265,2.154l11.265,2.153l71.871,-18.229l37.094,-20.057c69.825,-37.755 98.826,-58.505 200.847,-143.701c39.967,-33.377 132.796,-101.033 146.575,-106.828l13.683,-5.755l10.553,4.808l10.554,4.809l-2.206,6.496c-1.214,3.573 -6.916,19.621 -12.671,35.663l-10.464,29.167l-0.215,37.624l24.841,50.917l11.538,1.085c6.346,0.597 23.086,1.3 37.199,1.563l25.662,0.477l34.052,-17.708c18.728,-9.74 37.016,-17.708 40.641,-17.708c8.409,-0 61.05,-43.07 99.605,-81.495c34.747,-34.63 44.348,-51.628 55.715,-98.634l8.332,-34.455l4.921,-100l-6.53,-42.507c-3.591,-23.38 -9.146,-48.77 -12.344,-56.423c-5.758,-13.782 -67.684,-98.183 -82.803,-112.856c-9.218,-8.946 -54.31,-47.398 -68.257,-58.206c-5.317,-4.12 -13.04,-8.261 -17.161,-9.202c-15.468,-3.529 -50.728,-14.685 -99.161,-31.371c-52.398,-18.053 -59.424,-20.18 -78.192,-23.672l-11.526,-2.145l-24.005,8.977l-24.005,8.978l-45.719,-45.032l-45.72,-45.032l-39.125,-26.591c-46.973,-31.926 -123.192,-76.114 -149.271,-86.542l-18.862,-7.542l2.587,-55.867c1.424,-30.727 2.588,-78.79 2.588,-106.806l0,-50.939l7.292,-2.245c4.01,-1.235 27.916,-10.96 53.125,-21.61c25.208,-10.651 79.583,-30.593 120.833,-44.317l75,-24.953l47.289,-8.09l47.289,-8.09l38.59,-0c70.633,-0 175.582,20.602 227.482,44.656c15.025,6.963 33.325,13.98 40.667,15.592c19.174,4.212 64.448,27.847 86.183,44.992c2.292,1.807 16.354,12.882 31.25,24.611c77.917,61.348 147.536,130.181 185.261,183.169c13.665,19.193 34.365,46.147 46.001,59.897c33.087,39.098 66.859,86.152 78.927,109.967c6.065,11.968 18.909,33.664 28.544,48.213c43.253,65.318 79.327,134.588 107.487,206.403l13.888,35.417l1.634,32.23c1.824,35.951 -4.031,76.26 -16.413,113.016l-8.238,24.454l-22.662,28.049c-12.464,15.426 -26.476,36.67 -31.137,47.207l-8.475,19.159l-6.101,52.154c-3.355,28.684 -7.789,59.668 -9.853,68.854c-7.538,33.55 -43.493,82.692 -85.946,117.467c-16.042,13.141 -76.823,68.893 -135.07,123.894l-105.903,100.002l-44.157,25.061l-44.158,25.061l-41.546,9.487l-45.833,-4.732c-44.681,-4.613 -63.661,-8.912 -102.083,-23.12l-18.75,-6.933l-19.016,1.784l-19.015,1.783l-43.534,19.43l-43.533,19.43l-14.535,-4.321c-23.577,-7.011 -88.215,-19.36 -105.843,-20.222c-8.969,-0.439 -17.69,-1.651 -19.379,-2.695c-1.688,-1.044 -21.988,-2.915 -45.11,-4.158l-42.04,-2.26l-8.35,4.469c-4.593,2.458 -28.644,8.957 -53.447,14.443c-24.803,5.486 -51.532,13.705 -59.397,18.265c-7.866,4.559 -23.792,11.054 -35.391,14.433c-11.6,3.379 -35.038,12.665 -52.084,20.637c-17.046,7.971 -41.306,18.849 -53.91,24.172c-34.897,14.739 -50.38,25.655 -71.218,50.211c-38.148,44.956 -75.086,106.524 -105.966,176.622l-11.013,25l-0.641,47.337l6.718,10.252c3.695,5.64 19.933,19.039 36.086,29.777l29.368,19.524l-0,8.68c-0,4.774 2.92,36.657 6.49,70.852c3.57,34.195 5.913,64.438 5.208,67.207l-1.282,5.035l-10.416,-2.919Zm952.304,-506.642c-17.756,-1.93 -41.142,-15.924 -38.725,-23.174c0.818,-2.455 13.566,-6.913 28.329,-9.907c33.437,-6.781 81.298,-30.052 106.284,-51.677c10.44,-9.036 19.804,-16.428 20.809,-16.428c1.006,-0 18.235,-2.804 38.288,-6.232l36.461,-6.231l12.5,3.387l12.5,3.387l1.244,8.427l1.244,8.427l-17.911,21.334l-17.911,21.335l-72.503,38.039l-22.081,3.848c-30.067,5.239 -68.671,7.622 -88.528,5.465Zm-241.888,-19.714c-37.613,-7.574 -54.023,-13.981 -64.577,-25.216l-9.552,-10.168l9.981,-3.785c30.191,-11.448 53.737,-18.176 70.644,-20.185l18.996,-2.257l24.754,11.526l24.754,11.526l27.084,2.502l27.083,2.501l-0,6.118c-0,9.254 -29.73,24.012 -58.448,29.013c-30.174,5.255 -37.627,5.089 -70.719,-1.575Zm464.089,-143.755c-6.002,-1.854 -19.127,-2.817 -29.167,-2.14c-10.04,0.678 -15.911,0.293 -13.047,-0.853c2.865,-1.147 5.209,-6.489 5.209,-11.872l-0,-9.787l36.458,-30.925c20.052,-17.008 48.646,-40.684 63.542,-52.612c49.666,-39.771 99.714,-88.103 114.862,-110.924c18.347,-27.641 41.392,-91.091 45.347,-124.854c5.534,-47.25 22.814,-102.084 32.17,-102.084c3.729,0 5.827,47.94 4.009,91.667c-1.424,34.269 -19.197,135.874 -29.518,168.75c-4.317,13.75 -10.162,35.247 -12.99,47.77c-7.611,33.707 -18.147,53.949 -40.294,77.412c-24.268,25.71 -45.597,40.262 -78.253,53.389l-24.917,10.016l-31.25,0.209c-17.187,0.115 -36.16,-1.308 -42.161,-3.162l-0,0Zm225.495,-7.922c-0,-4.727 5.625,-18.135 12.5,-29.795c6.875,-11.66 12.5,-22.641 12.5,-24.401c-0,-1.76 3.503,-10.584 7.785,-19.608c9.897,-20.86 18.546,-41.102 26.596,-62.241c3.49,-9.167 9.355,-24.167 13.032,-33.334c12.717,-31.697 33.45,-135.291 37.943,-189.583c4.484,-54.186 27.037,-112.49 63.551,-164.292c12.266,-17.403 32.628,-34.728 36.391,-30.965c0.938,0.938 3.612,16.909 5.942,35.492l4.237,33.787l10.976,27.42l10.977,27.419l15.638,17.861c8.601,9.824 15.734,21.611 15.852,26.195c0.118,4.583 -6.037,34.781 -13.677,67.107l-13.892,58.774l-12.154,24.559c-23.808,48.112 -36.636,69.366 -63.364,104.988l-27.083,36.096l-36.176,29.351c-38.212,31.003 -88.056,66.277 -100.283,70.968l-7.291,2.798l-0,-8.596Zm-1384.88,-151.555c-1.085,-7.511 -1.823,-17.407 -1.642,-21.99c0.422,-10.658 -9.097,-228.092 -11.674,-266.667c-2.807,-42.004 -5.617,-52.856 -16.774,-64.76l-9.928,-10.593l-6.299,-95.421c-3.465,-52.482 -6.24,-110.527 -6.167,-128.99l0.133,-33.569l23.383,-32.974l23.383,-32.973l5.255,7.187c2.89,3.952 25.225,46.446 49.632,94.431c24.407,47.985 46.061,87.245 48.12,87.245c2.059,0 24.5,-41.25 49.868,-91.666l46.124,-91.667l5.11,0.054c4.641,0.048 36.192,45.498 49.028,70.626l5.243,10.264l-2.643,68.903c-1.454,37.897 -3.905,92.027 -5.448,120.29l-2.805,51.388l-16.008,16.661l-16.007,16.661l-0,10.076c-0,5.542 -1.986,10.077 -4.413,10.077l-4.412,-0l3.257,5.208c3.304,5.283 2.447,187.321 -0.937,199.135c-2.138,7.463 -43.887,28.99 -56.221,28.99c-15.516,0 -38.579,12.547 -87.006,47.335c-26.502,19.037 -50.434,35.915 -53.183,37.505l-4.998,2.892l-1.971,-13.658Zm-535.287,-137.144l-0.403,-58.904l-6.64,-22.842c-12.231,-42.071 -37.898,-72.193 -76.953,-90.307c-12.604,-5.846 -26.882,-10.647 -31.729,-10.669c-9.032,-0.042 -15.519,-4.195 -107.453,-68.791c-45.542,-32 -114.734,-77.298 -239.985,-157.114c-116.898,-74.493 -178.594,-120.155 -178.984,-132.469c-0.109,-3.438 -9.917,-12.813 -21.795,-20.834c-26.374,-17.81 -70.75,-61.483 -95.875,-94.358c-41.622,-54.46 -96.363,-165.912 -126.585,-257.725l-17.829,-54.167l-8.445,-52.083c-4.645,-28.646 -8.3,-54.896 -8.122,-58.333c0.177,-3.438 -1.842,-25.158 -4.488,-48.268c-7.553,-65.986 -9.13,-136.432 -4.42,-197.566c5.354,-69.505 8.649,-87.328 29.458,-159.373c19.67,-68.103 26.236,-84.096 53.071,-129.26c11.203,-18.856 29.993,-50.817 41.754,-71.025c11.762,-20.208 32.176,-51.093 45.365,-68.633c31.604,-42.033 107.65,-124.342 150.971,-163.405c19.044,-17.171 36.698,-33.202 39.233,-35.624c11.612,-11.097 88.756,-73.672 125.924,-102.142c65.481,-50.158 107.833,-79.599 170.351,-118.422c32.083,-19.923 69.235,-43.755 82.561,-52.958c62.705,-43.311 170.758,-97.783 270.463,-136.347c106.617,-41.238 158.397,-53.745 169.103,-40.845l4.398,5.299l-32.013,16.382l-32.012,16.382l-67.732,69.584l-6.77,27.902c-3.724,15.346 -6.765,40.168 -6.759,55.159l0.012,27.258l17.709,17.194l17.708,17.194l17.713,4.669c40.651,10.714 79.927,13.99 188.537,15.727l114.583,1.832l60.417,-5.565c33.229,-3.061 98.854,-5.501 145.833,-5.422l85.417,0.144l27.083,15.798c14.896,8.689 31.476,19.874 36.844,24.856l9.76,9.058l-2.072,15.625l-2.072,15.625l8.978,0.648c4.939,0.356 13.47,0.243 18.96,-0.253c11.391,-1.028 65.133,-27.171 69.121,-33.625c5.356,-8.665 35.596,-1.527 79.861,18.852c7.221,3.325 14.721,6.046 16.667,6.049c4.77,0.004 94.165,45.302 99.162,50.246c2.177,2.154 6.329,3.916 9.226,3.916l5.268,0l-24.954,-51.041l-24.954,-51.042l-6.784,-33.333l-6.784,-33.334l4.819,-28.294c5.041,-29.606 22.482,-69.622 30.342,-69.622l4.583,-0l-2.764,9.375c-1.521,5.156 -3.859,19.984 -5.197,32.95l-2.433,23.576l5.307,28.508c6.299,33.833 19.455,65.306 38.308,91.643c11.324,15.82 99.443,98.029 170.787,159.333l16.451,14.136l6.414,-6.415c3.528,-3.528 7.346,-14.674 8.484,-24.77l2.069,-18.355l-18.667,-28.949c-25.823,-40.047 -42.241,-73.792 -53.688,-110.346l-9.74,-31.103l0.872,-83.333l8.956,-23.276c7.59,-19.725 16.441,-35.676 46.02,-82.94c8.493,-13.57 7.51,-0.347 -2.477,33.317l-10.501,35.399l0.001,35.416l0.002,35.417l6.99,27.083c12.01,46.537 41.674,97.633 81.521,140.421c10.242,10.998 31.348,34.363 46.902,51.924c32.52,36.714 60.294,59.012 98.744,79.275l27.083,14.273l22.23,45.595l22.23,45.596l7.244,45.833l25.128,50.14l25.127,50.14l20.373,22.858c11.205,12.571 24.182,29.121 28.837,36.777l8.466,13.92l-7.624,27.493l-7.624,27.493l4.53,8.506c10.123,19.013 31.133,43.064 56.206,64.343l26.516,22.504l12.542,-0.357c6.898,-0.196 19.106,-4.229 27.127,-8.962c8.022,-4.733 15.416,-8.605 16.43,-8.605c4.074,-0 1.342,49.612 -4.161,75.573c-10.418,49.153 -53.232,136.927 -66.789,136.927l-4.348,-0l1.499,-18.847c0.825,-10.366 0.385,-23.286 -0.976,-28.71l-2.475,-9.862l-21,-13.476c-11.549,-7.411 -22.798,-16.836 -24.997,-20.945c-4.839,-9.041 -54.087,-42.199 -76.437,-51.464l-16.113,-6.679l2.843,-9.383c1.565,-5.161 3.756,-12.198 4.87,-15.637l2.025,-6.253l-16.046,-16.664c-8.825,-9.165 -19.089,-21.531 -22.807,-27.48l-6.761,-10.818l-23.638,-11.192c-13.001,-6.155 -32.365,-12.16 -43.032,-13.344c-10.667,-1.184 -24.753,-2.993 -31.301,-4.018l-11.906,-1.866l2.772,11.444c1.525,6.294 6.281,18.278 10.569,26.63l7.797,15.187l2.956,30.647l2.956,30.647l16.261,32.068l16.26,32.069l11.049,8.049l11.049,8.049l-13.776,3.025c-7.576,1.664 -25.616,1.758 -40.088,0.208l-26.312,-2.818l-29.639,-14.204c-51.33,-24.599 -99.03,-64.363 -77.208,-64.363c3.437,-0 10,-3.75 14.583,-8.333l8.333,-8.334l0,-13.961c0,-7.679 -2.19,-20.335 -4.867,-28.125c-5.694,-16.571 -43.872,-60.021 -77.175,-87.831l-23.352,-19.501l-31.961,-8.624l-31.962,-8.624l-26.976,-0c-14.837,-0 -51.272,4.677 -80.966,10.394c-29.695,5.716 -55.397,10.404 -57.116,10.416c-7.671,0.056 -1.654,-7.861 16.019,-21.078c10.529,-7.873 20.912,-17.605 23.073,-21.625l3.928,-7.309l-4.042,-15.607c-2.223,-8.585 -6.113,-23.57 -8.645,-33.3l-4.604,-17.693l-23.802,-17.353c-13.091,-9.544 -35.241,-27.276 -49.222,-39.406c-28.852,-25.03 -67.277,-46.442 -89.906,-50.099l-15.326,-2.477l-32.59,7.227c-80.827,17.922 -140.289,52.41 -181.509,105.277l-7.25,9.299l-20.092,0l-9.135,-15.482l-9.135,-15.483l4.557,-15.209c2.506,-8.365 4.556,-22.284 4.556,-30.931l0,-15.722l-20.508,2.429c-19.889,2.355 -62.808,20.746 -62.841,26.927c-0.009,1.68 -11.753,23.86 -26.098,49.289l-26.081,46.235l-26.165,22.515c-14.39,12.384 -35.529,30.484 -46.975,40.224l-20.811,17.708l-13.385,0.001c-7.362,0 -28.312,2.857 -46.556,6.348l-33.17,6.347l-23.08,12.99c-12.694,7.144 -45.171,29.6 -72.171,49.902c-27.001,20.302 -50.842,36.912 -52.98,36.912c-2.139,0 -10.424,5.738 -18.412,12.752l-14.523,12.751l-8.22,21.971c-11.137,29.767 -18.235,95.494 -16.521,152.991l1.414,47.452l21.526,35.417c11.839,19.479 38.247,58.016 58.684,85.639l37.158,50.222l15.61,9.21c8.586,5.066 23.61,11.003 33.387,13.194c9.777,2.191 26.97,7.932 38.206,12.758c11.236,4.826 25.231,9.388 31.1,10.139c5.87,0.751 18.104,3.592 27.188,6.313l16.517,4.949l35.312,-8.607c19.422,-4.734 39.531,-9.811 44.687,-11.281l9.375,-2.675l-0.046,49.444c-0.025,27.195 -1.156,56.007 -2.513,64.028l-2.467,14.583l-40.195,24.13c-80.784,48.494 -196.658,136.613 -218.531,166.185l-8.245,11.148l-3.742,40.204l8.179,18.75c9.161,21.001 48.916,78.14 69.004,99.178l13.139,13.761l1.385,49.527l1.385,49.528l-36.103,9.829l-68.957,-4.765l-43.779,-14.959c-82.025,-28.027 -211.384,-101.445 -274.764,-155.944c-13.75,-11.823 -28.75,-22.317 -33.333,-23.319c-4.584,-1.003 -25.486,-5.725 -46.449,-10.493l-38.116,-8.671l-18.811,-11.929l-18.811,-11.93l-11.383,-20.115c-6.261,-11.063 -15.939,-26.979 -21.508,-35.369c-27.842,-41.946 -72.958,-194.707 -86.986,-294.531l-6.823,-48.548l2.65,-56.25c3.439,-73.005 11.955,-131.768 27.415,-189.164c6.852,-25.439 15.935,-60.315 20.185,-77.503c4.25,-17.187 9.13,-35 10.844,-39.583c1.714,-4.583 -5.676,4.792 -16.423,20.833c-37.816,56.448 -64.752,128.099 -83.413,221.883l-10.564,53.095l-2.518,54.388l-2.518,54.389l4.616,26.873c2.539,14.78 5.769,40.935 7.177,58.122c5.438,66.389 27.292,145.757 49.349,179.222c5.307,8.051 11.061,19.089 12.788,24.529c1.727,5.44 13.096,25.325 25.264,44.188l22.125,34.296l19.93,16.175c10.962,8.895 38.766,34.207 61.788,56.248c48.374,46.312 64.6,60.217 87.692,75.146c9.166,5.927 24.635,17.808 34.375,26.404l17.708,15.629l-0,18.938l-6.514,2.5c-7.815,2.999 -23.388,-4.629 -48.353,-23.685c-10.163,-7.757 -23.43,-15.347 -29.483,-16.866c-14.882,-3.736 -52.772,-31.116 -99.696,-72.043c-45.868,-40.006 -53.132,-47.822 -99.439,-106.988c-19.396,-24.781 -42.381,-53.844 -51.078,-64.583c-37.249,-45.997 -100.078,-168.58 -134.941,-263.276l-14.572,-39.584l-2.232,-33.333l-2.231,-33.333l7.052,-44.958c11.307,-72.074 58.415,-241.12 81.585,-292.761l12.219,-27.235l12.692,-4.424l12.691,-4.424l20.082,-33.933c11.044,-18.662 25.53,-41.641 32.191,-51.064c15.951,-22.565 61.199,-82.297 64.352,-84.951c1.361,-1.146 8.382,-10.767 15.601,-21.38c7.22,-10.614 26.885,-34.051 43.7,-52.084c16.815,-18.032 39.791,-44.974 51.057,-59.87c11.266,-14.896 38.97,-46.156 61.564,-69.468l41.081,-42.385l-8.39,-4.49c-13.051,-6.985 -18.05,-5.762 -57.804,14.139c-103.05,51.587 -192.393,133.228 -264.599,241.788l-33.256,50l-32.454,66.666c-56.099,115.238 -72.664,165.325 -89.827,271.6l-6.605,40.9l0.302,68.75l0.301,68.75l6.24,33.334c6.882,36.771 18.805,87.48 31.839,135.416c8.432,31.012 43.783,117.668 66.668,163.423c6.558,13.112 11.921,25.299 11.919,27.083c-0.02,12.278 -56.665,-71.521 -85.12,-125.922c-46.955,-89.771 -64.459,-149.794 -73.558,-252.245l-4.981,-56.089l2.592,-64.583l2.592,-64.583l6.406,-29.167c3.524,-16.042 10.264,-47.601 14.978,-70.131c14.202,-67.873 41.234,-148.445 67.335,-200.702c7.643,-15.303 54.989,-94.478 62.29,-104.167c81.104,-107.624 160.206,-186.648 213.721,-213.511c33.437,-16.785 101.933,-42.364 185.416,-69.242l85.417,-27.501l66.524,-39.746l3.913,-11.209l3.913,-11.21l-11.108,-13.384l-56.621,2.534c-31.142,1.395 -65.996,4.576 -77.454,7.07c-53.327,11.608 -175.485,70.47 -269.526,129.872l-40.359,25.494l-47.141,45.946c-45.562,44.408 -55.551,55.022 -102.054,108.434c-11.869,13.633 -26.543,30.411 -32.608,37.286c-37.499,42.501 -107.368,166.348 -125.762,222.917c-13.896,42.738 -29.938,115.338 -34.526,156.25c-5.413,48.265 -5.435,135.719 -0.048,188.217c4.901,47.756 30.256,150.175 49.851,201.366c7.457,19.479 16.449,43.758 19.984,53.953c12.978,37.431 121.982,191.837 188.707,267.307l20.639,23.343l29.133,18.324c16.024,10.078 49.288,31.555 73.922,47.726c24.633,16.172 56.038,35.703 69.788,43.403c28.016,15.688 69.735,42.156 72.917,46.261c1.145,1.478 7.708,5.572 14.583,9.098c6.875,3.525 18.266,11.756 25.314,18.289c7.047,6.534 17.04,14.692 22.206,18.13c5.165,3.437 20.961,14.816 35.102,25.287c14.141,10.47 37.899,26.218 52.795,34.995c55.4,32.643 98.391,86.029 126.504,157.095c13.584,34.336 13.614,41.372 0.308,70.123c-14.591,31.526 -51.729,87.5 -58.055,87.5l-5.192,-0l-0.403,-58.904Zm-148.579,-1351.51l-0,-79.167l13.427,-28.348c21.521,-45.438 49.829,-84.025 88.952,-121.256l36.487,-34.722l19.395,-9.389l19.394,-9.388l16.094,2.158l16.093,2.159l23.882,17.101c27.127,19.426 30.734,20.01 53.776,8.71l16.666,-8.173l-34.281,4.606l-6.811,-6.812c-9.473,-9.473 -12.477,-24.317 -9.687,-47.87l2.382,-20.112l14.419,-28.498c37.662,-74.435 149.613,-186.647 242.312,-242.876c32.575,-19.759 23.894,-18.849 -22.431,2.352c-83.335,38.139 -161.079,106.382 -240.986,211.536l-17.583,23.138l-20.547,10.413c-11.302,5.726 -24.036,14.846 -28.299,20.266c-4.263,5.419 -13.318,11.251 -20.123,12.958c-14.64,3.675 -58.723,34.315 -86.25,59.948c-39.916,37.172 -76.972,93.76 -100.145,152.933l-14.685,37.5l3.562,28.742l3.563,28.743l7.148,7.899l7.149,7.899l8.563,-1.225l8.564,-1.225Zm441.666,-252.083l8.334,-3.581l-22.893,-0.586l-17.206,-15.545l-17.206,-15.544l2.197,-33.414l2.198,-33.414l11.376,-31.25c15.495,-42.563 26.265,-56.969 90.354,-120.856c58.215,-58.031 59.251,-59.981 15.763,-29.649c-44.398,30.968 -83.65,64.144 -114.144,96.478l-28.727,30.46l-13.839,29.953c-7.612,16.474 -15.085,37.742 -16.607,47.262l-2.768,17.309l6.867,17.98c3.776,9.888 12.046,22.942 18.377,29.007l11.51,11.028l22.791,3.777c29.281,4.853 33.557,4.91 43.623,0.585l0,-0Zm281.808,1062.5c-30.452,-59.584 -57.566,-108.327 -60.254,-108.318c-2.688,0.008 -11.45,3.959 -19.47,8.778c-49.046,29.471 -83.867,67.651 -111.202,121.932l-14.426,28.646l-3.382,-3.644c-7.636,-8.228 -75.156,-102.728 -75.143,-105.168c0.008,-1.454 17.803,-22.637 39.546,-47.075c63.631,-71.518 113.127,-103.709 187.946,-122.235c22.028,-5.455 40.953,-10.819 42.054,-11.921c1.102,-1.102 2.924,-13.871 4.049,-28.375c1.126,-14.503 3.67,-31.058 5.654,-36.787c3.045,-8.789 12.606,-200.663 17.857,-358.333l1.457,-43.75l5.88,-9.375c6.888,-10.981 15.142,-11.86 27.843,-2.963l9.154,6.411l12.4,-6.411c6.819,-3.527 15.059,-6.412 18.311,-6.412l5.911,-0l2.583,15.625c1.42,8.593 2.603,37.055 2.628,63.248c0.066,67.905 11.843,305.997 16.606,335.71c2.205,13.75 5.171,34.77 6.593,46.711l2.584,21.711l6.923,1.884c3.808,1.036 17.236,4.093 29.84,6.794c12.604,2.701 41.926,14.046 65.158,25.21l42.242,20.299l30.675,24.437c31.185,24.844 56.516,52.24 84.474,91.359l15.537,21.738l-35.99,52.22c-19.794,28.721 -36.782,52.22 -37.751,52.22c-0.969,0 -7.286,-12.183 -14.038,-27.074c-6.752,-14.891 -18.322,-35.494 -25.713,-45.785c-16.165,-22.51 -59.407,-59.586 -87.028,-74.619l-20.057,-10.917l-6.57,2.522l-6.571,2.521l-52.573,103.76c-28.916,57.067 -53.878,103.759 -55.471,103.759c-1.594,-0 -27.814,-48.75 -58.266,-108.333Zm1440.98,54.007c-7.329,-9.254 -23.502,-35.972 -35.939,-59.375c-12.438,-23.402 -25.817,-45.362 -29.733,-48.8c-3.915,-3.439 -15.449,-16.564 -25.63,-29.167c-10.181,-12.604 -33.035,-38.038 -50.788,-56.521l-32.277,-33.606l-4.783,-18.995c-4.388,-17.428 -13.279,-32.354 -59.897,-100.553c-8.941,-13.081 -15.252,-24.787 -14.025,-26.015c2.404,-2.404 66,12.935 77.492,18.69c3.826,1.916 13.518,6.485 21.539,10.153c8.021,3.668 22.084,11.321 31.25,17.008c9.167,5.686 23.111,13.606 30.987,17.6c15.583,7.902 79.43,68.905 79.43,75.892c-0,2.366 4.605,8.908 10.233,14.535l10.232,10.233l8.123,32.665l8.123,32.665l2.831,73.308l2.83,73.308l-6.9,6.901c-3.795,3.795 -7.547,6.9 -8.336,6.9c-0.79,-0 -7.433,-7.572 -14.762,-16.826Zm-1426.16,-799.904c-6.436,-1.932 -23.78,-14.117 -38.542,-27.077l-26.84,-23.564l0,-19.839l12.171,-13.862l12.171,-13.862l22.204,-9.869c12.212,-5.428 30.086,-13.444 39.72,-17.812l17.516,-7.942l2.651,-8.354l2.652,-8.353l-6.898,-7.622c-3.794,-4.192 -13.338,-8.83 -21.209,-10.307c-7.871,-1.476 -14.311,-3.64 -14.311,-4.808c-0,-3.65 33.514,-51.666 36.062,-51.666c1.329,0 17.14,13.272 35.133,29.493l32.717,29.494l2.656,14.158l2.656,14.158l-11.659,18.428l-11.658,18.428l-16.912,4.95c-28.152,8.24 -64.828,25.881 -64.828,31.183c-0,9.562 5.692,10.561 14.274,2.504c7.453,-6.997 80.532,-37.796 89.682,-37.796c5.891,0 25.916,22.549 33.87,38.14l7.822,15.332l-7.199,8.271c-3.96,4.55 -18.067,12.212 -31.35,17.028c-13.283,4.816 -31.49,12.5 -40.459,17.076l-16.308,8.32l-22.041,-0.358c-12.123,-0.197 -27.307,-1.939 -33.743,-3.872l0,0Zm-198.715,-61.26c-5.729,-1.021 -24.553,-8.192 -41.832,-15.937l-31.415,-14.082l-39.418,3.992c-21.68,2.195 -45.043,5.045 -51.918,6.332l-12.5,2.34l15.638,-13.786c8.601,-7.582 27.351,-24.163 41.667,-36.847c32.4,-28.708 60.136,-47.902 85.309,-59.037l19.419,-8.59l71.3,5.608l24.29,-26.21l24.289,-26.21l-2.357,10.417c-1.297,5.729 -2.384,23.683 -2.415,39.897l-0.057,29.481l-26.548,43.436c-14.601,23.89 -30.472,47.655 -35.267,52.811l-8.72,9.375l-9.524,-0.567c-5.239,-0.313 -14.212,-1.403 -19.941,-2.423Z" };

/* ..\drakonym\data\dice-sets.js */
/* The dice a rider can roll with (js/dice3d.js). Every set dresses the three
   kinds of Drakonym die: the pool's d6s, the Hero die and the Shadow die
   (both d12). Classic is the table's original look; the rest are the eight
   dragon Families, coloured from each Family's painting in the book
   (theme assets dk-dragon-<family>.webp), not from the written descriptions,
   which do not always agree with the art.

   A look:
     face     the body's colours; each die in a throw takes one of them
     pattern  what the body is made of: marble (resins swirled together),
              nebula, veins (glowing threads through the resin), gem, diamond, pearl,
              metal (brushed, cast metal; set metal: 1 as well)
     accent, accent2, accent3   the pattern's other colours
     foil     flakes suspended in resin: stars, gold, prism, pearl, ember,
              shard, fire, leaf, mica, none; foilCols gives them their own colours
     glow     0..1, how much of the pattern shines by its own light
     ink      the numbers: one colour, or a gradient top to bottom
     inkMetal the numbers are gilded and catch the light
     iridescence  0..1, an oil-slick sheen over the whole die
     frame    a colour: the edges and corners cast in that metal
     cut      'star': a gem cut, faceted edges and star-faceted corners
     shape    'rhombic': the look's d12 is a rhombic dodecahedron
   A set's group is the heading it sits under in the dice picker.
   Numbers are engraved and filled; there is no keyline round them. */
window.DK_DICE_SETS = [
  { id: 'classic', name: 'Classic', group: 'Default',
    pool:   { face: ['#b04a17', '#bd561c', '#a3410f'], pattern: 'marble', accent: '#e58a3e', accent2: '#5e2206', ink: '#fff4e2' },
    hero:   { face: ['#dcb052'], pattern: 'metal', metal: 1, ink: '#1a0f02' },
    shadow: { face: ['#2e2050'], pattern: 'marble', accent: '#54428c', accent2: '#120a22', ink: '#efe6ff' } },

  // violet and lavender, glowing cyan spots, a sky full of stars
  { id: 'astral', name: 'Astral Dragon', group: 'Dragon Families',
    pool:   { face: ['#3a2296', '#4226a4', '#331e88'], pattern: 'nebula', accent: '#9a78f2', accent2: '#3fd0ff', foil: 'stars', glow: 0.8,
              ink: ['#ffffff', '#ded8ff'], inkMetal: true },
    hero:   { face: ['#9a8ce0'], pattern: 'nebula', accent: '#cfc6f7', accent2: '#7adcff', foil: 'stars', glow: 0.4,
              ink: '#170f45' },
    shadow: { face: ['#120c28'], pattern: 'nebula', accent: '#4e3b8e', accent2: '#3fb6e8', foil: 'stars', glow: 0.7,
              ink: ['#ece6ff', '#b6a8f2'], inkMetal: true } },

  // dusty rose and magenta, a pale fur ruff, rainbow breath
  { id: 'aura', name: 'Aura Dragon', group: 'Dragon Families',
    pool:   { face: ['#763858', '#803d60', '#6d3354'], pattern: 'marble', accent: '#b8698f', accent2: '#3a1c30', accent3: '#a6dcc8', foil: 'prism',
              ink: ['#fffafc', '#f7dbe8'], inkMetal: true },
    hero:   { face: ['#ece4e2'], pattern: 'pearl', accent: '#f4c4da', accent2: '#c6eadc', foil: 'prism', iridescence: 0.9, ink: '#6b2c4a' },
    shadow: { face: ['#3a1d2e'], pattern: 'marble', accent: '#7c3c5d', accent2: '#12080e', foil: 'prism',
              ink: ['#ffe8f2', '#e9a8c7'], inkMetal: true } },

  // pale silver-grey, slate in the shadows, wings of icy glass
  { id: 'mirror', name: 'Mirror Dragon', group: 'Dragon Families',
    pool:   { face: ['#ccd2da', '#c3cad3'], pattern: 'metal', metal: 1, ink: '#0b1122' },
    hero:   { face: ['#7fb0e6'], pattern: 'pearl', accent: '#bcdcf6', accent2: '#5b8fd0', foil: 'pearl', iridescence: 0.6, ink: '#1c2a4a' },
    shadow: { face: ['#4a5068'], pattern: 'metal', metal: 1, ink: '#eef2f8' } },

  // deep royal blue under a white full moon
  { id: 'moon', name: 'Moon Dragon', group: 'Dragon Families',
    pool:   { face: ['#27396b', '#2d4379', '#233360'], pattern: 'marble', accent: '#6389c4', accent2: '#121a38', foil: 'pearl',
              ink: ['#ffffff', '#dfe8f8'], inkMetal: true },
    hero:   { face: ['#eaeef5'], pattern: 'pearl', accent: '#bfd2ef', accent2: '#fffdf4', foil: 'pearl', iridescence: 0.35, ink: '#223366' },
    shadow: { face: ['#0f1631'], pattern: 'marble', accent: '#2c4079', accent2: '#060912',
              ink: ['#f2f6ff', '#b8c8e6'], inkMetal: true } },

  // near-black red hide split by glowing lava, wings of fire
  { id: 'pyre', name: 'Pyre Dragon', group: 'Dragon Families',
    pool:   { face: ['#3c1612', '#451a15', '#351310'], pattern: 'veins', accent: '#ff6a1f', accent2: '#ffd070', glow: 0.8,
              ink: ['#ffffff', '#fff1dc'] },
    hero:   { face: ['#a82e0c'], pattern: 'marble', accent: '#e8691e', accent2: '#4a0c03', foil: 'ember', glow: 0.3, ink: '#fff6e6' },
    shadow: { face: ['#0c0807'], pattern: 'veins', accent: '#c2361a', accent2: '#ff8a3d', glow: 0.7,
              ink: ['#ffd0b0', '#f06a3a'], inkMetal: true } },

  // sea-green hide grown over with bright green crystal
  { id: 'shard', name: 'Shard Dragon', group: 'Dragon Families',
    pool:   { face: ['#2c7872', '#28706c', '#338078'], pattern: 'gem', foil: 'shard', foilCols: ['#c4f59a', '#86d95e', '#eaffd6'],
              ink: ['#f4fff0', '#cdf6b4'], inkMetal: true },
    hero:   { face: ['#7ad456'], pattern: 'gem', foil: 'shard', foilCols: ['#eaffd6', '#c4f59a'], iridescence: 0.3, ink: '#0a2412' },
    shadow: { face: ['#15302d'], pattern: 'gem', foil: 'shard', foilCols: ['#86d95e', '#4fae3c'],
              ink: ['#e0ffd4', '#94e27c'], inkMetal: true } },

  // mustard-gold armour, yellow lightning, grey storm cloud
  { id: 'storm', name: 'Storm Dragon', group: 'Dragon Families',
    pool:   { face: ['#b8963f', '#b08c3a'], pattern: 'marble', accent: '#d8be6c', accent2: '#5e4719', ink: '#1a1104' },
    hero:   { face: ['#d4b65c'], pattern: 'metal', metal: 1, ink: '#120c02' },
    shadow: { face: ['#3a3a42'], pattern: 'veins', accent: '#ecd65a', accent2: '#fffbe0', glow: 0.85,
              ink: ['#fff7d6', '#e8d27a'], inkMetal: true } },

  // ivory and silver armour plates, amber-gold wings
  { id: 'sun', name: 'Sun Dragon', group: 'Dragon Families',
    pool:   { face: ['#e3ddcf', '#dad3c3'], pattern: 'pearl', accent: '#f2e4bc', accent2: '#c9bda2', foil: 'leaf', ink: ['#4a2a04', '#2e1800'] },
    hero:   { face: ['#e6a426'], pattern: 'marble', accent: '#ffd86e', accent2: '#c77712', foil: 'leaf', ink: '#2e1500' },
    shadow: { face: ['#3d3526'], pattern: 'marble', accent: '#7a6a48', accent2: '#1a150c', foil: 'leaf',
              ink: ['#fff0c8', '#e8b54a'], inkMetal: true } },

  /* The Dragonfall dice, for everyone who backed Drakonym: the reward
     'drakonym-backer-dice', given to every account that redeemed a Drakonym
     BackerKit code (backer-dice.sql). Classic made precious: the same copper,
     gold and deep violet, now cut gems, with rhombic d12s. A carnelian pool full of embers, an amber-gold
     Hero die with fire in it, an amethyst Shadow die full of stars. */
  { id: 'backer', name: 'Dragonfall', group: 'Exclusive', reward: 'drakonym-backer-dice',
    earn: 'The Dragonfall dice are for everyone who backed Drakonym. Redeem your BackerKit code on your Sanctum account to roll with them.',
    pool:   { face: ['#b04a17', '#bd561c', '#a3410f'], pattern: 'diamond', foil: 'ember', glow: 0.25, iridescence: 0.2, ink: ['#fffaf0', '#ffe6bd'], escape: '#ffb35c', escapeK: 0.35, inkGlow: 0.12 },
    hero:   { shape: 'rhombic', face: ['#a8660f', '#b06d14'], pattern: 'diamond', foil: 'fire', glow: 0.25, iridescence: 0.25, ink: ['#fff6e0', '#ffe2a8'], inkMetal: true, escape: '#ffd27a', escapeK: 0.4, inkGlow: 0.1 },
    shadow: { shape: 'rhombic', face: ['#2e2050', '#34245a'], pattern: 'diamond', foil: 'stars', glow: 0.3, iridescence: 0.3, ink: ['#fff3d6', '#f2cf7a'], inkMetal: true, escape: '#b89cff', escapeK: 0.4 } },

  /* The Discord dice, for everyone who connects Discord to their Sanctum
     account: the reward 'discord-dice' (discord-dice.sql), shared with the
     Legends set of the same id. Discord's own colours on normal d12s: a
     starry blurple pool, a pearl-white Hero die inked in blurple, and a
     near-black Shadow die holding a blurple and fuchsia nebula. */
  { id: 'discord', name: 'Discord', group: 'Exclusive', reward: 'discord-dice',
    earn: 'The Discord dice are for everyone who connects their Discord. Open your Sanctum account and connect Discord to roll with them.',
    pool:   { face: ['#5865f2', '#5f6cf3', '#5260ea'], pattern: 'diamond', foil: 'stars', glow: 0.35, iridescence: 0.35,
              ink: ['#ffffff', '#eef0ff'], inkMetal: true, escape: '#aeb5ff', escapeK: 0.45, inkGlow: 0.12 },
    hero:   { face: ['#f2f3f5', '#eceef2'], pattern: 'pearl', accent: '#c9cdfb', accent2: '#ffd1ea', foil: 'prism', iridescence: 0.7, ink: '#5865f2' },
    shadow: { face: ['#1e1f22', '#232428'], pattern: 'nebula', accent: '#5865f2', accent2: '#eb459e', foil: 'stars', glow: 0.6,
              ink: ['#ffffff', '#c9cdfb'], inkMetal: true, escape: '#8f98ff', escapeK: 0.4 } },

  /* Season of Magic, the Sanctum Seasons pass reward 'magic-dice' (level 2, Silver): only a
     player who has unlocked it can pick it (anyone sees it when its owner
     rolls). Light blues and teal, kept plain so the Diamond set above it
     carries the stars and fire: a pale grey pool, a sky-blue Hero die and a
     deep-teal Shadow die, each with a soft light at its edges. */
  { id: 'season-magic', name: 'Season of Magic', group: 'Sanctum Seasons', reward: 'magic-dice', season: true,
    earn: 'The Season of Magic dice are a Sanctum Seasons reward. Reach level 2 (Silver) of the Season of Magic pass to roll with them.',
    pool:   { face: ['#dcecf3', '#d6e8f0', '#e3f1f6'], pattern: 'gem', iridescence: 0.4,
              ink: ['#0e2a3e', '#16364e'], escape: '#bfefff', escapeK: 0.6 },
    hero:   { face: ['#5fa9d6', '#62acd8'], pattern: 'gem', iridescence: 0.3,
              ink: '#07192b', escape: '#d8f6ff', escapeK: 0.6 },
    shadow: { face: ['#062a38', '#082f3e'], pattern: 'gem',
              ink: ['#effdff', '#bdeff3'], inkMetal: true, escape: '#4fe3e8', escapeK: 0.6 } },

  /* Season of Magic: Diamond, the level 4 (Platinum) reward (key 'magic-dice-diamond'),
     one step below Bramble's Notebook at the top of the pass.
     Cut gems, the Hero and Shadow dice rhombic dodecahedra (shape: 'rhombic'):
     an aquamarine for the pool, full of stars, a blue diamond for the Hero
     die and a black diamond for the Shadow die, each with fire in its facets. */
  { id: 'season-magic-diamond', name: 'Season of Magic: Diamond', group: 'Sanctum Seasons', reward: 'magic-dice-diamond', season: true,
    earn: 'The Diamond Season of Magic dice are a Sanctum Seasons reward. Reach level 4 (Platinum) of the Season of Magic pass to roll with them.',
    pool:   { face: ['#0f6a78', '#117282', '#0d6270'], pattern: 'diamond', foil: 'stars', glow: 0.45, iridescence: 0.35,
              ink: ['#ffffff', '#e2f8fb'], inkMetal: true, escape: '#8ff0ff', escapeK: 0.5, inkGlow: 0.15 },
    hero:   { shape: 'rhombic', face: ['#1c6a96'], pattern: 'diamond', foil: 'fire', glow: 0.2, iridescence: 0.35,
              ink: ['#ffffff', '#e4f4ff'], inkMetal: true, escape: '#aee6ff', escapeK: 0.45, inkGlow: 0.15 },
    shadow: { shape: 'rhombic', face: ['#15181f', '#181c24'], pattern: 'diamond', foil: 'fire', glow: 0.2, iridescence: 0.3,
              ink: ['#f4f8ff', '#c3cedd'], inkMetal: true, escape: '#b9c6ff', escapeK: 0.4, inkGlow: 0.15 } }
];

/* ..\drakonym\js\dice3d.js */
/* Three-dimensional dice for Drakonym: the digital sheet and the map board.

   Every roll the sheet makes is also thrown across the page as real dice,
   tumbling under physics and coming to rest on the numbers the sheet rolled:
   the pool's d6s, the Hero die and the Shadow die (both d12s). The highest
   face of every die carries the Drakonym mark. A dice set (data/dice-sets.js)
   gives each of the three kinds of die its look; the sets are the eight
   dragon Families, cast in layered resin with the Family's own inclusions
   (stars, embers, crystal, lightning...) drawn under a foil ink.

   Ported from the Legends engine (game-tools/legends/js/dice3d.js), which was
   itself grown from the map board's first dice: the throw is simulated to
   rest first, invisibly, to learn which face of each die ends uppermost; the
   faces are then numbered so that face carries the rolled value and the same
   throw is played for real. What the player sees is what the log says.

   three.js and cannon-es load on demand from a CDN. Nothing here runs until
   the first roll, or a prefetch. */
(function (w, d) {
  'use strict';

  var THREE = null, CANNON = null, loading = null;
  var LIBS = [
    ['https://unpkg.com/three@0.160.0/build/three.module.js',
     'https://unpkg.com/cannon-es@0.20.0/dist/cannon-es.js'],
    ['https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js',
     'https://cdn.jsdelivr.net/npm/cannon-es@0.20.0/dist/cannon-es.js']
  ];

  function libs() {
    if (loading) return loading;
    var i = 0;
    function attempt() {
      var pair = LIBS[i++];
      if (!pair) return Promise.reject(new Error('The dice libraries could not be fetched.'));
      return Promise.all([(new Function('u', 'return import(u)'))(pair[0]), (new Function('u', 'return import(u)'))(pair[1])]).then(function (m) {
        THREE = m[0]; CANNON = m[1];
        return true;
      }, function () { return attempt(); });
    }
    loading = attempt().catch(function (e) { loading = null; throw e; });
    return loading;
  }

  /* ------------------------------------------------------------ settings */

  var PREF = 'drakonym.dice3d.v2';
  var OLD_PREF = 'drakonym.dice3d.v1';       // the map board's on/off, "on" or "off"
  var pref = null;

  function prefs() {
    if (pref) return pref;
    pref = { on: true, set: 'classic' };
    try { if (localStorage.getItem(OLD_PREF) === 'off') pref.on = false; } catch (e) {}
    try {
      var raw = localStorage.getItem(PREF);
      if (raw) {
        var got = JSON.parse(raw);
        if (got && typeof got === 'object') {
          if (typeof got.on === 'boolean') pref.on = got.on;
          if (typeof got.set === 'string') pref.set = got.set;
        }
      }
    } catch (e) {}
    // a set that has been retired returns to the default
    if (!SETS.some(function (s) { return s.id === pref.set; })) {
      pref.set = SETS[0].id;
      try { localStorage.setItem(PREF, JSON.stringify(pref)); } catch (e) {}
    }
    return pref;
  }

  function savePrefs() {
    try { localStorage.setItem(PREF, JSON.stringify(prefs())); } catch (e) {}
    try { localStorage.setItem(OLD_PREF, prefs().on ? 'on' : 'off'); } catch (e) {}
  }

  var ALL_SETS = w.DK_DICE_SETS || [];
  var SETS = ALL_SETS.filter(function (s) { return !s.hidden; });
  if (!SETS.length) SETS = [{ id: 'classic', name: 'Classic', pool: { face: ['#b8511a'], ink: '#ffffff' } }];
  var ROLES = ['pool', 'hero', 'shadow'];

  function setById(id) {
    for (var i = 0; i < SETS.length; i++) if (SETS[i].id === id) return SETS[i];
    return SETS[0];
  }

  /* ---- sets a player earns ----
     A set with a `reward` is a Sanctum Seasons reward (season_rewards.key):
     anyone sees it thrown by its owner, but only a player who has unlocked
     it can pick it. The unlocks come from the site account on the page. */
  var UNLOCKS = null, unlockLoad = null;
  function pageWins() {
    var wins = [w];
    try { if (w.parent && w.parent !== w) wins.push(w.parent); } catch (e) {}
    try { if (w.top && wins.indexOf(w.top) < 0) wins.push(w.top); } catch (e) {}
    return wins;
  }
  function account() {
    var wins = pageWins();
    for (var i = 0; i < wins.length; i++) {
      try { if (wins[i].DKAccount && wins[i].DKAccount.api) return wins[i].DKAccount; } catch (e) {}
    }
    return null;
  }
  /* Sanctum Seasons is switched on by making the Seasons page visible, which
     is what sets DK_SEASONS_URL. While it is off, a season's dice (season:
     true) stay out of the picker and out of play, even for their holders. */
  function seasonsOn() {
    var wins = pageWins();
    for (var i = 0; i < wins.length; i++) {
      try { if (wins[i].DK_SEASONS_URL) return true; } catch (e) {}
    }
    return false;
  }
  function loadUnlocks(again) {
    if (unlockLoad && !again) return unlockLoad;
    var acc = account();
    if (!acc || !acc.signedIn || !acc.signedIn()) { UNLOCKS = []; return (unlockLoad = Promise.resolve(UNLOCKS)); }
    unlockLoad = acc.api('/rest/v1/season_unlocks?select=reward_key').then(function (rows) {
      UNLOCKS = (rows || []).map(function (r) { return r.reward_key; });
      return UNLOCKS;
    }, function () { UNLOCKS = UNLOCKS || []; unlockLoad = null; return UNLOCKS; });
    return unlockLoad;
  }
  function earned(set) {
    if (!set) return false;
    if (!set.reward) return true;
    if (set.season && !seasonsOn()) return false;
    return (UNLOCKS || []).indexOf(set.reward) >= 0;
  }

  /** The set in play: the player's pick, while they still hold it. */
  function currentSet() { var s = setById(prefs().set); return earned(s) ? s : SETS[0]; }

  /** A look of a set: the pool's d6s, the Hero die or the Shadow die. */
  function roleLook(set, role) { return set[role] || set.pool || set; }

  function inkKey(ink) { return Array.isArray(ink) ? ink.join('>') : String(ink || '#ffffff'); }

  /** A key that changes whenever the look does, for the caches. */
  function setKey(set) {
    return set.id + '|' + ROLES.map(function (r) {
      var l = roleLook(set, r);
      return [(l.face || []).join(','), l.pattern, l.accent, l.accent2, l.accent3, l.foil, (l.foilCols || []).join(','), l.glow,
              inkKey(l.ink), l.outline, !!l.inkMetal, l.iridescence, !!l.ring, l.escape, l.escapeK, l.inkGlow, l.frame, l.cut, l.shape].join('/') +
             (l.opal ? '/opal:' + l.opal + ':' + (l.opalScale || '') : '') +
             // only a set with artwork has these, so every other set keeps its key (and its seeds)
             (l.image || l.faceMap || l.faceMaps || l.mark ? '/' + [l.image, l.faceMap, l.faceCols, l.mark, JSON.stringify(l.faceMaps || '')].join('/') : '') +
             (l.fontFile ? '/font:' + l.fontFile : '') +
             (l.wrap || l.wraps ? '/wrap:' + [l.wrap, JSON.stringify(l.wraps || '')].join('/') : '');
    }).join('|') + (set.mark ? '|' + set.mark : '') + (set.fontFile ? '|font:' + set.fontFile : '');
  }

  /* ------------------------------------------------ a designer's artwork */

  /* A look may carry `image` (one seamless texture for the body),
     `faceMap` (a picture per face, on the die's template) or `wrap` (the
     whole die painted on its wrap template), and a set or look
     may carry `mark` (a picture for the highest face). They are fetched
     before any die of the set is built. */
  var ART = {};
  function loadArt(url) {
    if (!url) return Promise.resolve(null);
    if (ART[url]) return ART[url].p;
    var rec = ART[url] = { img: null };
    rec.p = new Promise(function (done) {
      var im = new Image(), timer = setTimeout(function () { done(null); }, 15000);
      im.crossOrigin = 'anonymous';
      im.onload = function () { clearTimeout(timer); rec.img = im; done(im); };
      im.onerror = function () { clearTimeout(timer); done(null); };
      im.src = url;
    });
    return rec.p;
  }
  function artOf(url) { return url && ART[url] ? ART[url].img : null; }
  /* A set's own font: loaded as a FontFace named after its address, for every weight. */
  var FONTS = {};
  function fontFamily(url) {
    var h = 0;
    for (var i = 0; i < url.length; i++) h = (h * 31 + url.charCodeAt(i)) >>> 0;
    return 'dkfont' + h.toString(36);
  }
  function loadFont(url) {
    if (!url) return Promise.resolve(null);
    if (FONTS[url]) return FONTS[url].p;
    var rec = FONTS[url] = { ok: false };
    rec.p = new Promise(function (done) {
      try {
        if (!w.FontFace || !d.fonts) return done(null);
        var face = new w.FontFace(fontFamily(url), 'url("' + url + '")', { weight: '100 900' });
        var timer = setTimeout(function () { done(null); }, 15000);
        face.load().then(function (f) { clearTimeout(timer); d.fonts.add(f); rec.ok = true; done(f); },
                         function () { clearTimeout(timer); done(null); });
      } catch (e) { done(null); }
    });
    return rec.p;
  }
  /** The family to write a look's numbers in: its own font once loaded, else none (Morion). */
  function fontOf(look) { return look.fontFile && FONTS[look.fontFile] && FONTS[look.fontFile].ok ? fontFamily(look.fontFile) : null; }

  function artReady(set) {
    var urls = [], fonts = [];
    if (set && set.fontFile) fonts.push(set.fontFile);
    if (set && set.mark) urls.push(set.mark);
    ROLES.forEach(function (r) {
      var l = roleLook(set || {}, r) || {};
      [l.image, l.faceMap, l.mark, l.wrap].forEach(function (u) { if (u) urls.push(u); });
      if (l.faceMaps) Object.keys(l.faceMaps).forEach(function (k) { if (l.faceMaps[k]) urls.push(l.faceMaps[k]); });
      if (l.wraps) Object.keys(l.wraps).forEach(function (k) { if (l.wraps[k]) urls.push(l.wraps[k]); });
      if (l.fontFile) fonts.push(l.fontFile);
    });
    return Promise.all(urls.map(loadArt).concat(fonts.map(loadFont)));
  }
  /** The mark as a stencil: the picture's shape, trimmed to what is drawn. */
  var STENCILS = {};
  function stencil(url) {
    if (STENCILS[url]) return STENCILS[url];
    var im = artOf(url);
    if (!im) return null;
    var W = im.naturalWidth || im.width || 512, H = im.naturalHeight || im.height || 512;
    var r = 640 / Math.max(W, H), c = d.createElement('canvas');
    c.width = Math.max(1, Math.round(W * r)); c.height = Math.max(1, Math.round(H * r));
    var g = c.getContext('2d');
    g.drawImage(im, 0, 0, c.width, c.height);
    var px = g.getImageData(0, 0, c.width, c.height).data, x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
    for (var y = 0; y < c.height; y++) for (var x = 0; x < c.width; x++) {
      if (px[(y * c.width + x) * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    var out = d.createElement('canvas'); out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext('2d').drawImage(c, -x0, -y0);
    return (STENCILS[url] = out);
  }

  /* ---------------------------------------------------- the ink and mark */

  var LOGO = null;
  function logoPath() {
    if (LOGO !== null) return LOGO;
    var src = (w.DK && w.DK.diceLogo) || w.DK_DICE_LOGO;
    LOGO = false;
    try {
      if (src && src.d && w.Path2D) {
        var vb = String(src.viewBox || '0 0 4075 4109').split(/\s+/).map(Number);
        LOGO = { path: new w.Path2D(src.d), w: vb[2], h: vb[3] };
      }
    } catch (e) { LOGO = false; }
    return LOGO;
  }

  var FACE_FONT = '"Morion", Georgia, "Times New Roman", serif';
  var fontReady = null;
  /** Morion, before the first face is painted: a face drawn in the fallback
   *  would be cached in it for the session. */
  function fonts() {
    if (fontReady) return fontReady;
    try {
      fontReady = d.fonts && d.fonts.load
        ? Promise.race([d.fonts.load('600 64px "Morion"'), new Promise(function (r) { setTimeout(r, 1500); })]).catch(function () {})
        : Promise.resolve();
    } catch (e) { fontReady = Promise.resolve(); }
    return fontReady;
  }

  /** Foil ink: a gradient down the label's height, or a flat colour. */
  function inkFill(g, ink, y0, y1) {
    if (!Array.isArray(ink)) return ink || '#ffffff';
    if (ink.length === 1) return ink[0];
    var gr = g.createLinearGradient(0, y0, 0, y1);
    ink.forEach(function (c, i) { gr.addColorStop(i / (ink.length - 1), c); });
    return gr;
  }

  /** The glyph itself, filled with whatever the context holds: a number,
   *  or the Drakonym mark on the highest face. A lone 6 or 9 is underlined
   *  so it cannot be read upside down. */
  function glyph(c, label, cx, cy, h, mark, family) {
    if (typeof label === 'string' && label.indexOf('pips:') === 0) {
      // a d6 face as pips (a look's pips): 'star', the four-point star the site uses for bullet
      // points, or 'diamond'
      var parts = label.split(':'), star = parts[1] === 'star', n = +parts[2], at = PIP_AT[n] || [];
      var q = h * 0.52, r = h * (star ? 0.27 : 0.2), w = r * 0.3;
      at.forEach(function (p) {
        var x = cx + ((p - 1) % 3 - 1) * q, y = cy + (Math.floor((p - 1) / 3) - 1) * q;
        c.beginPath();
        if (star) {
          c.moveTo(x, y - r); c.lineTo(x + w, y - w); c.lineTo(x + r, y); c.lineTo(x + w, y + w);
          c.lineTo(x, y + r); c.lineTo(x - w, y + w); c.lineTo(x - r, y); c.lineTo(x - w, y - w);
        } else { c.moveTo(x, y - r); c.lineTo(x + r, y); c.lineTo(x, y + r); c.lineTo(x - r, y); }
        c.closePath(); c.fill();
      });
      return;
    }
    if (label === 'logo' && mark) {
      // the set's own mark: its shape filled with whatever the context holds,
      // in the context's own blend
      var ms = h * 1.45, mk = ms / Math.max(mark.width, mark.height);
      var t2 = d.createElement('canvas'); t2.width = c.canvas.width; t2.height = c.canvas.height;
      var tc = t2.getContext('2d');
      tc.drawImage(mark, cx - mark.width * mk / 2, cy - mark.height * mk / 2, mark.width * mk, mark.height * mk);
      tc.globalCompositeOperation = 'source-in';
      tc.fillStyle = c.fillStyle;
      tc.fillRect(0, 0, t2.width, t2.height);
      c.drawImage(t2, 0, 0);
      return;
    }
    if (label === 'logo' && logoPath()) {
      var L = logoPath(), size = h * 1.45, k = size / Math.max(L.w, L.h);
      c.save();
      c.translate(cx - L.w * k / 2, cy - L.h * k / 2);
      c.scale(k, k);
      c.fill(L.path);
      c.restore();
      return;
    }
    var text = label === 'logo' ? '' : String(label);
    c.font = '600 ' + Math.round(h / 0.7) + 'px ' + (family ? '"' + family + '", ' : '') + FACE_FONT;
    c.textAlign = 'center';
    c.textBaseline = 'alphabetic';
    // figures sit on the baseline with a cap height of about 0.7em
    var base = cy + h / 2;
    c.fillText(text, cx, base);
    if (text === '6' || text === '9') c.fillRect(cx - h * 0.25, base + h * 0.13, h * 0.5, Math.max(2, h * 0.085));
  }

  /** A look's engraving round the number, in the ink: two fine rings with
   *  a band of small runes between them, hairline rays fanning out to the
   *  face's edge, and a four-point star at the top, like the linework of
   *  the Midnight Court's tarot. */
  var RUNES = null;
  function hairline(g, c, rin, ink, k) {
    var R = rin * 0.86, r2 = rin * 0.7, mid = (R + r2) / 2, gs = (R - r2) * 0.3;
    if (!RUNES) {
      var rnd = rng(0x7a4c31);
      RUNES = [];
      for (var n = 0; n < 16; n++) RUNES.push(Math.floor(rnd() * 6));
    }
    g.save();
    g.strokeStyle = g.fillStyle = inkFill(g, ink, c - R, c + R);
    g.lineCap = 'round'; g.lineJoin = 'round';
    g.lineWidth = Math.max(1, 1.5 * k);
    g.beginPath(); g.arc(c, c, R, 0, Math.PI * 2); g.stroke();
    g.lineWidth = Math.max(0.6, 0.9 * k);
    g.beginPath(); g.arc(c, c, r2, 0, Math.PI * 2); g.stroke();
    // the rays, alternately long and short
    g.lineWidth = Math.max(0.5, 0.7 * k);
    for (var t = 0; t < 40; t++) {
      var a0 = t / 40 * Math.PI * 2;
      if (Math.abs(Math.sin(a0 / 2)) < 0.06) continue;           // leave room for the star
      var len = rin * (t % 2 ? 0.05 : 0.1);
      g.beginPath();
      g.moveTo(c + Math.cos(a0 - Math.PI / 2) * (R + 2 * k), c + Math.sin(a0 - Math.PI / 2) * (R + 2 * k));
      g.lineTo(c + Math.cos(a0 - Math.PI / 2) * (R + 2 * k + len), c + Math.sin(a0 - Math.PI / 2) * (R + 2 * k + len));
      g.stroke();
    }
    // the rune band
    g.lineWidth = Math.max(0.6, 0.85 * k);
    RUNES.forEach(function (kind, i) {
      var ang = (i + 0.5) / RUNES.length * Math.PI * 2 - Math.PI / 2;
      g.save();
      g.translate(c + Math.cos(ang) * mid, c + Math.sin(ang) * mid);
      g.rotate(ang + Math.PI / 2);
      g.beginPath();
      switch (kind) {
        case 0: g.moveTo(0, -gs); g.lineTo(0, gs); g.moveTo(-gs * 0.6, -gs * 0.3); g.lineTo(gs * 0.6, -gs * 0.3); break;
        case 1: g.moveTo(0, -gs); g.lineTo(gs * 0.75, gs * 0.7); g.lineTo(-gs * 0.75, gs * 0.7); g.closePath(); break;
        case 2: g.arc(0, 0, gs * 0.55, 0, Math.PI * 2); break;
        case 3: g.moveTo(-gs * 0.6, -gs); g.lineTo(gs * 0.5, 0); g.lineTo(-gs * 0.6, gs); break;
        case 4: g.moveTo(-gs * 0.35, -gs); g.lineTo(-gs * 0.35, gs); g.moveTo(gs * 0.35, -gs); g.lineTo(gs * 0.35, gs); break;
        default: g.arc(0, gs * 0.2, gs * 0.65, Math.PI, 0); g.moveTo(0, -gs * 0.45); g.lineTo(0, gs);
      }
      g.stroke();
      g.restore();
    });
    // a four-point star at the top of the ring
    var sy = c - R, q = 5.5 * k;
    g.beginPath();
    g.moveTo(c, sy - q); g.quadraticCurveTo(c, sy, c + q * 0.45, sy);
    g.quadraticCurveTo(c, sy, c, sy + q); g.quadraticCurveTo(c, sy, c - q * 0.45, sy);
    g.quadraticCurveTo(c, sy, c, sy - q); g.fill();
    g.restore();
  }

  /** One label, cut into the face and filled: no keyline, just the ink,
   *  shaded along its upper edges and caught by the light along its lower
   *  ones, so it reads as engraved rather than printed on. */
  function drawLabel(g, label, cx, cy, h, ink, outline, mark, family) {
    var box = Math.ceil(h * 2.4), m = box / 2, off = Math.max(1, h * 0.055);
    var a = d.createElement('canvas'), s = d.createElement('canvas');
    a.width = a.height = s.width = s.height = box;
    var ca = a.getContext('2d'), cs = s.getContext('2d');
    ca.fillStyle = inkFill(ca, ink, m - h / 2, m + h / 2);
    glyph(ca, label, m, m, h, mark, family);
    function edge(colour, dx, alpha) {
      cs.globalCompositeOperation = 'source-over';
      cs.clearRect(0, 0, box, box);
      cs.fillStyle = colour;
      glyph(cs, label, m, m, h, mark, family);
      cs.globalCompositeOperation = 'destination-out';
      glyph(cs, label, m + dx, m + dx, h, mark, family);
      ca.save();
      ca.globalCompositeOperation = 'source-atop';
      ca.globalAlpha = alpha;
      ca.drawImage(s, 0, 0);
      ca.restore();
    }
    edge('#000000', off, 0.45);
    edge('#ffffff', -off * 0.8, 0.3);
    g.drawImage(a, cx - m, cy - m);
  }

  /* ------------------------------------------------------------ the faces */

  var S = 256;                       // a face texture is S by S
  var canvases = {};

  function faceKey(look, spec) {
    return (look.material === 'resin' ? 'ink|' + inkKey(look.ink) + '|' + look.outline + (look.ring ? '|ring' : '') + (look.mark ? '|m' + look.mark : '') + (look.pips ? '|p' + look.pips : '') + (look.fontFile ? '|ff' + look.fontFile : '') : look.key) +
      '|' + (spec.faceKey || spec.key) + '@' + (spec.size || S);
  }

  /** The face of one die. A resin die's face canvas holds only its ink (the
   *  resin under it is drawn by the shader); any other material paints its
   *  colour too. For a d4, three labels sit at the corners, each turned to
   *  read with its corner uppermost. */
  function faceCanvas(look, spec) {
    var size = spec.size || S, k = size / S;
    var key = faceKey(look, spec);
    if (canvases[key]) return canvases[key];
    var cv = d.createElement('canvas');
    cv.width = cv.height = size;
    var g = cv.getContext('2d');
    var resin = look.material === 'resin';
    if (!resin) {
      g.fillStyle = look.colour;
      g.fillRect(0, 0, size, size);
      // the face's edges fall into shade along its own outline, so every
      // solid reads as one: two soft bands stroked round the polygon, the
      // outer half of each lying off the face and unseen
      if (spec.poly && spec.poly.length) {
        g.beginPath();
        spec.poly.forEach(function (p, i) {
          var x = p[0] * size, y = (1 - p[1]) * size;
          if (i) g.lineTo(x, y); else g.moveTo(x, y);
        });
        g.closePath();
        g.lineJoin = 'round';
        var band = Math.max(4, (spec.rin || 0.5) * size * 0.34);
        g.strokeStyle = 'rgba(0,0,0,0.22)'; g.lineWidth = band; g.stroke();
        g.strokeStyle = 'rgba(0,0,0,0.28)'; g.lineWidth = band * 0.45; g.stroke();
      } else {
        var mid = size / 2;
        var vg = g.createRadialGradient(mid, mid, mid * 0.6, mid, mid, mid * 1.08);
        vg.addColorStop(0, 'rgba(0,0,0,0)');
        vg.addColorStop(1, 'rgba(0,0,0,0.45)');
        g.fillStyle = vg;
        g.fillRect(0, 0, size, size);
      }
    }
    var c = size / 2;
    if (spec.corners) {
      spec.corners.forEach(function (cn) {
        g.save();
        g.translate(cn.x * k, cn.y * k);
        g.rotate(cn.turn);
        drawLabel(g, cn.label, 0, 0, cn.px * k, look.ink, look.outline, look.mark ? stencil(look.mark) : null, fontOf(look));
        g.restore();
      });
    } else if (spec.label != null) {
      if (look.ring && spec.rin) hairline(g, c, spec.rin * size / 2, look.ink, k);
      drawLabel(g, spec.label, c, c + (spec.drop || 0) * k, spec.px * k, look.ink, look.outline, look.mark ? stencil(look.mark) : null, fontOf(look));
    }
    canvases[key] = cv;
    return cv;
  }

  /* ----------------------------------------------------------- the solids */

  var shapes = null;

  function v3(a) { return new THREE.Vector3(a[0], a[1], a[2]); }

  /** A face's corners in order round its centre, so a fan draws it. */
  function ring(V, face) {
    var c = new THREE.Vector3();
    face.forEach(function (i) { c.add(v3(V[i])); });
    c.multiplyScalar(1 / face.length);
    var n = c.clone().normalize();
    var ax = v3(V[face[0]]).sub(c).normalize();
    var ay = new THREE.Vector3().crossVectors(n, ax).normalize();
    return face.slice().sort(function (i, j) {
      var pi = v3(V[i]).sub(c), pj = v3(V[j]).sub(c);
      return Math.atan2(pi.dot(ay), pi.dot(ax)) - Math.atan2(pj.dot(ay), pj.dot(ax));
    });
  }

  /** Every face wound counter-clockwise seen from outside. */
  function orient(V, F) {
    return F.map(function (face) {
      var f = ring(V, face);
      var a = v3(V[f[0]]), b = v3(V[f[1]]), c = v3(V[f[2]]);
      var n = new THREE.Vector3().crossVectors(b.clone().sub(a), c.clone().sub(a));
      var cen = new THREE.Vector3();
      f.forEach(function (i) { cen.add(v3(V[i])); });
      return n.dot(cen) < 0 ? f.slice().reverse() : f;
    });
  }

  /** All the triangles of vertices a set edge-length apart: the faces of the
   *  tetrahedron, octahedron and icosahedron. */
  function trianglesBy(V, edge) {
    var out = [];
    for (var i = 0; i < V.length; i++) for (var j = i + 1; j < V.length; j++) for (var k = j + 1; k < V.length; k++) {
      if (Math.abs(v3(V[i]).distanceTo(v3(V[j])) - edge) < 1e-6 &&
          Math.abs(v3(V[j]).distanceTo(v3(V[k])) - edge) < 1e-6 &&
          Math.abs(v3(V[i]).distanceTo(v3(V[k])) - edge) < 1e-6) out.push([i, j, k]);
    }
    return out;
  }

  /* ------------------------------------------------------------ the wrap */

  /** A die laid out flat, the way a box is cut from card: every face on one
   *  sheet, each joined to the face it folds from along their shared edge.
   *  An artist paints the sheet (the die's wrap template) and the wrap lays
   *  it back over the die, its rounded edges and corners included, so a
   *  design runs on across every fold. Worked out from the solid itself, the
   *  same way every time, so a template made today still fits.
   *
   *  `V` are the corners, `F` the faces wound counter-clockwise seen from
   *  outside. Returns the
   *  sheet's size (w by h, in the die's own units), each face's outline on
   *  it, which edges fold and which are cut, and `uv(fi, p)`: where a point
   *  on face fi's plane lies on the sheet, 0..1 each way, v running up. */
  function unfold(V, F) {
    function sub(a, b) { return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]; }
    function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
    function cross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
    function unit(a) { var l = Math.sqrt(dot(a, a)) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
    var nF = F.length;
    var cen = F.map(function (f) {
      var c = [0, 0, 0];
      f.forEach(function (i) { c[0] += V[i][0]; c[1] += V[i][1]; c[2] += V[i][2]; });
      return [c[0] / f.length, c[1] / f.length, c[2] / f.length];
    });
    var nrm = F.map(function (f) { return unit(cross(sub(V[f[1]], V[f[0]]), sub(V[f[2]], V[f[0]]))); });
    // each face's neighbours, in its own winding: across edge a->b lies face g
    var owner = {};
    F.forEach(function (f, fi) { f.forEach(function (a, j) { owner[a + '>' + f[(j + 1) % f.length]] = fi; }); });
    var adj = F.map(function (f) {
      return f.map(function (a, j) { var b = f[(j + 1) % f.length]; return { g: owner[b + '>' + a], a: a, b: b }; });
    });

    /** Lay the faces out along a tree: the root as it faces the viewer, each
     *  child turned flat about the edge it shares with its parent. */
    function lay(root, order, turn) {
      var at = new Array(nF), parent = new Array(nF), seen = {};
      var rx = unit(sub(V[F[root][1]], V[F[root][0]]));
      at[root] = { c: cen[root], ex: rx, ey: cross(nrm[root], rx), o: [0, 0], X: [1, 0], Y: [0, 1] };
      parent[root] = -1; seen[root] = 1;
      var list = [root];
      function place(A, e) {
        var B = e.g, a = V[e.a], b = V[e.b];
        var Pa = to2(at[A], a), Pb = to2(at[A], b);
        var ex = unit(sub(b, a)), ey = cross(nrm[B], ex);
        var dx = Pb[0] - Pa[0], dy = Pb[1] - Pa[1], l = Math.hypot(dx, dy);
        var X = [dx / l, dy / l], Y = [-dy / l, dx / l];
        var q = sub(a, cen[B]), u = dot(q, ex), w = dot(q, ey);
        at[B] = { c: cen[B], ex: ex, ey: ey, X: X, Y: Y, o: [Pa[0] - u * X[0] - w * Y[0], Pa[1] - u * X[1] - w * Y[1]] };
      }
      function kids(A) {
        var n = adj[A].length, out = [];
        for (var k = 0; k < n; k++) out.push(adj[A][(k + turn) % n]);
        return out;
      }
      if (order === 'bfs') {
        for (var h = 0; h < list.length; h++) {
          kids(list[h]).forEach(function (e) {
            if (seen[e.g]) return;
            seen[e.g] = 1; parent[e.g] = list[h]; place(list[h], e); list.push(e.g);
          });
        }
      } else {
        (function walk(A) {
          kids(A).forEach(function (e) {
            if (seen[e.g]) return;
            seen[e.g] = 1; parent[e.g] = A; place(A, e); walk(e.g);
          });
        })(root);
      }
      return { at: at, parent: parent };
    }
    function to2(t, p) {
      var q = sub(p, t.c), u = dot(q, t.ex), w = dot(q, t.ey);
      return [t.o[0] + u * t.X[0] + w * t.Y[0], t.o[1] + u * t.X[1] + w * t.Y[1]];
    }
    function polys(at) { return F.map(function (f, fi) { return f.map(function (i) { return to2(at[fi], V[i]); }); }); }

    /** Two convex outlines overlap only if no edge of either separates them;
     *  outlines that merely touch (a shared edge or corner) do not. */
    function overlap(P, Q, eps) {
      var all = [P, Q];
      for (var s = 0; s < 2; s++) {
        var R = all[s];
        for (var i = 0; i < R.length; i++) {
          var a = R[i], b = R[(i + 1) % R.length], nx = b[1] - a[1], ny = a[0] - b[0];
          var l = Math.hypot(nx, ny); nx /= l; ny /= l;
          var p0 = Infinity, p1 = -Infinity, q0 = Infinity, q1 = -Infinity;
          P.forEach(function (p) { var d = p[0] * nx + p[1] * ny; p0 = Math.min(p0, d); p1 = Math.max(p1, d); });
          Q.forEach(function (p) { var d = p[0] * nx + p[1] * ny; q0 = Math.min(q0, d); q1 = Math.max(q1, d); });
          if (p1 <= q0 + eps || q1 <= p0 + eps) return false;
        }
      }
      return true;
    }

    /** The turn of the sheet that boxes it tightest, lying wide. */
    function boxed(P) {
      var best = null;
      P.forEach(function (poly) {
        poly.forEach(function (a, i) {
          var b = poly[(i + 1) % poly.length], ang = Math.atan2(b[1] - a[1], b[0] - a[0]);
          var c = Math.cos(-ang), s = Math.sin(-ang), x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
          P.forEach(function (pp) { pp.forEach(function (p) {
            var x = p[0] * c - p[1] * s, y = p[0] * s + p[1] * c;
            x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y);
          }); });
          var area = (x1 - x0) * (y1 - y0);
          if (!best || area < best.area - 1e-9) best = { area: area, ang: ang, w: x1 - x0, h: y1 - y0 };
        });
      });
      // lie the sheet wide
      if (best.h > best.w + 1e-9) { best.ang += Math.PI / 2; var t = best.w; best.w = best.h; best.h = t; }
      return best;
    }

    var chosen = null, size = Math.sqrt(dot(sub(V[F[0][0]], V[F[0][1]]), sub(V[F[0][0]], V[F[0][1]])));
    var turns = Math.max.apply(null, F.map(function (f) { return f.length; }));
    for (var root = 0; root < nF; root++) {
      ['bfs', 'dfs'].forEach(function (order) {
        for (var turn = 0; turn < turns; turn++) {
          var t = lay(root, order, turn), P = polys(t.at), ok = true;
          for (var i = 0; i < nF && ok; i++) for (var j = i + 1; j < nF && ok; j++) if (overlap(P[i], P[j], size * 1e-6)) ok = false;
          if (!ok) continue;
          // the fewest steps out from the middle face, so the design spreads from
          // one face across its neighbours like a flower; then the tightest sheet
          var depth = 0, b = boxed(P);
          for (var f = 0; f < nF; f++) { var dd = 0, g = f; while (t.parent[g] >= 0) { g = t.parent[g]; dd++; } depth = Math.max(depth, dd); }
          if (!chosen || depth < chosen.depth || (depth === chosen.depth && b.area < chosen.box.area - 1e-9)) chosen = { tree: t, box: b, depth: depth };
        }
      });
    }

    // the sheet: the net turned to lie wide, with a margin round it for bleed
    var at = chosen.tree.at, box = chosen.box, c = Math.cos(-box.ang), s = Math.sin(-box.ang);
    var turned = function (p) { return [p[0] * c - p[1] * s, p[0] * s + p[1] * c]; };
    var x0 = Infinity, y0 = Infinity;
    polys(at).forEach(function (poly) { poly.forEach(function (p) { var q = turned(p); x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); }); });
    var m = Math.max(box.w, box.h) * 0.04, W = box.w + 2 * m, H = box.h + 2 * m;
    function uv(fi, p) {
      var q = turned(to2(at[fi], p));
      return [(q[0] - x0 + m) / W, (q[1] - y0 + m) / H];
    }
    var parent = chosen.tree.parent;
    return {
      w: W, h: H, parent: parent,
      faces: F.map(function (f, fi) {
        return {
          outline: f.map(function (i) { return uv(fi, V[i]); }),
          centre: uv(fi, cen[fi]),
          // each edge of the face, in its winding: folded to its neighbour, or cut
          edges: adj[fi].map(function (e) { return { to: e.g, fold: parent[e.g] === fi || parent[fi] === e.g }; })
        };
      }),
      uv: uv
    };
  }

  /** One solid: its mesh geometry with a material group per face, the face
   *  normals and frames the labels are laid in, and the hull for the physics.
   *  `frame` says which way is up on a face: toward the apex of a triangle or
   *  a kite, toward a point of a pentagon.
   *
   *  The mesh is the hull with its edges and corners rounded off, the way a
   *  real die is tumbled: each face is drawn a little inside its outline, a
   *  strip joins neighbouring faces along every edge and a small cap closes
   *  every corner. The strip and cap take their normals from the faces they
   *  join, so the light rolls over them. The physics keeps the sharp hull,
   *  whose faces lie in the same planes, so a die rests exactly as before. */
  function solid(kind, V, F, radius, frame, opts) {
    opts = opts || {};
    var scale = radius / Math.max.apply(null, V.map(function (p) { return v3(p).length(); }));
    V = V.map(function (p) { return [p[0] * scale, p[1] * scale, p[2] * scale]; });
    F = orient(V, F);
    var normals = [], frames = [], info = [], faces = [];
    // the die laid flat for a wrap, worked out the first time a set asks for one
    var flat = null, wrapGeo = {};
    function wrapNet() { return flat || (flat = unfold(V, F)); }

    F.forEach(function (face, fi) {
      var pts = face.map(function (i) { return v3(V[i]); });
      var centre = new THREE.Vector3();
      pts.forEach(function (p) { centre.add(p); });
      centre.multiplyScalar(1 / pts.length);
      var n = new THREE.Vector3().crossVectors(pts[1].clone().sub(pts[0]), pts[2].clone().sub(pts[0])).normalize();
      if (n.dot(centre) < 0) n.negate();
      var fr = frame(pts, centre, n);
      var R = 0;
      pts.forEach(function (p) { R = Math.max(R, p.distanceTo(centre)); });
      // the inradius: how far the centre is from the nearest edge
      var rin = Infinity;
      for (var i = 0; i < pts.length; i++) {
        var a = pts[i], b = pts[(i + 1) % pts.length];
        var ab = b.clone().sub(a), t = centre.clone().sub(a).dot(ab) / ab.lengthSq();
        rin = Math.min(rin, centre.distanceTo(a.clone().add(ab.multiplyScalar(t))));
      }
      normals.push(n);
      frames.push({ ax: fr.ax, ay: fr.ay, R: R, rin: rin, centre: centre,
                    corners: pts.map(function (p) {
                      var q = p.clone().sub(centre);
                      return [0.5 + q.dot(fr.ax) / (2 * R), 0.5 + q.dot(fr.ay) / (2 * R)];
                    }) });
      info.push({ centre: centre, n: n, ax: fr.ax, ay: fr.ay, R: R });
      faces.push({ pts: pts, centre: centre, n: n, rin: rin });
    });

    /* The mesh, in one of two cuts.
       Rounded (the usual): each face is drawn a little inside its outline, a
       strip joins neighbouring faces along every edge and a small cap closes
       every corner; strip and cap take their normals from the faces they
       join, so the light rolls over them.
       Star (a gem cut): a deeper cut, every strip and corner facet flat, and
       each corner rising back to its sharp point, so a star of facets
       radiates from every corner and each facet flashes on its own.
       Either way the faces lie in the hull's planes, so the physics, which
       keeps the sharp hull, rests the die exactly as before. */
    function build(bevelFrac, star, wrap) {
      var bevel = radius * bevelFrac;
      // cut for a wrap: every point also gets its place on the flat sheet
      var net = wrap ? wrapNet() : null;
      function nuv(fi, p) { return net.uv(fi, [p.x, p.y, p.z]); }
      var inset = {}, edgeFace = {};
      // one group per face, and one more (EDGE) for the edges and corners,
      // so a strip is never split between two faces' materials
      var EDGE = F.length;
      var tris = F.map(function () { return []; }).concat([[]]);

      /** A triangle in a group, its texture laid from face uf, wound to face
       *  outward; with no normals given it is flat. */
      function tri(group, uf, p, nn, nu) {
        var e = new THREE.Vector3().crossVectors(p[1].clone().sub(p[0]), p[2].clone().sub(p[0]));
        var mid = p[0].clone().add(p[1]).add(p[2]);
        if (e.dot(mid) < 0) { p = [p[0], p[2], p[1]]; if (nn) nn = [nn[0], nn[2], nn[1]]; if (nu) nu = [nu[0], nu[2], nu[1]]; e.negate(); }
        if (!nn) { var fn = e.normalize(); nn = [fn, fn, fn]; }
        tris[group].push({ p: p, n: nn, uf: uf, nu: nu });
      }

      F.forEach(function (face, fi) {
        var fd = faces[fi], k = Math.min(0.4, bevel / fd.rin);
        face.forEach(function (vi, j) {
          inset[fi + ':' + vi] = fd.pts[j].clone().lerp(fd.centre, k);
          edgeFace[vi + '>' + face[(j + 1) % face.length]] = fi;
        });
        for (var m = 0; m < face.length; m++) {
          var I0 = inset[fi + ':' + face[m]], I1 = inset[fi + ':' + face[(m + 1) % face.length]];
          tri(fi, fi, [fd.centre, I0, I1], [fd.n, fd.n, fd.n], net && [nuv(fi, fd.centre), nuv(fi, I0), nuv(fi, I1)]);
        }
      });

      // the strips along the edges, each drawn once
      F.forEach(function (face, fi) {
        face.forEach(function (a, j) {
          var b = face[(j + 1) % face.length], gi = edgeFace[b + '>' + a];
          if (gi === undefined || gi < fi) return;
          var A1 = inset[fi + ':' + a], A2 = inset[fi + ':' + b], B1 = inset[gi + ':' + a], B2 = inset[gi + ':' + b];
          var nA = normals[fi], nB = normals[gi];
          if (net) {
            // halved along the edge itself: each half carries its own face's
            // art out to the edge, so the design runs on wherever the sheet folds
            var E1 = A1.clone().add(B1).multiplyScalar(0.5), E2 = A2.clone().add(B2).multiplyScalar(0.5);
            var nE = nA.clone().add(nB).normalize(), ea = v3(V[a]), eb = v3(V[b]);
            tri(EDGE, fi, [A1, A2, E2], star ? null : [nA, nA, nE], [nuv(fi, A1), nuv(fi, A2), nuv(fi, eb)]);
            tri(EDGE, fi, [A1, E2, E1], star ? null : [nA, nE, nE], [nuv(fi, A1), nuv(fi, eb), nuv(fi, ea)]);
            tri(EDGE, gi, [E1, E2, B2], star ? null : [nE, nE, nB], [nuv(gi, ea), nuv(gi, eb), nuv(gi, B2)]);
            tri(EDGE, gi, [E1, B2, B1], star ? null : [nE, nB, nB], [nuv(gi, ea), nuv(gi, B2), nuv(gi, B1)]);
            return;
          }
          tri(EDGE, fi, [A1, A2, B2], star ? null : [nA, nA, nB]);
          tri(EDGE, fi, [A1, B2, B1], star ? null : [nA, nB, nB]);
        });
      });

      // the corners
      V.forEach(function (v, vi) {
        var round = [];
        F.forEach(function (face, fi) { if (face.indexOf(vi) >= 0) round.push(fi); });
        if (round.length < 3) return;
        var dir = v3(v).normalize();
        var ex = new THREE.Vector3(1, 0, 0);
        if (Math.abs(dir.dot(ex)) > 0.9) ex.set(0, 1, 0);
        var ux = new THREE.Vector3().crossVectors(dir, ex).normalize(), uy = new THREE.Vector3().crossVectors(dir, ux);
        var ring = round.map(function (fi) { return { fi: fi, p: inset[fi + ':' + vi] }; });
        ring.sort(function (s, t) {
          var ps = s.p.clone().sub(v3(v)), pt = t.p.clone().sub(v3(v));
          return Math.atan2(ps.dot(uy), ps.dot(ux)) - Math.atan2(pt.dot(uy), pt.dot(ux));
        });
        var hub;
        if (star) {
          // the corner rises back toward its point, most of the way
          hub = v3(v).multiplyScalar(0.985);
        } else {
          hub = new THREE.Vector3();
          ring.forEach(function (r) { hub.add(r.p); });
          hub.multiplyScalar(1 / ring.length);
        }
        ring.forEach(function (r, j) {
          var q = ring[(j + 1) % ring.length];
          if (net) {
            // halved between its two faces, the corner's own point on both
            var Em = r.p.clone().add(q.p).multiplyScalar(0.5), nM = normals[r.fi].clone().add(normals[q.fi]).normalize(), vv = v3(v);
            tri(EDGE, r.fi, [hub, r.p, Em], star ? null : [dir, normals[r.fi], nM], [nuv(r.fi, vv), nuv(r.fi, r.p), nuv(r.fi, vv)]);
            tri(EDGE, q.fi, [hub, Em, q.p], star ? null : [dir, nM, normals[q.fi]], [nuv(q.fi, vv), nuv(q.fi, vv), nuv(q.fi, q.p)]);
            return;
          }
          tri(EDGE, r.fi, [hub, r.p, q.p], star ? null : [dir, normals[r.fi], normals[q.fi]]);
        });
      });

      var pos = [], nrm = [], uv = [], nets = [], groups = [], idx = 0;
      tris.forEach(function (list, gi) {
        var start = idx;
        list.forEach(function (t) {
          var f = info[t.uf];
          t.p.forEach(function (p, j) {
            pos.push(p.x, p.y, p.z);
            nrm.push(t.n[j].x, t.n[j].y, t.n[j].z);
            var q = p.clone().sub(f.centre);
            uv.push(0.5 + q.dot(f.ax) / (2 * f.R), 0.5 + q.dot(f.ay) / (2 * f.R));
            if (net) nets.push(t.nu[j][0], t.nu[j][1]);
            idx++;
          });
        });
        groups.push({ start: start, count: idx - start, materialIndex: gi });
      });
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      geo.setAttribute('normal', new THREE.Float32BufferAttribute(nrm, 3));
      geo.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
      if (net) geo.setAttribute('netUv', new THREE.Float32BufferAttribute(nets, 2));
      groups.forEach(function (g) { geo.addGroup(g.start, g.count, g.materialIndex); });
      return geo;
    }

    var starGeo = null;
    return {
      kind: kind, sides: F.length, geometry: build(opts.bevel == null ? 0.06 : opts.bevel, false),
      /** the star cut, built the first time a set asks for it */
      starGeometry: function () { return starGeo || (starGeo = build(0.13, true)); },
      /** the same cuts made for a wrap, built the first time a set asks */
      wrapGeometry: function (starCut) {
        var k = starCut ? 'star' : 'round';
        return wrapGeo[k] || (wrapGeo[k] = starCut ? build(0.13, true, true) : build(opts.bevel == null ? 0.06 : opts.bevel, false, true));
      },
      /** the die laid flat: the wrap template's sheet */
      wrap: wrapNet,
      normals: normals, frames: frames,
      V: V, F: F, hull: { V: V, F: F }, byVertex: !!opts.byVertex, glyph: opts.glyph || 1,
      opposite: null
    };
  }

  /** A die's mesh for a look: the star cut where the look asks for it. */
  function meshGeometry(shape, look) {
    var own = look && kindLook(look, shape);
    if (own && own.wrap) return shape.wrapGeometry(look.cut === 'star');
    return look && look.cut === 'star' ? shape.starGeometry() : shape.geometry;
  }

  /** The frame of a triangle or kite: up runs from the base edge to the apex,
   *  which is the corner furthest from the centre for a kite and, for a
   *  triangle, the last corner. */
  function apexFrame(pts, centre, n) {
    var apex = pts[0], far = -1;
    pts.forEach(function (p) { var dd = p.distanceTo(centre); if (dd > far + 1e-6) { far = dd; apex = p; } });
    if (pts.length === 3) apex = pts[2];
    var ay = apex.clone().sub(centre).normalize();
    var ax = new THREE.Vector3().crossVectors(ay, n).normalize();
    return { ax: ax, ay: ay };
  }

  /** The frame of a pentagon or square: up points at a corner. */
  function nearFrame(pts, centre, n) {
    var near = pts[0], best = Infinity;
    pts.forEach(function (p) { var dd = p.distanceTo(centre); if (dd < best - 1e-6) { best = dd; near = p; } });
    var ay = near.clone().sub(centre).normalize();
    var ax = new THREE.Vector3().crossVectors(ay, n).normalize();
    return { ax: ax, ay: ay };
  }

  function pointFrame(pts, centre, n) {
    var ay = pts[0].clone().sub(centre).normalize();
    var ax = new THREE.Vector3().crossVectors(ay, n).normalize();
    return { ax: ax, ay: ay };
  }

  /** The frame of a square: up runs along an edge. */
  function edgeFrame(pts, centre, n) {
    var ay = pts[1].clone().add(pts[0]).multiplyScalar(0.5).sub(centre).normalize();
    var ax = new THREE.Vector3().crossVectors(ay, n).normalize();
    return { ax: ax, ay: ay };
  }

  function buildShapes() {
    if (shapes) return shapes;
    var p = (1 + Math.sqrt(5)) / 2, q = 1 / p;

    var tetra = [[1, 1, 1], [-1, -1, 1], [-1, 1, -1], [1, -1, -1]];
    var cube = [];
    [-1, 1].forEach(function (x) { [-1, 1].forEach(function (y) { [-1, 1].forEach(function (z) { cube.push([x, y, z]); }); }); });
    var cubeF = [];
    [0, 1, 2].forEach(function (axis) {
      [-1, 1].forEach(function (sign) {
        var f = [];
        cube.forEach(function (v, i) { if (v[axis] === sign) f.push(i); });
        cubeF.push(f);
      });
    });
    var octa = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
    var ico = [
      [0, 1, p], [0, 1, -p], [0, -1, p], [0, -1, -p],
      [1, p, 0], [1, -p, 0], [-1, p, 0], [-1, -p, 0],
      [p, 0, 1], [p, 0, -1], [-p, 0, 1], [-p, 0, -1]
    ];
    var dode = [
      [1, 1, 1], [1, 1, -1], [1, -1, 1], [1, -1, -1],
      [-1, 1, 1], [-1, 1, -1], [-1, -1, 1], [-1, -1, -1],
      [0, q, p], [0, q, -p], [0, -q, p], [0, -q, -p],
      [q, p, 0], [q, -p, 0], [-q, p, 0], [-q, -p, 0],
      [p, 0, q], [-p, 0, q], [p, 0, -q], [-p, 0, -q]
    ];
    var dodeF = [
      [0, 8, 10, 2, 16], [0, 16, 18, 1, 12], [0, 12, 14, 4, 8],
      [8, 4, 17, 6, 10], [16, 2, 13, 3, 18], [12, 1, 9, 5, 14],
      [7, 11, 3, 13, 15], [7, 15, 6, 17, 19], [7, 19, 5, 9, 11],
      [11, 9, 1, 18, 3], [15, 13, 2, 10, 6], [19, 17, 4, 14, 5]
    ];
    // the pentagonal trapezohedron: ten kites round a zigzag ring, each flat
    // because the apex height answers to the ring's rise
    var e = 0.105, h = 0.994574, trap = [], trapF = [];
    for (var i = 0; i < 10; i++) {
      var a = Math.PI * i / 5;
      trap.push([Math.cos(a), i % 2 === 0 ? e : -e, Math.sin(a)]);
    }
    trap.push([0, h, 0]); trap.push([0, -h, 0]);
    for (var k = 0; k < 10; k++) trapF.push([k % 2 === 0 ? 10 : 11, k, (k + 1) % 10, (k + 2) % 10]);

    var rhomb = [];
    [-1, 1].forEach(function (x) { [-1, 1].forEach(function (y) { [-1, 1].forEach(function (z) { rhomb.push([x, y, z]); }); }); });
    [[2, 0, 0], [-2, 0, 0], [0, 2, 0], [0, -2, 0], [0, 0, 2], [0, 0, -2]].forEach(function (v) { rhomb.push(v); });
    var rhombF = [];
    [[0, 1], [0, 2], [1, 2]].forEach(function (ax) {
      [-1, 1].forEach(function (sa) {
        [-1, 1].forEach(function (sb) {
          var nrm = [0, 0, 0]; nrm[ax[0]] = sa; nrm[ax[1]] = sb;
          var f = [];
          rhomb.forEach(function (v, i) { if (Math.abs(v[0] * nrm[0] + v[1] * nrm[1] + v[2] * nrm[2] - 2) < 1e-6) f.push(i); });
          rhombF.push(f);
        });
      });
    });

    shapes = {
      d4: solid('d4', tetra, trianglesBy(tetra, Math.sqrt(8)), 0.78, apexFrame, { byVertex: true, glyph: 0.7 }),
      d6: solid('d6', cube, cubeF, 0.72, edgeFrame, { glyph: 0.95 }),
      d8: solid('d8', octa, trianglesBy(octa, Math.sqrt(2)), 0.76, apexFrame, { glyph: 1.05 }),
      d10: solid('d10', trap, trapF, 0.74, apexFrame, { glyph: 0.98 }),
      d12: solid('d12', dode, dodeF, 0.70, pointFrame, { glyph: 0.82 }),
      d12r: solid('d12r', rhomb, rhombF, 0.80, nearFrame, { glyph: 1.0 }),
      d20: solid('d20', ico, trianglesBy(ico, 2), 0.72, apexFrame, { glyph: 1.05 })
    };
    Object.keys(shapes).forEach(function (k) { shapes[k].opposite = opposites(shapes[k].normals); });
    return shapes;
  }

  function opposites(normals) {
    return normals.map(function (n) {
      var best = -2, at = -1;
      normals.forEach(function (m, j) { var dd = -n.dot(m); if (dd > best) { best = dd; at = j; } });
      return at;
    });
  }

  /* --------------------------------------------------------- the numbers */

  /** Label a die so the face that landed up carries the rolled value. A die
   *  whose faces pair off (opposites summing to one more than its sides) is
   *  dealt that way, so nothing about it looks wrong up close. `mode` is the
   *  d100's tens or units die, whose d10 reads 00..90 or 0..9. */
  function numbering(shape, upIndex, want, rand, mode) {
    var n = shape.sides, opp = shape.opposite;
    var out = new Array(n);
    var pairs = [], mate;
    if (mode) {
      // a percentile die pairs 0 with 9, 1 with 8 ... (10 stands for 0 or 00)
      pairs = [[10, 9], [1, 8], [2, 7], [3, 6], [4, 5]];
      mate = want === 10 ? 9 : want === 9 ? 10 : 9 - want;
    } else {
      for (var v = 1; v <= n / 2; v++) pairs.push([v, n + 1 - v]);
      mate = n + 1 - want;
    }
    out[upIndex] = want;
    out[opp[upIndex]] = mate;
    pairs = pairs.filter(function (pr) { return pr[0] !== want && pr[1] !== want; });
    var free = [];
    for (var i = 0; i < n; i++) if (out[i] === undefined && free.indexOf(opp[i]) < 0) free.push(i);
    // shuffle the pairs so the same value does not always sit beside the same neighbours
    for (var s = pairs.length - 1; s > 0; s--) {
      var j = Math.floor(rand() * (s + 1)), t = pairs[s]; pairs[s] = pairs[j]; pairs[j] = t;
    }
    free.forEach(function (i, k) {
      var pr = pairs[k];
      var flip = rand() < 0.5;
      out[i] = flip ? pr[1] : pr[0];
      out[opp[i]] = flip ? pr[0] : pr[1];
    });
    return out;
  }

  /** A d4 is numbered on its points: the point that stands up carries the
   *  value, and the other three take the rest. */
  function numberingD4(upVertex, want, rand) {
    var out = [0, 0, 0, 0], rest = [1, 2, 3, 4].filter(function (v) { return v !== want; });
    for (var s = rest.length - 1; s > 0; s--) {
      var j = Math.floor(rand() * (s + 1)), t = rest[s]; rest[s] = rest[j]; rest[j] = t;
    }
    out[upVertex] = want;
    var k = 0;
    for (var i = 0; i < 4; i++) if (i !== upVertex) out[i] = rest[k++];
    return out;
  }

  // where each pip sits on a 3 by 3 grid, read left to right, top to bottom
  var PIP_AT = { 1: [5], 2: [3, 7], 3: [3, 5, 7], 4: [1, 3, 7, 9], 5: [1, 3, 5, 7, 9], 6: [1, 3, 4, 6, 7, 9] };
  function labelOf(value, sides, mode) {
    if (mode === 'tens') return value === 10 ? '00' : String(value * 10);
    if (mode === 'units') return value === 10 ? '0' : String(value);
    return value === sides && MARK_ON ? 'logo' : String(value);
  }
  // The highest face carries the mark. Legends' copy of this code starts with
  // these false: its dice show numbers there unless a set brings its own mark.
  var MARK_DEFAULT = true, MARK_ON = true;

  /* ------------------------------------------------------- the materials */

  var MAT = {
    resin: { physical: true, roughness: 0.17, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.055, envMapIntensity: 0.7 },
    plastic: { roughness: 0.55, metalness: 0 },
    metal: { roughness: 0.42, metalness: 0.85 },
    glass: { roughness: 0.18, metalness: 0, envMapIntensity: 1.3 },
    wood: { roughness: 0.9, metalness: 0 },
    stone: { roughness: 0.95, metalness: 0 },
    chrome: { roughness: 0.12, metalness: 1 },
    pristine: { physical: true, roughness: 0.5, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.15 },
    iridescent: { physical: true, roughness: 0.25, metalness: 0.8, iridescence: 1, iridescenceIOR: 1.8 }
  };

  var materials = {}, faceTextures = {};

  /* ------------------------------------------------------ the resin inside */

  function hexRgb(h) {
    h = String(h || '#888888').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    return [parseInt(h.slice(0, 2), 16) || 0, parseInt(h.slice(2, 4), 16) || 0, parseInt(h.slice(4, 6), 16) || 0];
  }
  function mixc(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function scalec(a, k) { return [a[0] * k, a[1] * k, a[2] * k]; }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function smooth(e0, e1, x) { var t = clamp01((x - e0) / (e1 - e0)); return t * t * (3 - 2 * t); }
  function rgbCss(c, a) { return 'rgba(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ',' + (a == null ? 1 : a) + ')'; }

  /* Noise that wraps at the edges of the tile, since the resin is sampled
     with offsets that run off it. */
  function hash(x, y, s) {
    var h = (Math.imul(x, 374761393) + Math.imul(y, 668265263) + Math.imul(s, 1442695041)) | 0;
    h = Math.imul(h ^ (h >>> 13), 1274126177);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  }
  function vnoise(x, y, f, s) {
    var X = x * f, Y = y * f, ix = Math.floor(X), iy = Math.floor(Y), fx = X - ix, fy = Y - iy;
    var ux = fx * fx * (3 - 2 * fx), uy = fy * fy * (3 - 2 * fy);
    function v(a, b) { return hash(((a % f) + f) % f, ((b % f) + f) % f, s); }
    var a = v(ix, iy), b = v(ix + 1, iy), c = v(ix, iy + 1), e = v(ix + 1, iy + 1);
    return a + (b - a) * ux + (c - a) * uy + (a - b - c + e) * ux * uy;
  }
  function fbm(x, y, s, base, oct) {
    var t = 0, amp = 0.5, f = base || 3, norm = 0;
    for (var o = 0; o < (oct || 5); o++) { t += vnoise(x, y, f, s + o * 17) * amp; norm += amp; amp *= 0.5; f *= 2; }
    return t / norm;
  }
  /** The nearest two cell seeds of a wrapping Voronoi grid: d2 - d1 is small
   *  along the cracks between cells. */
  function voronoi(x, y, g, s) {
    var X = x * g, Y = y * g, ix = Math.floor(X), iy = Math.floor(Y), d1 = 9, d2 = 9, id = 0;
    for (var j = -1; j <= 1; j++) for (var i = -1; i <= 1; i++) {
      var cx = ix + i, cy = iy + j, wx = ((cx % g) + g) % g, wy = ((cy % g) + g) % g;
      var px = cx + 0.15 + hash(wx, wy, s) * 0.7, py = cy + 0.15 + hash(wx, wy, s + 7) * 0.7;
      var dd = Math.hypot(px - X, py - Y);
      if (dd < d1) { d2 = d1; d1 = dd; id = wx + wy * g; } else if (dd < d2) d2 = dd;
    }
    return { d1: d1, d2: d2, id: id };
  }

  /** The pattern suspended in the resin, one pixel at a time: its colour
   *  and, for the looks that shine, the light it gives off. Every pattern
   *  wraps at the tile's edges, and each face reads its own part of it. */
  function patternPixel(look, x, y, s, C) {
    var base = C.base, a1 = C.a1, a2 = C.a2, a3 = C.a3, col, glow = null;
    switch (look.pattern) {
      case 'nebula': {
        var c1 = smooth(0.42, 0.8, fbm(x + 0.1 * fbm(x, y, s + 3, 2, 3), y, s, 2, 5));
        var c2 = smooth(0.5, 0.86, fbm(x, y, s + 99, 3, 5));
        col = scalec(base, 0.8 + fbm(x, y, s + 40, 8, 3) * 0.35);
        col = mixc(col, a1, c1 * 0.7);
        col = mixc(col, a2, c2 * 0.55);
        glow = mixc(scalec(a1, c1 * 0.3), scalec(a2, c2 * 0.3), 0.5);
        break;
      }
      case 'veins': {
        // glowing threads through dark resin: the ridges of a folded noise
        var wx = x + (fbm(x, y, s + 5, 2, 3) - 0.5) * 0.25, wy = y + (fbm(x, y, s + 9, 2, 3) - 0.5) * 0.25;
        var ridge = 1 - Math.abs(2 * fbm(wx, wy, s, 2, 5) - 1);
        var ridge2 = 1 - Math.abs(2 * fbm(wx, wy, s + 31, 3, 4) - 1);
        var vein = Math.pow(ridge, 48) + Math.pow(ridge2, 80) * 0.5;
        col = scalec(base, 0.75 + fbm(x, y, s + 13, 4, 4) * 0.6);
        col = mixc(col, a1, clamp01(vein * 1.2));
        col = mixc(col, a2, clamp01(Math.pow(ridge, 90)));
        glow = mixc(scalec(a1, clamp01(vein)), scalec(a2, 1), clamp01(Math.pow(ridge, 90)));
        break;
      }
      case 'gem': {
        // deep colour, clearer in the middle, with soft streaks of light
        // bent through it
        var depth = fbm(x, y, s, 2, 4);
        var streak = Math.pow(1 - Math.abs(2 * fbm(x * 1.0, y, s + 21, 3, 3) - 1), 14);
        col = scalec(base, 0.45 + depth * 0.8);
        col = mixc(col, mixc(base, [255, 255, 255], 0.55), streak * 0.6);
        break;
      }
      case 'diamond': {
        // a brilliant cut: facets at many angles to the light, bright edges
        // between them, and a little rainbow fire in each
        var dv = voronoi(x, y, 3, s), sh = hash(dv.id, 3, s), hu = hash(dv.id, 9, s) * Math.PI * 2;
        var fire = [127 + 128 * Math.cos(hu), 127 + 128 * Math.cos(hu - 2.09), 127 + 128 * Math.cos(hu - 4.19)];
        var cut = 1 - smooth(0, 0.035, dv.d2 - dv.d1);
        col = mixc(scalec(base, 0.62 + sh * 0.45), fire, 0.06);
        col = mixc(col, [255, 255, 255], cut * 0.4);
        glow = scalec(fire, cut * 0.2);
        break;
      }
      case 'pearl': {
        var m1 = fbm(x, y, s, 2, 5), m2 = fbm(x + 0.3, y, s + 50, 3, 4);
        col = mixc(base, a1, smooth(0.35, 0.8, m1) * 0.7);
        col = mixc(col, a2, smooth(0.5, 0.9, m2) * 0.6);
        break;
      }
      case 'metal': {
        // brushed: fine grain running one way, a slow sheen across it
        var grain = vnoise(0.37, y, 96, s) * 0.6 + vnoise(0.61, y, 211, s + 3) * 0.4;
        var sheen = fbm(x, y, s + 7, 2, 3);
        col = scalec(base, 0.86 + grain * 0.14 + (sheen - 0.5) * 0.14);
        break;
      }
      default: {            // marble: two or three resins poured together
        var wx2 = x + 0.55 * fbm(x, y, s + 1, 2, 4), wy2 = y + 0.55 * fbm(x, y, s + 2, 2, 4);
        var n = fbm(wx2, wy2, s, 2, 5);
        var t = 0.5 + 0.5 * Math.sin(n * 11 + wx2 * 3);
        col = mixc(base, a1, smooth(0.5, 0.98, t) * 0.85);
        col = mixc(col, a2, smooth(0.62, 1, 1 - t) * 0.7);
        if (look.accent3) col = mixc(col, a3, smooth(0.8, 1, fbm(wx2, wy2, s + 77, 3, 4)) * 0.8);
        glow = scalec(a1, smooth(0.8, 1, t) * 0.35);
      }
    }
    return { col: col, glow: glow };
  }

  var FOIL = {
    mica:  { n: 32, r: [0.004, 0.06], shape: 'poly', a: 0.85, cols: ['#fffde0', '#b5f2ff', '#ffe098'] },
    gold:  { n: 70, r: [0.002, 0.008], shape: 'poly', a: 0.95, cols: ['#fff1b8', '#f5c451', '#c9922a'] },
    stars: { n: 70, r: [0.0025, 0.007], shape: 'dot', a: 1, cols: ['#ffffff', '#d4e6ff', '#ffe9c4'], shine: true },
    prism: { n: 26, r: [0.01, 0.045], shape: 'poly', a: 0.75, rainbow: true },
    pearl: { n: 40, r: [0.01, 0.05], shape: 'oval', a: 0.5, cols: ['#ffffff', '#e8e2ff', '#ffe8f2', '#e0f4ff'] },
    ember: { n: 45, r: [0.002, 0.009], shape: 'dot', a: 1, cols: ['#ffd27a', '#ff9a3c', '#ff5a1a'], shine: true },
    shard: { n: 38, r: [0.02, 0.075], shape: 'shard', a: 0.7, rainbow: true },
    spark: { n: 45, r: [0.02, 0.06], shape: 'streak', a: 0.95, cols: ['#ffffff', '#c8f6ff'], shine: true },
    dust:  { n: 24, r: [0.0015, 0.0038], shape: 'dot', a: 0.85, cols: ['#f3dc9a', '#d9b25c'] },
    fire:  { n: 22, r: [0.004, 0.016], shape: 'poly', a: 0.95, rainbow: true, shine: true },
    leaf:  { n: 16, r: [0.02, 0.07], shape: 'poly', a: 0.92, cols: ['#fff0b8', '#f2c14e', '#d59a2b'] }
  };

  /** The flakes: drawn once per look into the foil layer, and those that
   *  shine (stars, embers, sparks) into the glow layer too. */
  function paintFoil(look, f, gl, size, random) {
    var spec = FOIL[look.foil];
    if (!spec) return;
    var tint = look.pattern === 'storm' ? hexRgb(look.accent) : null;
    for (var n = 0; n < spec.n; n++) {
      var fx = random() * size, fy = random() * size;
      var radius = (spec.r[0] + random() * (spec.r[1] - spec.r[0])) * size;
      var angle = random() * Math.PI * 2;
      // a look may give its flakes its own colours (Shard's green crystal)
      var cols = look.foilCols || spec.cols;
      var colour = spec.rainbow && !look.foilCols ? 'hsl(' + Math.round(random() * 360) + ',90%,78%)'
        : cols[Math.floor(random() * cols.length)];
      if (tint && spec.shape === 'streak' && random() < 0.6) colour = rgbCss(mixc(tint, [255, 255, 255], 0.35));
      [f, spec.shine && look.glow ? gl : null].forEach(function (g, layer) {
        if (!g) return;
        g.save(); g.translate(fx, fy); g.rotate(angle);
        g.globalAlpha = layer ? 0.9 : spec.a;
        if (spec.shape === 'dot') {
          var gr = g.createRadialGradient(0, 0, 0, 0, 0, radius * 2.2);
          gr.addColorStop(0, colour); gr.addColorStop(0.35, colour); gr.addColorStop(1, 'rgba(0,0,0,0)');
          g.fillStyle = gr; g.beginPath(); g.arc(0, 0, radius * 2.2, 0, Math.PI * 2); g.fill();
          if (radius > spec.r[1] * size * 0.75) {           // the brightest few get a glint
            g.fillStyle = colour; g.globalAlpha *= 0.8;
            g.fillRect(-radius * 4, -0.5, radius * 8, 1); g.fillRect(-0.5, -radius * 4, 1, radius * 8);
          }
        } else if (spec.shape === 'streak') {
          g.strokeStyle = colour; g.lineWidth = Math.max(1, radius * 0.08); g.lineCap = 'round';
          g.beginPath(); g.moveTo(-radius / 2, 0);
          g.lineTo(-radius / 6, radius * 0.12); g.lineTo(radius / 6, -radius * 0.1); g.lineTo(radius / 2, 0.02 * radius);
          g.stroke();
        } else if (spec.shape === 'oval') {
          g.fillStyle = colour; g.beginPath(); g.ellipse(0, 0, radius, radius * 0.55, 0, 0, Math.PI * 2); g.fill();
        } else {
          var points = spec.shape === 'shard' ? 3 : 3 + Math.floor(random() * 3);
          var stretch = spec.shape === 'shard' ? 0.28 : 0.65;
          var flash = g.createLinearGradient(-radius, -radius, radius, radius);
          flash.addColorStop(0, 'rgba(255,255,255,0.95)'); flash.addColorStop(0.45, colour);
          flash.addColorStop(1, 'rgba(255,255,255,0.25)');
          g.fillStyle = flash; g.beginPath();
          for (var v = 0; v < points; v++) {
            var a = v / points * Math.PI * 2, r = radius * (0.45 + random() * 0.55);
            if (v) g.lineTo(Math.cos(a) * r, Math.sin(a) * r * stretch);
            else g.moveTo(Math.cos(a) * r, Math.sin(a) * r * stretch);
          }
          g.closePath(); g.fill();
        }
        g.restore();
      });
    }
  }

  /* The clock the escaping light breathes by, shared by every material. */
  var CLOCK = { value: 0 };
  var haloTex = null;
  function haloTexture() {
    if (haloTex) return haloTex;
    var cv = d.createElement('canvas'); cv.width = cv.height = 128;
    var g = cv.getContext('2d'), gr = g.createRadialGradient(64, 64, 0, 64, 64, 64);
    gr.addColorStop(0, 'rgba(255,255,255,0.9)'); gr.addColorStop(0.35, 'rgba(255,255,255,0.45)');
    gr.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = gr; g.fillRect(0, 0, 128, 128);
    haloTex = new THREE.CanvasTexture(cv);
    return haloTex;
  }

  var resinTextures = {};
  /** Colour, flakes and glow sit under the ink at different optical depths.
   *  The maps are shared by every face of the same look. */
  function resinMaps(look, size, fi) {
    var perFace = !!look.faceMap;
    var key = look.key + '@' + size + (perFace ? '|f' + fi : '');
    if (resinTextures[key]) return resinTextures[key];
    var body = d.createElement('canvas'), foil = d.createElement('canvas'), glow = d.createElement('canvas');
    body.width = body.height = foil.width = foil.height = glow.width = glow.height = size;
    var g = body.getContext('2d'), f = foil.getContext('2d'), gl = glow.getContext('2d');
    var wrapArt = look.wrap ? artOf(look.wrap) : null;
    var art = wrapArt || artOf(look.faceMap || look.image);
    if (art) {
      // the designer's picture is the body: the wrap's whole sheet, a face map's
      // cell for this face (the rounded edges take the look's plain colour), or
      // the seamless texture
      if (wrapArt) {
        var aw = art.naturalWidth || art.width, ah = art.naturalHeight || art.height;
        var fit = Math.min(1, (size >= S ? 4096 : 1024) / Math.max(aw, ah));
        body.width = Math.max(1, Math.round(aw * fit)); body.height = Math.max(1, Math.round(ah * fit));
        g.drawImage(art, 0, 0, body.width, body.height);
      } else if (perFace) {
        var cols = look.faceCols || 4, cw = (art.naturalWidth || art.width) / cols;
        if (fi == null || fi >= 99) { g.fillStyle = look.colour; g.fillRect(0, 0, size, size); }
        else g.drawImage(art, (fi % cols) * cw, Math.floor(fi / cols) * cw, cw, cw, 0, 0, size, size);
      } else {
        g.drawImage(art, 0, 0, size, size);
      }
      gl.fillStyle = '#000'; gl.fillRect(0, 0, size, size);
      var seedA = 0;
      for (var ja = 0; ja < look.key.length; ja++) seedA = (seedA * 31 + look.key.charCodeAt(ja)) >>> 0;
      paintFoil(look, f, gl, size, rng(seedA));
      function textureA(cv) {
        var tx = new THREE.CanvasTexture(cv);
        tx.colorSpace = THREE.SRGBColorSpace;
        tx.wrapS = tx.wrapT = THREE.RepeatWrapping;
        tx.anisotropy = 4;
        return tx;
      }
      return (resinTextures[key] = { body: textureA(body), foil: textureA(foil), glow: textureA(glow) });
    }
    var seed = 0;
    for (var j = 0; j < look.key.length; j++) seed = (seed * 31 + look.key.charCodeAt(j)) >>> 0;
    var s = seed % 100000;
    var C = { base: hexRgb(look.colour), a1: hexRgb(look.accent || look.colour), a2: hexRgb(look.accent2 || '#000000'),
              a3: hexRgb(look.accent3 || look.accent || look.colour) };
    var shine = look.glow || 0;
    var pixels = g.createImageData(size, size), p = pixels.data;
    var glowPx = gl.createImageData(size, size), q = glowPx.data;
    for (var y = 0; y < size; y++) for (var x = 0; x < size; x++) {
      var px = patternPixel(look, x / size, y / size, s, C), i = (y * size + x) * 4;
      p[i] = Math.min(255, px.col[0]); p[i + 1] = Math.min(255, px.col[1]); p[i + 2] = Math.min(255, px.col[2]); p[i + 3] = 255;
      var gw = px.glow && shine ? px.glow : null;
      q[i] = gw ? Math.min(255, gw[0] * shine) : 0; q[i + 1] = gw ? Math.min(255, gw[1] * shine) : 0;
      q[i + 2] = gw ? Math.min(255, gw[2] * shine) : 0; q[i + 3] = 255;
    }
    g.putImageData(pixels, 0, 0);
    gl.putImageData(glowPx, 0, 0);
    var random = rng(seed);
    paintFoil(look, f, gl, size, random);
    function texture(cv) {
      var t = new THREE.CanvasTexture(cv);
      t.colorSpace = THREE.SRGBColorSpace;
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      t.anisotropy = 4;
      return t;
    }
    return (resinTextures[key] = { body: texture(body), foil: texture(foil), glow: texture(glow) });
  }

  var resinBevels = {};
  function resinBevel(spec, size) {
    var polygon = spec.polygon;
    var key = polygon.map(function (p) {
      return p.map(function (v) { return Math.round(v * 1e6); }).join(',');
    }).sort().join(';') + '@' + size;
    if (resinBevels[key]) return resinBevels[key];
    var cv = d.createElement('canvas'); cv.width = cv.height = size;
    var g = cv.getContext('2d'), pixels = g.createImageData(size, size), p = pixels.data;
    // A narrow rounded edge bends the reflections without changing the hull.
    for (var y = 0; y < size; y++) for (var x = 0; x < size; x++) {
      var u = (x + 0.5) / size, v = 1 - (y + 0.5) / size;
      var best = Infinity, dx = 0, dy = 0;
      for (var j = 0; j < polygon.length; j++) {
        var a = polygon[j], b = polygon[(j + 1) % polygon.length];
        var ex = b[0] - a[0], ey = b[1] - a[1];
        var t = Math.max(0, Math.min(1, ((u - a[0]) * ex + (v - a[1]) * ey) / (ex * ex + ey * ey)));
        var qx = a[0] + t * ex - u, qy = a[1] + t * ey - v, distance = Math.hypot(qx, qy);
        if (distance < best) { best = distance; dx = qx; dy = qy; }
      }
      var edge = Math.pow(Math.max(0, 1 - best / 0.035), 1.4);
      var nx = dx / (best || 1) * edge * 1.1, ny = dy / (best || 1) * edge * 1.1;
      var length = Math.hypot(nx, ny, 1), i = (y * size + x) * 4;
      p[i] = (nx / length * 0.5 + 0.5) * 255;
      p[i + 1] = (ny / length * 0.5 + 0.5) * 255;
      p[i + 2] = (1 / length * 0.5 + 0.5) * 255;
      p[i + 3] = 255;
    }
    g.putImageData(pixels, 0, 0);
    var texture = new THREE.CanvasTexture(cv); texture.anisotropy = 4;
    return (resinBevels[key] = texture);
  }

  function finishResin(material, look, size, bevel, shift, edge, fi) {
    var maps = resinMaps(look, size, fi);
    var mapped = !!(look.faceMap && artOf(look.faceMap));
    var wrapped = !!(look.wrap && artOf(look.wrap));
    var glowK = look.glow ? 1.6 : 0;
    material.onBeforeCompile = function (shader) {
      if (wrapped) {
        // the die's place on its wrap's sheet
        shader.vertexShader = 'attribute vec2 netUv;\nvarying vec2 vNetUv;\n' +
          shader.vertexShader.replace('#include <uv_vertex>', '#include <uv_vertex>\nvNetUv = netUv;');
        shader.fragmentShader = 'varying vec2 vNetUv;\n' + shader.fragmentShader;
      }
      shader.uniforms.resinBodyMap = { value: maps.body };
      shader.uniforms.resinFoilMap = { value: maps.foil };
      shader.uniforms.resinGlowMap = { value: maps.glow };
      shader.uniforms.resinEdgeMap = { value: bevel };
      shader.uniforms.resinShift = { value: new THREE.Vector2(shift[0], shift[1]) };
      shader.uniforms.resinGlowK = { value: glowK };
      // the resin's own plain colour, which the pattern settles back to under the numbers
      shader.uniforms.resinPlain = { value: new THREE.Color(look.colour) };
      if (edge && look.frame) shader.uniforms.resinFrame = { value: new THREE.Color(look.frame) };
      shader.uniforms.resinInkMetal = { value: look.inkMetal ? 0.55 : 0 };
      shader.uniforms.resinInkRough = { value: look.inkMetal ? 0.3 : 0.38 };
      if (look.opal) {
        // an opal's play of colour: swirls of spectral colour that turn with the angle
        shader.uniforms.resinOpal = { value: look.opal };
        shader.uniforms.resinOpalScale = { value: look.opalScale || 6 };
        shader.fragmentShader = '#define RESIN_OPAL\nuniform float resinOpal;\nuniform float resinOpalScale;\n' +
          'float resinOpalHash(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }\n' +
          'float resinOpalNoise(vec2 p) { vec2 i = floor(p), f = fract(p); f = f * f * (3.0 - 2.0 * f);\n' +
          '  return mix(mix(resinOpalHash(i), resinOpalHash(i + vec2(1.0, 0.0)), f.x), mix(resinOpalHash(i + vec2(0.0, 1.0)), resinOpalHash(i + vec2(1.0, 1.0)), f.x), f.y); }\n' +
          shader.fragmentShader;
      }
      if (look.escape) {
        // magic held in the die, leaking out at its seams
        shader.uniforms.resinEscape = { value: new THREE.Color(look.escape) };
        shader.uniforms.resinInkGlow = { value: look.inkGlow || 0 };
        shader.uniforms.resinEscapeK = { value: look.escapeK == null ? 1 : look.escapeK };
        shader.uniforms.resinTime = CLOCK;
        shader.fragmentShader = '#define RESIN_ESCAPE\nuniform vec3 resinEscape;\nuniform float resinInkGlow;\nuniform float resinEscapeK;\nuniform float resinTime;\n' + shader.fragmentShader;
      }
      shader.fragmentShader = (look.metal ? '#define RESIN_EDGE_LO 0.97\n#define RESIN_EDGE_HI 0.25\n'
        : '#define RESIN_EDGE_LO 1.0\n#define RESIN_EDGE_HI 0.2\n') + shader.fragmentShader;
      shader.fragmentShader = 'uniform sampler2D resinBodyMap;\nuniform sampler2D resinFoilMap;\nuniform sampler2D resinGlowMap;\n' +
        (edge && look.frame ? 'uniform vec3 resinFrame;\n' : '') +
        'uniform sampler2D resinEdgeMap;\nuniform vec2 resinShift;\nuniform vec3 resinPlain;\nuniform float resinGlowK;\nuniform float resinInkMetal;\nuniform float resinInkRough;\n' + shader.fragmentShader;
      // The surface label stays fixed while the inclusions move underneath it.
      // Keeping the body opaque also lets the tray work over any HTML sheet.
      shader.fragmentShader = shader.fragmentShader.replace('#include <map_fragment>', [
        'vec3 resinQ0 = dFdx(-vViewPosition), resinQ1 = dFdy(-vViewPosition);',
        'vec2 resinST0 = dFdx(vMapUv), resinST1 = dFdy(vMapUv);',
        'float resinHand = sign(resinST0.x * resinST1.y - resinST0.y * resinST1.x);',
        'vec3 resinT = normalize(resinQ0 * resinST1.y - resinQ1 * resinST0.y) * resinHand;',
        'vec3 resinB = normalize(-resinQ0 * resinST1.x + resinQ1 * resinST0.x) * resinHand;',
        'vec3 resinV = normalize(vViewPosition);',
        'vec2 resinView = vec2(dot(resinT, resinV), dot(resinB, resinV));',
        'float resinCalm = clamp(texture2D(map, vMapUv, 5.5).a * 4.2, 0.0, 0.95);',
        'vec2 resinBase = vMapUv * 0.72 + resinShift;',
        'vec2 resinUV = resinBase + resinView * 0.045;',
        'vec3 resinBody = texture2D(resinBodyMap, resinUV).rgb;',
        'vec3 resinDeep = texture2D(resinBodyMap, resinBase * 1.37 - resinView * 0.075 + 0.17).rgb;',
        'resinBody = mix(resinBody, resinDeep, 0.23);',
        'vec3 resinGlow = texture2D(resinGlowMap, resinUV).rgb + texture2D(resinGlowMap, resinBase * 1.37 - resinView * 0.075 + 0.17).rgb * 0.35;',
        'vec4 resinFar = texture2D(resinFoilMap, resinBase * 1.21 - resinView * 0.095 + 0.31);',
        'vec4 resinNear = texture2D(resinFoilMap, resinBase + resinView * 0.035);',
        'float resinGlint = 0.5 + 0.5 * sin(dot(resinView, vec2(13.0, 9.0)) + vMapUv.x * 19.0);',
        'resinFar.a *= 1.0 - resinCalm; resinNear.a *= 1.0 - resinCalm; resinGlow *= 1.0 - resinCalm;',
        'resinBody = mix(resinBody, resinFar.rgb * (resinBody * 1.8 + 0.08), resinFar.a * 0.65);',
        'resinBody = mix(resinBody, resinNear.rgb * (resinBody * 1.4 + 0.12 + resinGlint * 0.45), resinNear.a * (0.35 + resinGlint * 0.55));',
        'resinBody = mix(resinBody, resinPlain, resinCalm * ' + (mapped || wrapped ? '0.2' : '0.8') + ');',
        edge ? 'float resinEdge = 0.5;' : 'float resinEdge = clamp((1.0 - texture2D(resinEdgeMap, vMapUv).b) * 6.0, 0.0, 1.0);',
        edge ? 'resinBody = mix(resinBody, resinPlain, 0.3);' : '',
        edge && look.frame ? 'resinBody = resinFrame; resinGlow = vec3(0.0); resinFar.a = 0.0; resinNear.a = 0.0;' : '',
        'resinBody *= RESIN_EDGE_LO + resinEdge * RESIN_EDGE_HI;',
        '#ifdef RESIN_OPAL',
        // the colour sits a little under the surface, so it slides against the numbers
        'vec2 resinOP = resinBase * resinOpalScale + resinView * 0.6;',
        'float resinON = resinOpalNoise(resinOP) * 0.65 + resinOpalNoise(resinOP * 2.3 + 5.1) * 0.35;',
        'float resinOM = resinOpalNoise(resinOP * 0.8 + 11.0 + resinView * 2.5);',
        'float resinHF = 1.0 - clamp(abs(dot(normalize(cross(resinQ0, resinQ1)), resinV)), 0.0, 1.0);',
        // the hue flows through the stone and turns with the angle; the fire flares where it catches the eye
        'float resinOH = fract(resinON * 2.2 + dot(resinView, vec2(1.3, 0.9)) + resinHF * 1.2 + resinShift.y * 2.0);',
        'vec3 resinRainbow = clamp(abs(fract(resinOH + vec3(0.0, 0.667, 0.333)) * 6.0 - 3.0) - 1.0, 0.0, 1.0);',
        'float resinOFl = smoothstep(0.3, 0.75, resinOM);',
        'float resinHK = resinOpal * (0.3 + 0.7 * resinOFl) * (1.0 - resinCalm * 0.5);',
        'resinBody = mix(resinBody, resinRainbow * (0.5 + dot(resinBody, vec3(0.4))) + resinBody * 0.25, resinHK);',
        '#endif',
        'vec4 resinInk = texture2D(map, vMapUv);',
        'diffuseColor.rgb *= mix(resinBody, resinInk.rgb, resinInk.a);'
      ].join('\n'));
      if (wrapped) {
        // a wrap lies on the die exactly as painted on the sheet, over the edges too
        shader.fragmentShader = shader.fragmentShader
          .replace('vec3 resinBody = texture2D(resinBodyMap, resinUV).rgb;', 'vec3 resinBody = texture2D(resinBodyMap, vNetUv).rgb;')
          .replace('resinBody = mix(resinBody, resinDeep, 0.23);', '')
          .replace('resinBody = mix(resinBody, resinPlain, 0.3);', '');
      }
      if (mapped) {
        // a face map lies on its face exactly as drawn on the template
        shader.fragmentShader = shader.fragmentShader
          .replace('vec2 resinBase = vMapUv * 0.72 + resinShift;', 'vec2 resinBase = vMapUv;')
          .replace('vec2 resinUV = resinBase + resinView * 0.045;', 'vec2 resinUV = resinBase;')
          .replace('resinBody = mix(resinBody, resinDeep, 0.23);', '');
      }
      shader.fragmentShader = shader.fragmentShader.replace('#include <roughnessmap_fragment>',
        '#include <roughnessmap_fragment>\nroughnessFactor = mix(roughnessFactor, 0.1, resinNear.a * (1.0 - resinInk.a));\nroughnessFactor = mix(roughnessFactor, resinInkRough, resinInk.a);');
      shader.fragmentShader = shader.fragmentShader.replace('#include <metalnessmap_fragment>',
        '#include <metalnessmap_fragment>\nmetalnessFactor = mix(metalnessFactor, resinInkMetal, resinInk.a);');
      shader.fragmentShader = shader.fragmentShader.replace('#include <emissivemap_fragment>',
        '#include <emissivemap_fragment>\ntotalEmissiveRadiance += resinGlow * resinGlowK * (1.0 - resinInk.a);' +
        '\n#ifdef RESIN_OPAL\ntotalEmissiveRadiance += resinRainbow * resinHK * resinHK * 0.5 * (1.0 - resinInk.a);\n#endif' +
        '\n#ifdef RESIN_ESCAPE\nfloat resinBreath = 0.8 + 0.2 * sin(resinTime * 1.7 + resinShift.x * 7.0);\n' +
        'totalEmissiveRadiance *= resinBreath;\n' +
        'float resinRim = pow(1.0 - clamp(dot(normalize(normal), normalize(vViewPosition)), 0.0, 1.0), 2.2);\n' +
        'totalEmissiveRadiance += resinEscape * (' + (edge ? (look.frame ? '0.0' : '0.05 + resinRim * 0.9') : 'resinRim * 0.55') + ') * resinEscapeK * resinBreath * (1.0 - resinInk.a);\n' +
        'totalEmissiveRadiance += resinInk.rgb * resinInk.a * resinInkGlow * resinBreath;\n#endif');
      shader.fragmentShader = shader.fragmentShader.replace('#include <lights_physical_fragment>',
        '#include <lights_physical_fragment>\nmaterial.clearcoat *= 1.0 - resinInk.a * 0.85;');
    };
    material.customProgramCacheKey = function () { return 'dk-layered-resin-v2' + (mapped ? '-map' : '') + (look.opal ? '-opal' : '') + (look.metal ? '-metal' : '') + (look.escape ? '-escape' : '') + (wrapped ? '-wrap' : '') + (edge ? '-edge' : '') + (edge && look.frame ? '-frame' : ''); };
  }

  /** Let go of every full-size face that is not of the look in play: a set
   *  tried and left would otherwise keep its textures for the session. The
   *  small preview faces stay; they are little and shared. */
  function prune(keep) {
    var tail = '@' + S;
    Object.keys(materials).forEach(function (key) {
      if (key.indexOf(keep) === 0 || key.slice(-tail.length) !== tail) return;
      try { materials[key].dispose(); } catch (e) {}
      delete materials[key];
    });
    Object.keys(faceTextures).forEach(function (key) {
      if (key.indexOf(keep) === 0 || key.slice(-tail.length) !== tail) return;
      try { faceTextures[key].dispose(); } catch (e) {}
      delete faceTextures[key];
    });
    Object.keys(canvases).forEach(function (key) {
      if (key.indexOf(keep) !== 0 && key.slice(-tail.length) === tail) delete canvases[key];
    });
  }

  function materialFor(look, spec) {
    var key = look.key + '|' + spec.key + '@' + (spec.size || S);
    if (materials[key]) return materials[key];
    var inkKey = faceKey(look, spec), tex = faceTextures[inkKey];
    if (!tex) {
      tex = new THREE.CanvasTexture(faceCanvas(look, spec));
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.anisotropy = 4;
      faceTextures[inkKey] = tex;
    }
    var cfg = MAT[look.material] || MAT.plastic, opts = { map: tex };
    Object.keys(cfg).forEach(function (k) { if (k !== 'physical') opts[k] = cfg[k]; });
    var bevel;
    if (look.material === 'resin') {
      bevel = resinBevel(spec, spec.size || S);
    }
    if (look.material === 'resin') {
      if (look.iridescence) { opts.iridescence = look.iridescence; opts.iridescenceIOR = 1.6; opts.iridescenceThicknessRange = [120, 620]; }
      if (spec.edge && look.frame) {
        // a frame of polished metal round a stone: the die's edges and corners
        opts.metalness = 1; opts.roughness = 0.2; opts.clearcoat = 0.3; opts.clearcoatRoughness = 0.15;
        opts.envMapIntensity = 1.7;
      }
      if (look.metal) {
        // cast metal: the body is the metal itself, lightly lacquered, and
        // the numbers are filled with enamel
        opts.metalness = 1; opts.roughness = 0.3; opts.clearcoat = 0.25; opts.clearcoatRoughness = 0.2;
        opts.envMapIntensity = 1.5;
      }
    }
    var m = cfg.physical ? new THREE.MeshPhysicalMaterial(opts) : new THREE.MeshStandardMaterial(opts);
    if (look.material === 'resin') finishResin(m, look, spec.size || S, bevel, [hash(spec.fi || 0, 1, 7) * 0.9, hash(spec.fi || 0, 2, 7) * 0.9], !!spec.edge, spec.fi);
    materials[key] = m;
    return m;
  }

  /** What one die of a set looks like: the set's look for its kind of die
   *  (the pool, the Hero die, the Shadow die), in one of that look's
   *  colours, since a throw mixes them. */
  function lookOf(set, role, colourIndex) {
    var l = roleLook(set, role), faces = l.face && l.face.length ? l.face : ['#888888'];
    var colour = faces[(colourIndex || 0) % faces.length];
    return {
      key: setKey(set) + '|' + role + '|' + colour,
      colour: colour, ink: l.ink || '#ffffff', outline: l.outline || 'none',
      material: l.material || 'resin',
      pattern: l.pattern || 'swirl', accent: l.accent, accent2: l.accent2, accent3: l.accent3,
      foil: l.foil || 'none', foilCols: l.foilCols || null, glow: l.glow || 0, inkMetal: !!l.inkMetal,
      iridescence: l.iridescence || 0, opal: l.opal || 0, opalScale: l.opalScale || 0, metal: l.metal || 0, ring: !!l.ring, escape: l.escape || null, escapeK: l.escapeK, inkGlow: l.inkGlow || 0, frame: l.frame || null, cut: l.cut || null,
      image: l.image || null, faceMap: l.faceMap || null, faceMaps: l.faceMaps || null, faceCols: l.faceCols || null,
      wrap: l.wrap || null, wraps: l.wraps || null,
      // the die the look's own face map was painted for
      faceMapKind: role === 'pool' ? 'd6' : (l.shape === 'rhombic' ? 'd12r' : 'd12'),
      mark: l.mark || set.mark || null, pips: l.pips || null,
      fontFile: l.fontFile || set.fontFile || null
    };
  }

  /* How many cells across each kind of die's template is. */
  var FACE_COLS = { d4: 4, d6: 3, d8: 4, d10: 5, d12: 4, d12r: 4, d20: 5 };
  /** The look for this kind of die: its own wrap or face map if it has one,
   *  else none. A wrap covers the whole die, so it wins over a face map. */
  function kindLook(look, shape) {
    if (!look.faceMap && !look.faceMaps && !look.wrap && !look.wraps) return look;
    var wrap = (look.wraps && look.wraps[shape.kind]) || (look.faceMapKind === shape.kind ? look.wrap : null) || null;
    var map = wrap ? null : (look.faceMaps && look.faceMaps[shape.kind]) || (look.faceMapKind === shape.kind ? look.faceMap : null);
    if (map === look.faceMap && look.faceCols && wrap === (look.wrap || null)) return look;
    var l2 = Object.assign({}, look);
    l2.faceMap = map || null;
    l2.wrap = wrap;
    l2.faceCols = look.faceCols && map === look.faceMap ? look.faceCols : (FACE_COLS[shape.kind] || 4);
    l2.key = look.key + '|' + shape.kind + (map ? '' : '|nomap') + (wrap ? '|wrap' : '');
    return l2;
  }

  /** The materials of one die, face by face, for its numbering. */
  function faceMaterials(shape, numbers, look, mode, opts) {
    opts = opts || {};
    look = kindLook(look, shape);
    MARK_ON = MARK_DEFAULT || !!look.mark;
    var out = [];
    for (var fi = 0; fi < shape.sides; fi++) {
      var fr = shape.frames[fi];
      var spec;
      if (opts.only && opts.only.indexOf(fi) < 0) {
        spec = { key: shape.kind + '|blank', label: null };
      } else if (shape.byVertex) {
        // three labels, one at each corner, each turned to read from its corner
        var px = (S / 2) * (fr.rin / fr.R) * shape.glyph;
        var corners = shape.F[fi].map(function (vi, k) {
          var c = fr.corners[k];
          var cx = c[0] * S, cy = (1 - c[1]) * S;
          var dx = cx - S / 2, dy = cy - S / 2;
          return { label: String(numbers[vi]), x: S / 2 + dx * 0.6, y: S / 2 + dy * 0.6,
                   turn: Math.atan2(dx, -dy), px: px };
        });
        spec = { key: 'd4|' + corners.map(function (c) { return c.label; }).join(','), corners: corners };
      } else {
        var label = labelOf(numbers[fi], shape.sides, mode);
        if (look.pips && shape.sides === 6 && label !== 'logo') label = 'pips:' + look.pips + ':' + label;
        var size = (S / 2) * (fr.rin / fr.R) * shape.glyph;
        var tri = shape.sides === 8 || shape.sides === 20;
        // Reserve room for two digits on every face of these dice, including
        // the units die in a percentile pair. A 1 stays as tall as a 12.
        var pxl = label === 'logo' || String(label).indexOf('pips:') === 0 ? (S / 2) * (fr.rin / fr.R)
          : size * (shape.sides >= 10 ? 0.86 : tri ? 1.2 : 1.18);
        // a triangle has more room below its centre than above
        var drop = shape.sides === 8 || shape.sides === 20 ? size * 0.12 : 0;
        spec = { key: shape.kind + '|' + label, label: label, px: pxl, drop: drop };
      }
      if (opts.size) spec.size = opts.size;
      else if (look.ring) spec.size = 384;
      if (look.ring && spec.label === 'logo') spec.px *= 0.86;
      spec.fi = fi;
      spec.poly = fr.corners; spec.rin = fr.rin / fr.R;
      if (look.material === 'resin') {
        spec.faceKey = spec.key;
        spec.polygon = fr.corners;
        spec.key += '|f' + fi + '|' + fr.corners.map(function (p) { return p.map(function (v) { return v.toFixed(3); }).join(','); }).join(';');
      }
      out.push(materialFor(look, spec));
    }
    // the rounded edges and corners, all of a piece
    var f0 = shape.frames[0];
    var edge = { key: shape.kind + '|edge', label: null, edge: true, fi: 99,
                 poly: f0.corners, rin: f0.rin / f0.R, polygon: f0.corners, faceKey: shape.kind + '|edge' };
    if (opts.size) edge.size = opts.size;
    out.push(materialFor(look, edge));
    return out;
  }

  /* ---------------------------------------------------------- the tray */

  function rng(seed) {
    var s = seed >>> 0;
    return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
  }

  function Tray() {
    this.ready = false;
    this.host = null;
  }

  var STYLE = '.dk-3d{position:fixed;left:0;top:0;z-index:245;pointer-events:none;opacity:0;transition:opacity .42s ease}' +
    '.dk-3d.is-staged{position:absolute;z-index:40}.dk-3d.is-live{opacity:1}.dk-3d canvas{display:block}';

  Tray.prototype.mount = function () {
    if (this.host) return;
    if (!d.getElementById('dk-3d-style')) {
      var st = d.createElement('style');
      st.id = 'dk-3d-style';
      st.textContent = STYLE;
      (d.head || d.body).appendChild(st);
    }
    var host = d.createElement('div');
    host.className = 'dk-3d';
    host.setAttribute('aria-hidden', 'true');
    host.style.overflow = 'hidden';
    d.body.appendChild(host);
    this.host = host;
  };

  /** Throw over one element (the map board) instead of the whole page. */
  Tray.prototype.stage = function (el) {
    el = el && el.isConnected ? el : null;
    var parent = el || d.body;
    if (this.stageEl === el && this.host.parentNode === parent) return;
    this.stageEl = el;
    parent.appendChild(this.host);
    this.host.classList.toggle('is-staged', !!el);
  };

  Tray.prototype.init = function () {
    if (this.ready) return;
    this.mount();
    var self = this;
    var w0 = w.innerWidth || 640, h0 = w.innerHeight || 420;

    this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, powerPreference: 'high-performance' });
    this.renderer.setPixelRatio(Math.min(w.devicePixelRatio || 1, 2));
    this.renderer.setSize(w0, h0);
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 1.1;
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.domElement.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none';
    this.host.appendChild(this.renderer.domElement);

    this.scene = new THREE.Scene();
    this.scene.environment = environment();
    this.camera = new THREE.PerspectiveCamera(30, w0 / h0, 0.1, 200);

    this.scene.add(new THREE.AmbientLight(0xffffff, 0.8));
    var key = new THREE.DirectionalLight(0xfff4e0, 1.9);
    key.position.set(-6, 14, 6);
    key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.radius = 4;
    key.shadow.camera.near = 1; key.shadow.camera.far = 40;
    this.scene.add(key);
    this.key = key;
    var rim = new THREE.DirectionalLight(0x9fb4ff, 0.5);
    rim.position.set(7, 6, -7);
    this.scene.add(rim);

    // the page, catching the dice's shadows and nothing else
    var ground = new THREE.Mesh(new THREE.PlaneGeometry(200, 200), new THREE.ShadowMaterial({ opacity: 0.28 }));
    ground.rotation.x = -Math.PI / 2;
    ground.receiveShadow = true;
    this.scene.add(ground);

    this.world = new CANNON.World({ gravity: new CANNON.Vec3(0, -30, 0) });
    this.world.allowSleep = true;
    var floorMat = new CANNON.Material('floor');
    this.diceMat = new CANNON.Material('dice');
    this.world.addContactMaterial(new CANNON.ContactMaterial(floorMat, this.diceMat, { friction: 0.4, restitution: 0.3 }));
    this.world.addContactMaterial(new CANNON.ContactMaterial(this.diceMat, this.diceMat, { friction: 0.3, restitution: 0.35 }));
    var floor = new CANNON.Body({ mass: 0, material: floorMat, shape: new CANNON.Plane() });
    floor.quaternion.setFromEuler(-Math.PI / 2, 0, 0);
    this.world.addBody(floor);

    this.walls = [];
    this.bodies = [];
    this.meshes = [];
    this.shapes = buildShapes();
    this.fit();
    this.ready = true;
    this.onResize = function () { self.fit(); };
    w.addEventListener('resize', this.onResize);
    if (w.visualViewport) w.visualViewport.addEventListener('resize', this.onResize);
  };

  /** An asymmetric studio: narrow softboxes give polished faces a clear
   *  highlight as they turn, with dark space between the reflections. */
  var envTex = null;
  function environment() {
    if (envTex) return envTex;
    function face(top, bottom, strip) {
      var cv = d.createElement('canvas'); cv.width = cv.height = 256;
      var g = cv.getContext('2d');
      var gr = g.createLinearGradient(0, 0, 0, 256);
      gr.addColorStop(0, top); gr.addColorStop(1, bottom);
      g.fillStyle = gr; g.fillRect(0, 0, 256, 256);
      if (strip) {
        g.save(); g.translate(strip[0], strip[1]); g.rotate(strip[2]);
        g.shadowColor = '#fff6e6'; g.shadowBlur = 14;
        g.fillStyle = '#fffaf0'; g.fillRect(-16, -104, 32, 208);
        g.shadowBlur = 0; g.fillStyle = '#efe4d0'; g.fillRect(40, -84, 8, 160);
        g.restore();
      }
      return cv;
    }
    var tex = new THREE.CubeTexture([
      face('#8f8779', '#3a342c', [78, 105, -0.22]),
      face('#a89f90', '#403930', [170, 112, 0.3]),
      face('#c9c1b2', '#6f675b', [90, 105, 0.75]),
      face('#5a5248', '#3a342c'),
      face('#b4ab9b', '#474036', [85, 86, -0.65]),
      face('#7b7367', '#352f28', [185, 120, 0.12])
    ]);
    tex.colorSpace = THREE.SRGBColorSpace;
    tex.needsUpdate = true;
    envTex = tex;
    return tex;
  }

  /** Size the table to the page: the dice are a hand's width on a phone and
   *  a little bigger on a desk, and the walls sit at the page's edges. On
   *  the map the table is the board. A framed page taller than the window
   *  (the sheet grows its frame to fit) uses the slice its parent shows. */
  Tray.prototype.band = function () {
    var st = this.stageEl;
    if (st && st.isConnected) {
      return { w: Math.max(1, st.clientWidth), h: Math.max(1, st.clientHeight), top: 0, left: 0 };
    }
    var w0 = w.innerWidth || 640, h0 = w.innerHeight || 420, top = 0, left = 0;
    try {
      var fe = w.frameElement;
      if (fe && w.parent && w.parent.innerHeight) {
        var r = fe.getBoundingClientRect(), ph = w.parent.innerHeight;
        var vis0 = Math.max(0, -r.top), vis1 = Math.min(h0, ph - r.top);
        if (vis1 - vis0 > 120) { top = vis0; h0 = vis1 - vis0; }
      }
    } catch (e) {}
    return { w: w0, h: h0, top: top, left: left };
  };

  Tray.prototype.fit = function () {
    if (!this.renderer) return;
    var band = this.band(), w0 = band.w, h0 = band.h;
    var before = this.viewport;
    var changed = before && ['w', 'h', 'top', 'left'].some(function (key) { return Math.abs(before[key] - band[key]) > 0.5; });
    // A replay uses the walls it was planned against. A changed viewport
    // ends that visual; the recorded result remains available on the sheet.
    if (changed && (this.busy || this.onDone || (this.meshes && this.meshes.length))) {
      if (this === tray) cancelShow('resized'); else this.clear();
    }
    this.viewport = band;
    this.host.style.top = band.top + 'px';
    this.host.style.left = band.left + 'px';
    this.host.style.right = 'auto';
    this.host.style.width = w0 + 'px';
    this.host.style.height = h0 + 'px';
    this.host.style.bottom = 'auto';
    this.renderer.setPixelRatio(Math.min(w.devicePixelRatio || 1, 2));
    this.renderer.setSize(w0, h0);
    var target = Math.max(46, Math.min(72, Math.min(w0, h0) / 8));  // pixels per unit
    var halfZ = h0 / (2 * target);
    var fov = this.camera.fov * Math.PI / 180;
    var H = halfZ / Math.tan(fov / 2);
    this.camera.aspect = w0 / h0;
    this.camera.position.set(0, H, 0.001);
    this.camera.lookAt(0, 0, 0);
    this.camera.updateProjectionMatrix();
    this.bounds = { x: halfZ * this.camera.aspect * 0.96, z: halfZ * 0.96 };
    // the light comes in on a diagonal, so its square must take in the corners
    var sc = this.key.shadow.camera, r = 0.71 * (this.bounds.x + this.bounds.z) + 2;
    sc.left = -r; sc.right = r; sc.top = r; sc.bottom = -r;
    sc.updateProjectionMatrix();
    // walls added to the world mid-roll would reorder its bodies and change
    // the replay's arithmetic, so a roll in flight keeps the walls it has
    if (this.busy) this.wallsStale = true;
    else this.buildWalls();
    // dice at rest are painted again, since a resize blanks the canvas
    if (!this.raf && this.meshes && this.meshes.length) this.renderer.render(this.scene, this.camera);
  };

  Tray.prototype.settled = function () {
    this.busy = false;
    if (this.wallsStale) { this.wallsStale = false; this.buildWalls(); }
  };

  Tray.prototype.buildWalls = function () {
    var self = this;
    this.walls.forEach(function (b) { self.world.removeBody(b); });
    this.walls = [];
    [[-1, 0], [1, 0], [0, -1], [0, 1]].forEach(function (dd) {
      var b = new CANNON.Body({ mass: 0, shape: new CANNON.Plane() });
      b.position.set(dd[0] * self.bounds.x, 0, dd[1] * self.bounds.z);
      b.quaternion.setFromEuler(0, Math.atan2(-dd[0], -dd[1]), 0);
      self.world.addBody(b);
      self.walls.push(b);
    });
  };

  Tray.prototype.makeBody = function (kind) {
    var s = this.shapes[kind];
    var shape = new CANNON.ConvexPolyhedron({
      vertices: s.hull.V.map(function (v) { return new CANNON.Vec3(v[0], v[1], v[2]); }),
      faces: s.hull.F.map(function (f) { return f.slice(); })
    });
    return new CANNON.Body({ mass: 1, shape: shape, material: this.diceMat,
                             linearDamping: 0.08, angularDamping: 0.1,
                             sleepSpeedLimit: 0.12, sleepTimeLimit: 0.25 });
  };

  /** Which face (or, for a d4, which point) of a resting die is uppermost. */
  Tray.prototype.up = function (kind, body) {
    var s = this.shapes[kind];
    var q = new THREE.Quaternion(body.quaternion.x, body.quaternion.y, body.quaternion.z, body.quaternion.w);
    var best = -2, at = 0;
    if (s.byVertex) {
      s.V.forEach(function (v, i) {
        var p = v3(v).applyQuaternion(q);
        if (p.y > best) { best = p.y; at = i; }
      });
      return at;
    }
    s.normals.forEach(function (n, i) {
      var v = n.clone().applyQuaternion(q);
      if (v.y > best) { best = v.y; at = i; }
    });
    return at;
  };

  /** Where each die starts and how it is thrown: from one edge of the page,
   *  towards the middle, spinning. A wide page throws from a side, a tall one
   *  from the bottom. */
  Tray.prototype.throwFrom = function (dice, seed) {
    var rand = rng(seed);
    var bx = this.bounds.x, bz = this.bounds.z;
    var wide = bx > bz;
    var side = wide ? (rand() < 0.5 ? 'left' : 'right') : 'bottom';
    // along the edge the dice need 1.7 units each; a short edge takes rows
    var span = (side === 'bottom' ? bx : bz) * 1.4;
    var rows = Math.max(1, Math.ceil(dice.length * 1.7 / span));
    var perRow = Math.ceil(dice.length / rows);
    return dice.map(function (die, i) {
      var row = i % rows, col = Math.floor(i / rows);
      var t = (col + 0.5) / perRow, back = row * 1.35;
      var pos, vel;
      if (side === 'bottom') {
        pos = [(t - 0.5) * bx * 1.4 + (rand() - 0.5) * 0.6, 1.5 + rand() * 1.5, bz * 0.9 - back + (rand() - 0.5) * 0.4];
        vel = [(rand() - 0.5) * 5, 1 + rand() * 2, -(bz * 1.3 + rand() * 4)];
      } else {
        var sx = side === 'left' ? -1 : 1;
        pos = [sx * (bx * 0.9 - back) + (rand() - 0.5) * 0.4, 1.5 + rand() * 1.5, (t - 0.5) * bz * 1.4 + (rand() - 0.5) * 0.6];
        vel = [-sx * (bx * 1.3 + rand() * 4), 1 + rand() * 2, (rand() - 0.5) * 5];
      }
      return {
        kind: die.kind, mode: die.mode, want: die.want, colour: die.colour, role: die.role,
        pos: pos, vel: vel,
        quat: [rand() * 2 - 1, rand() * 2 - 1, rand() * 2 - 1, rand() * 2 - 1],
        spin: [(rand() - 0.5) * 28, (rand() - 0.5) * 28, (rand() - 0.5) * 28]
      };
    });
  };

  Tray.prototype.place = function (throws) {
    var self = this;
    this.clearBodies();
    // the clock starts from nought for the pre-simulation and again for the
    // replay: cannon's sleep timer works in floating point on world.time, and
    // the two runs must add the same numbers to land the same
    this.world.time = 0;
    this.world.stepnumber = 0;
    this.bodies = throws.map(function (t) {
      var b = self.makeBody(t.kind);
      b.position.set(t.pos[0], t.pos[1], t.pos[2]);
      b.quaternion.set(t.quat[0], t.quat[1], t.quat[2], t.quat[3]);
      b.quaternion.normalize();
      b.velocity.set(t.vel[0], t.vel[1], t.vel[2]);
      b.angularVelocity.set(t.spin[0], t.spin[1], t.spin[2]);
      self.world.addBody(b);
      return b;
    });
  };

  Tray.prototype.clearBodies = function () {
    var self = this;
    (this.bodies || []).forEach(function (b) { self.world.removeBody(b); });
    this.bodies = [];
  };

  Tray.prototype.moving = function () {
    return this.bodies.some(function (b) {
      return b.velocity.lengthSquared() > 0.02 || b.angularVelocity.lengthSquared() > 0.02;
    });
  };

  /** Near enough still. Cubes that land against one another can shiver for
   *  ever without cannon ever letting them sleep, which held the whole throw
   *  on the page for its full twenty seconds; a die this slow counts as at
   *  rest. The pre-simulation and the replay both use it, so they agree. */
  Tray.prototype.slow = function () {
    return this.bodies.every(function (b) {
      return b.velocity.lengthSquared() < 0.25 && b.angularVelocity.lengthSquared() < 0.6;
    });
  };

  /** How squarely a resting die sits: 1 is flat on a face. */
  Tray.prototype.flatness = function (kind, body) {
    var s = this.shapes[kind];
    var q = new THREE.Quaternion(body.quaternion.x, body.quaternion.y, body.quaternion.z, body.quaternion.w);
    var best = -2;
    s.normals.forEach(function (n) {
      var v = n.clone().applyQuaternion(q);
      best = Math.max(best, s.byVertex ? -v.y : v.y);
    });
    return best;
  };

  /** Run the throw to rest, unseen, and read what ended up. A die that
   *  comes to rest cocked -- leaning on another, or a wall -- is nudged and
   *  the throw run on; the nudge is kept in the plan so the replay does the
   *  same. */
  Tray.prototype.settle = function (throws, seed) {
    var self = this;
    var rand = rng(seed ^ 0x3c6ef372);
    this.place(throws);
    var step = 1 / 60, n = 0, still = 0, nudges = [], rounds = 0;
    while (n < 1200) {
      this.world.step(step);
      n++;
      still = this.moving() && !this.slow() ? 0 : still + 1;
      if (still > 18) {
        var cocked = [];
        this.bodies.forEach(function (b, i) { if (self.flatness(throws[i].kind, b) < 0.985) cocked.push(i); });
        if (!cocked.length || rounds >= 6) break;
        rounds++;
        still = 0;
        cocked.forEach(function (i) {
          var nudge = { frame: n, i: i, v: [(rand() - 0.5) * 4, 3 + rand() * 2, (rand() - 0.5) * 4],
                        spin: [(rand() - 0.5) * 10, (rand() - 0.5) * 10, (rand() - 0.5) * 10] };
          nudges.push(nudge);
          self.nudge(nudge);
        });
      }
    }
    // the replay runs to this very step before it reads the faces
    return { ups: this.bodies.map(function (b, i) { return self.up(throws[i].kind, b); }),
      flatness: this.bodies.map(function (b, i) { return self.flatness(throws[i].kind, b); }),
      moving: this.moving(), nudges: nudges, steps: n };
  };

  Tray.prototype.nudge = function (nudge) {
    var b = this.bodies[nudge.i];
    if (!b) return;
    b.wakeUp();
    b.velocity.set(nudge.v[0], nudge.v[1], nudge.v[2]);
    b.angularVelocity.set(nudge.spin[0], nudge.spin[1], nudge.spin[2]);
  };

  /** The whole plan of a roll: the throw, and the numbering that makes it
   *  land right. */
  Tray.prototype.arrange = function (dice, seed) {
    var self = this;
    this.busy = true;
    var best = null;
    for (var attempt = 0; attempt < 3; attempt++) {
      var candidateSeed = attempt ? (seed ^ Math.imul(attempt, 0x9e3779b9)) : seed;
      var candidateThrows = this.throwFrom(dice, candidateSeed);
      var candidateRest = this.settle(candidateThrows, candidateSeed);
      var score = candidateRest.flatness.reduce(function (n, value) { return n + (value < 0.985 ? 1 + (1 - value) : 0); }, 0) +
        (candidateRest.moving ? dice.length + 1 : 0);
      if (!best || score < best.score) best = { score: score, seed: candidateSeed, throws: candidateThrows, rest: candidateRest };
      if (!score) break;
    }
    var throws = best.throws, rest = best.rest;
    var rand = rng(best.seed ^ 0x5f3759df);
    var numbers = rest.ups.map(function (up, i) {
      var s = self.shapes[throws[i].kind];
      return s.byVertex ? numberingD4(up, throws[i].want, rand) : numbering(s, up, throws[i].want, rand, throws[i].mode);
    });
    return { throws: throws, numbers: numbers, ups: rest.ups, nudges: rest.nudges, seed: best.seed, steps: rest.steps };
  };

  Tray.prototype.buildMeshes = function (throws, numbers, set) {
    var self = this;
    this.dropMeshes();
    this.meshes = throws.map(function (t, i) {
      var s = self.shapes[t.kind];
      var look = lookOf(set, t.role, t.colour);
      t.look = look;
      var m = new THREE.Mesh(meshGeometry(s, look), faceMaterials(s, numbers[i], look, t.mode));
      m.castShadow = true;
      self.scene.add(m);
      if (look.escape) {
        // the light that gets out pools on the page beneath the die
        var halo = new THREE.Mesh(new THREE.PlaneGeometry(2.6, 2.6), new THREE.MeshBasicMaterial({
          map: haloTexture(), color: new THREE.Color(look.escape), transparent: true, opacity: 0.5 * Math.min(1, look.escapeK == null ? 1 : look.escapeK), depthWrite: false }));
        halo.rotation.x = -Math.PI / 2;
        halo.position.y = 0.01;
        self.scene.add(halo);
        m.userData.halo = halo;
      }
      return m;
    });
  };

  Tray.prototype.dropMeshes = function () {
    var self = this;
    (this.meshes || []).forEach(function (m) { self.scene.remove(m); if (m.userData.halo) self.scene.remove(m.userData.halo); });
    this.meshes = [];
  };

  /** Play the throw for real, and say what faces came up when it rests. */
  Tray.prototype.play = function (plan, onDone, onValues) {
    var self = this;
    this.stop();
    this.place(plan.throws);
    var step = 1 / 60, frames = 0, nudges = plan.nudges || [], ni = 0, last = null, acc = 0, quiet = 0;
    var target = plan.steps || 1200;
    // Keep the planned physics intact, but show even a long throw in 3 seconds.
    // Ordinary throws get only a small speed-up, retaining their natural bounce.
    var playbackRate = Math.max(1.35, target * step / 3);
    var valuesShown = false;
    this.onDone = onDone;
    this.host.classList.add('is-live');
    function frame(now) {
      if (self.onDone !== onDone) return;
      CLOCK.value = now / 1000;
      // Replay the same fixed physics steps, independently of display refresh.
      var dt = last === null ? step : Math.max(0, Math.min(0.1, (now - last) / 1000));
      last = now; acc += dt * playbackRate;
      var todo = Math.min(48, Math.floor(acc / step + 1e-6));
      acc = Math.max(0, acc - todo * step);
      while (todo-- > 0 && frames < target) {
        self.world.step(step);
        frames++;
        while (ni < nudges.length && nudges[ni].frame === frames) self.nudge(nudges[ni++]);
        quiet = self.moving() && !self.slow() ? 0 : quiet + 1;
        // A die leaning on another die is still readable. Do not keep a
        // motionless roll waiting for perfect flatness or a later nudge.
        // The final face check below reconciles the result before releasing it.
        if (frames >= 45 && quiet >= 12 && self.bodies.length) { target = frames; break; }
      }
      self.bodies.forEach(function (b, i) {
        var m = self.meshes[i];
        m.position.set(b.position.x, b.position.y, b.position.z);
        m.quaternion.set(b.quaternion.x, b.quaternion.y, b.quaternion.z, b.quaternion.w);
        if (m.userData.halo) m.userData.halo.position.set(b.position.x, 0.01, b.position.z);
      });
      self.renderer.render(self.scene, self.camera);
      // A readable result need not wait for the dice to finish sliding.
      // Only reveal once every upward face shows its actual rolled value.
      if (!valuesShown && frames >= 30 && self.bodies.length && self.bodies.every(function (b, i) {
        return self.flatness(plan.throws[i].kind, b) >= 0.97 &&
          b.angularVelocity.lengthSquared() < 0.5 && Math.abs(b.velocity.y) < 0.5 &&
          plan.numbers[i][self.up(plan.throws[i].kind, b)] === plan.throws[i].want;
      })) {
        valuesShown = true;
        if (onValues) onValues();
      }
      if (frames >= target) {
        self.raf = 0;
        var faces = self.bodies.map(function (b, i) {
          var up = self.up(plan.throws[i].kind, b);
          return { up: up, value: plan.numbers[i][up] };
        });
        // should the replay have strayed from the plan, the die is relabelled
        // where it lies: the number the sheet rolled is what must be read
        var fixed = false;
        faces.forEach(function (f, i) {
          var t = plan.throws[i];
          if (f.value === t.want) return;
          var s = self.shapes[t.kind];
          var rand = rng((plan.seed || 1) ^ (i + 1) * 0x9e3779b9);
          plan.numbers[i] = s.byVertex ? numberingD4(f.up, t.want, rand) : numbering(s, f.up, t.want, rand, t.mode);
          self.meshes[i].material = faceMaterials(s, plan.numbers[i], t.look, t.mode);
          f.value = t.want; f.corrected = true; fixed = true;
        });
        if (fixed) self.renderer.render(self.scene, self.camera);
        self.onDone = null;
        self.settled();
        if (!valuesShown && onValues) onValues();
        onDone(faces);
        return;
      }
      self.raf = requestAnimationFrame(frame);
    }
    this.raf = requestAnimationFrame(frame);
  };

  Tray.prototype.stop = function () {
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
    // a roll cut short still answers whoever waits on it
    if (this.onDone) { var f = this.onDone; this.onDone = null; f(null); }
    if (this.hold) { clearTimeout(this.hold); this.hold = 0; }
    if (this.fadeT) { clearTimeout(this.fadeT); this.fadeT = 0; }
    if (this.idleRaf) { cancelAnimationFrame(this.idleRaf); this.idleRaf = 0; }
  };

  /** Keep drawing dice at rest whose light breathes, until they go. */
  Tray.prototype.idle = function () {
    var self = this;
    if (this.idleRaf) cancelAnimationFrame(this.idleRaf);
    function spin(now) {
      if (!self.meshes || !self.meshes.length) { self.idleRaf = 0; return; }
      CLOCK.value = now / 1000;
      self.renderer.render(self.scene, self.camera);
      self.idleRaf = requestAnimationFrame(spin);
    }
    this.idleRaf = requestAnimationFrame(spin);
  };

  Tray.prototype.clear = function () {
    this.stop();
    this.settled();
    this.clearBodies();
    this.dropMeshes();
    if (this.host) this.host.classList.remove('is-live');
    if (this.renderer) this.renderer.render(this.scene, this.camera);
  };

  /* ---------------------------------------------------------- previews */

  var previews = {};                 // set key -> data url
  var queue = [], pumping = false, pv = null;
  var previewsShown = null;
  var PW = 320, PH = 180, PFACE = 160;

  function previewKey(set) { return setKey(set); }

  /** Turn a die so face 0 looks at the camera, tipped by (tx, ty), with the
   *  face's own up the right way round. */
  function facing(shape, tx, ty) {
    var fr = shape.frames[0], normal = new THREE.Vector3(tx, ty, 1).normalize();
    var up = new THREE.Vector3(0, normal.z, -normal.y);
    var right = new THREE.Vector3().crossVectors(up, normal);
    var from = new THREE.Matrix4().makeBasis(fr.ax, fr.ay, shape.normals[0]).transpose();
    var to = new THREE.Matrix4().makeBasis(right, up, normal);
    return new THREE.Quaternion().setFromRotationMatrix(to.multiply(from));
  }

  /** The little stage the previews are shot on: the set's three dice side
   *  by side -- the Hero die, a pool d6 in the middle, the Shadow die --
   *  lit like the tray. */
  function previewStage() {
    if (pv) return pv;
    var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, preserveDrawingBuffer: true });
    renderer.setPixelRatio(Math.min(w.devicePixelRatio || 1, 2));
    renderer.setSize(PW, PH);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.1;
    var scene = new THREE.Scene();
    scene.environment = environment();
    var camera = new THREE.PerspectiveCamera(24, PW / PH, 0.1, 50);
    camera.position.set(0, 0, 5.4);
    camera.lookAt(0, 0, 0);
    scene.add(new THREE.AmbientLight(0xffffff, 0.8));
    var key = new THREE.DirectionalLight(0xfff4e0, 1.9);
    key.position.set(-2.5, 3.5, 4);
    scene.add(key);
    var rim = new THREE.DirectionalLight(0x9fb4ff, 0.6);
    rim.position.set(3, 1, -3);
    scene.add(rim);
    var sh = buildShapes();
    var slots = [
      { role: 'hero', shape: sh.d12, x: -1.08, want: 10, tx: -0.22, ty: 0.3, scale: 0.8 },
      // the pool die faces the viewer with the Drakonym mark, its underside showing
      { role: 'pool', shape: sh.d6, x: 0, want: 6, tx: 0, ty: 0.5, scale: 0.86 },
      { role: 'shadow', shape: sh.d12, x: 1.08, want: 11, tx: 0.3, ty: 0.3, scale: 0.8 }
    ].map(function (sl, i) {
      sl.q = facing(sl.shape, sl.tx, sl.ty);
      sl.visible = [];
      sl.shape.normals.forEach(function (n, k) { if (n.clone().applyQuaternion(sl.q).z > 0.08) sl.visible.push(k); });
      sl.numbers = numbering(sl.shape, 0, sl.want, rng(7 + i));
      if (sl.shape === sh.d12) {
        var r = { shape: sh.d12r };
        r.q = facing(r.shape, sl.tx, sl.ty);
        r.visible = [];
        r.shape.normals.forEach(function (n, k) { if (n.clone().applyQuaternion(r.q).z > 0.08) r.visible.push(k); });
        r.numbers = numbering(r.shape, 0, sl.want, rng(7 + i));
        sl.rhombic = r;
      }
      return sl;
    });
    pv = { renderer: renderer, scene: scene, camera: camera, slots: slots, meshes: [] };
    return pv;
  }

  function shoot(set) {
    var st = previewStage();
    if (st.renderer.getContext().isContextLost()) throw new Error('the preview stage lost its context');
    st.meshes.forEach(function (m) { st.scene.remove(m); });
    st.meshes = st.slots.map(function (sl) {
      var look = lookOf(set, sl.role, 0);
      var pose = sl.rhombic && roleLook(set, sl.role).shape === 'rhombic' ? sl.rhombic : sl;
      var mats = faceMaterials(pose.shape, pose.numbers, look, null, { size: PFACE, only: pose.visible });
      var m = new THREE.Mesh(meshGeometry(pose.shape, look), mats);
      m.quaternion.copy(pose.q);
      m.position.set(sl.x, 0, 0);
      // a rhombic d12 stands taller than the pentagonal one
      m.scale.setScalar(sl.scale * (pose === sl ? 1 : 0.84));
      st.scene.add(m);
      return m;
    });
    st.renderer.render(st.scene, st.camera);
    return st.renderer.domElement.toDataURL('image/png');
  }

  function pump() {
    if (pumping || !queue.length) return;
    pumping = true;
    var set = queue.shift(), key = previewKey(set);
    libs().then(fonts).then(function () { return artReady(set); }).then(function () {
      if (previewsShown === false) return;
      var url = shoot(set);
      previews[key] = url;
      // any picture on the page waiting for this set
      var imgs = d.querySelectorAll('img[data-dk3d-preview="' + set.id + '"]');
      for (var i = 0; i < imgs.length; i++) { imgs[i].src = url; imgs[i].removeAttribute('data-wait'); }
    }).catch(function (e) {
      try { console.warn('dice3d preview', e && e.message); } catch (x) {}
      // with no engine to shoot on, the rest of the queue would only fail the same way
      if (!THREE) queue.length = 0;
    }).then(function () {
      pumping = false;
      if (queue.length && previewsShown !== false) requestAnimationFrame(pump);
    });
  }

  /* ------------------------------------------------------- what is public */

  var tray = null;
  var supportedFlag = null;

  function supported() {
    if (supportedFlag !== null) return supportedFlag;
    try {
      var cv = d.createElement('canvas');
      supportedFlag = !!(cv.getContext('webgl2') || cv.getContext('webgl'));
    } catch (e) { supportedFlag = false; }
    return supportedFlag;
  }

  function reducedMotion() {
    try { return w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function seedNow() {
    return (Date.now() ^ Math.floor(Math.random() * 0x7fffffff)) & 0x7fffffff;
  }

  /** The sheet's dice as dice to throw. A die is {kind, v} as the sheet and
   *  the table log keep it ('d6', 'd12', 'hero', 'shadow'), or {s, v}. A d100
   *  is two d10, tens and units; a die of a size no one owns is left out. */
  function toThrow(dice, set, seed) {
    var rand = rng(seed ^ 0x2545f491), out = [], logical = 0;
    (dice || []).forEach(function (die) {
      if (!die || logical >= 24) return;
      var kind = die.kind, s = +die.s, v = +die.v, role = 'pool';
      if (kind === 'hero' || kind === 'shadow') { role = kind; s = 12; }
      else if (typeof kind === 'string' && /^d\d+$/.test(kind)) s = +kind.slice(1);
      if (!s) s = 6;
      if (!Number.isInteger(v) || !(v >= 1 && v <= s)) return;
      if ([4, 6, 8, 10, 12, 20, 100].indexOf(s) === -1) return;
      logical++;
      var faces = roleLook(set, role).face || ['#888888'];
      var colour = Math.floor(rand() * faces.length);
      if (s === 100) {
        var t = Math.floor(v / 10) % 10, u = v % 10;
        out.push({ kind: 'd10', mode: 'tens', want: t === 0 ? 10 : t, colour: colour, role: role });
        out.push({ kind: 'd10', mode: 'units', want: u === 0 ? 10 : u, colour: colour, role: role });
      } else {
        var kind = s === 12 && roleLook(set, role).shape === 'rhombic' ? 'd12r' : 'd' + s;
        out.push({ kind: kind, want: Math.max(1, Math.min(s, v)), colour: colour, role: role });
      }
    });
    return out;
  }

  var showEpoch = 0, pendingShow = null;
  function cancelShow(reason) {
    showEpoch++;
    if (pendingShow) pendingShow.finish({ ok: false, cancelled: true, superseded: reason === 'superseded' });
    if (tray) tray.clear();
  }

  // where published designs are listed: the public dice-designs bucket
  var DESIGNS_URL = 'https://ivtdsbuzdjjzgvbjexfx.supabase.co/storage/v1/object/public/dice-designs/manifest.json';
  var designsLoad = null;

  var API = {
    supported: supported,
    enabled: function () { return !!prefs().on; },
    setEnabled: function (v) { prefs().on = !!v; savePrefs(); if (!v) API.clear(); },
    /** Would a roll made now be thrown? */
    live: function () { return API.enabled() && supported() && !reducedMotion(); },
    previewsVisible: function (value) {
      previewsShown = !!value;
      if (value) { if (queue.length) pump(); }
      else queue = [];
    },
    sets: function () { return SETS; },
    /** Add sets published outside the code (the designs manifest, the Studio).
     *  A set naming games is only added where it says; one with an id already
     *  here replaces it only when it says `replace`. */
    addSets: function (list) {
      var added = 0;
      (list || []).forEach(function (s) {
        if (!s || !s.id || (s.games && s.games.indexOf('drakonym') < 0)) return;
        var at = -1;
        for (var i = 0; i < ALL_SETS.length; i++) if (ALL_SETS[i].id === s.id) at = i;
        if (at >= 0 && !s.replace) return;
        if (at >= 0) ALL_SETS[at] = s; else ALL_SETS.push(s);
        var j = -1;
        for (var k = 0; k < SETS.length; k++) if (SETS[k].id === s.id) j = k;
        if (!s.hidden) { if (j >= 0) SETS[j] = s; else SETS.push(s); }
        delete previews[previewKey(s)];
        added++;
      });
      return added;
    },
    /** Fetch the designs manifest ({ sets: [...] }) and add its sets. */
    loadDesigns: function (url) {
      url = url || w.DK_DICE_DESIGNS || DESIGNS_URL;
      if (!url || url === 'none' || !w.fetch) return Promise.resolve(0);  // 'none' turns the manifest off
      if (designsLoad && !arguments.length) return designsLoad;
      var p = fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 't=' + Math.floor(Date.now() / 60000), { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : { sets: [] }; })
        .then(function (m) { return API.addSets((m && m.sets) || []); })
        .catch(function () { return 0; });
      if (!arguments.length) designsLoad = p;
      return p;
    },
    /** Fetch a set's artwork (textures, face maps, marks) ahead of use. */
    art: function (set) { return artReady(typeof set === 'string' ? setById(set) : set); },
    setId: function () { return currentSet().id; },
    set: currentSet,
    byId: function (id) { return setById(id); },
    choose: function (id) { var s = setById(id); if (s.id === id && earned(s)) { prefs().set = id; savePrefs(); } },
    /** Has the player earned this set? Sets that are not rewards always are. */
    earned: function (id) { return earned(setById(id)); },
    /** Fetch (or, with true, refetch) the player's unlocked rewards. */
    unlocks: function (again) { return loadUnlocks(again); },
    ready: function () { return !!(THREE && CANNON); },

    /** Fetch the libraries and build the solids ahead of the first roll. */
    prefetch: function () {
      if (!API.live()) return Promise.resolve(false);
      var epoch = showEpoch;
      loadUnlocks();
      return libs().then(fonts).then(function () {
        if (epoch !== showEpoch || !API.enabled()) return false;
        if (!tray) tray = new Tray();
        tray.init();
        return true;
      }).catch(function () { return false; });
    },

    /** Throw these dice so they land as the sheet rolled.
     *  opts: set (a set id: another player's dice on the board), stage (an
     *  element to throw over instead of the page), seed (the same seed
     *  throws the same way), hold (ms the dice rest before they go),
     *  onValues (called once the rolled faces can be read). */
    show: function (dice, opts) {
      opts = opts || {};
      if (!API.live()) return Promise.resolve({ ok: false });
      var set = opts.set ? setById(opts.set) : currentSet();
      var seed = opts.seed || seedNow();
      var list = toThrow(dice, set, seed);
      if (!list.length) return Promise.resolve({ ok: false });
      cancelShow('superseded');
      var epoch = showEpoch;
      return new Promise(function (done) {
        var finished = false, deadline;
        var request = { finish: function (result) {
          if (finished) return;
          finished = true;
          clearTimeout(deadline);
          if (pendingShow === request) pendingShow = null;
          done(result);
        } };
        pendingShow = request;
        deadline = setTimeout(function () {
          if (finished) return;
          request.finish({ ok: false, timeout: true });
          if (epoch === showEpoch && tray) tray.clear();
        }, 30000);
        function active() { return !finished && epoch === showEpoch && API.enabled(); }
        libs().then(fonts).then(function () { return artReady(set); }).then(function () {
          if (!active()) return;
          if (!tray) tray = new Tray();
          tray.init();
          tray.stage(opts.stage || null);
          tray.clear();
          tray.fit();
          if (tray.viewport && (tray.viewport.w < 120 || tray.viewport.h < 120)) {
            request.finish({ ok: false }); return;
          }
          prune(setKey(set));
          var plan = tray.arrange(list, seed);
          tray.buildMeshes(plan.throws, plan.numbers, set);
          tray.play(plan, function (faces) {
            if (!faces) { request.finish({ ok: false, cancelled: true, superseded: true }); return; }
            if (!active()) return;
            var values = faces.map(function (f) { return f.value; });
            var wanted = plan.throws.map(function (t) { return t.want; });
            var corrected = faces.filter(function (f) { return f.corrected; }).length;
            var ok = values.join() === wanted.join();
            if (corrected) { try { console.warn('dice3d: ' + corrected + ' die relabelled at rest'); } catch (e) {} }
            // the dice rest a while for reading, then leave the page
            tray.hold = setTimeout(function () {
              if (epoch !== showEpoch) return;
              tray.host.classList.remove('is-live');
              tray.fadeT = setTimeout(function () { if (epoch === showEpoch) tray.clear(); }, 460);
            }, opts.hold == null ? 2800 : opts.hold);
            if (ROLES.some(function (r) { return roleLook(set, r).escape; })) tray.idle();
            request.finish({ ok: ok, values: values, wanted: wanted, seed: seed, corrected: corrected });
          }, function () {
            if (active() && typeof opts.onValues === 'function') opts.onValues();
          });
        }).catch(function (e) {
          if (!active()) return;
          try { console.warn('dice3d unavailable', e && e.message); } catch (x) {}
          request.finish({ ok: false, error: e });
          if (tray) tray.clear();
        });
      });
    },

    clear: function () { cancelShow('cleared'); },

    /** The chooser's pictures: a set's three dice as a data url once they
     *  have been shot, or null, which queues the shot; an <img> carrying
     *  data-dk3d-preview="<set id>" is filled in when it is ready. */
    preview: function (set) {
      set = typeof set === 'string' ? setById(set) : set;
      var key = previewKey(set);
      if (previews[key]) return previews[key];
      if (supported() && !queue.some(function (s) { return previewKey(s) === key; })) {
        queue.push(set);
        requestAnimationFrame(pump);
      }
      return null;
    },

    /** A still of a set's pool d6s showing the given faces (default a 6 and a 1), side by side on
     *  the preview stage: a promise of a PNG data URL. For showing a set off outside a throw.
     *  tilt [x, y] turns every die's face that way (default [0.18, 0.3]). */
    pairPreview: function (set, values, tilt) {
      set = typeof set === 'string' ? setById(set) : set;
      values = values && values.length ? values : [6, 1];
      return libs().then(fonts).then(function () { return artReady(set); }).then(function () {
        var st = previewStage(), d6 = buildShapes().d6, n = values.length, look = lookOf(set, 'pool', 0);
        st.meshes.forEach(function (m) { st.scene.remove(m); });
        st.meshes = values.map(function (v, i) {
          var q = facing(d6, tilt ? tilt[0] : 0.18, tilt ? tilt[1] : 0.3), visible = [];  // every die in the same pose
          d6.normals.forEach(function (nm, k) { if (nm.clone().applyQuaternion(q).z > 0.08) visible.push(k); });
          var m = new THREE.Mesh(meshGeometry(d6, look), faceMaterials(d6, numbering(d6, 0, v, rng(11 + i)), lookOf(set, 'pool', i), null, { size: PFACE, only: visible }));
          m.quaternion.copy(q);
          m.position.set((i - (n - 1) / 2) * (2.1 / n), 0, 0);
          m.scale.setScalar(Math.min(0.9, 1.9 / n));
          st.scene.add(m);
          return m;
        });
        st.renderer.render(st.scene, st.camera);
        return st.renderer.domElement.toDataURL('image/png');
      });
    },

    /** A die laid flat for its wrap template: the sheet (w by h), each face's
     *  outline, centre and edges (folded or cut), with the solid's frames. */
    wrapLayout: function (kind) {
      return libs().then(function () {
        var s = buildShapes()[kind];
        if (!s) return null;
        var net = s.wrap();
        return { kind: kind, sides: s.sides, byVertex: s.byVertex, w: net.w, h: net.h, faces: net.faces, F: s.F,
                 // each face's way up and across, as points one unit from its centre on the sheet
                 frames: s.frames.map(function (fr, fi) {
                   var at = function (v) { return net.uv(fi, [fr.centre.x + v.x, fr.centre.y + v.y, fr.centre.z + v.z]); };
                   return { R: fr.R, rin: fr.rin, ax: at(fr.ax), ay: at(fr.ay) };
                 }) };
      });
    },

    /** For the tests: the tray, once there is one. */
    _tray: function () { return tray; }
  };

  w.DKDice3D = API;
  // sets published outside the code join the list as soon as they are fetched
  try { API.loadDesigns(); } catch (e) {}
}(window, document));

/* data\cards.js */
// Akeroth: Herald's Wake: the five starter decks.
// Shared by the Illustrator card builder (illustrator/build-cards-v30.jsx) and the browser game.
// Plain ES3 so ExtendScript can read it. The rules are in DESIGN.md.
//
// A deck is 25 cards: its Herald, two Regions of its realm (rare and common) and two Events (both in the
// shared Atlas; the Events are shuffled into the deck), and 20 main-deck cards (decks[].main): its own cards,
// its commons, and a second copy of five of those commons (the last five in each list).
// There is no mana. cost is what a card takes of the 3 Actions you have each turn (0 to 3), and a Unit
// takes that much Space on your field, which holds 6. damage is a Unit's Power (shown as Power everywhere).
// Power budget: 1 Space is 2 Power with no text or 1 with text, 2 Space is 4 or 3, 3 Space 6 or 5.
// fast: true lets a card be played on an opponent's turn, paid from the Actions you saved this round.
//   Unit       goes onto your field. Play: what happens as it lands. Passive: while it's on the field.
//   Evolving Unit  a Dragon that enters as an Egg (1 Space) and grows at the start of your turns: stages[].at is
//              how many of your turns it must survive; bonus is its Power at that stage. It takes 2 Space as a
//              Hatchling and 3 as an Adolescent or Elder, and can't evolve without the room.
//   Equipment  attaches to your Herald (3 at most) and stays from round to round. It takes no Space.
//   Path       replaces your Herald's main ability (not Homecoming). It stays for the rest of the game.
//   Action, Spell  resolve, then go to your Tomb.
// rarity: Common (the shared commons), Uncommon (realm Units, Actions, Spells), Rare (realm Equipment,
// rare Regions), Epic (Evolving Units, Events), Legendary (Paths), Mythic (Heralds). It picks the frame
// colour on the printed cards (grey, blue, green, red, purple, yellow).
// Roll N: roll three dice; each 4, 5 or 6 is a success. The card prints what happens for each number of
// successes, so every roll does something.
// Recall: take any card from your Tomb back into your hand.
// art is a path under herald/art. focus [x, y] frames a Herald's art by hand; zoom enlarges it; shift
// [x, y] nudges it; scale shrinks other art from its bottom edge; cutout: true removes a white background.

var HW = {
  decks: {
    bramble: { name: "Bramble", realm: "Hyhill", style: "Spellslinging and Rifting",
      atlas: ["the-sanctum", "great-forest", "first-war", "shrinking-stone"],
      main: ["whiskersworth", "elder-pegasus", "moon-dragon", "path-mythweaver", "dragon-shield", "turn-back", "guardian-spirit", "travelling-cloak", "hedgehog-forager", "ferretfolk-scout", "study-the-stars", "couriers-dash", "runeward-script", "mindbreak", "winged-boots", "hedgehog-forager", "ferretfolk-scout", "study-the-stars", "runeward-script", "mindbreak"] },
    norag: { name: "Norag", realm: "Faewuld", style: "Spells and Units",
      atlas: ["unthroned-court", "world-tree", "the-shattering", "birth-of-akeroth"],
      main: ["faerie-rogue", "great-cat", "deep-faerie", "moth-dragon", "path-oathbinder", "nightmare-blade", "fae-rose", "glyphstorm", "shard-wolf", "rune-golem", "runeward-script", "arcane-sever", "great-axe", "study-the-stars", "mindbreak", "shard-wolf", "rune-golem", "runeward-script", "arcane-sever", "mindbreak"] },
    hiro: { name: "Hiro", realm: "Erwick", style: "Knights and Equipment",
      atlas: ["sword-promised", "new-erwick", "the-tragedy", "draviks-war"],
      main: ["vanguard", "fire-knight", "death-knight", "beast-slayer", "dragon-knight", "longsword", "reavers-mail", "path-oathless", "goblin-skirmisher", "dogfolk-ranger", "hollow-knight", "mountain-golem", "ambush", "great-axe", "dragon-shield", "goblin-skirmisher", "dogfolk-ranger", "hollow-knight", "mountain-golem", "ambush"] },
    iris: { name: "Iris & Theo", realm: "Mesym", style: "Relics and Spells",
      atlas: ["ekadells-gate", "midnight-court", "morifex", "rabbit-hole"],
      main: ["wandering-ghost", "mirror-dragon", "star-dragon", "path-cerevoker", "scrying-mirror", "star-glass-rings", "paragons-mail", "final-addendum", "hedgehog-forager", "ferretfolk-scout", "study-the-stars", "runeward-script", "mindbreak", "arcane-sever", "ambush", "hedgehog-forager", "ferretfolk-scout", "study-the-stars", "ambush", "runeward-script"] },
    therabir: { name: "Therabir", code: "THE", realm: "Batesian", style: "Dragons and Evolving Units",
      atlas: ["mirenscar", "witheters", "dragonfall", "crowned-sky"],
      main: ["fire-wyrm", "storm-wyrm", "sun-dragon", "shard-dragon", "dragon-keeper", "grodyr-rider", "shadow-dragon", "dragon-spear", "shard-wolf", "mountain-golem", "hollow-knight", "ambush", "runeward-script", "great-axe", "dragon-shield", "shard-wolf", "mountain-golem", "hollow-knight", "ambush", "runeward-script"] }
  },

  // Regions (name: realm, location: the place) make up the Atlas and stay until someone Rifts. Events are
  // shuffled into their deck; once played one lasts until the end of the round (or until another Event is played on top).
  atlas: [
    { id: "the-sanctum", type: "Region", realm: "Hyhill", rarity: "Rare", art: "atlas/the-sanctum.jpg",
      name: "Hyhill", location: "The Sanctum",
      text: "Whenever you play a Spell, +1 Power on the table this round." },
    { id: "great-forest", type: "Region", realm: "Hyhill", rarity: "Common", art: "atlas/hyhill.jpg",
      name: "Hyhill", location: "The Great Forest",
      text: "Units with 1 Power get +1." },
    { id: "unthroned-court", type: "Region", realm: "Faewuld", rarity: "Rare", art: "atlas/unthroned-court.jpg",
      name: "Faewuld", location: "The Unthroned Court",
      text: "Whoever wins the Clash must strike the opponent with the most life." },
    { id: "world-tree", type: "Region", realm: "Faewuld", rarity: "Common", art: "atlas/world-tree.jpg", artist: "Baroness",
      name: "Faewuld", location: "The World Tree",
      text: "At the start of each round, each Herald regains 2 life." },
    { id: "sword-promised", type: "Region", realm: "Erwick", rarity: "Rare", art: "atlas/sword-promised.jpg",
      name: "Erwick", location: "The Sword that was Promised",
      text: "Equipment can't be destroyed." },
    { id: "new-erwick", type: "Region", realm: "Erwick", rarity: "Common", art: "atlas/new-erwick.jpg",
      name: "Erwick", location: "New Erwick",
      text: "Each Herald may hold 4 Equipment." },
    { id: "ekadells-gate", type: "Region", realm: "Mesym", rarity: "Rare", art: "atlas/ekadells-gate.jpg",
      name: "Mesym", location: "Ekadell's Gate",
      text: "No Herald takes more than 3 damage from a Clash." },
    { id: "midnight-court", type: "Region", realm: "Mesym", rarity: "Common", art: "atlas/midnight-court.jpg", artist: "Baroness",
      name: "Mesym", location: "The Midnight Court",
      text: "At the Clash, the Herald with the least Power on the table regains 2 life." },
    { id: "mirenscar", type: "Region", realm: "Batesian", rarity: "Rare", art: "atlas/mirenscar.jpg",
      name: "Batesian", location: "Mirenscar",
      text: "Dragons get +1 Power." },
    { id: "witheters", type: "Region", realm: "Batesian", rarity: "Common", art: "atlas/witheters.jpg", artist: "Baroness",
      name: "Batesian", location: "Witheters",
      text: "Units with 4 or more Power get -1." },
    { id: "first-war", type: "Event", rarity: "Epic", cost: 1, art: "atlas/first-war.jpg",
      name: "The First War",
      text: "Every Unit gets +1 Power." },
    // Was The Shrinking Stone of Hyhill; the id stays so saved decks still load.
    { id: "shrinking-stone", type: "Event", rarity: "Epic", cost: 1, art: "atlas/heimstre-keeper.jpg", focus: [0.47, 1],
      name: "Heimstre's New Keeper",
      text: "All damage Heralds take is reduced by 1." },
    { id: "the-shattering", type: "Event", rarity: "Epic", cost: 1, art: "atlas/the-shattering.jpg", artist: "Bryan",
      name: "The Shattering",
      text: "When played, destroy every Unit with 1 Power or less." },
    // The Spellbreak keeps the old Rabbit Hole id so saved decks still load.
    { id: "rabbit-hole", type: "Event", rarity: "Epic", cost: 1, art: "atlas/rabbit-hole.jpg", artist: "Baroness",
      name: "The Spellbreak",
      text: "The lowest total wins the Clash." },
    { id: "birth-of-akeroth", type: "Event", rarity: "Epic", cost: 1, art: "atlas/birth-of-akeroth.jpg", artist: "Bryan",
      name: "The Birth of Akeroth",
      text: "The Herald with the most life can't be struck." },
    { id: "the-tragedy", type: "Event", rarity: "Epic", cost: 1, art: "atlas/the-tragedy.jpg",
      name: "The Tragedy",
      text: "When played, every Herald takes 2 damage." },
    { id: "draviks-war", type: "Event", rarity: "Epic", cost: 1, art: "atlas/draviks-war.jpg",
      name: "Dravik's War",
      text: "If every field holds the same number of Units, no one wins the Clash." },
    { id: "morifex", type: "Event", rarity: "Epic", cost: 1, art: "atlas/morifex.jpg", artist: "Baroness",
      name: "Morifex",
      text: "When played, every Herald discards a card." },
    { id: "dragonfall", type: "Event", rarity: "Epic", cost: 1, art: "atlas/dragonfall.jpg",
      name: "Dragonfall",
      text: "Dragons get +2 Power." },
    { id: "crowned-sky", type: "Event", rarity: "Epic", cost: 1, art: "atlas/crowned-sky.jpg",
      name: "Festival of the Crowned Sky",
      text: "Dragons can't be destroyed." }
  ],

  cards: [
    // ---------- Commons: shared between decks ----------
    { id: "goblin-skirmisher", deck: "common", type: "Unit", rarity: "Common", cost: 1, tag: "Goblin", damage: 1, art: "cards/goblin-skirmisher.jpg", artist: "Wynter",
      name: "Goblin Skirmisher",
      text: "Roll 0: +1 Power this round.\rRoll 1: +2 Power this round.\rRoll 2: +3 Power this round.\rRoll 3: +4 Power this round." },
    { id: "hedgehog-forager", deck: "common", type: "Unit", rarity: "Common", cost: 1, tag: "Beast", damage: 1, art: "cards/hedgehog-forager.jpg", artist: "Baroness", cutout: true,
      name: "Hedgehog Duellist",
      text: "Play: Recall a card." },
    { id: "ferretfolk-scout", deck: "common", type: "Unit", rarity: "Common", cost: 1, tag: "Beast", damage: 1, fast: true, art: "cards/ferretfolk-scout.jpg", artist: "Wynter",
      name: "Ferretfolk Cook",
      text: "Fast.\rPassive: When this leaves your field, Recall a card." },
    { id: "dogfolk-ranger", deck: "common", type: "Unit", rarity: "Common", cost: 1, tag: "Kin", damage: 1, art: "cards/dogfolk-ranger.jpg", artist: "Wynter",
      name: "Dogfolk Ranger",
      text: "Play: Destroy a Unit with 1 Power or less." },
    { id: "shard-wolf", deck: "common", type: "Unit", rarity: "Common", cost: 2, tag: "Beast", damage: 3, art: "cards/shard-wolf.jpg", artist: "Wynter",
      name: "Shard Wolf",
      text: "Passive: +1 Power while another Beast is on your field." },
    { id: "hollow-knight", deck: "common", type: "Unit", rarity: "Common", cost: 2, tag: "Knight", damage: 3, fast: true, art: "cards/hollow-knight.jpg", cutout: true,
      name: "Hollow Knight",
      text: "Fast.\rPassive: Actions and Spells can't destroy this." },
    // Was Mountain Golem (too like Rune Golem); the id stays so saved decks still load.
    { id: "mountain-golem", deck: "common", type: "Unit", rarity: "Common", cost: 2, tag: "Monster", damage: 4, art: "cards/giant-stone-crab.jpg", artist: "Wynter", cutout: true,
      name: "Giant Stone Crab",
      text: "" },
    { id: "rune-golem", deck: "common", type: "Unit", rarity: "Common", cost: 2, tag: "Construct", damage: 2, art: "cards/rune-golem.jpg", artist: "Wynter",
      name: "Rune Golem",
      text: "Passive: +1 Power for each Equipment on your Herald." },
    { id: "study-the-stars", deck: "common", type: "Action", rarity: "Common", cost: 1, art: "cards/study-the-stars.jpg", artist: "Wynter",
      name: "Study the Stars",
      text: "Play: Look at the top card of your deck. You may put it on the bottom. Then Recall a card." },
    { id: "couriers-dash", deck: "common", type: "Action", rarity: "Common", cost: 1, art: "cards/couriers-dash.jpg", artist: "Wynter",
      name: "Stormrunner's Dash",
      text: "Play: Rift, then Recall a card." },
    { id: "ambush", deck: "common", type: "Action", rarity: "Common", cost: 2, fast: true, art: "cards/ambush.jpg", cutout: true,
      name: "Ambush",
      text: "Fast.\rPlay: Destroy a Unit with 4 or more Power." },
    { id: "runeward-script", deck: "common", type: "Spell", rarity: "Common", cost: 1, fast: true, art: "cards/runeward-script.jpg", artist: "Wynter",
      name: "Verdant Ward",
      text: "Fast.\rPlay: Prevent the next 3 damage you'd take this round." },
    { id: "mindbreak", deck: "common", type: "Spell", rarity: "Common", cost: 1, fast: true, art: "cards/mindbreak.jpg", artist: "Wynter",
      name: "Mindbreak",
      text: "Fast.\rPlay: A Unit gets -2 Power this round." },
    { id: "arcane-sever", deck: "common", type: "Spell", rarity: "Common", cost: 1, art: "cards/arcane-sever.jpg", artist: "Wynter",
      name: "Severing Strike",
      text: "Play: Return an Equipment on any Herald to its owner's hand." },
    { id: "great-axe", deck: "common", type: "Equipment", rarity: "Common", cost: 2, art: "cards/great-axe.jpg", artist: "Wynter", scale: 0.8,
      name: "Great Axe",
      text: "Attach: +2 Power on the table." },
    { id: "winged-boots", deck: "common", type: "Equipment", rarity: "Common", cost: 2, art: "cards/winged-boots.jpg", artist: "Wynter",
      name: "Winged Boots",
      text: "Attach: Rift. +1 Power on the table, and +1 more for each Rift you make this round." },
    { id: "dragon-shield", deck: "common", type: "Equipment", rarity: "Common", cost: 1, art: "cards/dragon-shield.jpg", artist: "Wynter",
      name: "Dragonscale Shield",
      text: "Attach: Prevent the first 2 damage you take each Clash." },
    // ---------- Bramble, Mage Eternal: spellslinging and Rifting ----------
    { id: "bramble", deck: "bramble", type: "Herald", rarity: "Mythic", life: 13, art: "heralds/bramble-wynter.jpg", artist: "Wynter", focus: [0.45, 0.45],
      name: "Bramble", title: "Mage Eternal",
      text: "Your Rift move has no limit a round. Whenever you Rift, +2 Power on the table this round (up to 3 times a round) and Recall a card.\rHomecoming (Hyhill): In the Rift Phase, Rift again." },
    { id: "whiskersworth", deck: "bramble", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Beast", damage: 2, art: "cards/whiskersworth.jpg",
      name: "Whiskersworth",
      text: "Roll 0-1: Destroy a Unit with 1 Power or less.\rRoll 2: Destroy a Unit with 3 Power or less.\rRoll 3: Destroy any Unit." },
    { id: "elder-pegasus", deck: "bramble", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Beast", damage: 1, art: "cards/elder-pegasus.jpg", artist: "Wynter",
      name: "Elder Pegasus",
      text: "Play: Rift." },
    { id: "moon-dragon", deck: "bramble", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 1], shift: [0, -110], art: "cards/moon-dragon.jpg", artist: "Bryan",
      name: "Moon Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "Whenever you Rift, +1 Power this round." },
        { name: "Hatchling", at: 1, bonus: 3, text: "Recall a card as it hatches." },
        { name: "Adolescent", at: 2, bonus: 4, text: "Once a round, when you play a Spell, Rift." },
        { name: "Elder", at: 3, bonus: 5, text: "" }
      ],
      text: "I. Egg · 1 Power: Whenever you Rift, +1 Power this round.\rII. Hatchling · 3 Power: Recall a card as it hatches.\rIII. Adolescent · 4 Power: Once a round, when you play a Spell, Rift.\rIV. Elder · 5 Power." },
    { id: "path-mythweaver", deck: "bramble", type: "Path", rarity: "Legendary", cost: 2, art: "cards/path-mythweaver.jpg",
      name: "Path of the Mythweaver",
      text: "Living Story: Whenever you Rift, +3 Power on the table this round (up to 3 times a round) and Recall a card." },
    { id: "stolen-moment", deck: "bramble", type: "Spell", rarity: "Uncommon", cost: 1, fast: true, art: "cards/echo-of-thought.jpg", artist: "Wynter",
      name: "Moonlit Echo",
      text: "Fast.\rPlay: Copy the last Spell played this round." },
    { id: "turn-back", deck: "bramble", type: "Spell", rarity: "Uncommon", cost: 1, art: "cards/gnawborn-druid.jpg", artist: "Wynter",
      name: "Turn the Tide",
      text: "Play: Return a Unit on any field to its owner's hand." },
    { id: "guardian-spirit", deck: "bramble", type: "Spell", rarity: "Uncommon", cost: 2, fast: true, art: "cards/guardian-spirit.jpg", artist: "Wynter",
      name: "Fawn's Blessing",
      text: "Fast.\rPlay: Prevent 3 damage. Your Units can't be destroyed this round." },
    { id: "travelling-cloak", deck: "bramble", type: "Equipment", rarity: "Rare", cost: 1, art: "cards/travelling-cloak.jpg", artist: "Wynter",
      name: "Bramble's Travelling Cloak",
      text: "Attach: Whenever you Rift, Recall a card." },
    // ---------- Norag, The Fae King: Spells and Units ----------
    { id: "norag", deck: "norag", type: "Herald", rarity: "Mythic", life: 16, art: "heralds/norag-wynter.jpg", artist: "Wynter", focus: [0.43, 0.4], shift: [0, 70],
      name: "Norag", title: "The Fae King",
      text: "+2 Power on the table for each Equipment on your Herald.\rHomecoming (Faewuld): Your Fae Units get +1 Power." },
    { id: "faerie-rogue", deck: "norag", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Fae", damage: 1, fast: true, art: "cards/faerie-rogue.jpg", artist: "Wynter",
      name: "Faerie Rogue",
      text: "Fast.\rPassive: Prevent the first 1 damage you take each Clash." },
    { id: "great-cat", deck: "norag", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Beast", damage: 3, art: "cards/great-cat.jpg", artist: "Wynter",
      name: "Great Cat",
      text: "Roll 0-1: Deal 2 damage to an opponent.\rRoll 2-3: Deal 3 damage to an opponent." },
    { id: "deep-faerie", deck: "norag", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Fae", damage: 4, art: "cards/deep-faerie.jpg", artist: "Wynter",
      name: "Deep Faerie",
      text: "Passive: Opponents' Units with 4 or more Power get -1." },
    { id: "moth-dragon", deck: "norag", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.5], art: "cards/moth-dragon.jpg", artist: "Bryan",
      name: "Aura Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "Prevent the first 1 damage you take each Clash." },
        { name: "Hatchling", at: 1, bonus: 3, text: "" },
        { name: "Adolescent", at: 2, bonus: 4, text: "If you win the Clash, deal 1 extra damage." },
        { name: "Elder", at: 3, bonus: 5, text: "+1 Power on the table for each Equipment on your Herald." }
      ],
      text: "I. Egg · 1 Power: Prevent the first 1 damage you take each Clash.\rII. Hatchling · 3 Power.\rIII. Adolescent · 4 Power: If you win the Clash, deal 1 extra damage.\rIV. Elder · 5 Power: +1 Power on the table for each Equipment on your Herald." },
    { id: "path-oathbinder", deck: "norag", type: "Path", rarity: "Legendary", cost: 2, art: "cards/path-oathbinder.jpg",
      name: "Path of the Oathbinder",
      text: "Living Armament: Your Herald may hold 4 Equipment, and each adds +1 Power on the table." },
    { id: "nightmare-blade", deck: "norag", type: "Equipment", rarity: "Rare", cost: 1, art: "cards/nightmare-blade.jpg", artist: "Wynter",
      name: "Nightmare Blade",
      text: "Attach: If you win the Clash, deal 2 extra damage." },
    { id: "fae-rose", deck: "norag", type: "Equipment", rarity: "Rare", cost: 1, art: "cards/fae-rose.jpg", cutout: true,
      name: "Fae Rose",
      text: "Attach: Your Fae Units get +1 Power." },
    { id: "glyphstorm", deck: "norag", type: "Spell", rarity: "Uncommon", cost: 1, art: "cards/glyphstorm.jpg", artist: "Wynter",
      name: "Prismatic Burst",
      text: "Play: Deal 1 damage to an opponent for each Equipment on your Herald." },
    // ---------- Hiro, the Resilient One: knights and Equipment ----------
    { id: "hiro", deck: "hiro", type: "Herald", rarity: "Mythic", life: 16, art: "heralds/hiro-wynter.jpg", artist: "Wynter", focus: [0.5, 0.42],
      name: "Hiro", title: "the Resilient One",
      text: "Limit Break: Your Knights get +1 Power, or +3 if you were struck last round.\rHomecoming (Erwick): Your Knights can't be destroyed." },
    { id: "vanguard", deck: "hiro", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Knight", damage: 1, art: "cards/vanguard.jpg", artist: "Wynter",
      name: "Vanguard",
      text: "Passive: +1 Power for each Equipment on your Herald, up to +2." },
    { id: "fire-knight", deck: "hiro", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Knight", damage: 3, art: "cards/red-frenzy.jpg", artist: "Wynter",
      name: "Fire Knight",
      text: "Passive: Can't be destroyed while your Herald holds Equipment." },
    { id: "death-knight", deck: "hiro", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Knight", damage: 2, art: "cards/death-knight.jpg", artist: "Wynter",
      name: "Death Knight",
      text: "Roll 0: +1 Power this round.\rRoll 1: +2 Power this round.\rRoll 2-3: +3 Power this round, and deal 1 damage to an opponent." },
    { id: "beast-slayer", deck: "hiro", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Kin", damage: 1, art: "cards/first-cut.jpg", artist: "Wynter",
      name: "Beast Slayer",
      text: "Passive: +2 Power while an opponent has a Beast on their field." },
    { id: "dragon-knight", deck: "hiro", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Knight", damage: 1, art: "cards/dragon-knight.jpg", artist: "Wynter",
      name: "Dragon Knight",
      text: "Passive: +2 Power while an opponent has a Dragon on their field." },
    { id: "longsword", deck: "hiro", type: "Equipment", rarity: "Rare", cost: 2, art: "cards/longsword.jpg", artist: "Wynter",
      name: "Longsword",
      text: "Attach: +2 Power on the table." },
    { id: "reavers-mail", deck: "hiro", type: "Equipment", rarity: "Rare", cost: 1, art: "cards/heavy-armor.jpg", artist: "Wynter",
      name: "Reaver's Mail",
      text: "Attach: When you are struck, deal 2 damage back." },
    { id: "path-oathless", deck: "hiro", type: "Path", rarity: "Legendary", cost: 2, art: "cards/path-oathless.jpg",
      name: "Path of the Oathless",
      text: "Walking Armoury: Your Vault holds 2 cards. Your Units get +1 Power while your Herald holds Equipment." },
    // ---------- Iris & Theo, Morifex Survivors: Relics and Spells ----------
    { id: "iris-theo", deck: "iris", type: "Herald", rarity: "Mythic", life: 14, art: "heralds/iris-theo-the-fall.jpg", artist: "Wynter", focus: [0.5, 0.52], shift: [0, -150],
      name: "Iris & Theo", title: "Morifex Survivors",
      text: "+2 Power on the table for each Relic on your Herald, and +1 for each Spell you play this round.\rHomecoming (Mesym): +1 more Power for each Spell you play this round." },
    { id: "wandering-ghost", deck: "iris", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Paragon", damage: 1, fast: true, art: "cards/angel-wizard.jpg", artist: "Baroness", cutout: true,
      name: "Paragon of Lore",
      text: "Fast.\rPlay: Look at the top card of your deck. You may put it on the bottom." },
    { id: "mirror-dragon", deck: "iris", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.48], art: "cards/mirror-dragon.jpg", artist: "Bryan",
      name: "Mirror Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "When you're struck, the striker takes 1 damage." },
        { name: "Hatchling", at: 1, bonus: 3, text: "As it hatches, return the strongest Unit on the leading opponent's field to their hand." },
        { name: "Adolescent", at: 2, bonus: 4, text: "" },
        { name: "Elder", at: 3, bonus: 5, text: "+1 Power on the table for each Spell you play this round." }
      ],
      text: "I. Egg · 1 Power: When you're struck, the striker takes 1 damage.\rII. Hatchling · 3 Power: As it hatches, return the strongest Unit on the leading opponent's field to their hand.\rIII. Adolescent · 4 Power.\rIV. Elder · 5 Power: +1 Power on the table for each Spell you play this round." },
    { id: "star-dragon", deck: "iris", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.45], art: "cards/star-dragon.jpg", artist: "Bryan",
      name: "Astral Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "" },
        { name: "Hatchling", at: 1, bonus: 3, text: "Recall a card as it hatches." },
        { name: "Adolescent", at: 2, bonus: 4, text: "Whenever you play a Spell, +1 Power this round." },
        { name: "Elder", at: 3, bonus: 5, text: "Whenever you play a Spell, deal 1 damage to the leading opponent." }
      ],
      text: "I. Egg · 1 Power.\rII. Hatchling · 3 Power: Recall a card as it hatches.\rIII. Adolescent · 4 Power: Whenever you play a Spell, +1 Power this round.\rIV. Elder · 5 Power: Whenever you play a Spell, deal 1 damage to the leading opponent." },
    { id: "path-cerevoker", deck: "iris", type: "Path", rarity: "Legendary", cost: 2, art: "cards/path-cerevoker.jpg",
      name: "Path of the Cerevoker",
      text: "Mindlink: +1 Power on the table for each Spell you play this round. The first each round deals 1 damage to the leading opponent.\rShared Agony: When you're struck, the striker takes 1 damage too." },
    { id: "scrying-mirror", deck: "iris", type: "Equipment", rarity: "Rare", cost: 1, tag: "Relic", art: "cards/scrying-mirror.jpg", cutout: true,
      name: "Scrying Mirror",
      text: "Attach: Once a round, when you play a Spell, Recall a card." },
    { id: "star-glass-rings", deck: "iris", type: "Equipment", rarity: "Rare", cost: 2, tag: "Relic", art: "cards/star-glass-rings.jpg", artist: "Wynter",
      name: "Star-Glass Rings",
      text: "Attach: +1 Power on the table for each Spell you play this round." },
    { id: "paragons-mail", deck: "iris", type: "Equipment", rarity: "Rare", cost: 1, tag: "Relic", art: "cards/reavers-mail.jpg", artist: "Wynter",
      name: "Paragon's Mail",
      text: "Attach: Prevent 1 damage each Clash for each Relic on your Herald." },
    { id: "final-addendum", deck: "iris", type: "Spell", rarity: "Uncommon", cost: 1, art: "cards/final-addendum.jpg", artist: "Wynter",
      name: "Void Reaping",
      text: "Roll 0-2: Deal 1 damage to a Herald.\rRoll 3: Deal 2 damage to a Herald." },
    // ---------- Therabir, the Shadowed King: Dragons and Evolving Units ----------
    { id: "therabir", deck: "therabir", type: "Herald", rarity: "Mythic", life: 12, art: "heralds/therabir.jpg", artist: "Selwyn", focus: [0.5, 0.4],
      name: "Therabir", title: "the Shadowed King",
      text: "Your Dragons get +1 Power. Your Elder Dragons take 1 less Space.\rHomecoming (Batesian): Heralds you strike discard a card at random." },
    { id: "fire-wyrm", deck: "therabir", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.62], art: "cards/fire-wyrm.jpg", artist: "Bryan",
      name: "Pyre Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "Opponents' Units with 1 Power get -1." },
        { name: "Hatchling", at: 1, bonus: 3, text: "Deal 1 damage to the leading opponent as it hatches." },
        { name: "Adolescent", at: 2, bonus: 4, text: "If you win the Clash, deal 1 extra damage." },
        { name: "Elder", at: 3, bonus: 5, text: "Your other Dragons get +1 Power." }
      ],
      text: "I. Egg · 1 Power: Opponents' Units with 1 Power get -1.\rII. Hatchling · 3 Power: Deal 1 damage to the leading opponent as it hatches.\rIII. Adolescent · 4 Power: If you win the Clash, deal 1 extra damage.\rIV. Elder · 5 Power: Your other Dragons get +1 Power." },
    { id: "storm-wyrm", deck: "therabir", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.42], art: "cards/storm-wyrm.jpg", artist: "Bryan",
      name: "Storm Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "" },
        { name: "Hatchling", at: 1, bonus: 3, text: "Recall a card as it hatches." },
        { name: "Adolescent", at: 2, bonus: 4, text: "Your Units can't be destroyed." },
        { name: "Elder", at: 3, bonus: 5, text: "+1 Power on the table for each other Dragon you control." }
      ],
      text: "I. Egg · 1 Power.\rII. Hatchling · 3 Power: Recall a card as it hatches.\rIII. Adolescent · 4 Power: Your Units can't be destroyed.\rIV. Elder · 5 Power: +1 Power on the table for each other Dragon you control." },
    { id: "sun-dragon", deck: "therabir", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.38], art: "cards/sun-dragon.jpg", artist: "Bryan",
      name: "Sun Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "At the Clash, regain 1 life." },
        { name: "Hatchling", at: 1, bonus: 3, text: "Regain 2 life as it hatches." },
        { name: "Adolescent", at: 2, bonus: 4, text: "Your other Dragons can't be destroyed." },
        { name: "Elder", at: 3, bonus: 5, text: "At the Clash, regain 2 life." }
      ],
      text: "I. Egg · 1 Power: At the Clash, regain 1 life.\rII. Hatchling · 3 Power: Regain 2 life as it hatches.\rIII. Adolescent · 4 Power: Your other Dragons can't be destroyed.\rIV. Elder · 5 Power: At the Clash, regain 2 life." },
    { id: "shard-dragon", deck: "therabir", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, artFocus: [0.5, 0.45], art: "cards/shard-dragon.jpg", artist: "Bryan",
      name: "Shard Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "It can't be destroyed." },
        { name: "Hatchling", at: 1, bonus: 3, text: "As it hatches, destroy each opponent's Units with 1 Power or less." },
        { name: "Adolescent", at: 2, bonus: 4, text: "Opponents' Units with 4 or more Power get -1." },
        { name: "Elder", at: 3, bonus: 5, text: "Your Units can't be destroyed." }
      ],
      text: "I. Egg · 1 Power: It can't be destroyed.\rII. Hatchling · 3 Power: As it hatches, destroy each opponent's Units with 1 Power or less.\rIII. Adolescent · 4 Power: Opponents' Units with 4 or more Power get -1.\rIV. Elder · 5 Power: Your Units can't be destroyed." },
    { id: "dragon-keeper", deck: "therabir", type: "Unit", rarity: "Uncommon", cost: 1, tag: "Kin", damage: 1, art: "cards/dragon-keeper.jpg", artist: "Wynter",
      name: "Dragon Keeper",
      text: "Roll 0-1: An Evolving Unit on your field evolves to its next stage.\rRoll 2-3: An Evolving Unit on your field evolves twice." },
    { id: "grodyr-rider", deck: "therabir", type: "Unit", rarity: "Uncommon", cost: 2, tag: "Beast", damage: 4, art: "cards/grodyr-rider.jpg", artist: "Wynter",
      name: "Grodyr Rider",
      text: "" },
    { id: "shadow-dragon", deck: "therabir", type: "Evolving Unit", rarity: "Epic", cost: 1, tag: "Dragon", damage: 0, fast: true, artFocus: [0.5, 0.5], art: "cards/shadow-dragon.jpg", artist: "Wynter",
      name: "Shadow Dragon",
      stages: [
        { name: "Egg", at: 0, bonus: 1, text: "Fast. If it's played on an opponent's turn, it hatches at once." },
        { name: "Hatchling", at: 1, bonus: 3, text: "As it hatches, the leading opponent discards a card." },
        { name: "Adolescent", at: 2, bonus: 4, text: "+1 Power on the table while any opponent has more life than you." },
        { name: "Elder", at: 3, bonus: 5, text: "The Herald you strike discards a card." }
      ],
      text: "I. Egg · 1 Power: Fast. If it's played on an opponent's turn, it hatches at once.\rII. Hatchling · 3 Power: As it hatches, the leading opponent discards a card.\rIII. Adolescent · 4 Power: +1 Power on the table while any opponent has more life than you.\rIV. Elder · 5 Power: The Herald you strike discards a card." },
    { id: "dragon-spear", deck: "therabir", type: "Equipment", rarity: "Rare", cost: 1, art: "cards/dragon-spear.jpg", artist: "Wynter",
      name: "Dragon Spear",
      text: "Attach: Your Dragons get +1 Power." }
  ]
};

/* data\rules.js */
// Akeroth: Herald's Wake: the rules, keywords and symbols, in one place.
// Read by the in-game rules guide, the card compendium and tools/design.mjs (which writes DESIGN.md),
// so change the wording here and nowhere else. Plain ES3, like cards.js. Text may use <b> and <i>.

HW.rules = {
  intro: "Each player brings a Herald and a 25-card deck. Every round each player takes three turns, spending Actions to build up " +
         "Power on the table, and then the Clash decides who strikes whom. There is no mana, and every card does what it says. " +
         "Win by Victory, Dominion or Survival.",

  // The rules in the order a new player needs them.
  sections: [
    { title: "Your deck", points: [
      "<b>25 cards:</b> 1 Herald, 2 Regions, 2 Events and 20 main-deck cards.",
      "Your <b>Herald</b> sits beside your field. It has life, a main ability and a Homecoming ability.",
      "Your Regions go into the shared <b>Atlas</b>. Your two <b>Events</b> are shuffled into your deck with the rest.",
      "You start with <b>5 cards</b> in hand, and you hold <b>5 at most</b>: with 5 in hand you can't draw or Recall, and a card returned to your hand goes to your Tomb instead.",
      "<b>Who goes first:</b> in a duel, roll one die: the first seat has Odds, the second Evens. With three or four, everyone rolls a die and the highest goes first (ties roll again). Turns then go clockwise round the table.",
      "<b>Mulligan:</b> before the first round, keep your 5 cards, or shuffle them all back into your deck and draw a new 5."
    ] },
    { title: "A round", points: [
      "<b>Rift Phase:</b> the Atlas moves on to the next Region.",
      "<b>Main Phase:</b> starting with whoever goes first, players take turns clockwise until each has had <b>three turns</b>. End your turn whenever you like.",
      "Each turn gives you <b>3 Actions</b>. Any you don't spend <b>carry over</b> to your next turn, or pay for Fast and Vaulted cards on opponents' turns. Unspent Actions are lost when the round ends.",
      "Evolving Units grow at the start of each of your turns, so a Dragon played early can reach its Elder stage in one round.",
      "When everyone has had their third turn, the Clash comes.",
      "<b>Clash Phase:</b> the highest Power on the table strikes an opponent.",
      "<b>End Phase:</b> your hand, Equipment, Path and Evolving Units stay (Dragons kept from one round rest for a round, then keep growing). Shuffle your other Units and your Tomb together: <b>2 come back</b> to your hand at random and the rest are <b>Exiled</b>. Then <b>draw 2</b>. You keep only what fits in a hand of 5: the rest are Exiled."
    ] },
    { title: "Actions", points: [
      "The number on the banner at a card's top left is its <b>cost</b>: how many of your Actions playing it takes, from 0 to 3.",
      "<b>Draw a card:</b> 1 Action.",
      "<b>Vault a card:</b> 1 Action, once a round (see Your Vault).",
      "<b>Rift:</b> 1 Action, once a round.",
      "<b>Retire</b> one of your Units to your Tomb: no Actions.",
      "Drawing, Vaulting, Rifting for Actions and Retiring happen on your own turn."
    ] },
    { title: "Space", points: [
      "Your field holds <b>6 Space</b>. A Unit takes Space equal to its cost: a 1-cost Goblin takes 1, a 2-cost Golem takes 2.",
      "With no room for a Unit, Retire one of yours first.",
      "An <b>Evolving Unit</b> takes 1 Space as an Egg, 2 as a Hatchling and 3 as an Adolescent or Elder. <b>It can't evolve without the room.</b>",
      "Equipment, Paths, Actions and Spells take no Space."
    ] },
    { title: "Your Vault", points: [
      "Once a round, for 1 Action, you may <b>Vault</b> a card: put it face down beside you. Your Vault holds 1 card.",
      "Play it <b>at any time</b>, even on an opponent's turn, in any later round. It costs <b>1 less</b> than printed: the Action you spent Vaulting it counts.",
      "On an opponent's turn you pay with Actions you saved from your own turns this round."
    ] },
    { title: "Playing cards", points: [
      "<b>Unit:</b> goes onto your field and takes Space.",
      "<b>Evolving Unit:</b> a Dragon that enters your field as an Egg and evolves at the start of your turns, if it has room.",
      "<b>Equipment:</b> attaches to your Herald (3 at most; a fourth swaps one out) and stays from round to round.",
      "<b>Path:</b> replaces your Herald's main ability for the rest of the game. Homecoming stays.",
      "<b>Action</b> and <b>Spell:</b> do what they say, then go to your Tomb.",
      "<b>Fast</b> cards can be played at any time, even on an opponent's turn, like Instants. They still cost their Actions: on an opponent's turn you pay with Actions you saved from your own turns this round."
    ] },
    { title: "Rolls", points: [
      "Some cards say <b>Roll</b>. Roll three dice: each <b>4, 5 or 6 is a success</b>.",
      "The card says what happens for each number of successes, from 0 to 3, so every roll does something.",
      "A Roll that hurts or destroys picks its own target: the <b>leading opponent</b>, or the strongest Unit it can."
    ] },
    { title: "The Clash", points: [
      "After everyone's turn, each player adds up their <b>Total Power</b>: the Power of every Unit on their field, plus bonuses from their Herald, Equipment, Regions and Dragons. The gold number on each Herald is that total; hover over a Herald to see where it comes from.",
      "The highest total wins and <b>chooses one opponent</b> to strike: they take damage equal to the difference.",
      "A tie at the top means nobody is struck. The player who was struck takes the initiative next round."
    ] },
    { title: "Winning", points: [
      "<b>Victory:</b> bring your rivals to 0 life. In a duel the last Herald standing wins; with three or four, the first Herald to fall ends the game at once and the most life wins, then the most Clashes won.",
      "<b>Dominion:</b> win 4 Clashes and you win at once.",
      "<b>Survival:</b> when the decks run out, the most life wins, then the most Clashes won."
    ] },
    { title: "The Atlas", points: [
      "The Atlas is every Region of every deck at the table: 4 in a duel, 8 with four Heralds.",
      "The Region on top is the current Region and applies to everyone; each Rift Phase the Atlas moves on to the next.",
      "<b>Rift</b>, with a card or for 1 Action: move to the next Region at once. The current Region goes to the bottom of the Atlas."
    ] },
    { title: "Events", points: [
      "Events are in your deck and you draw them like any other card. Playing one costs <b>1 Action</b>, on your own turn (from your Vault too).",
      "It lasts until the end of the round: after the Clash it's gone. If another Event is played on top of it in the same round, only the top one counts."
    ] }
  ],

  // Words printed on cards. term is what appears in bold on the card. reminder, where there is one, is
  // printed in italics on the card after the sentence that first uses the word, as Magic's reminder text.
  keywords: [
    { term: "Roll", text: "Roll three dice; each 4, 5 or 6 is a success. Do what the card says for that many successes.", reminder: "Roll three dice. Each 4, 5 or 6 is a success." },
    { term: "Play", text: "What happens as the card is played." },
    { term: "Passive", text: "Always on while the Unit is on your field." },
    { term: "Attach", text: "Equipment's effect, active while it's on your Herald." },
    { term: "Fast", text: "Can be played at any time, even on an opponent's turn, in response. It still costs its Actions, paid from the ones you saved.", reminder: "You can play this at any time, even on an opponent's turn." },
    { term: "Vault", text: "Once a round, for 1 Action, put a card face down in your Vault. Play it at any time, even on an opponent's turn, for 1 Action less than printed.", reminder: "Once a round, for 1 Action, put a card face down in your Vault. Play it later, any time, for 1 Action less." },
    { term: "Rift", text: "Move to the next Region. The current Region moves to the bottom of the Atlas. You may also Rift for 1 Action, once a round.", reminder: "Move to the next Region. The current Region moves to the bottom of the Atlas." },
    { term: "Recall", text: "Take any card from your Tomb back into your hand.", reminder: "Take any card from your Tomb back into your hand." },
    { term: "Homecoming", text: "Your Herald's second ability. It works while a Region of your Herald's realm is face up.", reminder: "This works while a Region of that realm is face up." },
    { term: "Leading opponent", text: "The opponent with the most life. On a tie, the first of them in turn order." },
    { term: "Struck", text: "You're struck when the Clash winner chooses you." },
    { term: "Power on the table", text: "Your Total Power, the gold number on your Herald: the Power of your Units plus every bonus. Hover over a Herald to see where it comes from." },
    { term: "Exiled", text: "Units and Tomb cards that didn't come back in the End Phase. They're out of the game." },
    { term: "Retire", text: "Take one of your own Units off your field to your Tomb, for no Actions, to make room." },
    { term: "Tomb", text: "Where your played Actions and Spells, and your destroyed and Retired Units, go. It's shuffled in with your Units in the End Phase." },
    { term: "Hand limit", text: "You hold 5 cards at most. With 5 in hand you can't draw or Recall, and a card returned to your hand goes to your Tomb instead." },
    { term: "Evolving", text: "An Evolving Unit's stages: Egg (1 Power, 1 Space), Hatchling after 1 of your turns (3 Power, 2 Space), Adolescent after 2 (4 Power, 3 Space), Elder after 3 (5 Power, 3 Space). With three turns a round, that's one round from Egg to Elder. It can't evolve without the room." }
  ],

  // The numbers on a card: the cost banner at the top left, and Power or life in the name bar's right
  // diamond. img is the picture in play/img/ui (cropped from the printed cards).
  orbs: [
    { id: "cost", img: "sym-cost", name: "Cost", text: "The banner at the top left: how many Actions playing the card takes. A Unit also takes that much Space. Heralds and Regions have none." },
    { id: "power", img: "sym-power", name: "Power (gold)", text: "In the right diamond of the name bar: a Unit's Power on the table. Big Units carry no text; small ones carry effects." },
    { id: "life", img: "sym-life", name: "Life (red)", text: "In the right diamond of a Herald's name bar: its starting life." }
  ],

  // The icon in both diamonds of the name bar (the right one shows Power or life instead, when the card
  // has it). icon is play/img/ui/type-<icon>.webp, made from the card template's own icons.
  types: [
    { type: "Herald", icon: "herald", text: "Your leader. Never shuffled into your deck." },
    { type: "Unit", icon: "unit", text: "Goes onto your field, taking Space equal to its cost, and adds its Power to the Clash." },
    { type: "Evolving Unit", icon: "evolving", text: "A Dragon that evolves through four stages: Egg, Hatchling, Adolescent, Elder." },
    { type: "Equipment", icon: "equipment", text: "Attaches to your Herald and stays from round to round. Relics are Equipment." },
    { type: "Path", icon: "path", text: "A Drakonym Path. Replaces your Herald's main ability for the rest of the game." },
    { type: "Action", icon: "action", text: "A one-off effect, then to the Tomb." },
    { type: "Spell", icon: "spell", text: "A one-off magical effect. Many cards care about Spells." },
    { type: "Region", icon: "region", text: "A place in the Atlas. Applies to everyone while face up; a new one each round." },
    { type: "Event", icon: "event", text: "Played from your hand. Lasts until the end of the round, unless another Event is played on top." }
  ],

  // Deck building: what a custom deck must hold.
  building: [
    "1 Herald, 2 Regions from any realm (only your own realm's bring Homecoming) and 2 Events.",
    "Exactly 20 main-deck cards: your Herald's realm plus neutral cards, from what you own.",
    "Up to 2 of each neutral card, 1 of each realm card, and at most one Path."
  ]
};

/* play\engine.js */
/* Akeroth: Herald's Wake: the rules engine (design v5, see ../DESIGN.md).
   One pure state machine shared by the host's browser and the Node tests. The host is the only
   one who runs it: players send intents, the host applies them and broadcasts the new state.

   HWEngine.create(seed)                       an empty lobby
   HWEngine.apply(state, playerId, intent)     -> { state, error }   (state is replaced, never mutated)
   HWEngine.view(state, playerId)              what one player may see (other hands are hidden)

   Intents: join {name, deck}, leave, pickDeck {deck}, addBot {deck}, removeBot {player}, start, reset,
   mulligan {redraw: bool}, play {uid, from, target, replace}, arsenal {uid}, draw, rift, retire {uid},
   end, choose {pick}.

   Actions, not mana. Each round every player takes three turns in seat order, and each turn adds
   3 Actions to their pool; what's left carries to their next turn and the pool empties when the round
   ends. A card costs 0 to 3 Actions; a Unit also takes that much Space on your field, which holds 6
   (an Evolving Unit takes 1 as an Egg and grows into more, and can't evolve without room). You may also
   Draw (1 Action), Vault a card (1, once a round), Rift (1, once a round) or Retire one of your Units
   (free). End your turn when you like. A Fast card can be played at any time, paid from your saved
   Actions. An Event lasts until the end of the round. After everyone's third turn, the Clash: the highest
   Power on the table strikes one opponent for the difference. Then the End Phase: your hand, Equipment,
   Path and Evolving Units stay; your other Units and your Tomb shuffle together, 2 come back to your
   hand, the rest are Exiled,
   and you draw 2. You hold at most 5 cards: with 5 in hand you can't draw, Recall or take more. Win by Victory (last Herald standing; with three or
   four, the first fall ends it), Dominion (4 Clashes won) or Survival (most life when the decks
   run dry). */
(function (root) {
  "use strict";
  var HW = root.HW;

  var MAIN = 20, OLD_MAIN = 15, MAX_PLAYERS = 4, HAND = 5, LIMIT = 5, RENOWN = 4, FROM_DECK = 2, BACK = 2, GEAR_SLOTS = 3, ARSENAL = 1;
  var ACTIONS = 3, TURNS = 3, SPACE = 6, DRAW_COST = 1, VAULT_COST = 1, RIFT_COST = 1;
  var STAGE_SPACE = [1, 2, 3, 3];  // an Evolving Unit's Space at each stage: Egg, Hatchling, Adolescent, Elder

  var CARD = {};
  HW.cards.forEach(function (c) { CARD[c.id] = c; });
  HW.atlas.forEach(function (c) { CARD[c.id] = c; });

  /* ---------- helpers ---------- */

  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  // Mulberry32: a seeded RNG kept in the state so a game replays the same way.
  function rand(s) {
    s.rng = (s.rng + 0x6D2B79F5) | 0;
    var t = s.rng;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  function shuffle(s, a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rand(s) * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function log(s, text, kind) { s.log.push({ r: s.round, text: text, kind: kind || "" }); if (s.log.length > 240) s.log.shift(); }
  function def(c) { return CARD[c.id]; }
  function player(s, pid) { for (var i = 0; i < s.players.length; i++) if (s.players[i].id === pid) return s.players[i]; return null; }
  function alive(s) { return s.players.filter(function (p) { return p.life > 0; }); }
  // The leading opponent: the one with the most life (the first in turn order on a tie). Triggered
  // damage goes to them, so it never grows with the number of players or piles onto whoever is behind.
  function leader(s, p) {
    var seat = function (q) { var i = (s.order || []).indexOf(q.id); return i < 0 ? 99 : i; };
    return others(s, p).sort(function (a, b) { return b.life - a.life || seat(a) - seat(b); })[0] || null;
  }
  function others(s, p) { return alive(s).filter(function (q) { return q.id !== p.id; }); }
  function findIn(list, uid) { for (var i = 0; i < list.length; i++) if (list[i].uid === uid) return i; return -1; }

  function region(s) { return CARD[s.atlas.current]; }
  function isRegion(s, id) { var r = region(s); return !!r && r.type === "Region" && r.id === id; }
  // Events are played from hand onto a shared stack; only the one on top is in force.
  function topEvent(s) { return s.events && s.events.length ? CARD[s.events[s.events.length - 1].id] : null; }
  function isEvent(s, id) { var e = topEvent(s); return !!e && e.id === id; }
  function isEventCard(c) { return def(c).type === "Event"; }
  function home(s, p) { var r = region(s); return !!r && r.type === "Region" && r.realm === HW.decks[p.deck].realm; }
  function hasGear(p, id) { return p.gear.some(function (c) { return c.id === id; }); }
  function onField(p, id) { return p.field.some(function (c) { return c.id === id; }); }
  function relics(p) { return p.gear.filter(function (c) { return def(c).tag === "Relic"; }).length; }
  function heraldOf(p) { return CARD[p.herald]; }
  function ability(p) { return p.path ? p.path.id : p.deck; }  // a Path replaces the Herald's main ability
  function hasText(card, word) { return new RegExp("(^|\\r)" + word + ":").test(def(card).text); }
  function isFast(card) { return !!def(card).fast; }

  // Evolving Unit stage: the last stage whose turn count the Dragon has reached.
  function stageOf(c) {
    var st = def(c).stages, k = 0;
    for (var i = 0; i < st.length; i++) if ((c.turns || 0) >= st[i].at) k = i;
    return k;
  }
  // A card's cost in Actions; a Unit takes that much Space, an Evolving Unit what its stage needs.
  function cost(c) { return def(c).cost || 0; }
  // Therabir's Elder Dragons coil tight: they take 1 less Space.
  function stageSpace(p, k) { return STAGE_SPACE[k] - (p && ability(p) === "therabir" && k === 3 ? 1 : 0); }
  function size(c, p) {
    var d = def(c);
    if (d.type === "Evolving Unit") return stageSpace(p, stageOf(c));
    return d.type === "Unit" ? Math.max(1, d.cost || 0) : 0;
  }
  function spaceFree(p) { var n = SPACE; p.field.forEach(function (c) { n -= size(c, p); }); return n; }
  function saga(p, id, stage) { return p.field.some(function (c) { return c.id === id && stageOf(c) === stage; }); }

  /* ---------- lobby and setup ---------- */

  function create(seed) {
    return { v: 3, phase: "lobby", rng: seed | 0, round: 0, players: [], log: [], host: null, uid: 0,
             atlas: { draw: [], current: null }, events: [], turn: null, initiative: 0, pending: null, lastSpell: null, winner: null };
  }

  function heraldFor(deck) { for (var i = 0; i < HW.cards.length; i++) if (HW.cards[i].type === "Herald" && HW.cards[i].deck === deck) return HW.cards[i].id; }
  function newPlayer(s, id, name, deck, bot) {
    return { id: id, name: name, deck: deck, bot: !!bot, herald: heraldFor(deck), life: 0,
             hand: [], draw: [], discard: [], fallen: [], field: [], gear: [], path: null, arsenal: [], list: null,
             actions: 0, owed: 0, acted: false, passed: false, shield: 0, flags: {}, struckLast: false, wins: 0, connected: true };
  }
  // Two players can't share a name at one table: the second "Herald" becomes "Herald 2".
  function freeName(s, name) {
    var taken = function (n) { return s.players.some(function (q) { return q.name === n; }); }, k = 2, out = name;
    while (taken(out)) out = name + " " + k++;
    return out;
  }
  var BOT_NAMES = ["Wren", "Corvin", "Mossbell", "Tamsin"];

  function start(s) {
    s.phase = "mulligan"; s.round = 0;
    // The Atlas is every Region of every deck at the table: 4 in a duel, 8 with four Heralds.
    var atlas = [];
    s.players.forEach(function (p) { atlas = atlas.concat(deckRegions(p)); });
    shuffle(s, atlas);
    s.atlas.current = atlas.shift();
    s.atlas.draw = atlas;
    s.events = [];
    // Each deck is its 20 main cards and its 2 Events, shuffled together: 5 in hand, then 2 a round.
    s.players.forEach(function (p) {
      p.life = heraldOf(p).life;
      p.draw = shuffle(s, mainOf(p).concat(deckEvents(p)).map(function (id) { return { uid: ++s.uid, id: id }; }));
      p.hand = p.draw.splice(0, HAND);
      p.mulligan = true;
    });
    // Who goes first: in a duel one d6, Odds or Evens; with three or four, everyone rolls a die and the highest
    // goes first (ties roll again). s.opening is kept for the table to show.
    s.opening = openingRoll(s);
    s.initiative = s.players.indexOf(player(s, s.opening.first));
    log(s, s.opening.kind === "die" ? "The die shows " + s.opening.die + " (" + (s.opening.die % 2 ? "Odds" : "Evens") + "): " + player(s, s.opening.first).name + " goes first."
      : player(s, s.opening.first).name + " rolls highest and goes first.", "round");
    // The mulligan: each player keeps their opening 5 or redraws all of them. Bots decide at once.
    s.players.forEach(function (p) { if (p.bot) mulligan(s, p, botMulligan(p)); });
    if (s.players.every(function (p) { return !p.mulligan; })) begin(s);
  }
  function begin(s) {
    s.phase = "play";
    log(s, "The Heralds gather. The Atlas opens on " + atlasName(region(s)) + ".", "region");
    newRound(s);
  }
  function openingRoll(s) {
    // A duel: one d6. The first seat calls Odds, the second Evens.
    if (s.players.length === 2) {
      var n = 1 + Math.floor(rand(s) * 6), odds = s.players[0].id, evens = s.players[1].id;
      return { kind: "die", die: n, odds: odds, evens: evens, first: n % 2 ? odds : evens };
    }
    var rolls = {}, tied = s.players.map(function (p) { return p.id; });
    s.players.forEach(function (p) { rolls[p.id] = []; });
    while (tied.length > 1) {
      tied.forEach(function (id) { rolls[id].push(1 + Math.floor(rand(s) * 6)); });
      var best = Math.max.apply(null, tied.map(function (id) { return rolls[id][rolls[id].length - 1]; }));
      tied = tied.filter(function (id) { return rolls[id][rolls[id].length - 1] === best; });
    }
    return { kind: "dice", rolls: rolls, first: tied[0] };
  }
  // The mulligan is all or nothing: keep the hand, or shuffle it back into the deck and draw a new 5.
  function mulligan(s, p, redraw) {
    if (redraw) { p.draw = shuffle(s, p.draw.concat(p.hand)); p.hand = p.draw.splice(0, HAND); }
    p.mulligan = false;
    log(s, p.name + (redraw ? " shuffles their hand away and draws a new one." : " keeps their hand."), "");
  }
  // A bot redraws a hand with two or more 3-cost cards in it.
  function botMulligan(p) { return p.hand.filter(function (c) { return cost(c) >= 3; }).length >= 2; }
  // A deck's two Regions go into the Atlas; its two Events (a custom deck's own picks) into its deck.
  function deckRegions(p) { return p.list && p.list.regions ? p.list.regions : HW.decks[p.deck].atlas.filter(function (id) { return CARD[id].type === "Region"; }); }
  // A custom deck saved before decks grew to 20 holds 15: it's played with its Herald's 5 extra commons.
  function mainOf(p) {
    if (!p.list) return HW.decks[p.deck].main;
    return p.list.main.length === OLD_MAIN ? p.list.main.concat(HW.decks[p.list.herald].main.slice(-(MAIN - OLD_MAIN))) : p.list.main;
  }
  function deckEvents(p) { return p.list ? p.list.events : HW.decks[p.deck].atlas.filter(function (id) { return CARD[id].type === "Event"; }); }

  /* A custom deck: { name, herald (a starter deck's key), regions: [2 Region ids], events: [2 Event ids],
     main: [20 ids] }. The main deck is the Herald's own realm plus neutral cards: up to 2 of each
     neutral card, 1 of each realm card, and at most one Path. Regions may come from any realm (one
     from another realm never brings Homecoming). Returns why it can't be played, or null. Ownership is
     checked where the deck is built. */
  function checkList(l) {
    if (!l || typeof l !== "object") return "That deck can't be read.";
    if (!HW.decks[l.herald]) return "Choose a Herald.";
    if (!Array.isArray(l.events) || l.events.length !== 2) return "A deck needs 2 Events.";
    if (l.events[0] === l.events[1]) return "Choose 2 different Events.";
    for (var i = 0; i < 2; i++) if (!CARD[l.events[i]] || CARD[l.events[i]].type !== "Event") return "Choose 2 Events.";
    if (l.regions) {
      if (!Array.isArray(l.regions) || l.regions.length !== 2) return "A deck needs 2 Regions.";
      if (l.regions[0] === l.regions[1]) return "Choose 2 different Regions.";
      for (var r = 0; r < 2; r++) if (!CARD[l.regions[r]] || CARD[l.regions[r]].type !== "Region") return "Choose 2 Regions.";
    }
    if (!Array.isArray(l.main) || (l.main.length !== MAIN && l.main.length !== OLD_MAIN)) return "A deck needs exactly " + MAIN + " main-deck cards.";
    var n = {}, paths = 0;
    for (var j = 0; j < l.main.length; j++) {
      var c = CARD[l.main[j]];
      if (!c || c.type === "Herald" || c.type === "Region" || c.type === "Event") return "That card can't go in a main deck.";
      if (!inRealm(c, l.herald)) return c.name + " belongs to another Herald's realm.";
      if (c.type === "Path" && ++paths > 1) return "A deck can walk only one Path.";
      n[c.id] = (n[c.id] || 0) + 1;
      if (n[c.id] > copiesAllowed(c)) return "Too many copies of " + c.name + ".";
    }
    return null;
  }
  function copiesAllowed(c) { return c.deck === "common" ? 2 : 1; }
  function inRealm(c, herald) { return c.deck === "common" || c.deck === herald; }
  function cleanList(l) {
    return { name: String(l.name || "Custom deck").slice(0, 40), herald: l.herald, regions: l.regions ? l.regions.slice() : null,
             events: l.events.slice(), main: l.main.slice() };
  }

  function atlasName(c) { return c.location ? c.name + ": " + c.location : c.name; }

  // The Atlas moves on every round: it's a queue, and a round never opens on the
  // Region the last one opened on (a Rift may have brought it back round in the meantime).
  function turnAtlas(s) {
    if (!s.atlas.draw.length) return;
    var was = s.atlas.current;
    s.atlas.draw.push(was);
    s.atlas.current = nextRegion(s, [was, s.atlas.opened]);
    log(s, "The Atlas moves on to " + atlasName(region(s)) + ".", "region");
  }

  function newRound(s) {
    s.round++;
    if (s.round > 1) turnAtlas(s);
    s.atlas.opened = s.atlas.current;
    s.lastSpell = null; s.pending = null;
    // An Event lasts the round it's played in: the Clash is its last moment.
    if (s.events.length) { log(s, topEvent(s).name + " ends with the round.", "event"); s.events = []; }
    alive(s).forEach(function (p) {
      p.passed = false; p.turns = 0; p.shield = 0; p.arsenaled = false; p.actions = 0;
      p.flags = { rifts: 0, riftBonus: 0, riftAct: false, spells: 0, mirror: false, moon: false, rogue: false, egg: false, shieldUsed: false, mailUsed: false, protect: false };
      if (isRegion(s, "world-tree")) heal(p, 2);
    });
    // Bramble's Homecoming: at the start of a round in Hyhill, Bramble Rifts.
    alive(s).forEach(function (p) { if (p.deck === "bramble" && home(s, p)) rift(s, p, true); });  // stays with a Path
    s.order = [];
    for (var i = 0; i < s.players.length; i++) {
      var q = s.players[(s.initiative + i) % s.players.length];
      if (q.life > 0) s.order.push(q.id);
    }
    s.turn = null;
    log(s, "Round " + s.round + ". " + player(s, s.order[0]).name + " has the initiative.", "round");
    beginTurn(s, s.order[0]);
  }

  function heal(p, n) { p.life = Math.min(heraldOf(p).life, p.life + n); }
  // A player is done for the round once they've had their turn (or fallen). p.passed keeps its old name.
  function done(p) { return p.life <= 0 || p.passed; }

  // The next player who hasn't had their turn, in seat order; when everyone has, the Clash.
  function nextTurn(s) {
    if (over(s)) return finish(s);
    var start = s.turn ? s.order.indexOf(s.turn) : -1;
    for (var k = 1; k <= s.order.length; k++) {
      var q = player(s, s.order[(start + k) % s.order.length]);
      if (!done(q)) return beginTurn(s, q.id);
    }
    clash(s);
  }
  // After each thing a player does on their turn: with no Actions left, the turn passes on.
  // A play on someone else's turn (Fast, or from the Vault) can end the game, or fell the player whose
  // turn it is; either way the game moves on rather than waiting on them.
  function afterAction(s, p) {
    if (s.phase !== "play" || s.pending || s.responding) return;
    if (over(s)) return finish(s);
    var now = player(s, s.turn);
    if (now && now.life <= 0) return nextTurn(s);
    if (s.turn !== p.id) return;
    if (p.actions <= 0 || p.life <= 0) { lastTurn(s, p); nextTurn(s); }
  }
  // In a duel the game ends when one Herald is left; with three or four, the moment the first one falls.
  function over(s) { return alive(s).length <= 1 || (s.players.length > 2 && alive(s).length < s.players.length); }
  // Each round you get three turns; after the last you wait for the Clash (and can still play Fast and Vaulted cards).
  function lastTurn(s, p) {
    if (p.passed) return;
    if ((p.turns || 0) >= TURNS) p.passed = true;
    log(s, p.name + " ends their turn" + (p.passed ? ", their last this round." : " (" + p.turns + " of " + TURNS + ")."), "pass");
  }

  function beginTurn(s, pid) {
    var p = player(s, pid);
    if (done(p)) { s.turn = pid; return nextTurn(s); }
    s.turn = pid;
    // Each turn adds 3 Actions to what's left from your earlier turns this round; the pool empties at the round's end.
    p.actions += ACTIONS; p.acted = false; p.turns = (p.turns || 0) + 1;
    // Evolving Units evolve at the start of their owner's turn, if there's room; one kept from last round rests a round first.
    p.field.forEach(function (c) { if (def(c).type !== "Evolving Unit") return; if (c.rest) { delete c.rest; return; } grow(s, p, c, 1); });
    // A hatching Dragon can knock out the player whose turn it is.
    if (done(p) && !s.pending) nextTurn(s);
  }

  function grow(s, p, c, n) {
    var before = stageOf(c), d = def(c), turns = (c.turns || 0) + n;
    c.turns = turns;
    var natural = stageOf(c), after = natural;
    // A bigger stage needs room on the field: without it the Dragon waits at the stage it can fit.
    while (after > before && stageSpace(p, after) - stageSpace(p, before) > spaceFree(p)) after--;
    if (after < natural) {
      c.turns = d.stages[after].at;
      if (after === before) { log(s, p.name + "'s " + d.name + " has no room to grow.", "board"); return; }
    }
    if (after === before) return;
    log(s, p.name + "'s " + d.name + " grows into its " + d.stages[after].name + " stage.", "board");
    if (before === 0 && after >= 1) {
      if (/Recall a card/.test(d.stages[1].text)) recall(s, p, null, d.name + " hatched");
      if (/damage to the leading opponent/.test(d.stages[1].text) && leader(s, p)) damage(s, leader(s, p), 1, d.name);
      if (d.id === "sun-dragon") { heal(p, 2); log(s, p.name + " regains 2 life.", ""); }
      if (d.id === "shadow-dragon" && leader(s, p)) discardRandom(s, leader(s, p));
      if (d.id === "mirror-dragon" && leader(s, p)) {
        var o = leader(s, p), best = -1;
        o.field.forEach(function (u, i) { if (!sturdy(u) && (best < 0 || unitDamage(s, o, u) > unitDamage(s, o, o.field[best]))) best = i; });
        if (best >= 0) { var back = leaveField(s, o, best, "hand"); log(s, def(back).name + " returns to " + o.name + "'s hand.", ""); }
      }
      if (d.id === "shard-dragon") others(s, p).forEach(function (o) {
        for (var i = o.field.length - 1; i >= 0; i--) if (unitDamage(s, o, o.field[i]) <= 1) destroyUnit(s, o, i, c);
      });
    }
  }

  /* ---------- limits ---------- */

  function gearLimit(s, p) { return (ability(p) === "path-oathbinder" || isRegion(s, "new-erwick")) ? 4 : GEAR_SLOTS; }
  function gearSafe(s, p) { return isRegion(s, "sword-promised"); }
  function arsenalLimit(p) { return ability(p) === "path-oathless" ? 2 : ARSENAL; }

  /* ---------- Power on the table (the engine calls a Unit's Power its damage) ---------- */

  function isDragon(c) { return def(c).tag === "Dragon"; }
  function unitDamage(s, p, c) {
    var d = def(c), n = d.type === "Evolving Unit" ? d.stages[stageOf(c)].bonus : (d.damage || 0), base = n;
    n += c.mod || 0;
    if (d.id === "shard-wolf" && p.field.some(function (o) { return o !== c && def(o).tag === "Beast"; })) n += 1;
    if (d.id === "vanguard") n += Math.min(2, p.gear.length);
    if (d.id === "rune-golem") n += p.gear.length;
    if (d.id === "beast-slayer" && others(s, p).some(function (o) { return o.field.some(function (u) { return def(u).tag === "Beast"; }); })) n += 2;
    if (d.id === "dragon-knight" && others(s, p).some(function (o) { return o.field.some(isDragon); })) n += 2;
    if (d.tag === "Fae") { if (p.deck === "norag" && home(s, p)) n += 1; if (hasGear(p, "fae-rose")) n += 1; }
    if (isDragon(c)) {
      if (isRegion(s, "mirenscar")) n += 1;
      if (ability(p) === "therabir") n += 1;  // Therabir: the Shadowed King
      if (hasGear(p, "dragon-spear")) n += 1;
      if (isEvent(s, "dragonfall")) n += 2;
      if (p.field.some(function (o) { return o !== c && o.id === "fire-wyrm" && stageOf(o) === 3; })) n += 1;
    }
    if (isEvent(s, "first-war")) n += 1;
    if (ability(p) === "hiro" && d.tag === "Knight") n += p.struckLast ? 3 : 1;  // Limit Break
    if (ability(p) === "path-oathless" && p.gear.length) n += 1;  // Walking Arsenal
    if (isRegion(s, "great-forest") && base === 1) n += 1;
    // Answers to big Units: each takes 1 from a Unit of 4 or more Power.
    if (isRegion(s, "witheters") && base >= 4) n -= 1;
    others(s, p).forEach(function (o) {
      if (onField(o, "deep-faerie") && base >= 4) n -= 1;
      if (saga(o, "fire-wyrm", 0) && base === 1) n -= 1;
      if (saga(o, "shard-dragon", 2) && base >= 4) n -= 1;
    });
    return Math.max(0, n);
  }
  // Power on the table and where it comes from: each Unit, then each bonus, as [label, n].
  function powerParts(s, p) {
    var parts = [], add = function (label, n) { if (n) parts.push([label, n]); }, spells = p.flags.spells || 0;
    p.field.forEach(function (c) { parts.push([def(c).name, unitDamage(s, p, c)]); });
    if (hasGear(p, "great-axe")) add("Great Axe", 2);
    if (hasGear(p, "longsword")) add("Longsword", 2);
    if (hasGear(p, "winged-boots")) add("Winged Boots", 1 + (p.flags.rifts || 0));
    if (hasGear(p, "star-glass-rings")) add("Star-Glass Rings: Spells this round", spells);
    if (ability(p) === "norag") add("Norag: 2 for each Equipment", 2 * p.gear.length);
    if (ability(p) === "path-oathbinder") add("Path of the Oathbinder", p.gear.length);
    if (saga(p, "moth-dragon", 3)) add("Moth Dragon", p.gear.length);
    if (saga(p, "mirror-dragon", 3)) add("Mirror Dragon", spells);
    if (saga(p, "shadow-dragon", 2) && others(s, p).some(function (o) { return o.life > p.life; })) add("Shadow Dragon", 1);
    if (saga(p, "storm-wyrm", 3)) add("Storm Wyrm", p.field.filter(function (c) { return isDragon(c) && c.id !== "storm-wyrm"; }).length);
    add((ability(p) === "path-mythweaver" ? "The Mythweaver" : "Bramble") + ": Rifts this round", p.flags.riftBonus || 0);
    if (isRegion(s, "the-sanctum")) add("The Sanctum: Spells this round", spells);
    if (ability(p) === "iris") add("Iris & Theo: Relics and Spells", 2 * relics(p) + spells);
    if (p.deck === "iris" && home(s, p)) add("Homecoming (Mesym)", spells);
    if (ability(p) === "path-cerevoker") add("The Cerevoker: Mindlink", spells);
    return parts;
  }
  function total(s, p) {
    var n = 0;
    powerParts(s, p).forEach(function (x) { n += x[1]; });
    return Math.max(0, n);
  }

  /* ---------- damage ---------- */

  // clash: the damage of being struck. The cards that prevent damage "each Clash" only work on that.
  function damage(s, p, n, why, clash) {
    if (p.life <= 0 || n <= 0) return 0;
    if (isEvent(s, "shrinking-stone")) n = Math.max(0, n - 1);
    var first = function (flag, ok) { if (ok && !p.flags[flag] && n > 0) { n -= 1; p.flags[flag] = true; } };
    if (clash) {
      first("rogue", onField(p, "faerie-rogue"));
      first("egg", saga(p, "moth-dragon", 0));
      if (hasGear(p, "dragon-shield") && !p.flags.shieldUsed && n > 0) { n = Math.max(0, n - 2); p.flags.shieldUsed = true; }
      if (hasGear(p, "paragons-mail") && !p.flags.mailUsed && n > 0) { n = Math.max(0, n - relics(p)); p.flags.mailUsed = true; }
    }
    var stop = Math.min(p.shield, n); p.shield -= stop; n -= stop;
    if (n <= 0) { log(s, p.name + " takes no damage" + (why ? " from " + why : "") + ".", "block"); return 0; }
    p.life = Math.max(0, p.life - n);
    log(s, p.name + " takes " + n + " damage" + (why ? " from " + why : "") + ".", "hit");
    if (p.life <= 0) log(s, p.name + " falls.", "fall");
    return n;
  }

  /* ---------- the field and the Herald ---------- */

  function sturdy() { return false; }  // nothing is immovable now; kept for the checks that ask
  function canDestroy(s, owner, c, byCard) {
    var d = def(c);
    if (owner.flags.protect || saga(owner, "storm-wyrm", 2) || saga(owner, "shard-dragon", 3)) return false;
    if (d.id === "shard-dragon" && stageOf(c) === 0) return false;
    if (isDragon(c) && d.id !== "sun-dragon" && saga(owner, "sun-dragon", 2)) return false;
    if (isDragon(c) && isEvent(s, "crowned-sky")) return false;  // Festival of the Crowned Sky
    if (d.id === "fire-knight" && owner.gear.length) return false;
    if (d.tag === "Knight" && owner.deck === "hiro" && home(s, owner)) return false;  // Hiro's Homecoming (stays with a Path)
    if (d.id === "hollow-knight" && byCard && (def(byCard).type === "Action" || def(byCard).type === "Spell")) return false;
    return true;
  }
  // A card sent back to a full hand (5) goes to its owner's Tomb instead.
  function toHand(s, owner, c) {
    if (owner.hand.length >= LIMIT) { owner.discard.push(c); log(s, owner.name + "'s hand is full, so " + def(c).name + " goes to the Tomb.", ""); return false; }
    owner.hand.push(c); return true;
  }
  function leaveField(s, owner, idx, to) {
    var c = owner.field.splice(idx, 1)[0];
    delete c.turns; delete c.mod;
    if (to === "hand") toHand(s, owner, c); else owner.discard.push(c);
    if (c.id === "ferretfolk-scout") recall(s, owner, c.uid, "Ferretfolk Scout left the field");  // not itself: its effect hasn't finished
    return c;
  }
  function destroyUnit(s, owner, idx, byCard) {
    var c = owner.field[idx];
    if (!canDestroy(s, owner, c, byCard)) { log(s, def(c).name + " holds firm.", "block"); return; }
    leaveField(s, owner, idx, "discard");
    log(s, def(c).name + " is destroyed.", "hit");
  }
  function destroyGear(s, owner, idx) {
    if (gearSafe(s, owner)) { log(s, def(owner.gear[idx]).name + " can't be destroyed.", "block"); return; }
    var c = owner.gear.splice(idx, 1)[0]; owner.discard.push(c);
    log(s, def(c).name + " is destroyed.", "hit");
  }

  function discardRandom(s, q) {
    if (!q.hand.length) return;
    var c = q.hand.splice(Math.floor(rand(s) * q.hand.length), 1)[0]; q.discard.push(c);
    log(s, q.name + " discards " + def(c).name + ".", "");
  }

  // Recall: any card from your Tomb (p.discard) back to hand. The player chooses; a bot takes the strongest.
  // why names what caused it, for the prompt. With a full hand (5) it does nothing.
  function recall(s, p, except, why) {
    var pool = p.discard.filter(function (c) { return c.uid !== except; });
    if (!pool.length) return;
    if (p.hand.length >= LIMIT) { log(s, p.name + "'s hand is full, so " + (why || "the Recall") + " brings nothing back.", ""); return; }
    if (p.bot) {
      var best = pool.slice().sort(function (a, b) { return (def(b).damage || 0) - (def(a).damage || 0); })[0];
      p.discard.splice(findIn(p.discard, best.uid), 1); p.hand.push(best);
      log(s, p.name + " recalls " + def(best).name + ".", "");
      return;
    }
    queue(s, { player: p.id, kind: "recall", except: except, why: why || "", prompt: (why ? why + ": r" : "R") + "ecall a card from your Tomb" });
  }
  // Choices queue up so one card can ask for several (a Recall, then a Spell's other effects). Each is
  // tagged with the card resolving when it was asked for, which stays out of the Tomb until they're made.
  function queue(s, pd) { pd.src = s.resolving || null; s.queue = s.queue || []; if (s.pending) s.queue.push(pd); else s.pending = pd; }

  /* The stack: an Action or Spell isn't in the Tomb while it resolves, so nothing it sets off (a Recall
     through a Rift, the Travelling Cloak, the Scrying Mirror) can bring it back. It goes to the Tomb once
     every choice it asked for is made. A Fast or Vaulted card played in between (while a choice is open)
     goes on top and resolves fully first, so it reaches the Tomb before the card underneath. */
  function waitsOn(s, uid) { return [s.pending].concat(s.queue || []).some(function (pd) { return pd && pd.src === uid; }); }
  function settle(s) {
    s.stack = s.stack || [];
    while (s.stack.length && !waitsOn(s, s.stack[s.stack.length - 1].card.uid)) {
      var top = s.stack.pop(), q = player(s, top.player);
      if (q) q.discard.push(top.card);
    }
  }
  // Once the choices in front of the table are made: settle the stack, then let a turn that paused move on.
  function resume(s) {
    settle(s);
    if (!s.pending && s.waitingTurn) { var w = s.waitingTurn; s.waitingTurn = null; if (w === s.turn) afterAction(s, player(s, w)); }
  }
  // The next queued choice that can still be made: a Recall whose discard has since been emptied
  // (by an earlier Recall in the same queue) or a look at an empty deck is skipped.
  function nextPending(s) {
    s.pending = null;
    while (s.queue && s.queue.length && !s.pending) {
      var pd = s.queue.shift(), q = player(s, pd.player);
      if (!q || (pd.kind === "recall" && (q.hand.length >= LIMIT || !q.discard.some(function (c) { return c.uid !== pd.except; }))) || (pd.kind === "scry" && !q.draw.length)) continue;
      s.pending = pd;
    }
  }

  function scry(s, p, why) {
    if (!p.draw.length) return;
    if (p.bot) return;
    queue(s, { player: p.id, kind: "scry", card: p.draw[0].uid, prompt: (why ? why + ": t" : "T") + "he top card of your deck" });
  }

  /* ---------- card effects ----------
     need: what must be chosen as the card is played: "opponent", "player", "unit", "unit1", "unit4", "gear", "copy".
     A card's Play effect always happens. Stand, Attach and stage effects live in the rules above. */

  function destroyLow(s, p, t, card) {
    var o = player(s, t.player), i = o ? findIn(o.field, t.uid) : -1;
    if (i >= 0 && unitDamage(s, o, o.field[i]) <= 1) destroyUnit(s, o, i, card);
  }
  function destroyBig(s, p, t, card) {
    var o = player(s, t.player), i = o ? findIn(o.field, t.uid) : -1;
    if (i >= 0 && unitDamage(s, o, o.field[i]) >= 4) destroyUnit(s, o, i, card);
  }
  function returnUnit(s, p, t) {
    var o = player(s, t.player), i = o ? findIn(o.field, t.uid) : -1;
    if (i < 0) return;
    var full = o.hand.length >= LIMIT, c = leaveField(s, o, i, "hand"); if (!full) log(s, def(c).name + " returns to " + o.name + "'s hand.", "");
  }
  function evolveOne(s, p) {
    var c = p.field.filter(function (u) { return def(u).type === "Evolving Unit" && stageOf(u) < 3; })[0];
    if (c) { var st = def(c).stages; grow(s, p, c, st[stageOf(c) + 1].at - (c.turns || 0)); }
  }
  // A roll's own target: the strongest opposing Unit it can destroy, the leading opponent's first.
  function destroyStrongest(s, p, max, card) {
    var best = null;
    others(s, p).sort(function (a, b) { return b.life - a.life; }).forEach(function (o) {
      o.field.forEach(function (u, i) { var n = unitDamage(s, o, u); if (n <= max && (!best || n > best.n)) best = { o: o, i: i, n: n }; });
    });
    if (best) destroyUnit(s, best.o, best.i, card);
  }
  function pump(s, c, n, name) { c.mod = (c.mod || 0) + n; log(s, name + " gets +" + n + " Power this round.", ""); }
  function hurtLeader(s, p, n, why) { var q = leader(s, p); if (q) damage(s, q, n, why); }

  /* Roll: the card's player rolls three dice; each 4, 5 or 6 is a success. The card prints what
     happens for 0, 1, 2 and 3 successes, so every roll does something. Rolls choose their own targets
     (the leading opponent), and the result is kept in s.roll for the table to show. */
  var ROLLS = {
    "goblin-skirmisher": function (s, p, c, k) { pump(s, c, k + 1, "Goblin Skirmisher"); },
    "whiskersworth": function (s, p, c, k) { destroyStrongest(s, p, k <= 1 ? 1 : k === 2 ? 3 : 99, c); },
    "great-cat": function (s, p, c, k) { hurtLeader(s, p, k <= 1 ? 2 : 3, "the Great Cat"); },
    "death-knight": function (s, p, c, k) { pump(s, c, Math.min(3, k + 1), "Death Knight"); if (k >= 2) hurtLeader(s, p, 1, "the Death Knight"); },
    "final-addendum": function (s, p, c, k) { hurtLeader(s, p, k === 3 ? 2 : 1, "Void Reaping"); },
    "dragon-keeper": function (s, p, c, k) { evolveOne(s, p); if (k >= 2) evolveOne(s, p); }
  };
  function rollFor(s, p, card) {
    var r = ROLLS[card.id];
    if (!r) return;
    var dice = [0, 0, 0].map(function () { return 1 + Math.floor(rand(s) * 6); });
    var k = dice.filter(function (d) { return d >= 4; }).length;
    s.roll = { seq: (s.roll ? s.roll.seq : 0) + 1, by: p.id, id: card.id, dice: dice, successes: k };
    log(s, p.name + " rolls " + dice.join(", ") + " for " + def(card).name + ": " + k + (k === 1 ? " success." : " successes."), k ? "win" : "");
    r(s, p, card, k);
  }

  var EFFECTS = {
    "hedgehog-forager": { run: function (s, p) { recall(s, p, null, "Hedgehog Forager"); } },
    "dogfolk-ranger": { need: "unit1", run: destroyLow },
    "ambush": { need: "unit4", run: destroyBig },
    "study-the-stars": { run: function (s, p, t, c) { scry(s, p, "Study the Stars"); recall(s, p, c && c.uid, "Study the Stars"); } },
    "wandering-ghost": { run: function (s, p) { scry(s, p, "Wandering Ghost"); } },
    "couriers-dash": { run: function (s, p, t, c) { rift(s, p); recall(s, p, c && c.uid, "Courier's Dash"); } },
    "elder-pegasus": { run: function (s, p) { rift(s, p); } },
    "runeward-script": { run: function (s, p) { p.shield += 3; } },
    "guardian-spirit": { run: function (s, p) { p.shield += 3; p.flags.protect = true; } },
    "mindbreak": { need: "unit", run: function (s, p, t) {
      var o = player(s, t.player), i = o ? findIn(o.field, t.uid) : -1;
      if (i >= 0) { o.field[i].mod = (o.field[i].mod || 0) - 2; log(s, def(o.field[i]).name + " gets -2 Power this round.", ""); }
    } },
    "arcane-sever": { need: "gear", run: function (s, p, t) {
      // Sends Equipment back to its owner's hand: an answer to gear that doesn't erase it.
      var o = player(s, t.player), i = o ? findIn(o.gear, t.uid) : -1;
      if (i < 0) return;
      var c = o.gear.splice(i, 1)[0];  // returned, not destroyed: the Sword that was Promised doesn't stop it
      if (toHand(s, o, c)) log(s, def(c).name + " returns to " + o.name + "'s hand.", "");
    } },
    "stolen-moment": { need: "copy", run: function (s, p, t, c) {
      if (!s.lastSpell || s.lastSpell === "stolen-moment") return;
      var e = EFFECTS[s.lastSpell];
      if (e && e.run) { log(s, p.name + " echoes " + CARD[s.lastSpell].name + ".", ""); e.run(s, p, t, c); }
      else if (ROLLS[s.lastSpell]) { log(s, p.name + " echoes " + CARD[s.lastSpell].name + ".", ""); rollFor(s, p, { id: s.lastSpell }); }
    } },
    "turn-back": { need: "unit", run: returnUnit },
    "glyphstorm": { need: "opponent", run: function (s, p, t) { var o = player(s, t.player); if (o) damage(s, o, p.gear.length, "Prismatic Burst"); } }
  };

  function afterSpell(s, p, id) {
    p.flags.spells++; s.lastSpell = id;
    var a = ability(p);
    if (a === "path-cerevoker" && leader(s, p) && !p.flags.mindlink) { p.flags.mindlink = true; damage(s, leader(s, p), 1, "the Cerevoker"); }
    if (saga(p, "star-dragon", 3) && leader(s, p)) damage(s, leader(s, p), 1, "the Astral Dragon");
    p.field.forEach(function (c) { if (c.id === "star-dragon" && stageOf(c) === 2) pump(s, c, 1, "The Astral Dragon"); });
    if (hasGear(p, "scrying-mirror") && !p.flags.mirror) { p.flags.mirror = true; recall(s, p, null, "Scrying Mirror"); }
    if (saga(p, "moon-dragon", 2) && !p.flags.moon) { p.flags.moon = true; rift(s, p); }
  }

  /* ---------- the Atlas ---------- */

  // Takes the next Region from the queue that isn't another copy of the one in play (two players
  // on the same deck bring the same Regions).
  function nextRegion(s, avoid) {
    var i = 0;
    while (i < s.atlas.draw.length - 1 && avoid.indexOf(s.atlas.draw[i]) > -1) i++;
    return s.atlas.draw.splice(i, 1)[0];
  }
  // auto: a Rift the game makes for you (Bramble's Homecoming). It moves the Atlas but sets off nothing
  // that says "whenever you Rift": those count only Rifts you make, with the Rift move or a card.
  function rift(s, p, auto) {
    var left = region(s);
    s.atlas.draw.push(s.atlas.current);
    s.atlas.current = nextRegion(s, [left.id]);
    var now = region(s);
    log(s, p.name + " rifts: " + atlasName(left) + " gives way to " + atlasName(now) + ".", "region");
    if (auto) return;
    p.flags.rifts = (p.flags.rifts || 0) + 1;
    if (ability(p) === "path-mythweaver" || ability(p) === "bramble") recall(s, p, null, (ability(p) === "bramble" ? "Bramble" : "The Mythweaver") + ": you Rifted");
    // Bramble's (+2) and the Mythweaver's (+3) Power counts for their first 3 Rifts each round.
    if ((ability(p) === "bramble" || ability(p) === "path-mythweaver") && p.flags.rifts <= 3) p.flags.riftBonus = (p.flags.riftBonus || 0) + (ability(p) === "bramble" ? 2 : 3);
    if (hasGear(p, "travelling-cloak")) recall(s, p, null, "Travelling Cloak: you Rifted");
    p.field.forEach(function (c) { if (c.id === "moon-dragon" && stageOf(c) === 0) pump(s, c, 1, "The Moon Dragon"); });
  }
  // What an Event does the moment it's played; its lasting effect is read from topEvent().
  function playEvent(s, ev) {
    if (ev.id === "the-shattering") alive(s).forEach(function (q) {
      for (var i = q.field.length - 1; i >= 0; i--) if (unitDamage(s, q, q.field[i]) <= 1) destroyUnit(s, q, i);
    });
    if (ev.id === "the-tragedy") alive(s).forEach(function (q) { damage(s, q, 2, "the Tragedy"); });
    if (ev.id === "morifex") alive(s).forEach(function (q) {
      if (!q.hand.length) return;
      var c = q.hand.splice(Math.floor(rand(s) * q.hand.length), 1)[0]; q.discard.push(c);
      log(s, q.name + " discards " + def(c).name + ".", "");
    });
  }

  /* ---------- playing a card ---------- */

  function validTarget(s, p, need, t) {
    if (!need) return true;
    if (!t) return false;
    var o = t.player ? player(s, t.player) : null;
    switch (need) {
      case "opponent": return o && o.id !== p.id && o.life > 0;
      case "player": return o && o.life > 0;
      case "unit": return o && findIn(o.field, t.uid) >= 0;
      case "unit1": return o && findIn(o.field, t.uid) >= 0 && unitDamage(s, o, o.field[findIn(o.field, t.uid)]) <= 1;
      case "unit4": return o && findIn(o.field, t.uid) >= 0 && unitDamage(s, o, o.field[findIn(o.field, t.uid)]) >= 4;
      case "gear": return o && findIn(o.gear, t.uid) >= 0;
      case "copy": return !s.lastSpell || s.lastSpell === "stolen-moment" || validTarget(s, p, (EFFECTS[s.lastSpell] || {}).need, t);  // a Roll Spell has no EFFECTS entry
    }
    return true;
  }
  function anyTarget(s, p, need) {
    switch (need) {
      case "unit": return s.players.some(function (o) { return o.field.length; });
      case "unit1": return s.players.some(function (o) { return o.field.some(function (c) { return unitDamage(s, o, c) <= 1; }); });
      case "unit4": return s.players.some(function (o) { return o.field.some(function (c) { return unitDamage(s, o, c) >= 4; }); });
      case "gear": return s.players.some(function (o) { return o.gear.length; });
      case "copy":  // only when the Spell it copies needs a target
        var n = s.lastSpell && s.lastSpell !== "stolen-moment" ? (EFFECTS[s.lastSpell] || {}).need : null;
        return !!n && anyTarget(s, p, n);
    }
    return true;
  }

  /* Playing a card: on your turn, or any time before the Clash if it's Fast or comes from your Vault
     (p.arsenal). A Vaulted card costs 1 Action less. Events are played on your own turn. */
  function play(s, p, it) {
    var fromArsenal = it.from === "arsenal", pile = fromArsenal ? p.arsenal : p.hand;
    var hi = findIn(pile, it.uid);
    if (hi < 0) return fromArsenal ? "That card isn't in your Vault." : "That card isn't in your hand.";
    // A Vaulted card costs 1 less: the Action spent Vaulting it counts toward it.
    var card = pile[hi], d = def(card), mine = s.turn === p.id, price = fromArsenal ? Math.max(0, cost(card) - VAULT_COST) : cost(card);
    if (!mine && !fromArsenal && !isFast(card)) return "It isn't your turn.";
    if (price > p.actions) return "Not enough Actions.";
    // Pays for the play from your Actions, on your turn or (with Actions saved) on someone else's.
    var pay = function () { p.actions -= price; if (mine) p.acted = true; };
    var e = EFFECTS[d.id] || {};
    var needs = e.need && anyTarget(s, p, e.need);
    if (needs && !validTarget(s, p, e.need, it.target)) return "Choose a target for " + d.name + ".";
    if (d.type === "Event") {
      if (!mine) return "Events are played on your own turn.";
      pile.splice(hi, 1); pay();
      var under = topEvent(s);
      s.events.push({ id: d.id, by: p.id });
      log(s, p.name + " plays " + d.name + (under ? ", over " + under.name : "") + ".", "event");
      playEvent(s, d);
      afterAction(s, p);
      return null;
    }
    var onto = d.type === "Unit" || d.type === "Evolving Unit";
    if (onto && size(card, p) > spaceFree(p)) return "Not enough Space on your field. Retire a Unit first.";
    if (d.type === "Equipment" && p.gear.length >= gearLimit(s, p) && findIn(p.gear, it.replace) < 0)
      return "Your Herald is fully equipped. Choose Equipment to swap out.";

    pile.splice(hi, 1);
    pay();
    var how = fromArsenal ? " from their Vault" : "";
    if (onto) {
      card.turns = 0; card.mod = 0;
      p.field.push(card);
      if (d.id === "shadow-dragon" && !mine) grow(s, p, card, 1);  // from the shadows: hatches at once
      log(s, p.name + " plays " + d.name + (d.type === "Evolving Unit" ? " as an Egg" : "") + how + ".", "play");
      if (e.run) e.run(s, p, it.target || {}, card);
    } else if (d.type === "Equipment") {
      if (p.gear.length >= gearLimit(s, p)) {
        var g = p.gear.splice(findIn(p.gear, it.replace), 1)[0]; p.discard.push(g);
        log(s, p.name + " swaps out " + def(g).name + ".", "item");
      }
      p.gear.push(card);
      log(s, p.name + " equips " + d.name + how + ".", "item");
      if (d.id === "winged-boots") rift(s, p);
    } else if (d.type === "Path") {
      if (p.path) p.discard.push(p.path);
      p.path = card;
      log(s, p.name + " walks the " + d.name + how + ".", "item");
    } else {
      s.stack = s.stack || [];
      s.stack.push({ player: p.id, card: card });
      log(s, p.name + " plays " + d.name + how + ".", "play");
      var under = s.resolving; s.resolving = card.uid;
      if (e.run) e.run(s, p, it.target || {}, card);
      if (d.type === "Spell") afterSpell(s, p, d.id);
      rollFor(s, p, card);
      s.resolving = under;
      if (!s.responding) settle(s);
      afterAction(s, p);
      return null;
    }
    rollFor(s, p, card);
    afterAction(s, p);
    return null;
  }
  // A Fast or Vaulted card played while a choice is open: it goes on top of the stack, and the choices it
  // asks for come before the ones already waiting.
  function respond(s, p, it) {
    var held = s.pending, rest = s.queue || [];
    s.pending = null; s.queue = []; s.responding = true;
    var err = play(s, p, it);
    s.responding = false;
    if (err) return err;
    s.queue = (s.pending ? [s.pending] : []).concat(s.queue, [held], rest);
    nextPending(s);
    resume(s);
    afterAction(s, p);
    return null;
  }

  // The Vault: once a round, on your turn, set a card from your hand aside for 1 Action. It skips the
  // End Phase and can be played at any time later, on anyone's turn, for 1 Action less than printed.
  function arsenal(s, p, it) {
    if (s.turn !== p.id) return "You Vault a card on your own turn.";
    if (p.actions < VAULT_COST) return "Not enough Actions.";
    if (p.arsenal.length >= arsenalLimit(p)) return "Your Vault is full.";
    if (p.arsenaled) return "You've already Vaulted a card this round.";
    var hi = findIn(p.hand, it.uid);
    if (hi < 0) return "That card isn't in your hand.";
    p.arsenal.push(p.hand.splice(hi, 1)[0]); p.arsenaled = true;
    p.actions -= VAULT_COST; p.acted = true;
    log(s, p.name + " Vaults a card.", "play");
    afterAction(s, p);
    return null;
  }
  function drawCard(s, p) {
    if (s.turn !== p.id) return "You draw on your own turn.";
    if (p.actions < DRAW_COST) return "Not enough Actions.";
    if (!p.draw.length) return "Your deck is empty.";
    if (p.hand.length >= LIMIT) return "Your hand is full: you hold " + LIMIT + " cards at most.";
    p.hand.push(p.draw.shift()); p.actions -= DRAW_COST; p.acted = true;
    log(s, p.name + " draws a card.", "");
    afterAction(s, p);
    return null;
  }
  function riftMove(s, p) {
    if (s.turn !== p.id) return "You Rift on your own turn.";
    if (p.actions < RIFT_COST) return "Rifting takes " + RIFT_COST + " Actions.";
    if (p.flags.riftAct && ability(p) !== "bramble") return "You've already Rifted this way this round.";
    if (!s.atlas.draw.length) return "The Atlas is empty.";
    p.flags.riftAct = true; p.actions -= RIFT_COST; p.acted = true;
    rift(s, p);
    afterAction(s, p);
    return null;
  }
  // Retire: take one of your own Units off your field to your Tomb, for no Actions, to make room.
  function retire(s, p, it) {
    if (s.turn !== p.id) return "You Retire a Unit on your own turn.";
    var i = findIn(p.field, it.uid);
    if (i < 0) return "Choose one of your Units.";
    var c = leaveField(s, p, i, "discard"); p.acted = true;
    log(s, p.name + " retires " + def(c).name + ".", "board");
    return null;
  }
  // Ending your turn: the next player takes theirs, and after the last one, the Clash.
  function endTurn(s, p) {
    if (s.turn !== p.id) return "It isn't your turn.";
    lastTurn(s, p);
    nextTurn(s);
    return null;
  }

  /* ---------- the Clash and the refill ---------- */

  function clash(s) {
    s.turn = null;
    var field = alive(s).map(function (p) { return { p: p, n: total(s, p) }; });
    s.lastClash = field.map(function (f) { return { player: f.p.id, total: f.n }; });
    s.lastClashRound = s.round; s.lastWinner = null; s.lastTarget = null;
    log(s, "Clash! " + field.map(function (f) { return f.p.name + " " + f.n; }).join(", ") + ".", "clash");
    alive(s).forEach(function (p) { if (saga(p, "sun-dragon", 0)) heal(p, 1); if (saga(p, "sun-dragon", 3)) heal(p, 2); });
    // The Midnight Court: the Herald (or Heralds) with the least on the table regain 2 life.
    if (isRegion(s, "midnight-court")) {
      var least = Math.min.apply(null, field.map(function (f) { return f.n; }));
      field.forEach(function (f) { if (f.n === least) { heal(f.p, 2); log(s, f.p.name + " regains 2 life at the Midnight Court.", ""); } });
    }

    if (isEvent(s, "draviks-war") && field.every(function (f) { return f.p.field.length === field[0].p.field.length; })) {
      log(s, "Dravik's War: every field is matched. No one wins.", "event");
      return refill(s, null, null);
    }
    var low = isEvent(s, "rabbit-hole");
    var sorted = field.slice().sort(function (x, y) { return low ? x.n - y.n : y.n - x.n; });
    if (sorted.length < 2 || sorted[0].n === sorted[1].n) { log(s, "A tie at the top. No one wins the Clash.", "clash"); return refill(s, null, null); }
    var winner = sorted[0].p, foes = field.filter(function (f) { return f.p !== winner; });
    // The Unthroned Court: the winner must strike whoever has the most life.
    if (isRegion(s, "unthroned-court")) {
      var most = Math.max.apply(null, foes.map(function (f) { return f.p.life; }));
      foes = foes.filter(function (f) { return f.p.life === most; });
    }
    log(s, winner.name + " wins the Clash.", "win");
    s.lastWinner = winner.id; winner.wins = (winner.wins || 0) + 1;
    // The Birth of Akeroth: the Herald with the most life can't be struck.
    if (isEvent(s, "birth-of-akeroth")) {
      var top = Math.max.apply(null, alive(s).map(function (q) { return q.life; }));
      foes = foes.filter(function (f) { return f.p.life < top; });
      if (!foes.length) { log(s, "The Herald with the most life can't be struck.", "event"); return refill(s, winner, null); }
    }
    if (foes.length === 1) return strike(s, winner, foes[0].p);
    if (winner.bot) {
      var pick = foes.slice().sort(function (x, y) { return y.p.life - x.p.life; })[0].p;  // bots strike the leader
      return strike(s, winner, pick);
    }
    s.pending = { player: winner.id, kind: "strike", options: foes.map(function (f) { return f.p.id; }), prompt: "You win the Clash: choose who to strike" };
  }

  function strike(s, winner, target) {
    var n = Math.abs(total(s, winner) - total(s, target));
    if (hasGear(winner, "nightmare-blade")) n += 2;
    if (saga(winner, "moth-dragon", 2)) n += 1;
    if (saga(winner, "fire-wyrm", 2)) n += 1;
    if (isRegion(s, "ekadells-gate")) n = Math.min(n, 3);  // Ekadell's Gate holds
    s.lastTarget = target.id;
    log(s, winner.name + " strikes " + target.name + ".", "win");
    damage(s, target, n, winner.name, true);
    if (hasGear(target, "reavers-mail")) damage(s, winner, 2, "Reaver's Mail");
    if (ability(target) === "path-cerevoker") damage(s, winner, 1, "Shared Agony");
    if (saga(target, "mirror-dragon", 0)) damage(s, winner, 1, "the Mirror Dragon");
    if (saga(winner, "shadow-dragon", 3)) discardRandom(s, target);
    if (winner.deck === "therabir" && home(s, winner)) discardRandom(s, target);  // Therabir's Homecoming
    refill(s, winner, target);
  }

  /* ---------- the refresh ----------
     After the Clash each Herald keeps their hand, Equipment, Path, Vault and Evolving Units (which keep
     growing) and shuffles their other Units and their Tomb together, takes 2 at random back into hand and draws 2 from their deck,
     keeping only what fits in a hand of 5. The rest fall out of the game. */
  function refill(s, winner, target) {
    s.pending = null; s.queue = []; s.waitingTurn = null;
    s.players.forEach(function (p) { p.struckLast = !!target && p.id === target.id; });
    if (target) s.initiative = s.players.indexOf(target);
    // In a duel the last Herald standing wins; with more at the table the first to fall ends it.
    if (over(s)) return finish(s);
    if (winner && (winner.wins || 0) >= renownTarget(s)) return finish(s, winner);
    var spent = true;
    alive(s).forEach(function (p) {
      // One Evolving Unit stays, the furthest grown (the first played, on a tie); the rest go with the Units.
      var evo = p.field.filter(function (c) { return def(c).type === "Evolving Unit"; }).sort(function (x, y) { return stageOf(y) - stageOf(x); });
      var stay = evo.slice(0, 1);
      var pile = shuffle(s, p.field.filter(function (c) { return stay.indexOf(c) < 0; }).concat(p.discard));
      pile.forEach(function (c) { delete c.turns; delete c.mod; });
      // A kept Dragon keeps its age, not this round's bonuses, and rests: it skips growing next round.
      stay.forEach(function (c) { delete c.mod; c.rest = true; });
      p.field = stay; p.discard = [];
      var back = Math.max(0, Math.min(BACK, LIMIT - p.hand.length));
      p.hand = p.hand.concat(pile.slice(0, back));
      p.fallen = p.fallen.concat(pile.slice(back));
      // The 2 from the deck always leave it, so the decks run down; any that don't fit are Exiled.
      var drawn = p.draw.splice(0, FROM_DECK), fit = Math.max(0, LIMIT - p.hand.length);
      p.hand = p.hand.concat(drawn.slice(0, fit)); p.fallen = p.fallen.concat(drawn.slice(fit));
      if (drawn.length > fit) log(s, p.name + "'s hand is full: " + (drawn.length - fit) + (drawn.length - fit === 1 ? " card is" : " cards are") + " Exiled.", "");
      if (p.draw.length) spent = false;
    });
    if (spent) return finish(s);
    newRound(s);
  }

  /* ---------- winning ----------
     Victory: in a duel the last Herald standing wins; with three or four, the first Herald to fall ends
     the game at once and the most life wins. Dominion: winning 4 Clashes wins outright. Survival: if the
     decks run dry first, the most life wins, then the most Clashes won; only a tie on both is a draw.
     (winBy keeps the old names: break, renown, lastlight.) */
  function renownTarget() { return RENOWN; }
  function finish(s, byRenown) {
    var rank = function (a, b) { return b.life - a.life || (b.wins || 0) - (a.wins || 0); };
    var left = alive(s).sort(rank);
    s.phase = "over"; s.turn = null; s.pending = null;
    if (byRenown) {
      s.winner = byRenown.id; s.winBy = "renown";
      log(s, "Dominion: " + byRenown.name + " has won " + byRenown.wins + " Clashes.", "win");
      return;
    }
    var fell = alive(s).length < s.players.length;
    s.winner = left.length && (left.length === 1 || rank(left[0], left[1]) !== 0) ? left[0].id : null;
    s.winBy = fell ? "break" : "lastlight";
    log(s, !s.winner ? "The Heralds are evenly matched. It's a draw." :
      left.length === 1 ? "Victory: " + player(s, s.winner).name + " is the last Herald standing." :
      fell ? "Victory: a Herald has fallen, and " + player(s, s.winner).name + " has the most life." :
      "Survival: the decks are spent, and " + player(s, s.winner).name + " has the most life.", "win");
  }

  /* ---------- choices ---------- */

  function choose(s, p, it) {
    var pd = s.pending;
    if (!pd || pd.player !== p.id) return "Nothing to choose.";
    if (pd.kind === "strike") {
      if (pd.options.indexOf(it.pick) < 0) return "Choose an opponent to strike.";
      s.pending = null;
      strike(s, p, player(s, it.pick));
      return null;
    }
    if (pd.kind === "recall") {
      if (p.hand.length >= LIMIT) { nextPending(s); return null; }
      var i = findIn(p.discard, it.pick);
      if (i < 0 || it.pick === pd.except) return "Choose another card from your Tomb.";
      var c = p.discard.splice(i, 1)[0]; p.hand.push(c);
      log(s, p.name + " recalls " + def(c).name + ".", "");
    } else if (pd.kind === "scry") {
      if (it.pick === "bottom" && p.draw.length) p.draw.push(p.draw.shift());
    }
    nextPending(s);
    // A turn that paused for choices moves on once they're all made.
    resume(s);
    return null;
  }

  /* ---------- apply ---------- */

  function apply(state, pid, it) {
    var s = clone(state), p = player(s, pid), err = null;
    it = it || {};
    var live = function () { return !p || s.phase !== "play" || s.pending || p.life <= 0 ? "You can't do that right now." : null; };
    switch (it.type) {
      case "join":
        if (s.phase !== "lobby") { if (p) { p.connected = true; break; } err = "This game has already started."; break; }
        if (p) { p.name = it.name || p.name; p.connected = true; break; }
        if (s.players.length >= MAX_PLAYERS) { err = "The table is full."; break; }
        if (it.list && (err = checkList(it.list))) break;
        s.players.push(newPlayer(s, pid, freeName(s, (it.name || "Herald").slice(0, 20)), it.list ? it.list.herald : HW.decks[it.deck] ? it.deck : "bramble"));
        if (it.list) s.players[s.players.length - 1].list = cleanList(it.list);
        if (!s.host) s.host = pid;
        break;
      case "leave":
        if (!p) break;
        if (s.phase === "lobby") s.players = s.players.filter(function (q) { return q.id !== pid; });
        else p.connected = false;
        break;
      case "pickDeck":
        if (s.phase !== "lobby" || !p) { err = "Decks are chosen in the lobby."; break; }
        if (it.list) {
          if ((err = checkList(it.list))) break;
          p.list = cleanList(it.list); p.deck = p.list.herald;
        } else {
          if (!HW.decks[it.deck]) { err = "Choose a deck."; break; }
          p.list = null; p.deck = it.deck;
        }
        p.herald = heraldFor(p.deck);
        break;
      case "addBot":
        if (pid !== s.host || s.phase !== "lobby") { err = "Only the host can add a bot."; break; }
        if (s.players.length >= MAX_PLAYERS) { err = "The table is full."; break; }
        // A bot takes a Herald no one at the table has yet (there are five, and four seats).
        var decks = Object.keys(HW.decks), nb = s.players.filter(function (q) { return q.bot; }).length;
        var free = decks.filter(function (d) { return !s.players.some(function (q) { return q.deck === d; }); });
        if (!free.length) free = decks;
        s.players.push(newPlayer(s, "bot-" + (++s.uid), BOT_NAMES[nb % BOT_NAMES.length],
          HW.decks[it.deck] ? it.deck : free[Math.floor(rand(s) * free.length)], true));
        break;
      case "removeBot":
        if (pid !== s.host || s.phase !== "lobby") break;
        s.players = s.players.filter(function (q) { return q.id !== it.player || !q.bot; });
        break;
      case "start":
        if (pid !== s.host) { err = "Only the host can start the game."; break; }
        if (s.phase !== "lobby") { err = "The game has started."; break; }
        if (s.players.length < 2) { err = "You need at least two Heralds."; break; }
        start(s);
        break;
      case "reset":
        if (pid !== s.host || s.phase !== "over") { err = "Only the host can start a new game."; break; }
        var fresh = create(s.rng);
        fresh.host = s.host; fresh.uid = s.uid;
        s.players.forEach(function (q) { var np = newPlayer(fresh, q.id, q.name, q.deck, q.bot); np.connected = q.connected; np.list = q.list || null; fresh.players.push(np); });
        s = fresh;
        break;
      case "mulligan":
        if (!p || s.phase !== "mulligan" || !p.mulligan) { err = "There's nothing to put back now."; break; }
        mulligan(s, p, !!it.redraw || (Array.isArray(it.picks) && it.picks.length > 0));
        if (s.players.every(function (q) { return !q.mulligan; })) begin(s);
        break;
      case "play":
        // While a choice is open (a card part-way through resolving), Fast and Vaulted cards can still be played in between.
        var src = it.from === "arsenal" ? p && p.arsenal : p && p.hand, hc = src && src[findIn(src, it.uid)];
        if (s.pending && s.pending.kind !== "strike" && p && s.phase === "play" && p.life > 0 && hc && def(hc).type !== "Event" && (it.from === "arsenal" || isFast(hc))) { err = respond(s, p, it); break; }
        err = live() || play(s, p, it);
        if (!err && s.pending && s.turn === pid) s.waitingTurn = pid;  // the turn passes once choices are made
        break;
      case "arsenal": err = live() || arsenal(s, p, it); break;
      case "draw": err = live() || drawCard(s, p); break;
      case "rift": err = live() || riftMove(s, p); break;
      case "retire": err = live() || retire(s, p, it); break;
      case "end": err = live() || endTurn(s, p); break;
      case "choose": if (!p) { err = "You're not in this game."; break; } err = choose(s, p, it); break;
      default: err = "Unknown move.";
    }
    if (err) return { state: state, error: err };
    return { state: s, error: null };
  }

  /* ---------- views ---------- */

  function view(s, pid) {
    var v = clone(s);
    delete v.rng;
    v.atlas = { current: s.atlas.current, left: s.atlas.draw.length };
    v.events = (s.events || []).slice();
    v.players.forEach(function (p) {
      var real = player(s, p.id);
      p.drawCount = p.draw.length; delete p.draw;
      p.fallenCount = p.fallen.length; delete p.fallen;
      if (p.id !== pid) { p.handCount = p.hand.length; p.hand = []; p.arsenalCount = p.arsenal.length; p.arsenal = []; }
      p.total = s.phase === "play" && real.life > 0 ? total(s, real) : 0;
      p.powerParts = s.phase === "play" && real.life > 0 ? powerParts(s, real) : [];
      p.space = SPACE - spaceFree(real);
      p.field.forEach(function (c, i) {
        c.damage = unitDamage(s, real, real.field[i]);
        if (def(c).type === "Evolving Unit") c.stage = stageOf(real.field[i]);
        c.size = size(real.field[i], real);
        if (sturdy(c)) c.fixed = true;  // can't be swapped out or returned to hand
      });
    });
    if (s.pending && s.pending.kind === "scry" && s.pending.player === pid) {
      var me = player(s, pid); v.pending.top = me.draw[0] ? me.draw[0].id : null;
    }
    return v;
  }

  /* ---------- a simple bot ----------
     Spends its Actions on the best play it can afford and fit, and passes once it's ahead of everyone
     who has already passed (or has nothing worth doing). */

  function botMove(s, pid) {
    var p = player(s, pid);
    if (!p || p.life <= 0) return null;
    if (s.pending && s.pending.player === pid) {
      if (s.pending.kind === "strike") return { type: "choose", pick: s.pending.options[0] };
      if (s.pending.kind === "recall") return { type: "choose", pick: p.discard[0] && p.discard[0].uid };
      if (s.pending.kind === "scry") return { type: "choose", pick: "keep" };
    }
    if (s.phase !== "play" || s.turn !== pid || s.pending) return null;
    var rivals = alive(s).filter(function (q) { return q.id !== pid; });
    var low = isEvent(s, "rabbit-hole"), mine = total(s, p);
    var top = rivals.reduce(function (m, q) { var n = total(s, q); return low ? Math.min(m, n) : Math.max(m, n); }, low ? 99 : -1);
    var ahead = low ? mine < top : mine > top;
    // Everyone else is out and we're winning: stop here and keep the cards for later rounds.
    if (ahead && rivals.every(function (q) { return q.passed; })) return { type: "end" };
    // Keep a Fast answer back in the Vault when there's room, and play it once a big Unit shows up.
    if (p.arsenal.length) {
      var held = p.arsenal[0], hd = EFFECTS[held.id] || {}, hdef = def(held);
      var fits = (hdef.type !== "Unit" && hdef.type !== "Evolving Unit") || size(held, p) <= spaceFree(p);
      if (fits && (!hd.need || pickTarget(s, p, hd.need)))
        return { type: "play", from: "arsenal", uid: held.uid, target: hd.need ? pickTarget(s, p, hd.need) : null, replace: gearSwap(s, p, held) };
    } else if (!p.arsenaled && p.actions >= VAULT_COST && p.hand.length > 2) {
      var keep = p.hand.filter(function (c) { return isFast(c) && def(c).type !== "Unit" && EFFECTS[c.id] && (!EFFECTS[c.id].need || !pickTarget(s, p, EFFECTS[c.id].need)); })[0];
      if (keep) return { type: "arsenal", uid: keep.uid };
    }
    var choice = null, score = 0, free = spaceFree(p);
    p.hand.forEach(function (c) {
      var d = def(c), e = EFFECTS[d.id] || {}, sc = 0, target = null, unit = d.type === "Unit" || d.type === "Evolving Unit";
      if (cost(c) > p.actions) return;
      if (d.type === "Event") {
        var ev = s.events.length ? s.events[s.events.length - 1] : null; sc = !ev || ev.by !== p.id ? 4 : 0.5;
        // The Tragedy hurts everyone: only worth it with more life than every rival.
        if (d.id === "the-tragedy" && rivals.some(function (q) { return q.life >= p.life; })) sc = 0;
      }
      else if (d.type === "Path") sc = !p.path ? 9 : 0.5;
      else if (d.type === "Equipment") sc = p.gear.length < gearLimit(s, p) ? 5 + (ability(p) === "norag" ? 3 : 0) : 0.5;
      else if (unit) {
        if (size(c, p) > free) return;
        sc = 2 + (d.type === "Evolving Unit" ? 3 : d.damage || 0) + (ROLLS[d.id] ? 1 : 0) + (e.run ? 1 : 0);
      }
      else sc = e.need && !pickTarget(s, p, e.need) && anyTarget(s, p, e.need) ? 0.3 : 3.5;
      if (sc <= 0) return;
      sc = sc / Math.max(1, cost(c)) + cost(c) * 0.6;  // value for the Actions spent
      if (e.need) target = pickTarget(s, p, e.need);
      if (sc > score) { score = sc; choice = { type: "play", uid: c.uid, target: target, replace: gearSwap(s, p, c) }; }
    });
    // A full field: Retire the weakest Unit for a clearly bigger one that doesn't fit.
    if (!choice || score < 3) {
      var big = p.hand.filter(function (c) { var d = def(c); return (d.type === "Unit" || d.type === "Evolving Unit") && cost(c) <= p.actions && size(c, p) > free; })
        .sort(function (a, b) { return (def(b).damage || 3) - (def(a).damage || 3); })[0];
      var weak = p.field.slice().sort(function (a, b) { return unitDamage(s, p, a) - unitDamage(s, p, b); })[0];
      if (big && weak && unitDamage(s, p, weak) + 1 < (def(big).damage || 3) && size(big, p) <= free + size(weak, p)) return { type: "retire", uid: weak.uid };
    }
    var rifter = ability(p) === "bramble" || ability(p) === "path-mythweaver" || hasGear(p, "winged-boots") || hasGear(p, "travelling-cloak");
    if (rifter && p.actions >= RIFT_COST && (!p.flags.riftAct || (ability(p) === "bramble" && p.flags.rifts < 3)) && s.atlas.draw.length) return { type: "rift" };
    if (choice) return choice;
    if (p.actions >= DRAW_COST && p.draw.length && p.hand.length < 3) return { type: "draw" };
    return { type: "end" };
  }
  // The Equipment a bot swaps out when its Herald is full: its first.
  function gearSwap(s, p, c) {
    if (def(c).type === "Equipment" && p.gear.length >= gearLimit(s, p)) return p.gear[0].uid;
    return null;
  }
  function pickTarget(s, p, need) {
    var opp = leader(s, p);
    switch (need) {
      case "opponent": case "player": return opp ? { player: opp.id } : null;
      case "unit": case "unit1": case "unit4":
        // an opponent's Unit if there is one; if not, the card still has to land somewhere legal
        var mine = null;
        for (var i = 0; i < s.players.length; i++) { var o = s.players[i];
          for (var j = 0; j < o.field.length; j++) { var n = unitDamage(s, o, o.field[j]);
            if (need === "unit" || (need === "unit1" && n <= 1) || (need === "unit4" && n >= 4)) {
              if (o.id !== p.id) return { player: o.id, uid: o.field[j].uid };
              if (!mine) mine = { player: o.id, uid: o.field[j].uid };
            } } }
        return mine;
      case "gear":
        for (var k = 0; k < s.players.length; k++) if (s.players[k].id !== p.id && s.players[k].gear.length) return { player: s.players[k].id, uid: s.players[k].gear[0].uid };
        return p.gear.length ? { player: p.id, uid: p.gear[0].uid } : null;
    }
    return null;
  }

  root.HWEngine = {
    create: create, apply: apply, view: view, botMove: botMove, gearLimit: gearLimit, arsenalLimit: arsenalLimit, total: total,
    isFast: function (id) { return !!CARD[id].fast; },
    effectNeed: function (id) { return (EFFECTS[id] || {}).need || null; }, hasEffect: function (id) { return !!EFFECTS[id]; },
    hasRoll: function (id) { return !!ROLLS[id]; }, checkList: checkList, copiesAllowed: copiesAllowed, inRealm: inRealm,
    cost: function (id) { return CARD[id].cost || 0; }, STAGE_SPACE: STAGE_SPACE,
    MAIN: MAIN, CARD: CARD, MAX_PLAYERS: MAX_PLAYERS, GEAR_SLOTS: GEAR_SLOTS, HAND: HAND, LIMIT: LIMIT, powerParts: powerParts, ACTIONS: ACTIONS, TURNS: TURNS, SPACE: SPACE,
    DRAW_COST: DRAW_COST, VAULT_COST: VAULT_COST, RIFT_COST: RIFT_COST, BACK: BACK,
    RENOWN: RENOWN
  };
})(typeof window !== "undefined" ? window : globalThis);

/* play\decks.js */
/* Herald's Wake: custom decks, which cards a player owns, and where their decks are saved.
   Shared by the card compendium (which builds decks) and the game lobby (which plays them).

   A deck is { id, name, herald, events: [2], main: [15], updated }. HWEngine.checkList is the rule.
   Owning a starter deck owns every card in it, so a common found in two owned decks can be run
   twice. A starter deck with a product slug (HW.decks[k].product) is owned when the Sanctum
   account holds that product; one without a slug is free to everyone.

   Signed in to Sanctum (window.DKCloud), decks live on the account in tool_state under KEY, so
   they follow the player to any device. Otherwise they stay in this browser. */
(function (root) {
  "use strict";
  var E = root.HWEngine, CARD = E.CARD;
  var KEY = "herald.decks.v1", LOCAL = "hw.decks";
  var snapshot = null;

  function cloud() { return root.DKCloud && root.DKCloud.signedIn() ? root.DKCloud : null; }
  function readLocal() { try { return current(JSON.parse(localStorage.getItem(LOCAL)) || []); } catch (e) { return []; } }
  // Therabir's deck key was once "korvath": decks saved before the rename (3 Nov 2026) load as Therabir's.
  function current(list) { list.forEach(function (d) { if (d && d.herald === "korvath") d.herald = "therabir"; }); return list; }
  function writeLocal(list) { try { localStorage.setItem(LOCAL, JSON.stringify(list)); } catch (e) {} }

  // Signs in through the Shopify session when the page is on Sanctum. Resolves true when signed in.
  function connect() {
    var C = root.DKCloud;
    if (!C) return Promise.resolve(false);
    return (C.sso ? C.sso() : Promise.resolve(C.signedIn())).then(function () { return C.signedIn(); }, function () { return C.signedIn(); });
  }

  // Which starter decks this player owns, and so how many of each card they can build with.
  function owned() {
    var C = cloud();
    var ready = C && C.entitlements ? C.entitlements() : Promise.resolve([]);
    return ready.then(ownedFrom);
  }
  // How many copies of a card a deck may hold: the rule, capped by how many are owned.
  function limit(own, id) { return Math.min(E.copiesAllowed(CARD[id]), own.counts[id] || 0); }

  // Why a deck can't be played with these cards, or null.
  // The same from a list of owned products; the Ranked server checks decks with this too.
  function ownedFrom(products) {
    var decks = Object.keys(HW.decks).filter(function (k) { var p = HW.decks[k].product; return !p || products.indexOf(p) > -1; });
    var counts = {}, events = [];
    decks.forEach(function (k) {
      HW.decks[k].main.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      HW.decks[k].atlas.forEach(function (id) { if (CARD[id].type === "Event" && events.indexOf(id) < 0) events.push(id); });
    });
    return { decks: decks, counts: counts, events: events };
  }
  function problem(own, d) {
    var why = E.checkList(d);
    if (why) return why;
    if (own.decks.indexOf(d.herald) < 0) return "You don't own " + CARD[heraldOf(d.herald)].name + ".";
    for (var i = 0; i < d.events.length; i++) if (own.events.indexOf(d.events[i]) < 0) return "You don't own " + CARD[d.events[i]].name + ".";
    var n = {};
    for (var j = 0; j < d.main.length; j++) {
      n[d.main[j]] = (n[d.main[j]] || 0) + 1;
      if (n[d.main[j]] > limit(own, d.main[j])) return "You own " + (own.counts[d.main[j]] || 0) + " of " + CARD[d.main[j]].name + ".";
    }
    return null;
  }
  function heraldOf(k) { for (var i = 0; i < HW.cards.length; i++) if (HW.cards[i].type === "Herald" && HW.cards[i].deck === k) return HW.cards[i].id; }

  // Every saved deck. With an account, the account's copy wins; this browser keeps a cache.
  function load() {
    var C = cloud();
    if (!C) return Promise.resolve(readLocal());
    return C.readToolSnapshot(KEY).then(function (snap) {
      snapshot = snap;
      var list = current(snap.data && Array.isArray(snap.data.decks) ? snap.data.decks : []);
      // Decks made on this device before signing in move onto the account.
      var local = readLocal().filter(function (d) { return !list.some(function (x) { return x.id === d.id; }); });
      if (local.length) return save(list.concat(local));
      writeLocal(list);
      return list;
    }, function () { return readLocal(); });
  }

  // Saves the whole list. If another device saved first, merge by deck (newest edit wins) and retry.
  function save(list, retried) {
    writeLocal(list);
    var C = cloud();
    if (!C) return Promise.resolve(list);
    var ready = snapshot && snapshot.owner === C.userId() ? Promise.resolve(snapshot) : C.readToolSnapshot(KEY);
    return ready.then(function (snap) {
      snapshot = snap;
      return C.writeToolSnapshot(KEY, { decks: list }, snap);
    }).then(function (snap) { snapshot = snap; return list; }, function (err) {
      if (!err || err.code !== "CLOUD_CONFLICT" || retried) throw err;
      return C.readToolSnapshot(KEY).then(function (snap) {
        snapshot = snap;
        var theirs = snap.data && Array.isArray(snap.data.decks) ? snap.data.decks : [];
        var byId = {};
        theirs.concat(list).forEach(function (d) { if (!byId[d.id] || (d.updated || 0) >= (byId[d.id].updated || 0)) byId[d.id] = d; });
        return save(Object.keys(byId).map(function (k) { return byId[k]; }), true);
      });
    });
  }

  function newId() { return "d" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  root.HWDecks = { KEY: KEY, connect: connect, owned: owned, ownedFrom: ownedFrom, limit: limit, problem: problem, load: load, save: save,
                   newId: newId, heraldOf: heraldOf, signedIn: function () { return !!cloud(); } };
})(typeof window !== "undefined" ? window : globalThis);

/* play\rank.js */
/* Akeroth: Herald's Wake: the Ranked ladder. Pure rules, shared by the Ranked server and the game.

   A player's row for a Season is { points, games, wins, losses, streak, peak }. The first PLACEMENT
   games show as Unranked, then the tier comes from the points. Each tier has four divisions, IV up to
   I, each step points wide. A win pays WIN, and from the third win in a row STREAK more. A loss costs
   LOSS and can drop a division, but never drops you out of the tier you're in. A draw only counts as
   a game. peak is the most points reached; the Season-end reward goes by it. */
(function (root) {
  "use strict";
  var TIERS = [
    { key: "bronze", name: "Bronze", at: 0, step: 75 },
    { key: "silver", name: "Silver", at: 300, step: 100 },
    { key: "gold", name: "Gold", at: 700, step: 125 },
    { key: "platinum", name: "Platinum", at: 1200, step: 150 },
    { key: "diamond", name: "Diamond", at: 1800, step: 200 }
  ];
  var DIVISIONS = ["IV", "III", "II", "I"];
  var UNRANKED = { key: "unranked", name: "Unranked", at: 0 };
  var PLACEMENT = 3, WIN = 25, LOSS = 20, STREAK = 10, STREAK_FROM = 3;

  function blank() { return { points: 0, games: 0, wins: 0, losses: 0, streak: 0, peak: 0 }; }
  function tierAt(points) {
    var t = TIERS[0];
    for (var i = 0; i < TIERS.length; i++) if (points >= TIERS[i].at) t = TIERS[i];
    return t;
  }
  function tierOf(r) { return r.games < PLACEMENT ? UNRANKED : tierAt(r.points); }
  // Which division those points are in, 0 for IV up to 3 for I.
  function stepAt(points) { var t = tierAt(points); return Math.min(DIVISIONS.length - 1, Math.floor((points - t.at) / t.step)); }
  function labelAt(points) { return tierAt(points).name + " " + DIVISIONS[stepAt(points)]; }
  function labelOf(r) { return r.games < PLACEMENT ? UNRANKED.name : labelAt(r.points); }
  // won: true, false, or null for a draw. Returns a new row.
  function apply(r, won) {
    var n = { points: r.points, games: r.games + 1, wins: r.wins, losses: r.losses, streak: r.streak, peak: r.peak };
    if (won === null) { n.streak = 0; return n; }
    if (won) {
      n.wins++; n.streak = Math.max(0, n.streak) + 1;
      n.points += WIN + (n.streak >= STREAK_FROM ? STREAK : 0);
      n.peak = Math.max(n.peak, n.points);
    } else {
      n.losses++; n.streak = 0;
      n.points = Math.max(tierAt(r.points).at, r.points - LOSS);
    }
    return n;
  }
  // How far through the division: for the rank bar. next is the division above, or null at Diamond I.
  function progress(r) {
    var t = tierAt(r.points), i = TIERS.indexOf(t), d = stepAt(r.points), at = t.at + d * t.step, top = d === DIVISIONS.length - 1;
    var to = top ? (TIERS[i + 1] ? TIERS[i + 1].at : null) : at + t.step;
    return { tier: tierOf(r), label: labelOf(r), next: to === null ? null : { at: to, name: labelAt(to) }, into: r.points - at, span: to === null ? 0 : to - at, placement: Math.max(0, PLACEMENT - r.games) };
  }
  root.HWRank = { TIERS: TIERS, DIVISIONS: DIVISIONS, UNRANKED: UNRANKED, PLACEMENT: PLACEMENT, WIN: WIN, LOSS: LOSS, STREAK: STREAK, STREAK_FROM: STREAK_FROM,
    blank: blank, tierAt: tierAt, tierOf: tierOf, labelAt: labelAt, labelOf: labelOf, apply: apply, progress: progress };
})(typeof window !== "undefined" ? window : globalThis);

/* play\forge.js */
/* Akeroth: Herald's Wake: the rank-up evolution. The old badge heats up, burns down to a glowing core, cools,
   draws embers in, and blooms into the new badge in a flash, which then cools to metal.

   Every frame is drawn from the time alone, so the picture stays locked to the sound and any moment can
   be looked at on its own (seek). The art is the badge PSDs' own layers; the fire is those same layers
   recoloured and shown through a burn mask made from noise, so it follows the shape of the metal.

   HWForge.play({ host, spec, done }) -> { seek(ms), stop() }
   spec: { look: tier key, oldOuter: [urls], oldCore: [urls], oldTop: [urls], oldShade: url, base: [urls], frame: [urls],
           shade: url, crown: [urls], top: [urls], audio: url or null, name: text }, every list bottom layer first.
   The top lists and the shades are optional. Times below are ms into the sound. */
(function (w) {
  "use strict";
  var T = { rim: 160, sweep: 1140, burn: 1700, cool: 2400, gather: 3320, pulse1: 3660, pulse2: 4060, flash: 4620, settle: 5000, cold: 6000, end: 6600 };
  var HITS = [[1140, 5], [1540, 7], [2200, 4], [4840, 9], [5040, 7]];
  var STRIKES = [4620, 4840, 5040, 5200, 5360, 5520];
  // Each tier's fire. The beats stay the same all the way up; the colour changes, and there is more of everything.
  var LOOKS = {
    bronze: { ramp: [[0, 40, 4, 0], [0.3, 170, 34, 4], [0.58, 255, 112, 14], [0.8, 255, 196, 74], [1, 255, 248, 214]],
      ember: ["#ffd27a", "#ff6a1a"], gather: ["#ffe2a0", "#ff7a22"], spark: ["#fff0c0", "#ff7a22"], flash: [[255, 255, 240], [255, 196, 96], [255, 80, 10]], tint: [255, 240, 214], ring: "#ffdca0",
      bolt: ["70,150,255", "120,190,255", "240,250,255"], embers: 90, gathers: 130, bursts: 230, strikes: 3, rings: 1, motes: 0, boom: 22, swells: [] },
    silver: { ramp: [[0, 8, 14, 30], [0.3, 40, 80, 130], [0.58, 110, 170, 220], [0.8, 190, 225, 250], [1, 250, 253, 255]],
      ember: ["#e6f4ff", "#7fb8e8"], gather: ["#f2fbff", "#8fc4ee"], spark: ["#ffffff", "#9ccbf0"], flash: [[255, 255, 255], [190, 225, 250], [60, 130, 210]], tint: [225, 240, 255], ring: "#d6ecff",
      bolt: ["70,150,255", "130,195,255", "245,250,255"], embers: 110, gathers: 160, bursts: 300, strikes: 3, rings: 1, motes: 0, boom: 23, swells: [] },
    gold: { ramp: [[0, 40, 18, 0], [0.3, 180, 90, 8], [0.58, 255, 170, 30], [0.8, 255, 225, 110], [1, 255, 252, 225]],
      ember: ["#fff0a8", "#f0a020"], gather: ["#fff4c0", "#ffb030"], spark: ["#fffbe0", "#ffb830"], flash: [[255, 255, 235], [255, 214, 110], [230, 120, 10]], tint: [255, 244, 200], ring: "#ffe9a8",
      bolt: ["255,170,50", "255,215,120", "255,250,230"], embers: 130, gathers: 200, bursts: 380, strikes: 4, rings: 2, motes: 50, boom: 25, swells: [] },
    platinum: { ramp: [[0, 0, 20, 40], [0.3, 10, 90, 170], [0.58, 40, 170, 235], [0.8, 150, 235, 250], [1, 240, 255, 255]],
      ember: ["#d8fbff", "#3fb4ee"], gather: ["#e6fdff", "#52c4f2"], spark: ["#f0ffff", "#4cc0f0"], flash: [[245, 255, 255], [130, 225, 250], [20, 90, 200]], tint: [210, 245, 255], ring: "#bdf0ff",
      bolt: ["40,110,255", "90,190,255", "235,252,255"], embers: 150, gathers: 240, bursts: 480, strikes: 5, rings: 2, motes: 90, boom: 27, swells: [5360] },
    diamond: { ramp: [[0, 25, 5, 50], [0.3, 110, 40, 190], [0.58, 200, 90, 240], [0.8, 255, 170, 240], [1, 255, 245, 255]],
      ember: ["#ffe0f8", "#c060f0"], gather: ["#fff0ff", "#d080f8"], spark: ["#ffffff", "#d878f0"], flash: [[255, 250, 255], [240, 170, 250], [120, 50, 220]], tint: [250, 225, 255], ring: "#f2c8ff",
      bolt: ["150,70,255", "215,140,255", "255,245,255"], embers: 180, gathers: 300, bursts: 640, strikes: 6, rings: 3, motes: 160, boom: 30, swells: [5200, 5520] }
  };
  var S = 768, N = 192;

  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function span(t, a, b) { return clamp((t - a) / (b - a)); }
  function smooth(x) { x = clamp(x); return x * x * (3 - 2 * x); }
  function back(x) { x = clamp(x) - 1; return 1 + 2.4 * x * x * x + 1.4 * x * x; }
  function rng(seed) { var s = seed >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
  function canvas(w2, h2) { var c = document.createElement("canvas"); c.width = w2; c.height = h2; return c; }

  // Layered value noise, 0 to 1, which the burn follows.
  var NOISE = null;
  function noise() {
    if (NOISE) return NOISE;
    var r = rng(77), out = new Float32Array(N * N), size, x, y;
    for (size = 6; size <= 48; size *= 2) {
      var g = [], weight = 6 / size;
      for (y = 0; y <= size; y++) { g[y] = []; for (x = 0; x <= size; x++) g[y][x] = r(); }
      for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
        var fx = x / N * size, fy = y / N * size, ix = fx | 0, iy = fy | 0, tx = smooth(fx - ix), ty = smooth(fy - iy);
        var a = g[iy][ix] + (g[iy][ix + 1] - g[iy][ix]) * tx, b = g[iy + 1][ix] + (g[iy + 1][ix + 1] - g[iy + 1][ix]) * tx;
        out[y * N + x] += (a + (b - a) * ty) * weight;
      }
    }
    var lo = 9, hi = -9, i;
    for (i = 0; i < out.length; i++) { if (out[i] < lo) lo = out[i]; if (out[i] > hi) hi = out[i]; }
    for (i = 0; i < out.length; i++) out[i] = (out[i] - lo) / (hi - lo);
    return (NOISE = out);
  }

  function loadAll(urls) {
    return Promise.all(urls.map(function (u) { return new Promise(function (ok, no) { var i = new Image(); i.crossOrigin = "anonymous"; i.onload = function () { ok(i); }; i.onerror = no; i.src = u; }); }));
  }
  function stack(list) { var c = canvas(S, S), x = c.getContext("2d"); list.forEach(function (i) { x.drawImage(i, 0, 0, S, S); }); return c; }
  // The same art heated: its own light and dark mapped onto the colours of hot metal, so every rivet stays.
  var RAMP = LOOKS.bronze.ramp;
  function heated(src, lift) {
    var c = stack([src]), x = c.getContext("2d"), im = x.getImageData(0, 0, S, S), d = im.data;
    for (var i = 0; i < d.length; i += 4) {
      if (!d[i + 3]) continue;
      var l = clamp(Math.pow((0.3 * d[i] + 0.59 * d[i + 1] + 0.11 * d[i + 2]) / 255, 0.8) * 1.3 + lift), k = 1;
      while (k < RAMP.length - 1 && RAMP[k][0] < l) k++;
      var a = RAMP[k - 1], b = RAMP[k], m = (l - a[0]) / (b[0] - a[0]);
      d[i] = a[1] + (b[1] - a[1]) * m; d[i + 1] = a[2] + (b[2] - a[2]) * m; d[i + 2] = a[3] + (b[3] - a[3]) * m;
    }
    x.putImageData(im, 0, 0);
    return c;
  }
  // How near each point is to the edge of the shape, so fire can run round the rims and leave the middle.
  function edges(src) {
    var a = canvas(N, N), b = canvas(N, N), ax = a.getContext("2d"), bx = b.getContext("2d");
    ax.drawImage(src, 0, 0, N, N); bx.filter = "blur(5px)"; bx.drawImage(a, 0, 0);
    var da = ax.getImageData(0, 0, N, N).data, db = bx.getImageData(0, 0, N, N).data, out = new Float32Array(N * N);
    for (var i = 0; i < out.length; i++) out[i] = clamp((da[i * 4 + 3] / 255) * (1 - db[i * 4 + 3] / 255) * 3.4);
    return out;
  }
  function blurred(src, px) { var c = canvas(S, S), x = c.getContext("2d"); x.filter = "blur(" + px + "px)"; x.drawImage(src, 0, 0); return c; }
  function fog() {
    var n = noise(), c = canvas(N, N), x = c.getContext("2d"), d = x.createImageData(N, N);
    for (var i = 0; i < n.length; i++) { var v = smooth((n[i] - 0.34) / 0.5); d.data[i * 4] = 92; d.data[i * 4 + 1] = 112; d.data[i * 4 + 2] = 138; d.data[i * 4 + 3] = v * 110; }
    x.putImageData(d, 0, 0);
    var big = canvas(960, 540), bx = big.getContext("2d");
    bx.filter = "blur(26px)"; bx.imageSmoothingQuality = "high"; bx.drawImage(c, -60, -60, 1080, 660);
    return big;
  }

  // A whole badge: the shade multiplies over what is below it, as it does in the PSD.
  function whole(under, shade, over) {
    var c = canvas(S, S), x = c.getContext("2d");
    under.forEach(function (i) { x.drawImage(i, 0, 0); });
    if (shade) { x.globalCompositeOperation = "multiply"; x.globalAlpha = 0.7; x.drawImage(shade, 0, 0, S, S); x.globalCompositeOperation = "source-over"; x.globalAlpha = 1; }
    over.forEach(function (i) { x.drawImage(i, 0, 0); });
    return c;
  }
  function build(a) {
    var outer = stack(a.oldOuter), core = stack(a.oldCore), base = stack(a.base), frame = stack(a.frame), crown = stack(a.crown), top = a.top.length ? stack(a.top) : null;
    var oldTop = a.oldTop.length ? [stack(a.oldTop)] : [];
    var all = whole([base, frame], a.shade, top ? [crown, top] : [crown]), old = whole([outer], a.oldShade, [core].concat(oldTop));
    return { outer: outer, core: core, old: old, base: base, frame: frame, crown: crown, top: top, shade: a.shade, all: all,
      oldHot: heated(old, 0.1), coreHot: heated(core, 0.1), allHot: heated(all, 0.12), allWhite: heated(all, 0.62),
      oldEdge: edges(old), coreEdge: edges(core), allEdge: edges(all),
      oldGlow: blurred(heated(old, 0), 18), coreGlow: blurred(heated(core, 0), 16), allGlow: blurred(heated(all, 0.1), 24), fog: fog() };
  }

  // Particles, worked out once; each one's place is a formula of the time.
  function particles(look) {
    var r = rng(4242), list = { embers: [], gather: [], burst: [], wisps: [], motes: [] }, i;
    for (i = 0; i < look.embers; i++) list.embers.push({ t0: T.sweep + r() * 1250, life: 700 + r() * 1100, a: r() * Math.PI * 2, d: 0.2 + r() * 0.1, vx: (r() - 0.5) * 0.09, vy: -0.05 - r() * 0.13, s: 1 + r() * 2.4 });
    for (i = 0; i < look.gathers; i++) list.gather.push({ t0: T.gather - 200 + r() * 1100, a: r() * Math.PI * 2, d: 0.42 + r() * 0.5, spin: (r() - 0.5) * 1.5, s: 0.8 + r() * 2.2 });
    for (i = 0; i < look.bursts; i++) list.burst.push({ a: r() * Math.PI * 2, v: 0.22 + r() * r() * 1.05, life: 450 + r() * 1300, s: 0.8 + r() * 2.6, t0: T.flash + (i % 4 === 3 ? 220 : look.rings > 2 && i % 4 === 2 ? 440 : 0) + r() * 60 });
    // Sparks that hang in the air after the flash, on the higher tiers.
    for (i = 0; i < look.motes; i++) list.motes.push({ x: (r() - 0.5) * 1.3, y: (r() - 0.5) * 0.95, t0: T.flash + 120 + r() * 1500, life: 900 + r() * 1300, s: 0.8 + r() * 1.8, tw: 0.006 + r() * 0.012, up: 0.02 + r() * 0.05 });
    for (i = 0; i < 12; i++) list.wisps.push({ side: i % 2 ? 1 : -1, y: -0.34 + r() * 0.6, bend: (r() - 0.5) * 0.5, t0: T.gather + r() * 500, w: 0.6 + r() * 1.4 });
    return list;
  }
  function bolt(seed, x0, y0, x1, y1) {
    var r = rng(seed), pts = [[x0, y0], [x1, y1]], rough = Math.abs(y1 - y0) * 0.2;
    for (var pass = 0; pass < 6; pass++) {
      var next = [pts[0]];
      for (var i = 1; i < pts.length; i++) { var a = pts[i - 1], b = pts[i]; next.push([(a[0] + b[0]) / 2 + (r() - 0.5) * rough, (a[1] + b[1]) / 2 + (r() - 0.5) * rough * 0.3], b); }
      pts = next; rough *= 0.56;
    }
    return pts;
  }

  function play(o) {
    var host = o.host, spec = o.spec, cv = canvas(16, 16), ctx = cv.getContext("2d"), name = document.createElement("p");
    cv.className = "hw-forge-canvas"; name.className = "hw-forge-name"; name.textContent = spec.name;
    host.appendChild(cv); host.appendChild(name);
    var work = canvas(S, S), wx = work.getContext("2d"), maskC = canvas(N, N), mx = maskC.getContext("2d"), maskD = mx.createImageData(N, N), n = noise();
    var look = LOOKS[spec.look] || LOOKS.bronze, strikes = STRIKES.slice(0, look.strikes), hits = HITS.concat([[T.flash, look.boom]], strikes.slice(3).map(function (st) { return [st, 9]; }));
    var flashAt = function (c, a) { return "rgba(" + c[0] + "," + c[1] + "," + c[2] + "," + a + ")"; };
    var art = null, fx = particles(look), W = 0, H = 0, D = 0, cx = 0, cy = 0, raf = 0, stopped = false, t0 = 0, audio = null, ended = false;
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5), r = host.getBoundingClientRect();
      W = cv.width = Math.round(r.width * dpr); H = cv.height = Math.round(r.height * dpr); D = Math.min(H * 0.78, W * 0.9); cx = W / 2; cy = H * 0.44;
    }
    // Burn masks: fn(height down the badge 0-1, noise 0-1) gives how much shows.
    function mask(fn, edge) {
      var d = maskD.data, i = 0;
      for (var y = 0; y < N; y++) for (var x = 0; x < N; x++, i++) d[i * 4 + 3] = fn(y / N, n[i], edge ? edge[i] : 0) * 255;
      mx.putImageData(maskD, 0, 0);
      return maskC;
    }
    function through(sprite, m) {
      wx.globalCompositeOperation = "source-over"; wx.clearRect(0, 0, S, S); wx.drawImage(sprite, 0, 0);
      wx.globalCompositeOperation = "destination-in"; wx.imageSmoothingEnabled = true; wx.drawImage(m, 0, 0, S, S);
      return work;
    }
    function put(sprite, scale, alpha, mode) {
      var d = D * (scale || 1);
      ctx.globalAlpha = alpha === undefined ? 1 : alpha; ctx.globalCompositeOperation = mode || "source-over";
      ctx.drawImage(sprite, cx - d / 2, cy - d / 2, d, d);
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
    }
    function dot(x, y, r2, col, a) { ctx.globalAlpha = a; ctx.fillStyle = col; ctx.beginPath(); ctx.arc(x, y, r2, 0, 6.3); ctx.fill(); }

    // only: draw one pass alone (see PASSES), for exporting the layers to After Effects.
    var only = null, on = function (n) { return !only || only === n; };
    function draw(t) {
      var i, k, sx = 0, sy = 0, flash = t >= T.flash;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, W, H);
      if (on("fog")) { ctx.globalAlpha = 0.5 + 0.12 * Math.sin(t / 900); ctx.drawImage(art.fog, -W * 0.1 - t * 0.012, -H * 0.15, W * 1.3, H * 1.3); ctx.globalAlpha = 1; }
      for (i = 0; i < hits.length; i++) { k = (t - hits[i][0]) / 300; if (k >= 0 && k < 1) { var amp = hits[i][1] * (1 - k) * (D / 900); sx += Math.sin(t * 0.09 + i) * amp; sy += Math.cos(t * 0.11 + i) * amp; } }
      ctx.setTransform(1, 0, 0, 1, sx, sy);

      if (!flash) {
        var burn = span(t, T.burn, T.cool), sweep = smooth(span(t, T.sweep, T.burn)), shrink = 1 - 0.1 * smooth(span(t, T.burn, T.cool + 300));
        var rim = smooth(span(t, T.rim, T.sweep)) * (1 - span(t, T.burn, T.cool));
        var edge = 0.09;
        if (burn < 1) {
          var gone = function (y, v) { return 1 - smooth((burn * 1.25 - (v * 0.8 + 0.1) + edge) / edge); };
          if (on("old")) put(through(art.old, mask(gone)), 1, 1);
          // A band of fire runs down from the top and leaves the rims burning behind it.
          if (sweep > 0 && on("old")) put(through(art.oldHot, mask(function (y, v, ed) {
            var d = sweep * 1.5 - (y * 0.72 + v * 0.28), band = 1 - clamp(Math.abs(d) / 0.13);
            return gone(y, v) * clamp(smooth(d / 0.06) * Math.max(ed, smooth((v - 0.56) / 0.16) * 0.8) + band);
          }, art.oldEdge)), 1, 1);
        } else if (on("old")) put(art.core, shrink, 1);
        if (burn > 0 && on("old")) put(art.core, shrink, burn);
        if (rim > 0 && on("old-glow")) put(art.oldGlow, 1.02, rim * 0.34 + sweep * 0.3, "lighter");
        // The core cools in patches, then takes heat back as the embers reach it.
        var cooled = 0.3, down = smooth(span(t, T.cool, T.gather)), up = span(t, T.gather, T.flash);
        var heat = t < T.cool ? burn : 1 - (1 - cooled) * down + (1 - cooled) * up * up * (3 - 2 * up) * 0.9;
        var level = heat * 0.86;
        if (burn > 0) {
          if (on("core-heat")) put(through(art.coreHot, mask(function (y, v, ed) { return smooth((level * 1.45 - v + 0.12) / 0.34) * Math.max(ed, smooth((v - 0.3) / 0.34)); }, art.coreEdge)), shrink, 1);
          if (on("core-glow")) put(art.coreGlow, shrink * 1.03, level * 0.42, "lighter");
        }
      } else {
        var e = t - T.flash, mA = back(e / 300), mB = back((e - 45) / 340), mC = back((e - 90) / 380), cool = span(t, T.flash + 120, T.cold);
        if (on("badge")) {
        put(art.base, 0.82 + 0.18 * mA, 1);
        put(art.frame, 0.7 + 0.3 * mB, clamp(e / 70));
        if (art.shade) put(art.shade, 0.82 + 0.18 * mA, 0.7, "multiply");
        put(art.crown, 0.8 + 0.2 * mC, clamp(e / 60));
        if (art.top) put(art.top, 0.76 + 0.24 * back((e - 135) / 400), clamp((e - 40) / 60));
        }
        var white = 1 - span(e, 40, 240);
        if (cool < 1) {
          // Everything is hot at first; then the middle goes dark and the rims and a few patches hold on.
          if (on("badge-heat")) put(through(art.allHot, mask(function (y, v, ed) {
            var left = smooth(((1 - cool) * 1.3 - (0.65 * (1 - v) + 0.35 * Math.abs(y - 0.45) * 2)) / 0.14);
            return left * Math.max(1 - cool * 3.4, ed, smooth((v - 0.5) / 0.16));
          }, art.allEdge)), 1, 1);
          if (on("badge-glow")) put(art.allGlow, 1.03, (1 - cool) * (1 - cool) * 0.55, "lighter");
        }
        if (white > 0 && on("white-hot")) put(art.allWhite, 1, white);
        // On the top tiers the finished badge swells with light again, on the later strikes.
        look.swells.forEach(function (at) { var q = span(t, at, at + 460); if (q > 0 && q < 1 && on("swell")) put(art.allGlow, 1.05, Math.sin(q * Math.PI) * 0.55, "lighter"); });
      }

      // Embers thrown off as it heats, carried up.
      ctx.globalCompositeOperation = "lighter";
      fx.embers.forEach(function (p) {
        var a = (t - p.t0) / p.life; if (a < 0 || a > 1 || !on("embers")) return;
        var x = cx + Math.cos(p.a) * p.d * D + p.vx * D * a, y = cy + Math.sin(p.a) * p.d * D + p.vy * D * a * (1 + a);
        dot(x, y, p.s * (D / 900) * (1 - a * 0.5), a < 0.3 ? look.ember[0] : look.ember[1], (1 - a) * 0.95);
      });
      // Smoke drawn in from the sides, and embers spiralling down onto the core.
      fx.wisps.forEach(function (p) {
        var a = span(t, p.t0, T.flash); if (a <= 0 || t > T.flash + 90 || !on("smoke")) return;
        var tail = Math.max(0, a * a - 0.32), head = a * a, from = p.side * W * 0.62, seg = 16;
        ctx.strokeStyle = "#9db6d2"; ctx.lineWidth = p.w * (D / 900); ctx.globalAlpha = 0.34 * Math.sin(a * Math.PI); ctx.beginPath();
        for (var s = 0; s <= seg; s++) { var q = tail + (head - tail) * s / seg, xx = cx + from * (1 - q), yy = cy + p.y * D * (1 - q) + Math.sin(q * Math.PI) * p.bend * D; if (s) ctx.lineTo(xx, yy); else ctx.moveTo(xx, yy); }
        ctx.stroke();
      });
      fx.gather.forEach(function (p) {
        var a = (t - p.t0) / (T.flash - p.t0); if (a < 0 || a > 1 || !on("gather")) return;
        var q = a * a * a, r2 = p.d * (1 - q) * D, ang = p.a + p.spin * q * 2.4;
        dot(cx + Math.cos(ang) * r2, cy + Math.sin(ang) * r2, p.s * (D / 900), q > 0.5 ? look.gather[0] : look.gather[1], clamp(a * 3) * 0.95);
      });
      if (flash) {
        var e2 = t - T.flash;
        fx.motes.forEach(function (p) {
          var a = (t - p.t0) / p.life; if (a < 0 || a > 1 || !on("sparks")) return;
          dot(cx + p.x * D, cy + (p.y - p.up * a) * D, p.s * (D / 900), look.spark[0], Math.sin(a * Math.PI) * (0.55 + 0.45 * Math.sin(t * p.tw + p.x * 40)));
        });
        fx.burst.forEach(function (p) {
          var a = (t - p.t0) / p.life; if (a < 0 || a > 1 || !on("sparks")) return;
          var run = (1 - Math.pow(1 - a, 3)) * p.v * D * 0.62, x = cx + Math.cos(p.a) * run, y = cy + Math.sin(p.a) * run + a * a * D * 0.16, tail = 0.018 * D * (1 - a);
          ctx.strokeStyle = a < 0.35 ? look.spark[0] : look.spark[1]; ctx.lineWidth = p.s * (D / 1000); ctx.globalAlpha = 1 - a;
          ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x - Math.cos(p.a) * tail, y - Math.sin(p.a) * tail); ctx.stroke();
        });
        // The flash, and the ring of air it pushes out.
        var f = 1 - span(e2, 0, 520);
        if (f > 0 && on("flash")) {
          var rad = D * (0.42 + 0.34 * span(e2, 0, 220)), g = ctx.createRadialGradient(cx, cy, 0, cx, cy, rad);
          g.addColorStop(0, flashAt(look.flash[0], f)); g.addColorStop(0.32, flashAt(look.flash[1], f * 0.85)); g.addColorStop(1, flashAt(look.flash[2], 0));
          ctx.globalAlpha = 1; ctx.fillStyle = g; ctx.fillRect(-40, -40, W + 80, H + 80);
          ctx.fillStyle = flashAt(look.tint, 0.34 * (1 - span(e2, 0, 130))); ctx.fillRect(-40, -40, W + 80, H + 80);
        }
        for (i = 0; i < look.rings; i++) {
          var ring = span(e2 - i * 200, 0, 460);
          if (ring > 0 && ring < 1 && on("shockwave")) { ctx.globalAlpha = (1 - ring) * 0.7; ctx.strokeStyle = look.ring; ctx.lineWidth = (1 - ring) * 12 * (D / 900); ctx.beginPath(); ctx.ellipse(cx, cy, D * (0.2 + ring * 0.62), D * (0.17 + ring * 0.5), 0, 0, 6.3); ctx.stroke(); }
        }
        // Lightning, striking from above.
        strikes.forEach(function (st, si) {
          var a = (t - st) / 170; if (a < 0 || a > 1 || !on("lightning")) return;
          var frame = Math.floor(t / 34), pts = bolt(st + frame * 7, cx + (si % 3 - 1) * (1 + (si / 3 | 0) * 1.7) * D * 0.08, -20, cx + (si === 1 ? -1 : 1) * D * 0.03, cy - D * 0.2);
          [[20, "rgba(" + look.bolt[0] + ",0.2)"], [8, "rgba(" + look.bolt[1] + ",0.55)"], [2.6, "rgba(" + look.bolt[2] + ",1)"]].forEach(function (l) {
            ctx.globalAlpha = 1 - a; ctx.strokeStyle = l[1]; ctx.lineWidth = l[0] * (D / 900); ctx.lineJoin = "round"; ctx.beginPath();
            pts.forEach(function (q, pi) { if (pi) ctx.lineTo(q[0], q[1]); else ctx.moveTo(q[0], q[1]); }); ctx.stroke();
          });
        });
      }
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
      name.classList.toggle("hw-forge-on", t >= T.settle);
    }

    function finish() { if (ended) return; ended = true; if (o.done) o.done(); }
    function tick() {
      if (stopped) return;
      // The sound's own position only moves in steps, so frames run on the steady clock, eased towards it.
      var now = performance.now(), t = now - t0;
      if (audio && !audio.paused && audio.currentTime > 0) { var off = audio.currentTime * 1000 - t; if (Math.abs(off) > 30) t0 -= off * 0.08; t = now - t0; }
      draw(Math.min(t, T.end));
      if (t >= T.end + 900) { finish(); return; }
      raf = requestAnimationFrame(tick);
    }
    var one = function (u) { return loadAll(u ? [u] : []); };
    var ready = Promise.all([loadAll(spec.oldOuter), loadAll(spec.oldCore), loadAll(spec.oldTop || []), one(spec.oldShade), loadAll(spec.base), loadAll(spec.frame), one(spec.shade), loadAll(spec.crown), loadAll(spec.top || [])]).then(function (r) {
      RAMP = look.ramp;
      art = build({ oldOuter: r[0], oldCore: r[1], oldTop: r[2], oldShade: r[3][0], base: r[4], frame: r[5], shade: r[6][0], crown: r[7], top: r[8] });
      size(); draw(0);
      if (o.paused) return;
      t0 = performance.now(); raf = requestAnimationFrame(tick);
      if (spec.audio) {
        audio = new Audio(spec.audio);
        audio.addEventListener("playing", function () { t0 = performance.now() - audio.currentTime * 1000; }, { once: true });
        audio.play().catch(function () { audio = null; });
      }
    });
    return { ready: ready, seek: function (ms, pass) { only = pass || null; draw(ms); only = null; }, art: function () { return art; }, canvas: cv, stop: function () { stopped = true; cancelAnimationFrame(raf); if (audio) audio.pause(); } };
  }
  // The passes, bottom first, and how each one blends: "add" passes were drawn with the canvas's lighter mode.
  var PASSES = [["fog", "normal"], ["old", "normal"], ["old-glow", "add"], ["core-heat", "normal"], ["core-glow", "add"], ["badge", "normal"], ["badge-heat", "normal"], ["badge-glow", "add"], ["white-hot", "normal"], ["swell", "add"],
    ["embers", "add"], ["smoke", "add"], ["gather", "add"], ["sparks", "add"], ["flash", "add"], ["shockwave", "add"], ["lightning", "add"]];
  w.HWForge = { play: play, END: T.end + 900, PASSES: PASSES, T: T };
})(window);

/* play\net.js */
/* Akeroth: Herald's Wake: the table connection.
   One Supabase Realtime channel per room ("realtime:hw-<room>"), the same hand-made Phoenix socket
   the other Sanctum tools use. No tables: the host's browser holds the game, everyone else sends
   intents to it and draws whatever state it broadcasts.

   HWNet.connect(room, me, handlers) -> { send(event, payload), close() }
     handlers.onMessage(event, payload)   a broadcast from someone else
     handlers.onPeers(ids)                who is at the table right now
     handlers.onStatus("connecting" | "open" | "closed") */
(function (w) {
  "use strict";
  var BASE = "https://ivtdsbuzdjjzgvbjexfx.supabase.co";
  var ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml2dGRzYnV6ZGpqemd2YmpleGZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY0NDAxMDMsImV4cCI6MjEwMjAxNjEwM30.V-OeLe9hrnNIluIHy8KZUiHQlsKkG7MXLtsMC66-kl0";

  function connect(room, me, h) {
    var topic = "realtime:hw-" + room, ref = 0, sock = null, beat = 0, wait = 1000, stopped = false, peers = {};
    var queue = [];

    function raw(msg) {
      if (sock && sock.readyState === 1) sock.send(JSON.stringify(msg));
      else queue.push(msg);
    }
    function tellPeers() { h.onPeers && h.onPeers(Object.keys(peers)); }

    function open() {
      if (stopped) return;
      h.onStatus && h.onStatus("connecting");
      sock = new WebSocket(BASE.replace(/^http/, "ws") + "/realtime/v1/websocket?apikey=" + ANON + "&vsn=1.0.0");
      sock.onopen = function () {
        sock.send(JSON.stringify({ topic: topic, event: "phx_join", ref: String(++ref), join_ref: "1",
          payload: { access_token: ANON, config: { broadcast: { self: false }, presence: { key: me } } } }));
        beat = setInterval(function () { raw({ topic: "phoenix", event: "heartbeat", payload: {}, ref: String(++ref) }); }, 25000);
      };
      sock.onmessage = function (e) {
        var m; try { m = JSON.parse(e.data); } catch (x) { return; }
        if (m.event === "phx_reply" && m.ref === "1") {
          wait = 1000;
          sock.send(JSON.stringify({ topic: topic, event: "presence", ref: String(++ref),
            payload: { type: "presence", event: "track", payload: { at: Date.now() } } }));
          while (queue.length) sock.send(JSON.stringify(queue.shift()));
          h.onStatus && h.onStatus("open");
          return;
        }
        if (m.event === "presence_state") { peers = {}; Object.keys(m.payload || {}).forEach(function (k) { peers[k] = true; }); tellPeers(); return; }
        if (m.event === "presence_diff") {
          Object.keys((m.payload || {}).joins || {}).forEach(function (k) { peers[k] = true; });
          Object.keys((m.payload || {}).leaves || {}).forEach(function (k) { delete peers[k]; });
          tellPeers(); return;
        }
        if (m.event === "broadcast" && m.payload) h.onMessage && h.onMessage(m.payload.event, m.payload.payload);
      };
      sock.onclose = function () {
        clearInterval(beat);
        h.onStatus && h.onStatus("closed");
        if (!stopped) { setTimeout(open, wait); wait = Math.min(wait * 2, 15000); }
      };
      sock.onerror = function () { try { sock.close(); } catch (x) {} };
    }
    open();

    return {
      send: function (event, payload) {
        raw({ topic: topic, event: "broadcast", ref: String(++ref), payload: { type: "broadcast", event: event, payload: payload } });
      },
      close: function () { stopped = true; try { sock.close(); } catch (x) {} }
    };
  }

  w.HWNet = { connect: connect };
})(window);

/* play\app.js */
/* Herald's Wake: the table in the browser.
   Opening the page with no ?room= offers to open a table; the opener is the host and their browser
   runs HWEngine. Everyone else who opens the room link joins over HWNet and sends intents.

   Every screen is laid out on one fixed 1600 x 900 stage that scales to fit the window, the way a
   game canvas does, so a phone held sideways gets exactly the same table as a desktop. */
(function () {
  "use strict";
  var E = window.HWEngine, CARD = E.CARD;
  var $app = document.getElementById("app");
  if (!$app) return;  // on Sanctum the same page shows the card compendium instead (see herald-wake.liquid)
  var $preview = document.getElementById("preview");
  var $toast = document.getElementById("toast");

  var STAGE_W = 1600, STAGE_H = 900;
  var DECK_ORDER = Object.keys(HW.decks);
  var MID = (DECK_ORDER.length - 1) / 2;  // fans of Heralds are centred on the middle one

  /* ---------- identity and room ---------- */

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function makeId(n) { var a = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789", s = ""; for (var i = 0; i < n; i++) s += a[Math.floor(Math.random() * a.length)]; return s; }

  // A player is one browser tab: the id survives reloads but a second tab joins as someone new.
  function tabStore(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  var ME = tabStore("hw.me") || ("p-" + makeId(10));
  tabStore("hw.me", ME);
  var myName = store("hw.name") || "";
  var myDeck = (store("hw.deck") || "bramble").replace(/^korvath$/, "therabir");  // Therabir's old key   // a starter deck's key, or "custom:<id>" for a saved deck
  var myLists = [];                              // the player's saved decks that are ready to play (HWDecks)
  function myList() {
    if (myDeck.indexOf("custom:") !== 0) return null;
    var id = myDeck.slice(7);
    return myLists.filter(function (d) { return d.id === id; })[0] || null;
  }
  // What to send when joining or changing deck: a saved deck travels as its full list.
  function deckChoice(intent) {
    var l = myList();
    if (l) intent.list = { name: l.name, herald: l.herald, regions: l.regions || null, events: l.events, main: l.main };
    else intent.deck = myDeck.indexOf("custom:") === 0 ? "bramble" : myDeck;
    return intent;
  }
  var room = (new URLSearchParams(location.search).get("room") || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  var isHost = room && store("hw.host." + room) === ME;
  // Solo games (?mode=tutorial or ?mode=bot) run entirely in this tab: no table link, no network.
  var MODE = (new URLSearchParams(location.search).get("mode") || "").toLowerCase();
  var local = MODE === "tutorial" || MODE === "bot";

  var state = null;          // the host's authoritative state, or the last state a client received
  var net = null, peers = [], status = "connecting";
  var ui = { picked: null, menu: null, targeting: null, reveal: null, shownRound: 0, playLog: false, rules: false, tips: {} };

  /* ---------- helpers ---------- */

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  // Images live in img/<folder>/<id>.webp next to the page; on Sanctum they are flat theme assets
  // named herald-<kind>-<id>.webp under the base URL the section passes in.
  var ASSETS = ($app.getAttribute("data-assets") || "").replace(/[^/]*$/, "");
  var DIRS = { rank: "ranks", card: "cards", atlas: "atlas", scene: "scenes", hero: "heroes", art: "art", brand: "brand", ui: "ui", token: "tokens" };
  // On the theme every image URL carries its content hash (HW_VER, from tools/package.mjs) so a new
  // render replaces the cached one.
  function asset(name) { return ASSETS + name + (window.HW_VER && HW_VER[name] ? "?v=" + HW_VER[name] : ""); }
  function img(kind, id) { return ASSETS ? asset("herald-" + kind + "-" + id + ".webp") : "img/" + DIRS[kind] + "/" + id + ".webp"; }
  function brand(file) { return ASSETS ? asset("herald-brand-" + file) : "img/brand/" + file; }
  function cardImg(id) { return CARD[id].type === "Region" || CARD[id].type === "Event" ? img("atlas", id) : img("card", id); }
  var rootStyle = document.documentElement.style;
  rootStyle.setProperty("--hw-back", "url(" + (ASSETS ? asset("herald-card-back.webp") : "img/card-back.webp") + ")");
  rootStyle.setProperty("--hw-home", "url(" + brand("backdrop.webp") + ")");
  rootStyle.setProperty("--hw-sigil", "url(" + brand("crossed-paths.svg") + ")");
  ["plate", "orb-life", "orb-power", "emblem"].forEach(function (k) { rootStyle.setProperty("--hw-ui-" + k, "url(" + img("ui", k) + ")"); });

  // Regions and Events are landscape; in a portrait spot (your hand, a choice) they lie sideways.
  function cardEl(id, cls, attrs) {
    var wide = CARD[id].type === "Region" || CARD[id].type === "Event";
    return '<div class="hw-card ' + (wide ? "hw-sideways " : "") + (cls || "") + '"' + (wide ? "" : ' style="background-image:url(' + cardImg(id) + ')"') + ' data-img="' + id + '" ' + (attrs || "") +
      ' role="img" aria-label="' + esc(CARD[id].name) + '">' + (wide ? '<span class="hw-sideways-face" style="background-image:url(' + cardImg(id) + ')"></span>' : "") + "</div>";
  }
  // On the table a card is its art alone, as Arena shows a creature (tools/tokens.py cuts these);
  // hovering it still shows the whole card.
  function tokEl(id, cls, attrs) {
    return '<div class="hw-tok ' + (cls || "") + '" style="background-image:url(' + img("token", id) + ')" data-img="' + id + '" ' + (attrs || "") +
      ' role="img" aria-label="' + esc(CARD[id].name) + '"></div>';
  }
  function orb(kind, n, cls) { return '<span class="hw-orb hw-orb-' + kind + " " + (cls || "") + '" title="' + { life: "Life", power: "Total Power on the table" }[kind] + '">' + n + "</span>"; }
  function plate(text, cls) { return '<span class="hw-plate ' + (cls || "") + '">' + text + "</span>"; }
  function toast(text) {
    $toast.textContent = text; $toast.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(function () { $toast.hidden = true; }, 2600);
  }
  function link() { return location.origin + location.pathname + "?room=" + room; }
  function view() { if (ranked) return ranked.view; return state ? E.view(state, ME) : null; }
  function playerIn(v, id) { for (var i = 0; i < v.players.length; i++) if (v.players[i].id === id) return v.players[i]; return null; }
  function heraldId(deck) { for (var i = 0; i < HW.cards.length; i++) if (HW.cards[i].type === "Herald" && HW.cards[i].deck === deck) return HW.cards[i].id; }

  /* ---------- host side ---------- */

  function save() { if (isHost && !local) store("hw.state." + room, JSON.stringify(state)); }

  function hostApply(pid, intent) {
    var r = E.apply(state, pid, intent);
    if (r.error) {
      if (pid === ME) toast(r.error); else net.send("error", { to: pid, text: r.error });
      return;
    }
    state = r.state;
    save(); broadcast(); render(); botTick();
  }

  function broadcast() {
    if (local || !net || !state) return;
    var out = JSON.parse(JSON.stringify(state));
    out.log = out.log.slice(-60);
    net.send("state", out);
  }

  var botTimer = 0;
  function botTick() {
    clearTimeout(botTimer);
    if (!isHost || !state || state.phase !== "play") return;
    var actor = state.pending ? state.pending.player : state.turn;
    var p = state.players.filter(function (q) { return q.id === actor; })[0];
    if (!p || !p.bot) return;
    botTimer = setTimeout(function () {
      if (MODE === "tutorial" && local && ui.tip) { botTick(); return; }
      var mv = E.botMove(state, actor);
      if (mv) hostApply(actor, mv);
    }, 1100 + castQueue);  // a card the last move put up is seen out before the next
  }

  /* ---------- everyone ---------- */

  function act(intent) {
    if (intent.type === "play") ui.respondTo = null;  // a choice set aside comes back once the card played in between resolves
    if (ranked) rankedMove(intent);
    else if (isHost) hostApply(ME, intent);
    else if (net) net.send("intent", { from: ME, intent: intent });
  }

  var helloTimer = 0;
  function hello() {
    clearInterval(helloTimer);
    if (isHost) return;
    var send = function () {
      if (state && playerIn(state, ME)) { clearInterval(helloTimer); return; }
      net.send("hello", deckChoice({ from: ME, name: myName || "Herald" }));
    };
    send(); helloTimer = setInterval(send, 2500);
  }

  function connect() {
    net = HWNet.connect(room, ME, {
      onStatus: function (s) { status = s; if (s === "open") { hello(); if (isHost) broadcast(); } renderStatus(); },
      onPeers: function (ids) { peers = ids; if (isHost) broadcast(); renderStatus(); },
      onMessage: function (event, msg) {
        if (isHost) {
          if (event === "hello") hostApply(msg.from, { type: "join", name: msg.name, deck: msg.deck, list: msg.list });
          else if (event === "intent") hostApply(msg.from, msg.intent);
          return;
        }
        if (event === "state") { state = msg; render(); }
        else if (event === "error" && msg.to === ME) toast(msg.text);
      }
    });
  }

  /* ---------- the stage ---------- */

  // Fill the app box with the scene, and scale the fixed-size board into it.
  /* ---------- full screen ----------
     Phone browsers keep their address bar unless the page asks for full screen, which they only
     allow from a tap: the Full Screen buttons on the main menu, the rotate screen and the menu.
     iPhone browsers don't support it for pages, so the buttons don't show there. */
  var TOUCH = matchMedia("(pointer: coarse)").matches;
  function canFull() { var d = document.documentElement; return !!(d.requestFullscreen || d.webkitRequestFullscreen); }
  function isFull() { return !!(document.fullscreenElement || document.webkitFullscreenElement); }
  // One plain request, only ever from a Full Screen button. Chrome shows its own "to exit full
  // screen" notice when a page enters full screen; asking again, or turning the screen at the same
  // moment, makes it show again, so nothing here does either.
  function goFull() {
    var el = document.documentElement, req = el.requestFullscreen || el.webkitRequestFullscreen;
    if (!req || isFull()) return;
    try { var done = req.call(el); if (done && done.catch) done.catch(function () {}); } catch (e) {}
  }
  function leaveFull() {
    var exit = document.exitFullscreen || document.webkitExitFullscreen;
    if (exit && isFull()) try { exit.call(document); } catch (e) {}
  }
  ["fullscreenchange", "webkitfullscreenchange"].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(fit, 200); }); });

  // scene is a Region's art URL, or a Herald's painting from heroScene() for the front screens.
  function stage(scene, inner, cls) {
    var sc = typeof scene === "string" ? '<div class="hw-scene" style="background-image:url(' + scene + ')"></div>'
      : '<div class="hw-scene hw-scene-hero" style="background-image:url(' + scene.url + ');background-position:' + scene.pos + '"></div>';
    return sc +
      '<div class="hw-board ' + (cls || "") + '" id="board">' + inner + (ui.menuOpen ? menuPanel() : "") + (ui.guide ? rulesModal(ui.guide) : "") + "</div>" +
      '<div class="hw-rotate"><img src="' + brand("logo.webp") + '" alt=""><p>Turn your device sideways to play.</p>' +
      (canFull() && !isFull() ? '<button class="hw-plate-btn hw-primary" id="go-full-rotate">Play Full Screen</button>' : "") + "</div>";
  }
  function fit() {
    var b = document.getElementById("board");
    if (!b) return;
    var w = $app.clientWidth, h = $app.clientHeight;
    // Wider screens (most phones held sideways) widen the stage instead of leaving bars at the sides.
    var bw = Math.max(STAGE_W, Math.min(2000, STAGE_H * w / h));
    b.style.width = bw + "px";
    var s = Math.min(w / bw, h / STAGE_H);
    b.style.transform = "translate(-50%, -50%) scale(" + s + ")";
  }
  addEventListener("resize", fit);
  addEventListener("orientationchange", function () { setTimeout(fit, 250); });
  // On Sanctum the game starts below the site header: fill the rest of the window.
  // On Sanctum the game takes over the window; the exit button returns to wherever the player came from.
  var EMBEDDED = $app.classList.contains("hw-embedded");
  function placeEmbedded() { if (EMBEDDED) document.documentElement.classList.add("hw-taken"); }
  function exitUrl() {
    var r = document.referrer;
    return r && r.indexOf(location.origin) === 0 && r.indexOf(location.pathname) < 0 ? r : "/pages/inner-sanctum";
  }


  function logo(cls) { return '<img class="hw-logo ' + (cls || "") + '" src="' + brand("logo.webp") + '" alt="Akeroth: Herald\'s Wake">'; }
  function rulesButton() { return '<button class="hw-rules-btn" id="menu-open" aria-label="Menu" aria-expanded="' + !!ui.menuOpen + '"></button>'; }
  // The one menu, top right on every screen: the game fills the window, so leaving lives here.
  function menuPanel() {
    var inGame = !!(state && state.phase !== "lobby" && (local || room)), atTable = !!(room || local);
    var item = function (id, label) { return '<button class="hw-plate-btn hw-plate-sm" id="' + id + '">' + label + "</button>"; };
    return '<div class="hw-menu-panel" id="menu-panel">' +
      item("menu-rules", "Rules &amp; Keywords") + item("menu-cards", "Every Card") +
      (canFull() ? item(isFull() ? "exit-full" : "go-full", isFull() ? "Exit Full Screen" : "Full Screen") : "") +
      (atTable ? item("menu-leave", inGame ? "Leave the Game" : "Leave the Table") : "") +
      (ranked && ranked.screen === "table" && ranked.status !== "done" ? item("menu-concede", ui.sureConcede ? "Are You Sure?" : "Concede") : "") +
      (EMBEDDED ? item("exit", "Exit to Sanctum") : "") + soundControls() + "</div>";
  }
  // The battlefield every screen shares: a Region's art under one even dimming.
  function sceneFor(deck) { var d = HW.decks[deck] || HW.decks.bramble; return img("scene", d.atlas[0]); }
  function myScene() { var l = myList(); return sceneFor(l ? l.herald : myDeck.indexOf("custom:") === 0 ? "bramble" : myDeck); }

  /* ---------- home ---------- */

  // The front screens stand on one still painting: the chosen Herald's, framed on their focus.
  function heroScene(deck) {
    var h = CARD[heraldId(deck)] || CARD[heraldId("bramble")], f = h.focus || [0.5, 0.4];
    return { url: img("hero", h.id), pos: (f[0] * 100) + "% " + (f[1] * 100) + "%" };
  }
  function heroPanel(deck, cls) {
    var h = CARD[heraldId(deck)] || CARD[heraldId("bramble")], d = HW.decks[h.deck];
    return '<div class="hw-hero-cap ' + (cls || "") + '"><b>' + esc(h.name) + "</b><span>" + esc(h.title) + "</span></div>";
  }
  // The five Heralds as a row of cards; a saved deck shows under its Herald.
  function heraldRow(selected, custom) {
    return '<div class="hw-heralds">' + DECK_ORDER.map(function (k) {
      var on = selected === k && !custom;
      return '<button class="hw-herald-pick' + (on ? " hw-on" : "") + (selected === k && custom ? " hw-on-custom" : "") + '" data-deck="' + k + '" aria-pressed="' + on + '" title="' + esc(CARD[heraldId(k)].name) + '">' +
        cardEl(heraldId(k)) + "</button>";
    }).join("") + "</div>";
  }
  function deckKey() { var l = myList(); return l ? l.herald : myDeck.indexOf("custom:") === 0 ? "bramble" : myDeck; }

  // The main menu, as Arena's home screen: one painting behind (the World Tree, no slideshow) with the
  // logo on it, a bar across the top for everything that isn't a game, and the play panel at the bottom right: the deck
  // you'll play, how you'll play it, and Play.
  var TITLE_ART = "world-tree";
  var MODES = [["bot", "Bot", "A game against the computer"], ["friends", "Friends", "A table to invite friends to"], ["ranked", "Ranked", "Climb the ladder against other players"]];
  var playMode = store("hw.mode") || "bot";
  if (!MODES.some(function (m) { return m[0] === playMode; })) playMode = "bot";
  function deckLabel() {
    var l = myList(), h = CARD[heraldId(deckKey())];
    return { name: l ? l.name : h.name + "'s Deck", sub: l ? h.name : h.title || "" };
  }
  function renderHome() {
    var nav = function (id, label, on) { return '<button class="hw-nav' + (on ? " hw-on" : "") + '" id="' + id + '"' + (on ? ' aria-current="page"' : "") + ">" + label + "</button>"; };
    var mode = MODES.filter(function (m) { return m[0] === playMode; })[0] || MODES[0], dl = deckLabel();
    $app.innerHTML = stage({ url: img("scene", TITLE_ART), pos: "center" },
      '<div class="hw-arena">' +
      '<header class="hw-topbar">' +
        '<nav class="hw-navs">' + nav("nav-home", "Home", true) + nav("decks-btn", "Decks") + nav("cards-btn", "Cards") + nav("menu-rules", "Rules") + nav("learn", "Learn to Play") + "</nav>" +
        '<div class="hw-topbar-end">' + (TOUCH && canFull() && !isFull() ? nav("go-full", "Full Screen") : "") +
          nav("mix-on", SND.mix.on ? "Sound On" : "Sound Off") + (EMBEDDED ? nav("exit", "Back to Sanctum") : "") + "</div></header>" +
      logo("hw-logo-home") +
      '<aside class="hw-playbox">' +
        '<button class="hw-deckbox" id="deck-pick" aria-haspopup="menu">' + cardEl(heraldId(deckKey()), "hw-deckbox-card") +
          "<span><b>" + esc(dl.name) + "</b><i>" + esc(dl.sub) + "</i><em>Change Deck</em></span></button>" +
        '<div class="hw-modes" role="radiogroup" aria-label="How to play">' + MODES.map(function (m) {
          return '<button class="hw-mode' + (m[0] === mode[0] ? " hw-on" : "") + '" role="radio" aria-checked="' + (m[0] === mode[0]) + '" data-mode="' + m[0] + '">' + m[1] + "</button>"; }).join("") + "</div>" +
        '<p class="hw-mode-note">' + mode[2] + "</p>" +
        '<button class="hw-plate-btn hw-plate-lg hw-primary hw-play-go" id="play-go">Play</button>' +
      "</aside></div>" + rankChip(), "hw-home");
    fit();
    on("rank-chip", openRanked);
    if (!rankAsked) { rankAsked = true; refreshRank(); }
    each("[data-mode]", function (b) { b.onclick = function () { playMode = b.getAttribute("data-mode"); store("hw.mode", playMode); render(); }; });
    // The deck: a starter deck for each Herald, then your saved decks, then the deck builder.
    on("deck-pick", function (e) {
      e.stopPropagation();
      var opts = DECK_ORDER.map(function (k) { return { label: CARD[heraldId(k)].name + "'s Deck", detail: CARD[heraldId(k)].title || "", pick: k }; })
        .concat(myLists.map(function (d) { return { label: d.name, detail: CARD[heraldId(d.herald)].name, pick: "custom:" + d.id }; }))
        .concat([{ label: "Build a Deck", detail: "Opens the deck builder", build: true }]);
      showMenu("Choose a Deck", opts, e.currentTarget, function (o) {
        if (o.build) { location.href = compendiumUrl() + "#decks"; return; }
        myDeck = o.pick; store("hw.deck", myDeck); render();
      });
    });
    on("play-go", function () {
      if (playMode === "ranked") return openRanked();
      if (playMode === "bot") return startLocal("bot");
      openTable();
    });
    on("nav-home", function () {});
    // Play with Friends opens a table straight away: invite friends, add bots, or begin alone against a bot.
    function openTable() {
      myName = myName || "Herald";
      room = makeId(5);
      store("hw.host." + room, ME);
      isHost = true;
      state = E.create(Math.floor(Math.random() * 2147483647));
      state = E.apply(state, ME, deckChoice({ type: "join", name: myName })).state;
      save();
      history.replaceState(null, "", "?room=" + room);
      connect();
      render();
    }
    on("cards-btn", function () { location.href = compendiumUrl(); });
    on("decks-btn", function () { location.href = compendiumUrl() + "#decks"; });
    on("learn", function () { startLocal("tutorial"); });
    wireCommon();
  }

  // A 1v1 against a bot in this tab. The tutorial always deals you Bramble against Norag and
  // talks you through the first rounds; Bot mode uses your chosen Herald against a random one.
  function startLocal(mode) {
    var nameIn = document.getElementById("name");
    if (nameIn && nameIn.value.trim()) { myName = nameIn.value.trim(); store("hw.name", myName); }
    MODE = mode; local = true; room = "SOLO"; isHost = true;
    ui = { picked: null, menu: null, targeting: null, reveal: null, shownRound: 0, playLog: false, rules: false, tips: {} };
    var tutorial = mode === "tutorial";
    state = E.create(tutorial ? 20261023 : Math.floor(Math.random() * 2147483647));
    // Against a bot you go by your own name, or else your Herald's, so the log reads "Bramble plays…".
    var soloName = myName && myName !== "Herald" ? myName : CARD[heraldId(tutorial ? "bramble" : deckKey())].name;
    state = E.apply(state, ME, tutorial ? { type: "join", name: soloName, deck: "bramble" } : deckChoice({ type: "join", name: soloName })).state;
    var mineKey = state.players[0].deck;
    var foes = DECK_ORDER.filter(function (k) { return k !== (tutorial ? "bramble" : mineKey); });
    state = E.apply(state, ME, { type: "addBot", deck: tutorial ? "norag" : foes[Math.floor(Math.random() * foes.length)] }).state;
    // A solo opponent goes by its Herald's name.
    var bot = state.players[1]; bot.name = CARD[bot.herald].name;
    state = E.apply(state, ME, { type: "start" }).state;
    if (tutorial) state = E.apply(state, ME, { type: "mulligan", picks: [] }).state;  // the lesson's hand is set
    history.replaceState(null, "", "?mode=" + mode);
    render(); botTick();
  }
  function goHome() {
    clearTimeout(botTimer);
    local = false; MODE = ""; room = ""; state = null; isHost = false;
    history.replaceState(null, "", location.pathname);
    render();
  }

  /* ---------- lobby ---------- */

  function renderLobby(v) {
    var me = playerIn(v, ME), host = v.host === ME, full = v.players.length >= E.MAX_PLAYERS;
    var seats = "";
    for (var i = 0; i < E.MAX_PLAYERS; i++) {
      var p = v.players[i];
      if (!p) { seats += '<div class="hw-seat hw-seat-open"><div class="hw-seat-card"></div><div class="hw-seat-info"><b>Open seat</b></div></div>'; continue; }
      var h = CARD[p.herald];
      seats += '<div class="hw-seat' + (p.id === ME ? " hw-seat-me" : "") + '">' + cardEl(p.herald, "hw-seat-card") +
        '<div class="hw-seat-info"><b>' + esc(p.name) + "</b><span>" + esc(h.name) + ", " + esc(h.title) + "</span>" +
        (p.list ? "<em>" + esc(p.list.name) + "</em>" : "") +
        (p.id === v.host || p.bot ? '<i class="hw-seat-tag">' + (p.bot ? "Bot" : "Host") + "</i>" : "") +
        (host && p.bot ? '<button class="hw-text-btn" data-kick="' + p.id + '">Remove</button>' : "") + "</div></div>";
    }
    var mine = me ? me.deck : deckKey();
    $app.innerHTML = stage(heroScene(mine),
      heroPanel(mine, "hw-hero-lobby") +
      '<div class="hw-col hw-col-lobby">' +
      '<div class="hw-col-head">' + logo("hw-logo-small") + '<div class="hw-invite">' + plate("Table " + room, "hw-plate-sm") +
      '<button class="hw-plate-btn hw-plate-sm hw-primary" id="copy">Copy Invite</button></div></div>' +
      '<div class="hw-seats">' + seats + "</div>" +
      (me ? heraldRow(me.deck, !!me.list) +
        '<div class="hw-col-row"><input class="hw-plate-field" id="name" maxlength="20" placeholder="Your name" value="' + esc(me.name) + '" aria-label="Your name">' +
        '<button class="hw-plate-btn' + (me.list ? " hw-primary" : "") + '" id="my-decks">' + (me.list ? esc(me.list.name) : "Your Decks") + "</button></div>"
          : '<p class="hw-col-note">' + (full ? "This table is full." : "Taking your seat…") + "</p>") +
      '<div class="hw-col-row hw-col-end">' +
      (host ? '<button class="hw-plate-btn" id="bot"' + (full ? " disabled" : "") + ">Add a Bot</button>" +
              '<button class="hw-plate-btn hw-primary" id="start">' + (v.players.length < 2 ? "Play a Bot" : "Begin the Clash") + "</button>"
            : '<p class="hw-col-note">The host begins when everyone is seated.</p>') +
      "</div>" + rulesButton() + "</div>", "hw-lobby");
    fit();

    document.getElementById("copy").onclick = copyLink;
    var nameIn = document.getElementById("name");
    if (nameIn) nameIn.onchange = function () {
      myName = nameIn.value.trim() || "Herald"; store("hw.name", myName);
      act(deckChoice({ type: "join", name: myName }));
    };
    each("[data-deck]", function (b) {
      b.onclick = function () { myDeck = b.getAttribute("data-deck"); store("hw.deck", myDeck); act({ type: "pickDeck", deck: myDeck }); };
    });
    each("[data-kick]", function (b) { b.onclick = function () { act({ type: "removeBot", player: b.getAttribute("data-kick") }); }; });
    on("my-decks", function (e) { e.stopPropagation(); decksMenu(e.currentTarget, function () { act(deckChoice({ type: "pickDeck" })); }); });
    if (host) {
      document.getElementById("bot").onclick = function () { act({ type: "addBot" }); };
      // Alone at the table, Begin plays a bot in this tab, with no connection needed.
      document.getElementById("start").onclick = function () {
        if (v.players.length >= 2) return act({ type: "start" });
        if (net && net.close) net.close();
        net = null;
        startLocal("bot");
      };
    }
    wireCommon();
  }

  // Saved decks from the compendium's builder, and a way to build one.
  function decksMenu(el, picked) {
    var opts = myLists.map(function (d) {
      return { label: d.name, detail: CARD[heraldId(d.herald)].name, pick: "custom:" + d.id };
    }).concat([{ label: "Build a Deck", detail: "Opens the card compendium", build: true }]);
    showMenu("Your Decks", opts, el, function (o) {
      if (o.build) { location.href = compendiumUrl() + "#decks"; return; }
      myDeck = o.pick; store("hw.deck", myDeck); picked();
    });
  }

  // The quick reference behind the ? button, from data/rules.js: the rules, the words on the
  // cards, and what the orbs and emblems mean, one tab each.
  var GUIDE_TABS = [["rules", "How to Play"], ["words", "Keywords"], ["symbols", "Symbols"]];
  function guideBody(tab) {
    var R = HW.rules;
    if (tab === "words") return '<dl class="hw-guide-words">' + R.keywords.map(function (k) {
      return "<dt>" + esc(k.term) + "</dt><dd>" + k.text + "</dd>"; }).join("") + "</dl>";
    if (tab === "symbols") return '<div class="hw-guide-cols"><section><h3>The Numbers</h3><ul class="hw-guide-orbs">' + R.orbs.map(function (o) {
        return '<li><span class="hw-type-icon" style="background-image:url(' + img("ui", o.img) + ')"></span><div><b>' + esc(o.name) + "</b><br>" + o.text + "</div></li>"; }).join("") +
      "</ul></section><section><h3>Card Types</h3><ul class=\"hw-guide-types\">" + R.types.map(function (t) {
        return '<li><span class="hw-type-icon" style="background-image:url(' + img("ui", "type-" + t.icon) + ')"></span><div><b>' + t.type + "</b> " + t.text + "</div></li>"; }).join("") +
      "</ul></section></div>";
    // Three columns: two sections, two sections, then the rest.
    var sec = function (s) { return "<h3>" + esc(s.title) + "</h3><ul>" + s.points.map(function (p) { return "<li>" + p + "</li>"; }).join("") + "</ul>"; };
    var cols = [R.sections.slice(0, 2), R.sections.slice(2, 4), R.sections.slice(4)];
    return '<p class="hw-guide-intro">' + R.intro + '</p><div class="hw-guide-flow">' + cols.map(function (c) {
      return "<section>" + c.map(sec).join("") + "</section>"; }).join("") + "</div>";
  }
  function rulesModal(tab) {
    tab = tab || "rules";
    return '<div class="hw-modal" id="rules-modal"><div class="hw-sheet hw-guide">' +
      '<div class="hw-tabs">' + GUIDE_TABS.map(function (t) {
        return '<button class="hw-tab' + (t[0] === tab ? " hw-on" : "") + '" data-guide="' + t[0] + '">' + t[1] + "</button>"; }).join("") + "</div>" +
      '<div class="hw-guide-body">' + guideBody(tab) + "</div>" +
      '<div class="hw-row">' + (local && MODE ? '<button class="hw-plate-btn" id="rules-home">Leave the Game</button>' : "") +
      '<a class="hw-plate-btn" href="' + compendiumUrl() + '" target="_blank" rel="noopener">Every Card</a>' +
      '<button class="hw-plate-btn" id="rules-close">Close</button></div></div></div>';
  }
  // The card compendium: its own Sanctum page, or the page beside this one when run locally.
  function compendiumUrl() { return $app.getAttribute("data-cards") || (EMBEDDED ? location.pathname + "?cards" : "../compendium/"); }

  function copyLink() {
    var url = link();
    var done = function () { toast("Invite copied. Send it to up to three friends."); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { prompt("Copy this link", url); });
    else prompt("Copy this link", url);
  }

  /* ---------- the table ----------
     A duel is laid out like Hearthstone: the two Heralds face each other in the middle of the top
     and bottom edges, each with their Equipment to the left and their Path and Vault to the right,
     and the two fields meet in the middle. The Region and Event sit on the left, the turn on the
     right with the decks above and below it, and your hand rises from the bottom edge.
     With three or four players the rivals become tabs across the top, each with its Herald, Power
     and life; the board shows one rival's side at a time: the one you pick, or else whoever's turn
     it is. */

  function boardWidth() { return Math.max(STAGE_W, Math.min(2000, STAGE_H * $app.clientWidth / Math.max(1, $app.clientHeight))); }

  // The rival whose side the board shows: the one picked from the tabs, or else whoever's turn it
  // is, or else the next in turn order.
  function focusFoe(v, foes) {
    var pick = foes.filter(function (p) { return p.id === ui.focus; })[0];
    if (pick) return pick;
    return foes.filter(function (p) { return p.id === v.turn; })[0] || foes[0];
  }

  function renderTable(v) {
    var me = playerIn(v, ME);
    var foes = [];
    var mine = v.players.map(function (p) { return p.id; }).indexOf(ME);
    for (var i = 1; i <= v.players.length; i++) {
      var p = v.players[(Math.max(mine, 0) + i) % v.players.length];
      if (p.id !== ME) foes.push(p);
    }
    var bw = boardWidth(), handAt = fxHandRects(), fieldAt = fxFieldRects(), pileAt = fxPileRect();
    var strikeChoice = v.pending && v.pending.kind === "strike" && v.pending.player === ME;
    var reveal = !!(ui.reveal && ui.reveal.round === v.lastClashRound);
    var multi = foes.length > 1, shown = focusFoe(v, foes);
    $app.innerHTML = stage(img("scene", v.atlas.current),
      (multi ? rivalTabs(v, foes, shown, strikeChoice, reveal) : "") +
      (shown ? foeSide(v, shown, multi, strikeChoice, reveal) : "") +
      atlasBlock(v, me, strikeChoice, reveal) + eventBlock(v) + stackBlock(v) + turnBlock(v, me, strikeChoice, reveal) + banner(v, strikeChoice, reveal) +
      '<div class="hw-corner">' + rulesButton() + '<button class="hw-plate-btn hw-plate-sm" id="log-btn" aria-pressed="' + !!ui.playLog + '">Play Log</button>' +
        (local || ranked ? "" : '<button class="hw-plate-btn hw-plate-sm" id="copy">Invite</button>') + "</div>" +
      (me ? mySide(v, me, reveal) + (v.phase === "mulligan" ? "" : handRow(v, me)) : '<p class="hw-watching">You are watching this game.</p>') +
      (ui.playLog ? playLog(v) : "") +
      (MODE === "tutorial" && local ? coach(v, me) : "") +
      pendingModal(v, me) + overModal(v) + openingModal(v, me), "hw-play" + (multi ? " hw-multi" : " hw-duel") + (ui.targeting || strikeChoice ? " hw-targeting" : ""));
    var board = document.getElementById("board");
    if (board) board.style.setProperty("--bw", bw + "px");
    fit();
    spotlight();
    renderStatus();
    wireTable(v, me);
    wireOpening(v, me);
    if (ranked) wireRankedTable(v);
    setupDice();
    showRoll(v);
    tableFx(v, handAt, fieldAt, pileAt);
    holdModal();
    aimArrow();
  }

  /* ---------- sound ----------
     Effects are the CC0 Kenney sounds Drakonym: Origins ships (theme assets dk-origins-x-*); music is
     Crossed Paths' own soundtrack from Origins and the visual novel (dk-origins-music-*, dk-vn-music-*).
     On the dev server they are local copies in play/audio/sfx and play/audio/music (not in git). Effects
     go through Web Audio so several can sound at once; music is one <audio> at a time, crossfaded. A
     browser plays nothing before the first click or key, so the music waits for one. The mix (on,
     music, effects) is kept per browser in hw.mix. */
  var SND = (function () {
    var mix = { on: true, music: 0.3, sfx: 0.7 };
    try { var saved = JSON.parse(localStorage.getItem("hw.mix") || "null"); if (saved) mix = Object.assign(mix, saved); } catch (e) {}
    function save() { try { localStorage.setItem("hw.mix", JSON.stringify(mix)); } catch (e) {} }
    function url(kind, name) { return ASSETS ? ASSETS + (kind === "sfx" ? "dk-origins-x-" : "") + name + ".mp3" : "audio/" + kind + "/" + name + ".mp3"; }
    // Each effect: its variants (one is picked at random), then its level.
    var FX = {
      hover: [["tick-1", "tick-2"], 0.12], click: [["select-1", "select-2"], 0.35], confirm: [["confirm-1", "confirm-2"], 0.45],
      pick: [["cloth-1", "cloth-2"], 0.45], draw: [["page-1", "page-2"], 0.5], land: [["slam-1", "slam-2"], 0.45],
      spell: [["glass-1"], 0.4], action: [["slice-1", "slice-2"], 0.5], gear: [["clank-1", "clank-2"], 0.5], path: [["bell-2"], 0.35],
      event: [["bong-1"], 0.5], hit: [["punch-1", "punch-2"], 0.6], bighit: [["slam-1"], 0.7], heal: [["bell-2"], 0.3],
      gone: [["crack-1", "crack-2"], 0.55], turn: [["bell-1"], 0.4], region: [["page-2"], 0.5], pop: [["pop-1", "pop-2"], 0.4],
      clash: [["sword-1", "sword-2"], 0.6], strike: [["slash-1", "slash-2"], 0.6], won: [["jingle-1"], 0.5], lost: [["bong-1"], 0.55],
      dice: [["dice-1", "dice-2", "dice-3"], 0.6], die: [["die-1", "die-2"], 0.5]
    };
    var ctx = null, out = null, bufs = {}, woke = false;
    function wake() {
      if (woke) return;
      woke = true;
      try { ctx = new (window.AudioContext || window.webkitAudioContext)(); out = ctx.createGain(); out.connect(ctx.destination); out.gain.value = mix.sfx; } catch (e) { ctx = null; }
      if (want) music(want, true);
    }
    ["pointerdown", "keydown"].forEach(function (t) { addEventListener(t, wake, { capture: true, once: false, passive: true }); });
    function buf(name) {
      if (!bufs[name]) bufs[name] = fetch(url("sfx", name)).then(function (r) { return r.arrayBuffer(); }).then(function (a) { return ctx.decodeAudioData(a); }).catch(function () { return null; });
      return bufs[name];
    }
    function play(kind, opts) {
      var f = FX[kind];
      if (!f || !mix.on || !mix.sfx || !ctx || document.hidden) return;
      if (ctx.state === "suspended") ctx.resume();
      opts = opts || {};
      var name = f[0][Math.floor(Math.random() * f[0].length)];
      buf(name).then(function (b) {
        if (!b) return;
        var s = ctx.createBufferSource(), g = ctx.createGain();
        s.buffer = b; s.playbackRate.value = (opts.rate || 1) * (0.96 + Math.random() * 0.08);
        g.gain.value = f[1] * (opts.gain || 1);
        s.connect(g); g.connect(out);
        s.start(ctx.currentTime + (opts.delay || 0) / 1000);
      });
    }
    // Music: each scene's tracks, levelled to one loudness (measured RMS).
    var LEVEL = { "dk-origins-music-main": 0.55, "dk-origins-music-keiku": 0.9, "dk-origins-music-hatching": 1, "dk-origins-music-challenge": 0.7,
      "dk-vn-music-map": 0.9, "dk-vn-music-glades": 1, "dk-vn-music-spiritwell": 1, "dk-vn-music-ending": 0.55 };
    var SCENES = { home: ["dk-origins-music-main"], table: ["dk-vn-music-map", "dk-origins-music-keiku", "dk-vn-music-glades", "dk-vn-music-spiritwell", "dk-origins-music-hatching"],
      tense: ["dk-origins-music-challenge"], over: ["dk-vn-music-ending"] };
    var want = null, now = null, el = null, turn = 0;
    function level(track) { return (LEVEL[track] || 1) * mix.music * (mix.on ? 1 : 0); }
    function fade(a, to, ms, done) {
      var from = a.volume, t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / ms);
        a.volume = Math.max(0, Math.min(1, from + (to - from) * k));
        if (k < 1) requestAnimationFrame(step); else if (done) done();
      })(t0);
    }
    function start(track) {
      var a = new Audio(url("music", track));
      a.volume = 0; a.preload = "auto"; a.dataset.track = track;
      a.onended = function () { if (el === a) { var list = SCENES[now] || []; if (now === "over") return; start(list.length > 1 ? list[++turn % list.length] : track); } };
      var p = a.play(); if (p && p.catch) p.catch(function () {});
      var old = el; el = a;
      if (old) fade(old, 0, 1600, function () { old.pause(); });
      fade(a, level(track), 1600);
    }
    function music(scene, force) {
      want = scene;
      if (!woke || (scene === now && !force)) return;
      now = scene;
      var list = SCENES[scene];
      if (!list) { if (el) { var old = el; el = null; fade(old, 0, 1200, function () { old.pause(); }); } return; }
      if (scene === "table") turn = Math.floor(Math.random() * list.length);
      start(list[turn % list.length]);
    }
    function set(k, v) {
      mix[k] = v; save();
      if (out) out.gain.value = mix.sfx;
      if (el) el.volume = level(el.dataset.track);
      if (k === "on" && v && want && !el) music(want, true);
    }
    return { play: play, music: music, set: set, mix: mix };
  })();
  // The mix, in the menu on every screen: sound on or off, and how loud the music and effects are.
  function soundControls() {
    var m = SND.mix, slider = function (k, label) {
      return '<label class="hw-mix-row"><span>' + label + '</span><input type="range" min="0" max="1" step="0.05" value="' + m[k] + '" data-mix="' + k + '"' + (m.on ? "" : " disabled") + "></label>";
    };
    return '<div class="hw-mix"><button class="hw-plate-btn hw-plate-sm" id="mix-on" aria-pressed="' + m.on + '">' + (m.on ? "Sound On" : "Sound Off") + "</button>" +
      slider("music", "Music") + slider("sfx", "Effects") + "</div>";
  }
  document.addEventListener("input", function (e) {
    var k = e.target.getAttribute && e.target.getAttribute("data-mix");
    if (k) SND.set(k, +e.target.value);
  });
  document.addEventListener("change", function (e) { if (e.target.getAttribute && e.target.getAttribute("data-mix") === "sfx") SND.play("click"); });
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("button");
    if (!t) return;
    if (t.id === "mix-on") {
      SND.set("on", !SND.mix.on);
      t.textContent = SND.mix.on ? "Sound On" : "Sound Off"; t.setAttribute("aria-pressed", SND.mix.on);
      each("[data-mix]", function (i) { i.disabled = !SND.mix.on; });
      e.stopPropagation();
    }
    if (!t.disabled && (t.classList.contains("hw-plate-btn") || t.classList.contains("hw-mi") || t.classList.contains("hw-menu-opt"))) SND.play(t.classList.contains("hw-primary") ? "confirm" : "click");
  }, true);

  /* ---------- table effects ----------
     The table is redrawn from the state, so what just happened is read off the difference between
     the last view and this one: a card flies from the hand onto the field, damage and healing rise off
     the Herald, the Atlas moves on, your turn is announced, and the Clash plays out across the
     table. Everything is laid over the board in #fx (which a redraw leaves alone), takes no clicks and
     stays out of the way with reduced motion. */
  var fxCalm = matchMedia("(prefers-reduced-motion: reduce)").matches, fxLast = null;
  function fxRoot() {
    var r = document.getElementById("fx");
    if (!r) { r = document.createElement("div"); r.id = "fx"; r.className = "hw-fx"; document.body.appendChild(r); }
    return r;
  }
  function fxHandRects() {
    var out = {};
    each(".hw-hand [data-hand]", function (el) { out[el.getAttribute("data-hand")] = el.getBoundingClientRect(); });
    return out;
  }
  function fxPid(id) { return document.querySelector('[data-pid="' + id + '"]'); }
  function fxFloat(pid, n, onClash) {
    var el = (onClash && document.querySelector('[data-side="' + pid + '"] img')) || fxPid(pid);
    if (!el) return;
    var r = el.getBoundingClientRect(), f = document.createElement("div");
    f.className = "hw-float" + (n > 0 ? " hw-float-heal" : "");
    f.textContent = (n > 0 ? "+" : "") + n;
    f.style.left = r.left + r.width / 2 + "px"; f.style.top = r.top + r.height / 2 + "px";
    fxRoot().appendChild(f);
    setTimeout(function () { f.remove(); }, 1500);
    SND.play(n > 0 ? "heal" : n <= -3 ? "bighit" : "hit");
    if (n < 0) {
      el.animate([{ transform: "translateX(0)" }, { transform: "translateX(-9px)" }, { transform: "translateX(8px)" }, { transform: "translateX(-5px)" }, { transform: "translateX(0)" }], { duration: 340 });
      var sc = document.querySelector(".hw-scene");
      if (sc && n <= -3) sc.animate([{ transform: "translate(0, 0)" }, { transform: "translate(-7px, 5px)" }, { transform: "translate(6px, -4px)" }, { transform: "translate(0, 0)" }], { duration: 300 });
    }
  }
  // A Unit lands from where it was: your hand, or the Herald of whoever played it.
  function fxLand(uid, from) {
    var el = document.querySelector('[data-unit="' + uid + '"]');
    if (!el || !from) return;
    var to = el.getBoundingClientRect(), s = boardScale();
    var dx = (from.left + from.width / 2 - to.left - to.width / 2) / s, dy = (from.top + from.height / 2 - to.top - to.height / 2) / s;
    SND.play("land", { delay: 380 });
    el.animate([{ transform: "translate(" + dx + "px, " + dy + "px) scale(1.35) rotate(-4deg)", opacity: 0.9, zIndex: 40 },
      { transform: "translate(" + dx * 0.12 + "px, " + (dy * 0.12 - 20) + "px) scale(1.18)", opacity: 1, offset: 0.66, zIndex: 40 },
      { transform: "none", opacity: 1, zIndex: 40 }], { duration: 580, easing: "cubic-bezier(0.22, 0.8, 0.3, 1)" });
  }
  function fxTurn(text, colour) {
    var b = document.createElement("div");
    b.className = "hw-turnfx"; b.style.setProperty("--seat", colour);
    b.innerHTML = "<b>" + esc(text) + "</b>";
    SND.play("turn");
    fxRoot().appendChild(b);
    setTimeout(function () { b.remove(); }, 1300);
  }
  function fxRegion() {
    SND.play("region");
    var sc = document.querySelector(".hw-scene"), card = document.querySelector(".hw-atlas-card");
    if (sc) sc.animate([{ opacity: 0, transform: "scale(1.05)" }, { opacity: 1, transform: "scale(1)" }], { duration: 700, easing: "ease-out" });
    if (card) card.animate([{ transform: "rotateY(90deg)" }, { transform: "rotateY(0)" }], { duration: 420, easing: "ease-out" });
  }
  function fxFieldRects() {
    var out = {};
    each("[data-unit]", function (el) { var c = el.querySelector("[data-img]"); out[el.getAttribute("data-unit")] = { r: el.getBoundingClientRect(), id: c && c.getAttribute("data-img") }; });
    return out;
  }
  function fxPileRect() { var el = document.querySelector(".hw-my-piles .hw-pile-card"); return el && el.getBoundingClientRect(); }
  function fxCard(cls, id, r, url) {
    var g = document.createElement("div");
    g.className = cls; g.style.backgroundImage = "url(" + (url || cardImg(id)) + ")";
    g.style.width = r.width + "px"; g.style.height = r.height + "px";
    g.style.transform = "translate(" + r.left + "px," + r.top + "px)";
    fxRoot().appendChild(g);
    return g;
  }
  // A card drawn flies from your deck into its place in the hand.
  function fxDraw(uid, pile) {
    var el = document.querySelector('.hw-hand [data-hand="' + uid + '"]');
    if (!el || !pile) return;
    var to = el.getBoundingClientRect(), s = boardScale(), slot = el.parentNode;
    var a = (parseFloat(slot.style.getPropertyValue("--k")) || 0) * 2.2;
    var dx = (pile.left + pile.width / 2 - to.left - to.width / 2) / s, dy = (pile.top + pile.height / 2 - to.top - to.height / 2) / s;
    SND.play("draw", { delay: Math.random() * 60 });
    var from = "rotate(" + -a + "deg) translate(" + dx + "px, " + dy + "px) rotate(" + a + "deg) scale(" + (pile.width / to.width).toFixed(3) + ")";
    el.animate([{ transform: from, opacity: 1 }, { transform: "translateY(-40px) scale(1.04)", offset: 0.75 }, { transform: "none" }],
      { duration: 620, easing: "cubic-bezier(0.22, 0.8, 0.3, 1)" });
  }
  // A Unit that leaves the field breaks away where it stood.
  function fxGone(at) {
    if (!at || !at.id) return;
    SND.play("gone");
    var g = fxCard("hw-gone", at.id, at.r, img("token", at.id)), t = "translate(" + at.r.left + "px," + at.r.top + "px)";
    g.animate([{ transform: t, opacity: 1, filter: "none" },
      { transform: t + " translateY(-12px) rotate(-3deg) scale(1.05)", filter: "grayscale(1) brightness(1.7)", opacity: 1, offset: 0.3 },
      { transform: t + " translateY(36px) rotate(7deg) scale(0.78)", filter: "grayscale(1) brightness(0.35)", opacity: 0 }],
      { duration: 700, easing: "ease-in" }).onfinish = function () { g.remove(); };
  }
  // A number that changes gives a little bump.
  function fxBump(el) { if (el) el.animate([{ transform: "scale(1.3)" }, { transform: "scale(1)" }], { duration: 480, easing: "cubic-bezier(0.22, 0.8, 0.3, 1)", composite: "add" }); }
  // A card someone plays (other than a Unit, which lands on the field) is shown large in the middle of
  // the table for a moment, then goes to its Herald (Equipment, a Path), to the Event spot or away.
  // Several in a row queue up.
  var castQueue = 0, fxBusyUntil = 0;
  // A choice that comes up while a played card is still shown waits for it to finish, so the card is
  // seen and then the question, not one over the other.
  function holdModal() {
    var m = document.querySelector("#board > .hw-modal"), left = fxBusyUntil - performance.now() - 200;
    if (m && left > 0) m.style.animation = "hw-modal-in 0.3s ease-out " + Math.round(left) + "ms backwards";
  }
  function fxCast(id, from, mine, dest) {
    var d = CARD[id], wide = d.type === "Event", s = boardScale();
    var w = (wide ? 420 : 300) * s, h = wide ? w * 5 / 7 : w * 7 / 5;
    var cx = innerWidth / 2 - w / 2, cy = innerHeight / 2 - h / 2 - 20 * s;
    var start = from ? { x: from.left + from.width / 2 - w / 2, y: from.top + from.height / 2 - h / 2, k: Math.max(0.2, from.width / w) } : { x: cx, y: cy + 60 * s, k: 0.6 };
    var end = dest ? { x: dest.left + dest.width / 2 - w / 2, y: dest.top + dest.height / 2 - h / 2, k: Math.max(0.15, dest.width / w) } : { x: cx, y: cy - 40 * s, k: 0.9 };
    var tf = function (p, k) { return "translate(" + p.x + "px," + p.y + "px) scale(" + k + ")"; };
    if (castQueue > 3000) return;  // a backlog (a rejoin, a burst of plays) isn't replayed
    var wait = castQueue, hold = mine ? 520 : 1000;
    castQueue += hold + 620;
    fxBusyUntil = Math.max(fxBusyUntil, performance.now() + wait + 360 + hold + 460);
    setTimeout(function () {
      castQueue = Math.max(0, castQueue - hold - 620);
      var g = fxCard("hw-cast", id, { left: 0, top: 0, width: w, height: h });
      SND.play({ Spell: "spell", Action: "action", Event: "event", Equipment: "gear", Path: "path" }[d.type] || "spell");
      // Each leg eases on its own: in and settle, hold, then off to where it goes.
      var total = 360 + hold + 460;
      g.animate([{ transform: tf(start, start.k), opacity: from ? 1 : 0, easing: "cubic-bezier(0.22, 0.8, 0.3, 1)" },
        { transform: tf({ x: cx, y: cy }, 1), opacity: 1, offset: 360 / total },
        { transform: tf({ x: cx, y: cy }, 1), opacity: 1, offset: (360 + hold) / total, easing: "cubic-bezier(0.5, 0, 0.4, 1)" },
        { transform: tf(end, end.k), opacity: 0 }], { duration: total }).onfinish = function () { g.remove(); };
    }, wait);
  }
  // What the log gained since the last view (the log keeps its last 240 lines, so match its tail).
  function newLog(a, b) {
    if (!a.length) return [];
    var last = a[a.length - 1], prev = a[a.length - 2];
    for (var i = b.length - 1; i >= 0; i--) if (b[i].text === last.text && b[i].r === last.r && (!prev || (i > 0 && b[i - 1].text === prev.text))) return b.slice(i + 1);
    return [];
  }
  var CARD_BY_NAME = null;
  function cardNamed(name) {
    if (!CARD_BY_NAME) { CARD_BY_NAME = {}; for (var id in CARD) CARD_BY_NAME[CARD[id].name] = id; }
    return CARD_BY_NAME[name];
  }
  /* The Clash: each Herald steps in, their totals count up, the winner rises and the loser's life drops. */
  function fxClash(v) {
    var list = (v.lastClash || []).map(function (c) { return { c: c, p: playerIn(v, c.player) }; }).filter(function (x) { return x.p; });
    if (!list.length) return;
    var win = playerIn(v, v.lastWinner);
    var box = document.createElement("div");
    box.className = "hw-clashfx";
    box.innerHTML = '<p class="hw-cf-title">The Clash</p><div class="hw-cf-row">' + list.map(function (x, i) {
      return '<div class="hw-cf-side" data-side="' + x.p.id + '" style="--i:' + i + ";--seat:" + seatColour(v, x.p) + '"><img src="' + cardImg(x.p.herald) + '" alt="">' +
        "<b>0</b><span>" + esc(x.p.id === ME ? "You" : x.p.name) + "</span></div>";
    }).join("") + '</div><p class="hw-cf-result"></p>';
    fxRoot().appendChild(box);
    SND.play("clash");
    var nums = box.querySelectorAll(".hw-cf-side b"), t0 = performance.now();
    (function tick(now) {
      var k = Math.min(1, (now - t0 - 500) / 800);
      if (k > 0) list.forEach(function (x, i) { nums[i].textContent = Math.round(x.c.total * (1 - Math.pow(1 - k, 3))); });
      if (k < 1 && box.isConnected) requestAnimationFrame(tick);
    })(t0);
    setTimeout(function () {
      SND.play("strike");
      if (win) each(".hw-cf-side", function (s) { s.classList.add(s.getAttribute("data-side") === win.id ? "hw-cf-win" : "hw-cf-lose"); });
      box.querySelector(".hw-cf-result").textContent = !win ? "No one wins the Clash." : (win.id === ME ? "You win the Clash" : win.name + " wins the Clash");
    }, 1450);
    setTimeout(function () { box.classList.add("hw-cf-out"); }, 2700);
    setTimeout(function () { box.remove(); }, 3100);
  }
  function tableFx(v, handAt, fieldAt, pileAt) {
    var was = fxLast;
    fxLast = v;
    if (fxCalm || !was || was.round === undefined || v.phase === "lobby") return;
    var clash = !!ui.reveal && ui.fxClashed !== ui.reveal.round;
    if (clash) { ui.fxClashed = ui.reveal.round; fxClash(v); }
    var sameRound = v.round === was.round && !clash;
    v.players.forEach(function (p) {
      var q = playerIn(was, p.id);
      if (!q) return;
      var d = p.life - q.life;
      if (d) setTimeout(function () { fxFloat(p.id, d, clash); }, clash ? 1700 : 0);
      if (sameRound && p.total !== q.total) { var hp = fxPid(p.id); fxBump(hp && hp.querySelector(".hw-o-power")); }
      var had = {}, has = {};
      q.field.forEach(function (c) { had[c.uid] = c; });
      p.field.forEach(function (c) {
        has[c.uid] = true;
        if (had[c.uid]) {
          if (had[c.uid].damage !== c.damage) fxBump(document.querySelector('[data-unit="' + c.uid + '"] .hw-pow'));
          return;
        }
        var from = handAt[c.uid], hero = fxPid(p.id);
        fxLand(c.uid, from || (hero && hero.getBoundingClientRect()));
      });
      // Retired, destroyed or Exiled in the middle of a round (the round's sweep is left to the Clash).
      if (sameRound) q.field.forEach(function (c) { if (!has[c.uid]) fxGone(fieldAt[c.uid]); });
      // Cards you draw come off the deck.
      if (p.id === ME && v.phase === "play" && was.phase === "play") {
        var held = {};
        q.hand.forEach(function (c) { held[c.uid] = true; });
        p.hand.forEach(function (c) { if (!held[c.uid]) fxDraw(c.uid, pileAt); });
      }
    });
    // What was just played, shown large: Spells, Actions, Events, Equipment and Paths.
    newLog(was.log, v.log).slice(-4).forEach(function (l) {
      var m = l.text.match(/^(.*) (?:plays|equips|walks the) (.*?)(?: from their Vault)?(?:, over .*)?\.$/);
      var id = m && cardNamed(m[2]), d = id && CARD[id];
      if (!d || d.type === "Unit" || d.type === "Evolving Unit") return;
      var p = v.players.filter(function (x) { return x.name === m[1]; })[0];
      if (!p) return;
      var q = playerIn(was, p.id), from = null;
      if (p.id === ME && q) q.hand.forEach(function (c) { if (!from && c.id === id && handAt[c.uid] && !p.hand.some(function (h) { return h.uid === c.uid; })) from = handAt[c.uid]; });
      var hero = fxPid(p.id), heroAt = hero && hero.getBoundingClientRect();
      var ev = d.type === "Event" && document.querySelector(".hw-event .hw-atlas-card");
      fxCast(id, from || heroAt, p.id === ME, ev ? ev.getBoundingClientRect() : (d.type === "Equipment" || d.type === "Path") ? heroAt : null);
    });
    if (v.atlas.current !== was.atlas.current) fxRegion();
    if (v.phase === "over" && was.phase !== "over") SND.play(v.winner === ME ? "won" : "lost", { delay: 600 });
    if (v.pending && v.pending.player === ME && pendingKey(v) !== pendingKey(was)) SND.play("pop");
    if (v.turn === ME && was.turn !== ME && v.phase === "play" && !clash) { var me = playerIn(v, ME); if (me) fxTurn("Your Turn", seatColour(v, me)); }
  }

  /* ---------- dice ----------
     A Roll card throws three dice of its player's deck: Drakonym's 3D dice (DKDice3D), dressed
     in the deck's set, with star pips (the site's bullet star) and the deck's icon on the 6. A plate above them
     names the roll and then how many successes it scored. Without WebGL (or with reduced motion) flat dice in the
     same colours stand in. */
  // Each deck's d6s wear a look taken from one of Drakonym's dice sets (copied here, since the reward
  // designs come from the online manifest the game doesn't load): Bramble the Dragonfall d6, Norag
  // the World Tree d6, Iris & Theo the Voidcraft Hero die, Hiro the Inheric Hero die and Therabir
  // the Season of Magic: Diamond Shadow die. Every set has star pips and the deck's icon on the 6
  // (play/img/dice/<deck>.png).
  function diceFile(name) { return ASSETS ? asset("herald-dice-" + name) : "img/dice/" + name; }
  var DECK_DICE = {
    // Dragonfall (backer) pool
    bramble: { face: ["#b04a17", "#bd561c", "#a3410f"], pattern: "diamond", foil: "ember", glow: 0.25, iridescence: 0.2,
               ink: ["#fffaf0", "#ffe6bd"], escape: "#ffb35c", escapeK: 0.35, inkGlow: 0.12 },
    // The World Tree (akr-world-tree) pool, its ink deepened and kept matt: the set's metallic purple
    // caught the light on the pale opal and the Runeblade washed out
    norag: { face: ["#b890e0"], image: "world-tree.jpg", foil: "prism", iridescence: 0.35, opal: 0.2, opalScale: 5,
             ink: ["#2a0a52", "#1e0640"], escape: "#ffe08a", escapeK: 0.5 },
    // Inheric (asp-inheric) Hero die
    hiro: { face: ["#2fae6c"], pattern: "diamond", foil: "fire", foilCols: ["#b8ffd4", "#5fe39a", "#ffffff"], glow: 0.35, iridescence: 0.4,
            ink: ["#ffffff", "#e2ffee"], inkMetal: true, escape: "#7dffb4", escapeK: 0.65, inkGlow: 0.35 },
    // Voidcraft (asp-voidcraft) Hero die
    iris: { face: ["#6e48c8"], pattern: "diamond", foil: "fire", foilCols: ["#e3ccff", "#a46bff", "#ffffff"], glow: 0.35, iridescence: 0.4,
            ink: ["#ffffff", "#efe4ff"], inkMetal: true, escape: "#c9a2ff", escapeK: 0.65, inkGlow: 0.35 },
    // Season of Magic: Diamond (season-magic-diamond) Shadow die
    therabir: { face: ["#15181f", "#181c24"], pattern: "diamond", foil: "fire", glow: 0.2, iridescence: 0.3,
               ink: ["#f4f8ff", "#c3cedd"], inkMetal: true, escape: "#b9c6ff", escapeK: 0.4, inkGlow: 0.15 }
  };
  function diceMark(deck) { return diceFile(deck + ".png"); }
  function diceSet(deck) { return "herald-" + (DECK_DICE[deck] ? deck : "bramble"); }
  function deckPool(k) { var d = DECK_DICE[k]; return Object.assign({}, d, d.image ? { image: diceFile(d.image) } : {}); }
  var diceReady = false;
  function setupDice() {
    if (diceReady || !window.DKDice3D) return;
    diceReady = true;
    var base = DKDice3D.byId("classic");
    DKDice3D.addSets(Object.keys(DECK_DICE).map(function (k) {
      return { id: diceSet(k), name: CARD[heraldId(k)].name, group: "Herald's Wake",
               pool: Object.assign({}, deckPool(k), { pips: "star", mark: diceMark(k) }), hero: base.hero, shadow: base.shadow };
    }));
    DKDice3D.prefetch();
  }
  function poolOf(deck) {
    var d = DECK_DICE[deck] || DECK_DICE.bramble;
    return { face: d.face[0], ink: [].concat(d.ink)[0] };
  }
  var PIPS = { 1: [5], 2: [3, 7], 3: [3, 5, 7], 4: [1, 3, 7, 9], 5: [1, 3, 5, 7, 9] };
  function dieFace(n, deck) {
    if (n === 6) return '<span class="hw-die-mark" style="-webkit-mask-image:url(' + diceMark(deck) + ");mask-image:url(" + diceMark(deck) + ')"></span>';
    var out = "";
    for (var i = 1; i <= 9; i++) out += "<i" + (PIPS[n].indexOf(i) >= 0 ? ' class="hw-pip"' : "") + "></i>";
    return out;
  }
  function showRoll(v) {
    var r = v.roll;
    if (!r || r.seq === ui.rollSeq) return;
    var first = ui.rollSeq === undefined && v.log.length > 12;  // joining a game in progress: don't replay an old roll
    ui.rollSeq = r.seq;
    if (first) return;
    setupDice();
    var who = playerIn(v, r.by), deck = who ? who.deck : "bramble", col = poolOf(deck);
    var box = document.getElementById("roll");
    if (!box) { box = document.createElement("div"); box.id = "roll"; document.body.appendChild(box); }
    SND.play("dice");
    box.className = "hw-roll";
    box.style.setProperty("--die", col.face); box.style.setProperty("--pip", col.ink);
    box.innerHTML = '<p class="hw-roll-what">' + esc(r.by === ME ? "You roll" : (who ? who.name : "") + " rolls") + " for " + esc(CARD[r.id].name) + "</p>" +
      '<div class="hw-dice" hidden><div class="hw-die"></div><div class="hw-die"></div><div class="hw-die"></div></div><p class="hw-roll-result"></p>';
    box.hidden = false;
    clearInterval(showRoll.spin); clearTimeout(showRoll.hide);
    var done = function () {
      var res = box.querySelector(".hw-roll-result");
      res.textContent = r.successes + (r.successes === 1 ? " success" : " successes");
      SND.play("die");
      box.classList.add(r.successes ? "hw-roll-hit" : "hw-roll-miss");
      clearTimeout(showRoll.hide);
      showRoll.hide = setTimeout(function () { box.hidden = true; }, 2400);
    };
    var flat = function () {
      var wrap = box.querySelector(".hw-dice"), dice = wrap.querySelectorAll(".hw-die"), k = 0;
      wrap.hidden = false;
      showRoll.spin = setInterval(function () {
        dice.forEach(function (d) { d.innerHTML = dieFace(1 + Math.floor(Math.random() * 6), deck); });
        if (++k < 9) return;
        clearInterval(showRoll.spin);
        dice.forEach(function (d, i) { d.innerHTML = dieFace(r.dice[i], deck); d.classList.add("hw-settled"); });
        done();
      }, 70);
    };
    if (!window.DKDice3D || !DKDice3D.live()) return flat();
    var settled = false;
    DKDice3D.show(r.dice.map(function (n) { return { kind: "d6", v: n }; }), { set: diceSet(deck), hold: 2200,
      onValues: function () { settled = true; done(); } })
      .then(function () { if (!settled) done(); })
      .catch(function () { if (!settled) done(); });
  }

  // A card on a field: its Power in a gold orb; an Evolving Unit also shows its stage.
  // A card seen for the first time slides in; every later render leaves it still.
  var seenCards = {};
  function arrived(uid, zone) { var k = zone + uid; if (seenCards[k]) return ""; seenCards[k] = true; return " hw-arrive"; }
  function fieldCard(c, owner) {
    var d = CARD[c.id], t = ui.targeting, attrs = "";
    var targetable = t && ((t.need === "unit") || (t.need === "unit1" && c.damage <= 1) || (t.need === "unit4" && c.damage >= 4));
    if (targetable) attrs = 'data-target="unit" data-player="' + owner.id + '" data-uid="' + c.uid + '"';
    else if (owner.id === ME) attrs = 'data-field="' + c.uid + '"';
    // An Evolving Unit's tab names its stage and the Space it takes now.
    var stage = d.type === "Evolving Unit" ? '<span class="hw-stage" title="' + c.size + ' Space">' + ["I", "II", "III", "IV"][c.stage] + " · " + d.stages[c.stage].name + "</span>" : "";
    var base = d.type === "Evolving Unit" ? d.stages[c.stage].bonus || 0 : d.damage || 0;
    var moved = c.damage > base ? " hw-pow-up" : c.damage < base ? " hw-pow-down" : "";
    return '<div class="hw-unit' + arrived(c.uid, "f") + '" data-unit="' + c.uid + '">' +
      '<div class="hw-tok hw-u" data-img="' + c.id + '" ' + attrs + ' role="img" aria-label="' + esc(d.name) + '">' +
        '<b class="hw-u-name">' + esc(d.name) + '</b><span class="hw-u-art" style="background-image:url(' + img("token", c.id) + ')"></span></div>' +
      '<span class="hw-pow' + moved + '" title="Power ' + c.damage + (moved ? ", printed " + base : "") + '">' + c.damage + "</span>" + stage + "</div>";
  }
  // A field holds 6 Space. Up to three Units show at full size; more share the width. Six small
  // marks beside it count the Space used.
  function fieldRow(p, cls) {
    var used = p.space || 0, pips = "";
    for (var i = 0; i < E.SPACE; i++) pips += '<i class="' + (i < used ? "hw-on" : "") + '"></i>';
    return '<div class="hw-field ' + cls + '" style="--n:' + Math.max(3, p.field.length) + '">' +
      '<span class="hw-space" title="' + used + " of " + E.SPACE + ' Space used">' + pips + "</span>" + p.field.map(function (c) { return fieldCard(c, p); }).join("") + "</div>";
  }
  // Equipment to the left of a Herald, the Path and Vault to the right, as Hearthstone puts the
  // weapon and the hero power: small cards, and nothing at all for an empty slot.
  function gearCards(p) {
    var t = ui.targeting, mine = p.id === ME;
    return '<div class="hw-gear">' + (p.path ? tokEl(p.path.id, "hw-sm-tok hw-path-tok", 'title="Path"') : "") + p.gear.map(function (c) {
      var ok = t && (t.need === "gear" || (t.need === "swapGear" && mine));
      return tokEl(c.id, "hw-sm-tok" + arrived(c.uid, "g"), ok ? 'data-target="gear" data-player="' + p.id + '" data-uid="' + c.uid + '"' : 'title="Equipment"');
    }).join("") + "</div>";
  }
  function pathVault(p) {
    var mine = p.id === ME, out = [];
    if (mine) p.arsenal.forEach(function (c) {
      var v = view(), lit = v && !ui.targeting && vaultOptions(v, p, c).some(canPlay);
      out.push(tokEl(c.id, "hw-sm-tok hw-vaulted" + (lit ? " hw-can" : ""), 'data-vault="' + c.uid + '" title="In your Vault: play it any time"'));
    });
    else for (var i = 0; i < (p.arsenalCount || 0); i++) out.push('<div class="hw-card hw-back hw-sm-card" title="Vaulted"></div>');
    return '<div class="hw-pv">' + out.join("") + "</div>";
  }
  // A Herald: Power on the left (gold), life on the right (red), as a Hearthstone hero carries attack
  // and health, and the Clashes won on a tab above. While a Clash result shows, the Power is the
  // total they clashed with.
  function heroAttrs(v, p, strikeChoice) {
    var t = ui.targeting, mine = p.id === ME;
    var targetable = (t && ((t.need === "opponent" && !mine) || t.need === "player") && p.life > 0) ||
                     (!mine && strikeChoice && v.pending.options.indexOf(p.id) >= 0);
    return strikeChoice && targetable ? ' data-strike="' + p.id + '"' : targetable ? ' data-target="player" data-player="' + p.id + '"' : "";
  }
  function heroState(v, p, reveal) {
    return reveal ? (v.lastWinner === p.id ? " hw-won" : v.lastTarget === p.id ? " hw-hit" : "") : v.turn === p.id ? " hw-active" : "";
  }
  function powerOf(v, p, reveal) {
    var n = p.total;
    if (reveal) (v.lastClash || []).forEach(function (c) { if (c.player === p.id) n = c.total; });
    return n;
  }
  function renownMarks(p) {
    var marks = "";
    for (var r = 0; r < E.RENOWN; r++) marks += '<i class="' + (r < (p.wins || 0) ? "hw-won" : "") + '"></i>';
    return '<span class="hw-renown" title="Dominion: ' + (p.wins || 0) + " of " + E.RENOWN + ' Clashes won">' + marks + "</span>";
  }
  // A Herald: no name over the card (hovering it, or holding it on a phone, says whose it is);
  // the player's name sits by their deck instead.
  function hero(v, p, strikeChoice, reveal) {
    return '<div class="hw-hero' + heroState(v, p, reveal) + '"' + heroAttrs(v, p, strikeChoice) + ' data-pid="' + p.id + '" data-who="' + esc(whoLine(v, p)) + '" data-power="' + esc(powerData(p)) + '" data-total="' + powerOf(v, p, reveal) + '">' +
      '<div class="hw-avatar hw-hero-card" data-img="' + p.herald + '" style="background-image:url(' + img("token", p.herald + "-face") + ')" role="img" aria-label="' + esc(CARD[p.herald].name) + '"></div>' +
      orb("power", powerOf(v, p, reveal), "hw-o-power") + orb("life", p.life, "hw-o-life") + renownMarks(p) + "</div>";
  }
  // Where a Herald's Total Power comes from, for the hover panel: "Moon Dragon 4|Bramble: Rifts this round 1".
  function powerData(p) {
    return (p.powerParts || []).map(function (x) { return x[0].replace(/\|/g, "") + "\t" + x[1]; }).join("|");
  }
  // Each seat has its colour (red, blue, green, orange), used for its diamonds and its name.
  var SEATS = ["#c4505c", "#3f7fd6", "#4f9e5a", "#d98a2b"];
  function seatColour(v, p) { return SEATS[Math.max(0, v.players.indexOf(p)) % SEATS.length]; }
  function seatStyle(v, p) { return ' style="--seat:' + seatColour(v, p) + '"'; }
  function whoLine(v, p) {
    return (p.id === ME ? p.name + " (you)" : p.name) + (p.id === ME ? "" : " · " + (p.handCount || 0) + " in hand") +
      (p.passed && v.phase === "play" ? " · turn done" : "") + (p.connected === false ? " · away" : "");
  }
  // A deck face down and the Tomb face up, small, each with its count.
  function piles(v, p, cls) {
    var top = p.discard.length ? p.discard[p.discard.length - 1].id : null;
    var rk = v.ranks && v.ranks[p.id];
    var who = '<p class="hw-who">' + (rk ? rankBadge(rk.tier, "hw-who-badge") : "") + "<b>" + esc(p.name) + "</b>" + (p.id === ME ? "" : "<i>" + (p.handCount || 0) + " in hand</i>") +
      (p.passed && v.phase === "play" ? "<i>turn done</i>" : "") + (p.connected === false ? "<i>away</i>" : "") + "</p>";
    return '<div class="hw-piles ' + cls + '">' + who +
      '<div class="hw-pile" title="Deck: ' + p.drawCount + " left, " + (p.fallenCount || 0) + ' Exiled">' +
        (p.drawCount ? '<div class="hw-card hw-back hw-pile-card"></div>' : '<div class="hw-pile-card hw-pile-empty"></div>') + '<b class="hw-pile-n">' + p.drawCount + "</b></div>" +
      (top ? '<div class="hw-pile" title="The Tomb: Recall brings cards back">' + cardEl(top, "hw-pile-card") + '<b class="hw-pile-n">' + p.discard.length + "</b></div>" : "") +
      "</div>";
  }

  // The rival's side across the top. In a duel their Herald faces yours; with more rivals the
  // Herald is on its tab and this row holds just their Equipment, Path and Vault beside the field.
  function foeSide(v, p, multi, strikeChoice, reveal) {
    return '<div class="hw-foe' + (p.life <= 0 ? " hw-fallen" : "") + '"' + seatStyle(v, p) + '>' +
      '<div class="hw-hero-row hw-foe-row">' + gearCards(p) + (multi ? '<div class="hw-hero-gap"></div>' : hero(v, p, strikeChoice, reveal)) + pathVault(p) + "</div>" +
      fieldRow(p, "hw-foe-field") + piles(v, p, "hw-foe-piles") + "</div>";
  }
  function mySide(v, me, reveal) {
    return '<div class="hw-me' + (me.life <= 0 ? " hw-fallen" : "") + '"' + seatStyle(v, me) + '>' + fieldRow(me, "hw-my-field") +
      '<div class="hw-hero-row hw-my-row">' + gearCards(me) + hero(v, me, false, reveal) + pathVault(me) + "</div>" +
      piles(v, me, "hw-my-piles") + "</div>";
  }
  // Three or four players: a tab for each rival, with their Herald, Power, life and Clashes won.
  // The tab whose side is showing is raised; picking it again goes back to following the turn.
  function rivalTabs(v, foes, shown, strikeChoice, reveal) {
    return '<div class="hw-tabs" data-n="' + foes.length + '">' + foes.map(function (p) {
      var on = p === shown, attrs = heroAttrs(v, p, strikeChoice);
      return '<button class="hw-tab-rival' + (on ? " hw-on" : "") + heroState(v, p, reveal) + (p.life <= 0 ? " hw-fallen" : "") + '" data-focus="' + p.id + '"' + attrs + seatStyle(v, p) + ' data-pid="' + p.id + '" data-who="' + esc(whoLine(v, p)) + '" data-power="' + esc(powerData(p)) + '" data-total="' + powerOf(v, p, reveal) + '"' +
        ' aria-pressed="' + on + '" title="' + (on && ui.focus === p.id ? "Showing " + esc(p.name) + ": pick again to follow the turn" : "Show " + esc(p.name) + "'s side") + '">' +
        '<span class="hw-tab-face" data-img="' + p.herald + '" style="background-image:url(' + img("hero", p.herald) + ')"></span>' +  // hover shows their Herald
        '<span class="hw-tab-text"><b>' + esc(p.name) + "</b><i>" + (p.handCount || 0) + " in hand" + (p.passed && v.phase === "play" ? ", turn done" : "") + "</i>" + renownMarks(p) + "</span>" +
        orb("power", powerOf(v, p, reveal), "hw-o-tab") + orb("life", p.life, "hw-o-tab") + "</button>";
    }).join("") + "</div>";
  }

  // The Region in play, with the rest of the Atlas under it, and the Event in force.
  // Whether you can Rift for Actions now: on your turn, once a round (Bramble without a Path, as often as they like).
  function canRiftNow(v, me, strikeChoice, reveal) {
    return !!me && v.turn === ME && v.phase === "play" && !v.pending && !reveal && me.actions >= E.RIFT_COST &&
      (!me.flags.riftAct || (me.deck === "bramble" && !me.path)) && v.atlas.left > 0;
  }
  // The Rift move sits under the Region it moves on from, shown on your turn.
  function riftButton(v, me, strikeChoice, reveal) {
    if (!me || v.turn !== ME || v.phase !== "play") return "";
    return '<button class="hw-plate-btn hw-rift-btn" id="rift"' + (canRiftNow(v, me, strikeChoice, reveal) ? "" : " disabled") +
      ' title="Move the Atlas on to the next Region, once a round">Rift · ' + E.RIFT_COST + (E.RIFT_COST === 1 ? " Action" : " Actions") + "</button>";
  }
  function atlasBlock(v, me, strikeChoice, reveal) {
    var region = CARD[v.atlas.current];
    return '<div class="hw-atlas"><div class="hw-atlas-stack">' + (v.atlas.left ? '<div class="hw-atlas-under"></div>' : "") +
      '<div class="hw-atlas-card" style="background-image:url(' + img("atlas", region.id) + ')" data-img="' + region.id + '"></div></div>' +
      '<p class="hw-atlas-left"><b>Region</b> · ' + v.atlas.left + " more in the Atlas</p>" + riftButton(v, me, strikeChoice, reveal) + "</div>";
  }
  // Cards still resolving, as Arena shows its stack: each stays here, out of the Tomb, until everything
  // it set off is done; the one on top resolves first.
  function stackBlock(v) {
    var st = v.stack || [];
    if (!st.length) return "";
    return '<div class="hw-stack"><p class="hw-stack-label">Resolving</p><div class="hw-stack-cards">' + st.map(function (e, i) {
      var p = playerIn(v, e.player);
      return '<div class="hw-stack-card" style="--i:' + i + (p ? ";--seat:" + seatColour(v, p) : "") + '">' + tokEl(e.card.id) +
        "<span>" + esc(p ? (p.id === ME ? "You" : p.name) : "") + "</span></div>";
    }).join("") + "</div></div>";
  }
  function eventBlock(v) {
    var ev = v.events || [], top = ev.length ? ev[ev.length - 1] : null, by = top ? playerIn(v, top.by) : null;
    if (!top) return "";
    return '<div class="hw-event"><div class="hw-atlas-stack">' + (ev.length > 1 ? '<div class="hw-atlas-under"></div>' : "") +
      '<div class="hw-atlas-card" style="background-image:url(' + img("atlas", top.id) + ')" data-img="' + top.id + '"></div></div>' +
      '<p class="hw-atlas-left"><b>Event</b>' + (by ? " · played by " + esc(by.id === ME ? "you" : by.name) : "") + (ev.length > 1 ? " · " + (ev.length - 1) + " beneath" : "") + "</p></div>";
  }

  // The turn, on the right between the decks, as Hearthstone's End Turn button: on your turn it's
  // the button with your Actions and the Draw and Rift moves beneath; otherwise it names whose turn it is.
  // The round, as Arena's phase marks: one diamond per turn in turn order, in the seat's colour (done
  // ones solid, the one being taken large, the rest faint), and the Clash at the end.
  function tracker(v, reveal) {
    if (v.phase !== "play" || !v.order) return "";
    var out = [];
    for (var t = 1; t <= E.TURNS; t++) {
      out.push('<span class="hw-tr-turn">' + v.order.map(function (id) {
        var p = playerIn(v, id);
        if (!p || p.life <= 0) return "";
        var n = p.turns || 0, now = !reveal && v.turn === id && n === t, done = n > t || (n === t && !now) || reveal;
        return '<i class="' + (now ? "hw-tr-now" : done ? "hw-tr-done" : "") + '"' + seatStyle(v, p) + ' title="' + esc(p.id === ME ? "Your" : p.name + "'s") + " turn " + t + '"></i>';
      }).join("") + "</span>");
    }
    var clash = reveal || !v.turn;
    return '<p class="hw-tracker">' + out.join("") + '<b class="' + (clash ? "hw-tr-now" : "") + '">Clash</b></p>';
  }
  function turnBlock(v, me, strikeChoice, reveal) {
    var myTurn = !!me && v.turn === ME && v.phase === "play" && !v.pending && !reveal;
    var top = '<p class="hw-round">Round ' + v.round + "</p>" + tracker(v, reveal), main, below = "";
    if (myTurn) {
      var last = me.turns >= E.TURNS && v.players.every(function (p) { return p.id === ME || p.life <= 0 || p.passed; });
      main = '<button class="hw-plate-btn hw-turn-plate hw-primary' + (ui.targeting || anyPlay(v, me) ? "" : " hw-done") + '" id="end-turn" title="' + (last ? "End your turn: the Clash comes next" : "End your turn") + '">End Turn</button>';
      var pips = "";
      // One pip per Action in your pool: this turn's 3 plus any saved from your earlier turns this round.
      for (var i = 0; i < Math.max(E.ACTIONS, me.actions); i++) pips += '<i class="' + (i < me.actions ? "hw-on" : "") + '"></i>';
      var canDraw = me.actions >= E.DRAW_COST && me.drawCount > 0 && me.hand.length < E.LIMIT;
      below = '<div class="hw-plays" title="Unspent Actions carry over to your next turn this round"><span class="hw-pips hw-actions">' + pips + "</span><span>" + actionsWord(me.actions) + "</span></div>" +
        '<div class="hw-moves"><button class="hw-plate-btn hw-plate-sm" id="draw"' + (canDraw ? "" : " disabled") + ' title="' + (me.hand.length >= E.LIMIT ? "Your hand is full: " + E.LIMIT + " cards at most" : "Draw a card for " + E.DRAW_COST + " Action") + '">Draw · ' + E.DRAW_COST + "</button></div>";
    } else {
      var who = v.turn && playerIn(v, v.turn);
      main = plate(v.phase === "mulligan" ? "Opening Hands" : reveal || !v.turn ? "The Clash" : v.pending ? "Waiting" : who.id === ME ? "Your Turn" : esc(who.name) + "'s Turn", "hw-turn-plate");
      if (me && me.passed && !reveal) below = '<p class="hw-hint">Your turns are done. The Clash comes after the last turn.</p>';
      if (me && me.actions && v.phase === "play" && !reveal) below += '<p class="hw-hint">' + actionsWord(me.actions) + " saved for Fast and Vaulted cards</p>";
    }
    if (ranked) below += '<p class="hw-clock"></p>';
    return '<div class="hw-turn' + (myTurn ? " hw-mine" : "") + '"' + (me ? seatStyle(v, me) : "") + '>' + top + main + below + '<p class="hw-status" id="status"></p></div>';
  }
  /* The opening: who goes first (one die, Odds or Evens, in a duel; a roll-off with three or four), then the mulligan.
     Your 5 cards are laid out large: keep them, or shuffle them away and draw a new 5. */
  function openingModal(v, me) {
    if (v.phase !== "mulligan" || !v.opening) return "";
    var o = v.opening, first = playerIn(v, o.first), flip = ui.openSeen !== o.first;
    var head = o.kind === "die"
      ? '<div class="hw-oddeven">' + [[o.odds, "Odds"], [o.evens, "Evens"]].map(function (x) { var p = playerIn(v, x[0]);
          return "<p" + seatStyle(v, p) + (x[0] === o.first ? ' class="hw-first"' : "") + "><b>" + esc(p.id === ME ? "You" : p.name) + "</b><i>" + x[1] + "</i></p>"; }).join("") +
        '<div class="hw-die hw-settled hw-opening-die' + (flip ? " hw-wait" : "") + '"' + seatStyle(v, first) + ">" + dieFace(o.die, first.deck) + "</div></div>"
      : '<ul class="hw-rolloff">' + v.players.map(function (p) {
          return "<li" + seatStyle(v, p) + (p.id === o.first ? ' class="hw-first"' : "") + "><b>" + esc(p.name) + "</b>" +
            o.rolls[p.id].map(function (n) { return "<i>" + n + "</i>"; }).join("") + "</li>"; }).join("") + "</ul>";
    var who = (o.kind === "die" ? o.die + ", " + (o.die % 2 ? "Odds" : "Evens") + ". " : "") + (first.id === ME ? "You go first." : esc(first.name) + " goes first.");
    var body;
    if (me && me.mulligan) {
      body = '<p class="hw-hint">Keep this hand, or shuffle it into your deck and draw a new 5.</p>' +
        '<div class="hw-mull">' + me.hand.map(function (c) { return '<div class="hw-mull-card">' + cardEl(c.id, "") + "</div>"; }).join("") + "</div>" +
        '<div class="hw-row"><button class="hw-plate-btn" id="mull-redraw">Redraw</button><button class="hw-plate-btn hw-primary" id="mull-go">Keep My Hand</button></div>';
    } else body = '<p class="hw-hint">Waiting for ' + v.players.filter(function (p) { return p.mulligan; }).map(function (p) { return esc(p.name); }).join(", ") + " to choose.</p>";
    return '<div class="hw-modal hw-opening"><div class="hw-sheet hw-opening-sheet">' + head + '<p class="hw-opening-who">' + who + "</p>" + body + (ranked ? '<p class="hw-clock"></p>' : "") + "</div></div>";
  }
  function wireOpening(v, me) {
    if (v.phase !== "mulligan") { ui.mull = null; return; }
    // A duel's d6 is thrown once, in 3D, as Roll cards are; the flat die in the panel shows once it lands.
    if (v.opening && v.opening.kind === "die" && ui.openSeen !== v.opening.first) {
      var o = v.opening, deck = (playerIn(v, o.first) || {}).deck, show = function () { each(".hw-opening-die", function (d) { d.classList.remove("hw-wait"); }); };
      setupDice();
      if (window.DKDice3D && DKDice3D.live() && !fxCalm) DKDice3D.show([{ kind: "d6", v: o.die }], { set: diceSet(deck), hold: 1400, onValues: show }).then(show, show);
      else show();
    }
    if (v.opening) ui.openSeen = v.opening.first;  // the die is thrown once
    on("mull-go", function () { act({ type: "mulligan", redraw: false }); });
    // picks too, so a server still on the old pick-and-choose mulligan puts all 5 back: the same redraw.
    on("mull-redraw", function () { act({ type: "mulligan", redraw: true, picks: me.hand.map(function (c) { return c.uid; }) }); });
  }

  // Between the fields, only when there's something to say: a choice to make, a target to pick, or
  // for a moment after each Clash, who won it.
  function banner(v, strikeChoice, reveal) {
    var title = "", line = "", extra = "";
    if (reveal && !strikeChoice && !fxCalm) return "";  // the Clash plays out in the table effects
    if (reveal) {
      var w = playerIn(v, v.lastWinner);
      title = w ? (w.id === ME ? "You win the Clash" : esc(w.name) + " wins the Clash") : "No one wins the Clash";
      line = (v.lastClash || []).map(function (c) {
        var p = playerIn(v, c.player);
        return p ? (p.id === ME ? "You" : esc(p.name)) + " <b>" + c.total + "</b>" : "";
      }).join(" · ");
    } else if (strikeChoice) { title = "You win the Clash"; line = "Choose a rival to strike."; }
    else if (ui.targeting) { title = esc(ui.targeting.prompt); extra = '<button class="hw-plate-btn hw-plate-sm" id="cancel">Cancel</button>'; }
    else if (v.pending && v.pending.player !== ME) title = "Waiting on " + esc(playerIn(v, v.pending.player).name);
    else if (v.pending && ui.respondTo === pendingKey(v)) { title = esc(v.pending.prompt); line = "Play a Fast or Vaulted card, then come back to this."; extra = '<button class="hw-plate-btn hw-plate-sm" id="unrespond">Back to the Choice</button>'; }
    if (!title) return "";
    return '<div class="hw-banner' + (reveal ? " hw-reveal" : "") + (ui.targeting && !reveal && !strikeChoice ? " hw-banner-aim" : "") + '">' + plate(title, "hw-banner-plate") + (line ? '<p class="hw-hint">' + line + "</p>" : "") + extra + "</div>";
  }

  // The tutorial coach: one tip at a time, each shown once, picked from what is happening now.
  // spot is the part of the table the tip points at.
  var TIPS = [
    { id: "welcome", spot: ".hw-me .hw-hero", when: function (v) { return v.round === 1; },
      title: "This is your Herald", text: "Bramble, Mage Eternal. The <b>red orb</b> is your life and the <b>gold orb</b> your Power on the table. Bring the other Herald's life to 0 to win." },
    { id: "foe", spot: ".hw-foe .hw-hero", when: function (v) { return v.round === 1; },
      title: "Your opponent", text: "Norag, the Fae King, played by a bot. Their side of the table is at the top: their Herald, field and Equipment." },
    { id: "hand", spot: ".hw-hand", when: function (v) { return v.turn === ME; },
      title: "Three Actions a turn", text: "Each turn gives you <b>3 Actions</b>. The number on the banner at a card's top left is how many it takes. Drag a card onto the table, or tap it. Actions you don't spend <b>carry over</b> to your next turn. Everyone takes <b>three turns</b> a round, then the <b>Clash</b>. You hold <b>5 cards</b> at most." },
    { id: "track", spot: ".hw-me .hw-hero", when: function (v, me) { return v.round === 1 && me.acted; },
      title: "Power on the table", text: "The gold orb on each Herald is their <b>Total Power</b>: every Unit on their field plus bonuses. Hover over a Herald to see where it comes from. After everyone's turn, the highest Total Power wins the <b>Clash</b>." },
    { id: "clash", spot: ".hw-banner", when: function () { return !!ui.reveal; },
      title: "The Clash", text: "The winner strikes a rival, who takes <b>damage equal to the difference</b>. Win 4 Clashes for a <b>Dominion</b> victory: the marks under each Herald count them." },
    { id: "refill", spot: ".hw-hand", when: function (v) { return v.round === 2 && v.turn === ME; },
      title: "A new round", text: "Your hand, Equipment, Path and Evolving Dragons stayed. In the End Phase your other Units and your Tomb were shuffled together: <b>2</b> came back at random and you drew <b>2</b>. The rest are <b>Exiled</b>. You hold <b>5 cards</b> at most, so a full hand takes nothing back." },
    { id: "vault", spot: ".hw-hand", when: function (v) { return v.round >= 2 && v.turn === ME; },
      title: "The Vault", text: "Once a round, for 1 Action, tap a card and <b>Vault</b> it. Play it any time later, even on a rival's turn, for 1 Action less than printed." },
    { id: "field", spot: ".hw-me .hw-field", when: function (v, me) { return me.field.length >= 2 && v.turn === ME; },
      title: "Space", text: "Your field holds <b>6 Space</b>, and a Unit takes Space equal to its cost. With no room, tap one of your Units to <b>Retire</b> it for free." },
    { id: "atlas", spot: ".hw-atlas", when: function (v) { return v.round >= 2 && v.turn === ME; },
      title: "The Atlas", text: "The current Region changes the rules for everyone, and the Atlas moves on to the next one every round. <b>Rift</b>, with the button under the Region or with a card, to move it on sooner. Bramble's Rifts add <b>+2 Power</b> and Recall a card." },
    { id: "events", spot: ".hw-event", when: function (v, me) { return v.turn === ME && me.hand.some(function (c) { return CARD[c.id].type === "Event"; }); },
      title: "Events", text: "Your two <b>Events</b> are shuffled into your deck; when you draw one it lies sideways in your hand. It lasts until the end of the round, unless someone plays another Event on top." },
    { id: "evolve", spot: ".hw-me .hw-field", when: function (v, me) { return me.field.some(function (c) { return CARD[c.id].type === "Evolving Unit"; }); },
      title: "Dragons evolve", text: "An Evolving Unit starts as an <b>Egg</b> (1 Space) and evolves at the start of your turns toward its <b>Elder</b> stage (3 Space). It needs the room to grow." },
    { id: "roll", spot: ".hw-turn", when: function (v) { return !!v.roll; },
      title: "Rolling the dice", text: "Cards with <b>Roll</b> throw three dice. Each 4, 5 or 6 is a success, and the card says what happens for 0, 1, 2 or 3 successes." },
    { id: "done", spot: ".hw-rules-btn", when: function (v) { return v.round >= 3; },
      title: "You know the basics", text: "Keep going and win the match. The menu at the top right has the rules and every keyword." }
  ];
  function coach(v, me) {
    if (!me || v.phase !== "play" || ui.targeting) return "";
    var tip = null;
    for (var i = 0; i < TIPS.length; i++) if (!ui.tips[TIPS[i].id] && TIPS[i].when(v, me)) { tip = TIPS[i]; break; }
    ui.tip = tip ? tip.id : null;
    if (!tip) return "";
    var fresh = ui.tipShown !== tip.id; ui.tipShown = tip.id;
    // The tip sits clear of what it points at: over your side for the rivals', over the rivals' for the middle band.
    var top = /hw-foe/.test(tip.spot) ? 440 : /banner|turn|atlas|event|rules/.test(tip.spot) ? 30 : 230;
    return '<div class="hw-coach' + (fresh ? " hw-new" : "") + '" style="top:' + top + 'px">' + plate(tip.title, "hw-plate-sm") + "<p>" + tip.text + "</p>" +
      '<div class="hw-row"><button class="hw-text-btn" id="tip-skip">Skip the tutorial</button><button class="hw-plate-btn hw-plate-sm hw-primary" id="tip-ok">Got it</button></div></div>';
  }
  function spotlight() {
    var tip = TIPS.filter(function (x) { return x.id === ui.tip; })[0];
    if (!tip) return;
    each(tip.spot, function (el) { el.classList.add("hw-spot"); });
  }

  // Your hand, fanned up from the bottom edge. A card you can't play right now is dimmed; one you can
  // play is lit; the one you're choosing a target for stays up, picked.
  function canPlay(o) { return !o.off && !o.vault; }
  function casting(uid, from) { var t = ui.targeting; return !!(t && t.intent && t.intent.uid === uid && (t.intent.from === "arsenal") === (from === "arsenal")); }
  function handRow(v, me) {
    var n = me.hand.length;
    return '<div class="hw-hand">' + me.hand.map(function (c, i) {
      var k = i - (n - 1) / 2, opts = handOptions(v, me, c);
      var dim = !opts.some(function (o) { return !o.off; }), can = !ui.targeting && opts.some(canPlay);
      return '<div class="hw-hand-slot' + arrived(c.uid, "h") + (handUp === c.uid ? " hw-up" : "") + '" style="--k:' + k + ";--n:" + n + '">' +
        cardEl(c.id, (ui.picked === c.uid || casting(c.uid) ? "hw-picked " : "") + (dim ? "hw-cant" : can ? "hw-can" : ""), 'data-hand="' + c.uid + '"') + "</div>";
    }).join("") + "</div>";
  }
  // Is there anything left to play? (Drawing doesn't count: End Turn lights up when the cards are spent.)
  function anyPlay(v, me) {
    return me.hand.some(function (c) { return handOptions(v, me, c).some(canPlay); }) ||
      me.arsenal.some(function (c) { return vaultOptions(v, me, c).some(canPlay); });
  }

  function playLog(v) {
    return '<aside class="hw-playlog">' + plate("Play Log", "hw-plate-sm") + "<ol>" +
      v.log.slice().reverse().map(function (l) { return '<li class="hw-k-' + (l.kind || "plain") + '">' + esc(l.text) + "</li>"; }).join("") +
      "</ol></aside>";
  }

  // A choice part-way through a card can be set aside to play a Fast or Vaulted card first; the choice
  // comes back when that card has resolved, or with Back to the Choice.
  function pendingKey(v) { return v.pending ? [v.pending.kind, v.pending.prompt, v.pending.src, v.pending.card].join("|") : ""; }
  function canRespond(v, me) {
    // Asked as if the choice were already set aside.
    var was = ui.respondTo; ui.respondTo = pendingKey(v);
    var any = me.hand.some(function (c) { return handOptions(v, me, c).some(canPlay); }) || me.arsenal.some(function (c) { return vaultOptions(v, me, c).some(canPlay); });
    ui.respondTo = was;
    return any;
  }
  function pendingModal(v, me) {
    if (!v.pending || v.pending.player !== ME || !me || v.pending.kind === "strike" || ui.respondTo === pendingKey(v)) return "";
    var first = canRespond(v, me) ? '<button class="hw-plate-btn" id="respond">Play a Fast Card First</button>' : "";
    if (v.pending.kind === "scry") {
      return '<div class="hw-modal"><div class="hw-sheet">' + plate(esc(v.pending.prompt)) +
        '<div class="hw-choice">' + (v.pending.top ? cardEl(v.pending.top) : "") + "</div>" +
        '<div class="hw-row">' + first + '<button class="hw-plate-btn" data-pick-word="bottom">Put it on the bottom</button>' +
        '<button class="hw-plate-btn hw-primary" data-pick-word="keep">Keep it on top</button></div></div></div>';
    }
    // Recall: any card from the Tomb comes back to hand.
    return '<div class="hw-modal"><div class="hw-sheet">' + plate(esc(v.pending.prompt)) + '<div class="hw-choice hw-choice-many">' +
      me.discard.filter(function (c) { return c.uid !== v.pending.except; }).map(function (c) { return cardEl(c.id, "", 'data-pick="' + c.uid + '"'); }).join("") + "</div>" +
      (first ? '<div class="hw-row">' + first + "</div>" : "") + "</div></div>";
  }

  function overModal(v) {
    if (v.phase !== "over") return "";
    if (ranked) return rankResult(v);
    var w = playerIn(v, v.winner);
    return '<div class="hw-modal"><div class="hw-sheet hw-over">' +
      (w ? cardEl(w.herald) + plate(esc(w.name) + " wins", "hw-plate-lg") : plate("No Herald remains", "hw-plate-lg")) +
      '<p class="hw-over-how">' + ({ break: v.players.length > 2 ? "Victory: a Herald fell, and the most life won." : "Victory: the last Herald standing.",
        renown: "Dominion: " + E.RENOWN + " Clashes won.", lastlight: "Survival: the decks ran out, and the most life won." }[v.winBy] || "") + "</p>" +
      (local ? '<div class="hw-row"><button class="hw-plate-btn" id="home">Main Menu</button><button class="hw-plate-btn hw-primary" id="replay">Play Again</button></div>' :
       v.host === ME ? '<button class="hw-plate-btn hw-primary" id="again">Back to the Lobby</button>' : '<p class="hw-hint">Waiting for the host.</p>') +
      "</div></div>";
  }

  function renderStatus() {
    var el = document.getElementById("status");
    if (!el || !state || local) return;
    var hostHere = isHost || peers.indexOf(state.host) >= 0;
    // The host of a table of bots holds the whole game, so the connection doesn't matter to them.
    var people = state.players.filter(function (p) { return !p.bot && p.id !== ME; }).length;
    el.textContent = isHost && !people ? "" : status !== "open" ? "Reconnecting…" : !hostHere ? "The host has stepped away. The table waits for them." : "";
  }

  /* ---------- interaction ---------- */

  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
  function on(id, fn) { var el = document.getElementById(id); if (el) el.onclick = fn; }

  function wireCommon() {
    // The guide is part of every render (see stage()), so a bot's move behind it doesn't close it.
    var guide = function (tab) { return function (e) { e.stopPropagation(); ui.guide = tab; render(); }; };
    on("go-full", function (e) { e.stopPropagation(); ui.menuOpen = false; goFull(); });
    on("go-full-rotate", function (e) { e.stopPropagation(); goFull(); });
    on("exit-full", function (e) { e.stopPropagation(); ui.menuOpen = false; leaveFull(); render(); });
    on("menu-open", function (e) { e.stopPropagation(); ui.menuOpen = !ui.menuOpen; render(); });
    on("menu-rules", function (e) { e.stopPropagation(); ui.menuOpen = false; ui.guide = "rules"; render(); });
    on("menu-cards", function () { location.href = compendiumUrl(); });
    on("menu-leave", function () { ui.menuOpen = false; if (net && net.close) net.close(); goHome(); });
    each("[data-guide]", function (t) { t.onclick = guide(t.getAttribute("data-guide")); });
    on("rules-close", guide(null));
    on("rules-home", function () { ui.guide = null; goHome(); });
    on("exit", function () { location.href = exitUrl(); });
  }

  function wireTable(v, me) {
    each("[data-hand]", function (el) {
      el.onclick = function (e) { e.stopPropagation(); if (suppressClick) return; openMenu(v, me, +el.getAttribute("data-hand"), el); };
    });
    each("[data-field]", function (el) {
      el.onclick = function (e) { e.stopPropagation(); if (suppressClick) return; openFieldMenu(v, me, +el.getAttribute("data-field"), el); };
    });
    each("[data-vault]", function (el) {
      el.onclick = function (e) { e.stopPropagation(); if (suppressClick) return; openVaultMenu(v, me, +el.getAttribute("data-vault"), el); };
    });
    each("[data-target]", function (el) {
      el.onclick = function (e) {
        e.stopPropagation();
        var t = ui.targeting; if (!t) return;
        ui.targeting = null;
        if (t.need === "swapGear") {
          t.intent.replace = +el.getAttribute("data-uid");
          beginTargeting(v, me, t.d, t.o);  // the effect may still need a target
          return;
        }
        var target = { player: el.getAttribute("data-player") };
        if (el.getAttribute("data-uid")) target.uid = +el.getAttribute("data-uid");
        t.intent.target = target;
        act(t.intent);
        render();
      };
    });
    each("[data-focus]", function (el) {
      if (el.hasAttribute("data-strike") || el.hasAttribute("data-target")) return;
      el.onclick = function (e) { e.stopPropagation(); var id = el.getAttribute("data-focus"); ui.focus = ui.focus === id ? null : id; render(); };
    });
    each("[data-strike]", function (el) { el.onclick = function (e) { e.stopPropagation(); act({ type: "choose", pick: el.getAttribute("data-strike") }); }; });
    each("[data-pick]", function (el) { el.onclick = function () { act({ type: "choose", pick: +el.getAttribute("data-pick") }); }; });
    each("[data-pick-word]", function (el) { el.onclick = function () { act({ type: "choose", pick: el.getAttribute("data-pick-word") }); }; });
    on("respond", function (e) { e.stopPropagation(); ui.respondTo = pendingKey(v); render(); });
    on("unrespond", function (e) { e.stopPropagation(); ui.respondTo = null; ui.targeting = null; render(); });
    on("again", function () { act({ type: "reset" }); });
    on("end-turn", function () { closeMenu(); act({ type: "end" }); });
    on("draw", function () { act({ type: "draw" }); });
    on("rift", function () { act({ type: "rift" }); });
    on("cancel", function () { ui.targeting = null; render(); });
    on("copy", copyLink);
    on("log-btn", function (e) { e.stopPropagation(); ui.playLog = !ui.playLog; render(); });
    on("home", goHome);
    on("replay", function () { startLocal(MODE === "tutorial" ? "bot" : MODE); });
    on("tip-ok", function (e) { e.stopPropagation(); ui.tips[ui.tip] = true; render(); });
    on("tip-skip", function (e) { e.stopPropagation(); TIPS.forEach(function (x) { ui.tips[x.id] = true; }); render(); });
    wireCommon();
  }

  // Everything a card in hand can do right now, with the reason when it can't. On your turn a card
  // costs its Actions; a Unit also needs the Space. On a rival's turn only Fast cards can be played,
  // paid from the Actions you saved this round. Vaulting takes 1 Action, once a round.
  function actionsWord(n) { return n + (n === 1 ? " Action" : " Actions"); }
  function playOff(v, me, d, price) {
    var myTurn = v.turn === ME, unit = d.type === "Unit" || d.type === "Evolving Unit";
    if (price > me.actions) return myTurn ? "Not enough Actions." : "Not enough saved Actions.";
    var need = d.type === "Evolving Unit" ? E.STAGE_SPACE[0] : Math.max(1, d.cost || 0);
    if (unit && need > E.SPACE - (me.space || 0)) return "Not enough Space: Retire a Unit first.";
    return null;
  }
  function handOptions(v, me, c) {
    // While a choice is open, only Fast cards can be played (in between); nothing else.
    var d = CARD[c.id], myTurn = v.turn === ME && !v.pending, opts = [], price = d.cost || 0;
    if (v.phase !== "play" || noPlay(v)) return [];
    var unit = d.type === "Unit" || d.type === "Evolving Unit";
    if (d.type === "Event") {
      if (myTurn) opts.push({ label: "Play This Event", detail: actionsWord(price), intent: { type: "play", uid: c.uid }, off: playOff(v, me, d, price) });
    } else if (myTurn || E.isFast(c.id)) {
      var label = { Unit: "Play It to Your Field", "Evolving Unit": "Play It as an Egg", Equipment: "Equip Your Herald", Path: "Walk This Path" }[d.type] || "Play It";
      opts.push({ label: label, detail: myTurn ? actionsWord(price) : "Fast: " + actionsWord(price), intent: { type: "play", uid: c.uid }, need: true,
        unit: unit, equip: d.type === "Equipment", off: playOff(v, me, d, price) });
    }
    if (myTurn) opts.push({ label: "Vault This Card", detail: actionsWord(E.VAULT_COST) + ", once a round", vault: true, intent: { type: "arsenal", uid: c.uid },
      off: me.actions < E.VAULT_COST ? "Not enough Actions." :
        me.arsenaled ? "You've already Vaulted a card this round." : me.arsenal.length >= E.arsenalLimit(me) ? "Your Vault is full." : null });
    return opts;
  }
  // A Vaulted card can be played any time, even on a rival's turn, for 1 Action less than printed.
  function vaultOptions(v, me, c) {
    var d = CARD[c.id], price = Math.max(0, (d.cost || 0) - E.VAULT_COST);
    if (v.phase !== "play" || noPlay(v)) return [];
    return [{ label: "Play It from Your Vault", detail: v.turn === ME ? actionsWord(price) : price + " from your next turn", intent: { type: "play", from: "arsenal", uid: c.uid }, need: true,
      unit: d.type === "Unit" || d.type === "Evolving Unit", equip: d.type === "Equipment",
      off: d.type === "Event" && (v.turn !== ME || v.pending) ? "Events are played on your own turn, not in between." : playOff(v, me, d, price) }];
  }
  // A choice of whom to strike in the Clash, or your own choice still on screen, stops all play.
  function noPlay(v) { return !!v.pending && (v.pending.kind === "strike" || (v.pending.player === ME && ui.respondTo !== pendingKey(v))); }
  // Your own Unit on the field: Retire it to your Tomb, for no Actions, to make room.
  function openFieldMenu(v, me, uid, el) {
    closeMenu();
    if (v.phase !== "play" || v.pending) return;
    var c = me.field.filter(function (f) { return f.uid === uid; })[0];
    if (!c) return;
    showMenu(CARD[c.id].name, [{ label: "Retire It to Your Tomb", detail: "frees " + c.size + " Space, no Actions", intent: { type: "retire", uid: uid },
      off: v.turn !== ME ? "Retire on your own turn." : null }], el, function (o) { act(o.intent); });
  }

  function openMenu(v, me, uid, el) {
    closeMenu();
    if (v.phase !== "play" || noPlay(v)) return;
    var c = me.hand.filter(function (h) { return h.uid === uid; })[0];
    if (!c) return;
    var opts = handOptions(v, me, c);
    if (!opts.length) { toast(v.turn === ME ? "Nothing to do with this card right now." : "It isn't your turn."); return; }
    showMenu(CARD[c.id].name, opts, el, function (o) { beginTargeting(v, me, CARD[c.id], o); });
    ui.picked = uid;
    el.classList.add("hw-picked");
    SND.play("pick");
  }

  function openVaultMenu(v, me, uid, el) {
    closeMenu();
    var c = me.arsenal.filter(function (h) { return h.uid === uid; })[0];
    if (!c) return;
    var opts = vaultOptions(v, me, c);
    if (!opts.length) { toast("Finish the choice in front of you first."); return; }
    showMenu(CARD[c.id].name, opts, el, function (o) { beginTargeting(v, me, CARD[c.id], o); });
  }

  function showMenu(title, opts, el, choose) {
    var m = document.createElement("div");
    m.className = "hw-menu";
    m.innerHTML = '<p class="hw-menu-title">' + esc(title) + "</p>" + opts.map(function (o, i) {
      return '<button class="hw-menu-opt" data-opt="' + i + '"' + (o.off ? " disabled" : "") + "><span>" + esc(o.label) + "</span><em>" + esc(o.off || o.detail) + "</em></button>";
    }).join("");
    document.body.appendChild(m);
    var r = el.getBoundingClientRect();
    m.style.left = Math.max(8, Math.min(innerWidth - m.offsetWidth - 8, r.left + r.width / 2 - m.offsetWidth / 2)) + "px";
    m.style.top = Math.max(8, Math.min(innerHeight - m.offsetHeight - 8, r.top - m.offsetHeight - 10)) + "px";
    ui.menu = m;
    each(".hw-menu [data-opt]", function (b) {
      b.onclick = function (e) { e.stopPropagation(); var o = opts[+b.getAttribute("data-opt")]; closeMenu(); choose(o); };
    });
  }
  function closeMenu() { if (ui.menu) { ui.menu.remove(); ui.menu = null; } ui.picked = null; }

  var PROMPT = {
    opponent: "Choose an opponent", player: "Choose a player", unit: "Choose a Unit on any field",
    unit1: "Choose a Unit with 1 Power or less", unit4: "Choose a Unit with 4 or more Power", gear: "Choose Equipment on a Herald",
    swapGear: "Your Herald is fully equipped: choose Equipment to swap out"
  };

  // Asks for whatever the play still needs, one choice at a time: what to swap out, then a target.
  function beginTargeting(v, me, d, o) {
    var it = o.intent;
    // A fully equipped Herald asks which Equipment to swap out.
    if (o.equip && it.replace == null && me.gear.length >= E.gearLimit(v, me)) { ui.targeting = { need: "swapGear", intent: it, o: o, d: d, prompt: PROMPT.swapGear }; render(); return; }
    var need = o.need && !it.target ? E.effectNeed(d.id) : null;
    if (need === "copy") need = v.lastSpell ? E.effectNeed(v.lastSpell) : null;
    if (!need || !anyTarget(v, need)) { act(o.intent); return; }
    ui.targeting = { need: need, intent: o.intent, prompt: PROMPT[need] };
    render();
  }

  function anyTarget(v, need) {
    return v.players.some(function (p) {
      if (need === "opponent") return p.id !== ME && p.life > 0;
      if (need === "player") return p.life > 0;
      if (need === "unit") return p.field.length;
      if (need === "unit1") return p.field.some(function (c) { return c.damage <= 1; });
      if (need === "unit4") return p.field.some(function (c) { return c.damage >= 4; });
      if (need === "gear") return p.gear.length;
      return false;
    });
  }

  /* ---------- the targeting arrow ----------
     As in Arena: while a card waits for a target (or the Clash winner picks whom to strike), a glowing
     arrow grows from the card and stretches to the pointer, locking on to whatever it can target, which lifts.
     It's redrawn every frame while the table is in targeting, and goes when it isn't. On touch it
     shows once the finger moves. */
  var aim = { x: null, y: null, moved: 0, svg: null, raf: 0, on: null, since: 0 };
  document.addEventListener("pointermove", function (e) { aim.x = e.clientX; aim.y = e.clientY; aim.moved = performance.now(); aim.touch = e.pointerType !== "mouse"; }, { passive: true });
  function aimSource() {
    var t = ui.targeting, el = null;
    if (t && t.intent && t.intent.uid != null) el = document.querySelector(t.intent.from === "arsenal" ? '[data-vault="' + t.intent.uid + '"]' : '.hw-hand [data-hand="' + t.intent.uid + '"]');
    if (!el) { var h = fxPid(ME); el = h && h.querySelector(".hw-hero-card"); }
    return el;
  }
  function aimArrow() {
    var live = !!document.querySelector(".hw-play.hw-targeting");
    if (live && !aim.raf) { aim.since = performance.now(); aim.raf = requestAnimationFrame(aimFrame); }
  }
  function aimStop() {
    cancelAnimationFrame(aim.raf); aim.raf = 0;
    if (aim.svg) { aim.svg.remove(); aim.svg = null; }
    if (aim.on) { aim.on.classList.remove("hw-aimed"); aim.on = null; }
  }
  function aimFrame(now) {
    aim.raf = 0;
    if (!document.querySelector(".hw-play.hw-targeting")) { aimStop(); return; }
    aim.raf = requestAnimationFrame(aimFrame);
    var src = aimSource(), show = src && aim.x != null && (!aim.touch || aim.moved > aim.since);
    // lock on to a target under the pointer
    var hit = show && document.elementFromPoint(aim.x, aim.y), tgt = hit && hit.closest && hit.closest("[data-target], [data-strike]");
    if (tgt !== aim.on) { if (aim.on) aim.on.classList.remove("hw-aimed"); aim.on = tgt || null; if (tgt) tgt.classList.add("hw-aimed"); }
    if (!aim.svg) { aim.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"); aim.svg.setAttribute("class", "hw-arrow"); fxRoot().appendChild(aim.svg); }
    if (!show) { aim.svg.innerHTML = ""; return; }
    var s = src.getBoundingClientRect(), S = { x: s.left + s.width / 2, y: s.top + Math.min(s.height / 2, 40) }, E = { x: aim.x, y: aim.y };
    if (tgt) { var tr = (tgt.querySelector(".hw-card") || tgt).getBoundingClientRect(); E = { x: tr.left + tr.width / 2, y: tr.top + tr.height / 2 }; }
    aim.svg.classList.toggle("hw-locked", !!tgt);
    // a curve that rises from the card and comes down on the target
    var dist = Math.hypot(E.x - S.x, E.y - S.y), nx = (S.y - E.y) / (dist || 1), ny = (E.x - S.x) / (dist || 1);
    if (ny > 0) { nx = -nx; ny = -ny; }  // bow upwards, gently
    var C = { x: (S.x + E.x) / 2 + nx * dist * 0.2, y: (S.y + E.y) / 2 + ny * dist * 0.2 };
    var pts = [], lens = [0], N = 48;
    for (var i = 0; i <= N; i++) {
      var t = i / N, u = 1 - t;
      pts.push({ x: u * u * S.x + 2 * u * t * C.x + t * t * E.x, y: u * u * S.y + 2 * u * t * C.y + t * t * E.y });
      if (i) lens.push(lens[i - 1] + Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y));
    }
    var sc = Math.max(0.7, boardScale() * 1.4), j = 0;
    var at = function (d) {
      while (j < N - 1 && lens[j + 1] < d) j++;
      var f = Math.min(1, (d - lens[j]) / ((lens[j + 1] - lens[j]) || 1)), a = pts[j], b = pts[j + 1], l = Math.hypot(b.x - a.x, b.y - a.y) || 1;
      return { x: a.x + (b.x - a.x) * f, y: a.y + (b.y - a.y) * f, tx: (b.x - a.x) / l, ty: (b.y - a.y) / l };
    };
    // It grows out of the card when aiming starts, then reaches wherever it's pointed.
    var L = lens[N] * (fxCalm ? 1 : Math.min(1, (now - aim.since) / 220));
    // A thick beam, a little wider towards the end, under a broad, short head; a brighter core runs
    // the whole length and into the head.
    var headL = Math.min(L * 0.5, 66 * sc), headW = 104 * sc, bodyL = L - headL * 0.85;
    var ribbon = function (w0, w1, inset) {
      var M = 36, left = [], right = [];
      j = 0;
      for (var m = 0; m <= M; m++) {
        var k = m / M, p = at(k * bodyL), w = (w0 + (w1 - w0) * k) * sc / 2;
        left.push((p.x - p.ty * w).toFixed(1) + "," + (p.y + p.tx * w).toFixed(1));
        right.unshift((p.x + p.ty * w).toFixed(1) + "," + (p.y - p.tx * w).toFixed(1));
      }
      j = 0;
      var base = at(L - headL), tip = at(L - inset * sc), hw = (headW - inset * 2.6 * sc) / 2; var ax = tip.x - base.x, ay = tip.y - base.y, al = Math.hypot(ax, ay) || 1; base.tx = ax / al; base.ty = ay / al;
      var head = [(base.x - base.ty * hw).toFixed(1) + "," + (base.y + base.tx * hw).toFixed(1), tip.x.toFixed(1) + "," + tip.y.toFixed(1),
        (base.x + base.ty * hw).toFixed(1) + "," + (base.y - base.tx * hw).toFixed(1)].join(" ");
      return '<polygon points="' + left.concat(right).join(" ") + '"/><polygon points="' + head + '"/>';
    };
    aim.svg.innerHTML = '<g class="hw-arrow-body">' + ribbon(30, 42, 0) + "</g>" + '<g class="hw-arrow-core">' + ribbon(10, 16, 18) + "</g>";
  }

  function showPicker(title, cards, done) {
    var b = document.getElementById("board");
    b.insertAdjacentHTML("beforeend", '<div class="hw-modal" id="picker"><div class="hw-sheet">' + plate(esc(title)) + '<div class="hw-choice">' +
      cards.map(function (c) { return cardEl(c.id, "", 'data-choice="' + c.uid + '"'); }).join("") + "</div></div></div>");
    each("#picker [data-choice]", function (el) {
      el.onclick = function () { document.getElementById("picker").remove(); done(+el.getAttribute("data-choice")); };
    });
  }

  document.addEventListener("click", function (e) {
    if (suppressClick) return;  // the release that ends a drag isn't a click away
    var inPanel = e.target.closest && e.target.closest("#menu-panel");
    if (ui.menu || (ui.menuOpen && !inPanel)) { closeMenu(); ui.menuOpen = false; render(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeInspect(); closeMenu(); if (ui.targeting) { ui.targeting = null; render(); } } });

  /* ---------- card preview: hover with a mouse, press and hold on touch ---------- */

  var lastPointer = "mouse", holdTimer = 0, suppressClick = false;

  function showPreview(el) {
    var id = el.getAttribute("data-img"), d = CARD[id], wide = d.type === "Region" || d.type === "Event";
    var ph, pw;
    if (wide) { pw = Math.min(560, innerWidth * 0.6); ph = pw * 5 / 7; } else { ph = Math.min(560, innerHeight * 0.8); pw = ph * 5 / 7; }
    $preview.className = "hw-preview";
    $preview.style.width = pw + "px"; $preview.style.height = ph + "px";
    $preview.style.backgroundImage = "url(" + cardImg(id) + ")";
    $preview.hidden = false;
    var r = el.getBoundingClientRect();
    var x = r.right + 14; if (x + pw > innerWidth - 8) x = r.left - pw - 14;
    if (x < 8) x = (innerWidth - pw) / 2;
    var y = Math.max(8, Math.min(innerHeight - ph - 8, r.top + r.height / 2 - ph / 2));
    if (el.closest(".hw-hand")) { x = Math.max(8, Math.min(r.left - pw - 20, innerWidth * 0.06)); y = Math.max(8, innerHeight - ph - innerHeight * 0.06); if (r.left < pw + 30) x = innerWidth - pw - 12; }
    $preview.style.left = x + "px"; $preview.style.top = y + "px";
    // Beside the card, as Hearthstone does: whose Herald it is, and what its keywords mean.
    var words = keywordsOf(d), heroEl = el.closest(".hw-hero, .hw-tab-rival"), who = heroEl ? heroEl.getAttribute("data-who") : "";
    if (!words.length && !who) { $preview.innerHTML = ""; return; }
    var right = x + pw + 320 < innerWidth - 8;
    // On a Herald, its Total Power line by line: each Unit, then each bonus.
    var pw2 = heroEl && heroEl.getAttribute("data-power"), sum = heroEl && heroEl.getAttribute("data-total");
    var power = heroEl && sum !== null ? '<div class="hw-power-sum"><b>Total Power ' + esc(sum) + "</b>" +
      (pw2 ? '<ul>' + pw2.split("|").map(function (r) { var k = r.split("\t"); return "<li><span>" + esc(k[0]) + "</span><i>" + (+k[1] > 0 ? "+" : "") + esc(k[1]) + "</i></li>"; }).join("") + "</ul>"
        : "<p>Nothing on the table yet.</p>") + "</div>" : "";
    $preview.innerHTML = '<div class="hw-preview-side' + (right ? "" : " hw-left") + '">' + (who ? '<p class="hw-preview-who">' + esc(who) + "</p>" : "") + power +
      words.map(function (k) { return "<p><b>" + esc(k.term) + "</b> " + k.text + "</p>"; }).join("") + "</div>";
  }
  // The keywords a card uses (its stages too), each once.
  function keywordsOf(d) {
    var text = [d.text || "", d.actText || ""].concat((d.stages || []).map(function (s) { return s.text || ""; })).join(" ");
    // Game terms are written in lower case on the cards ("the leading opponent", "struck").
    var loose = { "Leading opponent": 1, "Struck": 1, "Power on the table": 1, "Exiled": 1, "Tomb": 1 };
    return HW.rules.keywords.filter(function (k) { return new RegExp("\\b" + k.term + "\\b", loose[k.term] ? "i" : "").test(text) || (k.term === "Evolving" && !!d.stages); });
  }

  /* ---------- inspecting a card ----------
     As in Arena and Hearthstone: press and hold a card on a phone to see it large over the dimmed
     table, with its rules set beside it in readable type; let go and it closes. With a mouse,
     right-click opens it and any click closes it. */
  function bigImg(id) {
    var wide = CARD[id].type === "Region" || CARD[id].type === "Event";
    return ASSETS ? asset("herald-" + (wide ? "atlas-lg-" : "card-lg-") + id + ".webp") : "img/" + (wide ? "atlas-lg" : "cards-lg") + "/" + id + ".webp";
  }
  // Card text as printed: bold before a colon, the Homecoming realm and Fast reminder in italics.
  function richText(t) {
    return esc(t || "").split("\r").map(function (line) {
      return line.replace(/^([^:]{1,40}):/, "<b>$1:</b>").replace(/\((Fast:[^)]*)\)/, "<i>($1)</i>").replace(/Homecoming \((\w+)\)/, "Homecoming (<i>$1</i>)");
    }).join("<br>");
  }
  function inspect(el) {
    var id = el.getAttribute("data-img"), d = CARD[id];
    if (!d) return;
    var wide = d.type === "Region" || d.type === "Event";
    var title = d.type === "Herald" ? d.name + ", " + d.title : d.location ? d.name + " / " + d.location : d.name;
    var stats = [];
    if (d.type === "Herald") stats.push("Life " + d.life);
    else if (d.cost != null) stats.push(actionsWord(d.cost) + (d.type === "Unit" ? ", " + Math.max(1, d.cost) + " Space" : d.type === "Evolving Unit" ? ", 1 Space as an Egg" : ""));
    if (d.damage != null) stats.push("Power " + d.damage);
    // A Unit on a field also shows what it counts for right now.
    var unit = el.closest(".hw-unit"), now = "";
    if (unit) {
      var orbEl = unit.querySelector(".hw-pow"), stageEl = unit.querySelector(".hw-stage");
      now = '<p class="hw-in-now">On the table now: <b>' + (orbEl ? orbEl.textContent : "?") + " Power</b>" + (stageEl ? ", " + esc(stageEl.textContent) : "") + "</p>";
    }
    var body = d.stages ? (d.actText ? "<p>" + richText(d.actText) + "</p>" : "") + "<ol class=\"hw-in-stages\">" + d.stages.map(function (st, i) {
      return "<li><b>" + ["I", "II", "III", "IV"][i] + ". " + esc(st.name) + " · " + st.bonus + " Power:</b> " + esc(st.text) + "</li>"; }).join("") + "</ol>"
      : "<p>" + richText(d.text) + "</p>";
    var text = (d.text || "") + (d.actText || "") + (d.stages ? " Evolving" : "");
    var words = HW.rules.keywords.filter(function (k) { return text.indexOf(k.term.replace(/ \(N\+?\)/, "")) > -1; });
    var box = document.getElementById("inspect");
    if (!box) { box = document.createElement("div"); box.id = "inspect"; document.body.appendChild(box); }
    box.className = "hw-inspect" + (wide ? " hw-inspect-wide" : "");
    box.innerHTML = '<img class="hw-in-card" src="' + bigImg(id) + '" alt="' + esc(title) + '">' +
      '<div class="hw-in-text"><h2>' + esc(title) + '</h2><p class="hw-in-type">' + esc((d.rarity ? d.rarity + " " : "") + d.type + (d.tag ? " · " + d.tag : "")) +
      (stats.length ? " · " + stats.join(" · ") : "") + "</p>" + now + '<div class="hw-in-rules">' + body + "</div>" +
      (words.length ? '<dl class="hw-in-words">' + words.map(function (k) { return "<dt>" + esc(k.term) + "</dt><dd>" + k.text + "</dd>"; }).join("") + "</dl>" : "") +
      (lastPointer === "mouse" ? '<p class="hw-in-close">Click anywhere to close</p>' : "") + "</div>";
    box.hidden = false;
    $preview.hidden = true;
    heldOpen = lastPointer !== "mouse";
  }
  var heldOpen = false, swallowUntil = 0;
  function inspecting() { var box = document.getElementById("inspect"); return !!box && !box.hidden; }
  function closeInspect() {
    var box = document.getElementById("inspect");
    if (box) box.hidden = true;
    heldOpen = false;
    swallowUntil = Date.now() + 400;  // the click that follows the release or close does nothing
  }
  document.addEventListener("click", function (e) {
    if (Date.now() < swallowUntil) { e.stopPropagation(); e.preventDefault(); return; }
    if (!inspecting()) return;
    e.stopPropagation(); e.preventDefault(); closeInspect();
  }, true);

  var holdFrom = null;
  document.addEventListener("pointerdown", function (e) {
    lastPointer = e.pointerType;
    if (e.pointerType === "mouse" || inspecting()) return;
    var el = e.target.closest && e.target.closest("[data-img]");
    if (!el) return;
    clearTimeout(holdTimer);
    holdFrom = { x: e.clientX, y: e.clientY };
    holdTimer = setTimeout(function () { suppressClick = true; closeMenu(); inspect(el); }, 350);
  });
  function endHold() {
    clearTimeout(holdTimer); holdFrom = null;
    if (heldOpen) closeInspect();  // letting go of a held card puts it back
    if (lastPointer !== "mouse") setTimeout(function () { suppressClick = false; }, 60);
  }
  document.addEventListener("pointerup", endHold);
  document.addEventListener("pointercancel", function () { if (!heldOpen) endHold(); });
  // Moving the finger away before the card opens means a drag, not a hold.
  document.addEventListener("pointermove", function (e) {
    if (holdFrom && Math.abs(e.clientX - holdFrom.x) + Math.abs(e.clientY - holdFrom.y) > 12) { clearTimeout(holdTimer); holdFrom = null; }
  });
  document.addEventListener("contextmenu", function (e) {
    var el = e.target.closest && e.target.closest("[data-img]");
    if (!el) return;
    e.preventDefault();
    if (lastPointer === "mouse") { closeMenu(); inspect(el); }
  });
  // The hand card under the pointer, raised by class so a redraw keeps it up instead of replaying the rise.
  var handUp = null;
  function raiseHand(slot) {
    var c = slot && slot.querySelector("[data-hand]"), uid = c ? +c.getAttribute("data-hand") : null;
    if (uid === handUp) return;
    handUp = uid;
    if (uid !== null) SND.play("hover");
    each(".hw-hand-slot", function (s) { s.classList.toggle("hw-up", s === slot); });
  }
  document.addEventListener("mouseleave", function () { raiseHand(null); });
  // The large card waits a moment before it fades in, so sweeping across the table doesn't flash it;
  // once it's up, moving to the next card swaps it straight away, and a gap between cards doesn't blink it off.
  var previewEl = null, previewTimer = 0, mouseAt = null;
  function previewOn(el, fade) {
    // The table may have been redrawn while it waited: take the card that's under the pointer now.
    if (!el.isConnected) { var at = mouseAt && document.elementFromPoint(mouseAt.x, mouseAt.y); el = at && at.closest("[data-img]"); }
    if (!el) return;
    previewEl = el; showPreview(el);
    if (fade && !fxCalm) $preview.animate([{ opacity: 0, transform: "translateY(10px)" }, { opacity: 1, transform: "none" }], { duration: 180, easing: "ease-out" });
  }
  document.addEventListener("mouseover", function (e) {
    if (lastPointer !== "mouse") return;
    mouseAt = { x: e.clientX, y: e.clientY };
    raiseHand(e.target.closest && e.target.closest(".hw-hand-slot"));
    var el = e.target.closest && e.target.closest("[data-img]");
    clearTimeout(previewTimer);
    // While aiming, the large card would cover the arrow and the targets.
    if (ui.targeting || document.querySelector(".hw-play.hw-targeting")) { $preview.hidden = true; return; }
    if (!el) { previewTimer = setTimeout(function () { $preview.hidden = true; }, 90); return; }
    if (el === previewEl && !$preview.hidden) return;
    if ($preview.hidden) previewTimer = setTimeout(function () { previewOn(el, true); }, 120);
    else previewOn(el, false);
  });

  /* ---------- dragging a card onto the table ----------
     As in Hearthstone and Arena: pick a card up from your hand and drop it on the table to play it.
     A card with one way to play is played at once; with two (pay for its effect or not) a small
     menu asks where it was dropped. Dropping it back on the hand puts it back. A tap still opens
     the menu, and holding still opens the large view. */
  var drag = null;
  function boardScale() { var b = document.getElementById("board"); return b ? b.getBoundingClientRect().width / b.offsetWidth : 1; }
  function dropLine() { var h = document.querySelector(".hw-hand-slot"); return h ? h.getBoundingClientRect().top - 24 : innerHeight * 0.7; }
  document.addEventListener("pointerdown", function (e) {
    var el = e.target.closest && e.target.closest(".hw-hand [data-hand]");
    if (!el || e.button > 0 || ui.targeting) return;
    drag = { el: el, uid: +el.getAttribute("data-hand"), x: e.clientX, y: e.clientY, id: e.pointerId, ghost: null };
  });
  document.addEventListener("pointermove", function (e) {
    if (!drag || e.pointerId !== drag.id || inspecting()) return;
    if (!drag.ghost) {
      if (Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) < 12) return;
      clearTimeout(holdTimer); closeMenu(); $preview.hidden = true;
      var g = drag.el.cloneNode(true), sc = boardScale();
      g.className = "hw-card hw-ghost" + (drag.el.classList.contains("hw-sideways") ? " hw-sideways" : "");
      g.removeAttribute("data-hand"); g.removeAttribute("data-img");
      var w0 = drag.el.offsetWidth * sc;
      g.style.width = w0 + "px";
      // Start under the pointer, so the first frame doesn't flash in from the corner.
      g.style.transform = "translate(" + (e.clientX - w0 / 2) + "px," + (e.clientY - w0 * 0.7) + "px)";
      document.body.appendChild(g);
      drag.ghost = g;
      drag.el.classList.add("hw-lifted");
      SND.play("pick");
    }
    var gw = drag.ghost.offsetWidth, gh = drag.ghost.offsetHeight, over = e.clientY < dropLine();
    drag.ghost.style.transform = "translate(" + (e.clientX - gw / 2) + "px," + (e.clientY - gh / 2) + "px) scale(" + (over ? 1.08 : 1) + ")";
    drag.ghost.classList.toggle("hw-ghost-over", over);
    e.preventDefault();
  }, { passive: false });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag; drag = null;
    if (!d.ghost) return;
    d.ghost.remove();
    if (d.el) d.el.classList.remove("hw-lifted");
    suppressClick = true; setTimeout(function () { suppressClick = false; }, 80);
    if (e && e.type === "pointerup" && e.clientY < dropLine()) dropToPlay(d.uid, e.clientX, e.clientY);
  }
  document.addEventListener("pointerup", endDrag);
  document.addEventListener("pointercancel", endDrag);
  function dropToPlay(uid, x, y) {
    var v = view(), me = v && playerIn(v, ME);
    if (!me || v.phase !== "play") return;
    if (noPlay(v)) { toast("Finish the choice in front of you first."); return; }
    var c = me.hand.filter(function (h) { return h.uid === uid; })[0];
    if (!c) return;
    var spot = document.elementFromPoint(x, y), toVault = !!(spot && spot.closest && spot.closest(".hw-vault-mine"));
    var opts = handOptions(v, me, c).filter(function (o) { return !!o.vault === toVault; }), ok = opts.filter(function (o) { return !o.off; });
    if (!ok.length) { toast(opts.length ? opts[0].off : v.turn === ME ? "Nothing to do with this card right now." : "It isn't your turn."); return; }
    if (ok.length === 1) { beginTargeting(v, me, CARD[c.id], ok[0]); return; }
    var at = { getBoundingClientRect: function () { return { left: x, right: x, top: y, bottom: y, width: 0, height: 0 }; } };
    showMenu(CARD[c.id].name, opts, at, function (o) { beginTargeting(v, me, CARD[c.id], o); });
  }

  /* ---------- render ---------- */

  // The music follows the screen: the main theme on the menus, the table's tracks in play, The
  // Challenge once a Herald is down to 4 life, and the ending at the end.
  function scoreFor(v) {
    if (!v || v.phase === "lobby") return "home";
    if (v.phase === "over") return "over";
    return v.players.some(function (p) { return p.life > 0 && p.life <= 4; }) ? "tense" : "table";
  }
  function render() {
    if (ranked && ranked.screen !== "table") { SND.music("home"); renderRanked(); return; }
    if (!room && !local && !ranked) { SND.music("home"); renderHome(); return; }
    var v = view();
    SND.music(scoreFor(v));
    if (!v) { $app.innerHTML = stage(myScene(), logo("hw-logo-home") + '<p class="hw-lobby-wait hw-finding">Finding the table…</p>', "hw-home"); fit(); return; }
    if (v.phase === "lobby") { renderLobby(v); return; }
    // Hold the last Clash on the table for a moment so everyone sees who won.
    if (v.lastClashRound && v.lastClashRound !== ui.shownRound) {
      ui.shownRound = v.lastClashRound;
      ui.reveal = { round: v.lastClashRound };
      setTimeout(function () { ui.reveal = null; render(); }, 3200);
    }
    renderTable(v);
  }

  /* ---------- Ranked ----------
     The screens around a Ranked game. The game itself is the ordinary table, drawn from what the
     herald-ranked function sends: in Ranked, `ranked.view` stands in for the state, moves go to the server
     (act -> rankedMove), and the table refreshes when the server says something changed, or every few
     seconds if that message doesn't arrive. ME is the account id here, because the server seats accounts. */
  var RANKED_URL = "https://ivtdsbuzdjjzgvbjexfx.supabase.co/functions/v1/herald-ranked";
  var ranked = null, rankMe = null, rankAsked = false, guestMe = ME;
  function rankedCloud() { var C = window.DKCloud; return C && C.signedIn() ? C : null; }
  function rankedCall(action, body) {
    var C = rankedCloud();
    if (!C) return Promise.reject(new Error("Sign in to play Ranked."));
    return Promise.resolve(C.fresh ? C.fresh() : C.session()).then(function (s) {
      return fetch(RANKED_URL, { method: "POST", headers: { authorization: "Bearer " + s.access_token, "content-type": "application/json" },
        body: JSON.stringify(Object.assign({ action: action }, body || {})) });
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.error || "Ranked isn't available right now."); return d; });
    });
  }
  function refreshRank() {
    if (!rankedCloud()) return Promise.resolve(null);
    return rankedCall("me").then(function (d) { rankMe = d; if (!room && !local) render(); return d; }, function () { return null; });
  }
  function rankBadge(key, cls) {
    return '<img class="hw-badge ' + (cls || "") + '" src="' + img("rank", "badge-" + key) + '" alt="' + esc(key) + '">';
  }
  function rankBar(p) { return p.next ? Math.round(100 * p.into / p.span) : 100; }
  function rankLine(rank, p) {
    return p.placement ? p.placement + (p.placement === 1 ? " placement game left" : " placement games left") : rank.points + " points" + (p.next ? ", " + (p.next.at - rank.points) + " to " + p.next.name : "");
  }
  function rankChip() {
    if (!rankMe) return "";
    var p = HWRank.progress(rankMe.rank);
    return '<button class="hw-rank-chip" id="rank-chip">' + rankBadge(p.tier.key) + "<span><b>" + p.label + "</b><i>" + esc(rankLine(rankMe.rank, p)) + '</i><u><s style="width:' + rankBar(p) + '%"></s></u></span>' +
      (rankMe.match ? "<em>Return to Your Match</em>" : "") + "</button>";
  }
  function rankCard(rank) {
    var p = HWRank.progress(rank);
    return '<div class="hw-rank-card" style="background-image:url(' + img("rank", "border-" + p.tier.key) + ')">' + rankBadge(p.tier.key) +
      "<div><h2>" + p.label + "</h2><p>" + esc(rankLine(rank, p)) + '</p><u><s style="width:' + rankBar(p) + '%"></s></u>' +
      "<p>" + rank.wins + " won, " + rank.losses + " lost" + (rank.streak >= 2 ? ", " + rank.streak + " in a row" : "") + "</p></div></div>";
  }
  function openRanked() {
    var C = rankedCloud();
    ranked = { screen: C ? "home" : "signin", view: null, match: null };
    if (C) { ME = C.userId(); rankedCall("me").then(function (d) { rankMe = d; if (d.match) enterMatch(d.match); else if (ranked) render(); }, function (e) { if (ranked) { ranked.error = e.message; render(); } }); }
    render();
  }
  function leaveRanked() {
    clearInterval(rankedTimers.poll); clearInterval(rankedTimers.clock);
    if (rankedNet) { rankedNet.close(); rankedNet = null; }
    ranked = null; ME = guestMe; rankAsked = false;
    history.replaceState(null, "", location.pathname);
    render();
  }
  function renderRanked() {
    var k = deckKey(), r = ranked, body;
    if (r.screen === "versus") { renderVersus(); return; }
    if (r.screen === "signin") {
      body = '<h2 class="hw-rk-title">Ranked</h2><p class="hw-col-note">Ranked is played on your Sanctum account, so your rank stays with you.</p>' +
        '<div class="hw-col-row"><a class="hw-plate-btn hw-primary" href="/pages/inner-sanctum">Sign In</a><button class="hw-plate-btn" id="rk-back">Main Menu</button></div>';
    } else if (r.screen === "queue") {
      var rank = rankMe ? rankMe.rank : HWRank.blank();
      body = '<div class="hw-rk-search">' + rankBadge(HWRank.tierOf(rank).key) + '</div><h2 class="hw-rk-title">Finding a Match</h2><p class="hw-rk-time" id="rk-time">0:00</p>' +
        '<div class="hw-col-row"><button class="hw-plate-btn" id="rk-cancel">Cancel</button></div>';
    } else {
      var s = rankMe && rankMe.season;
      body = '<h2 class="hw-rk-title">Ranked' + (s ? "<i>" + esc(s.name) + "</i>" : "") + "</h2>" + rankCard(rankMe ? rankMe.rank : HWRank.blank()) +
        heraldRow(k, !!myList()) + (r.error ? '<p class="hw-col-note">' + esc(r.error) + "</p>" : "") +
        '<div class="hw-col-row"><button class="hw-plate-btn" id="my-decks">' + (myList() ? esc(myList().name) : "Your Decks") + '</button><button class="hw-plate-btn" id="rk-ladder">Ladder</button></div>' +
        '<div class="hw-col-row"><button class="hw-plate-btn" id="rk-back">Main Menu</button><button class="hw-plate-btn hw-primary" id="rk-find">Find Match</button></div>';
    }
    $app.innerHTML = stage(heroScene(k), heroPanel(k, "hw-hero-lobby") + '<div class="hw-col hw-col-ranked">' + logo("hw-logo-small") + body + "</div>" + (r.ladder ? ladderModal(r.ladder) : ""), "hw-lobby");
    fit();
    each("[data-deck]", function (b) { b.onclick = function () { myDeck = b.getAttribute("data-deck"); store("hw.deck", myDeck); render(); }; });
    on("my-decks", function (e) { e.stopPropagation(); decksMenu(e.currentTarget, render); });
    on("rk-back", leaveRanked);
    on("rk-find", findMatch);
    on("rk-cancel", function () { clearInterval(rankedTimers.poll); clearInterval(rankedTimers.clock); ranked.screen = "home"; rankedCall("cancel"); render(); });
    on("rk-ladder", function () { rankedCall("ladder", { limit: 20 }).then(function (d) { ranked.ladder = d.ladder; render(); }, function (e) { toast(e.message); }); });
    on("rk-ladder-close", function () { ranked.ladder = null; render(); });
    wireCommon();
  }
  function ladderModal(rows) {
    return '<div class="hw-modal" id="rk-ladder-box"><div class="hw-sheet hw-ladder"><h2 class="hw-rk-title">Ladder</h2>' +
      (rows.length ? "<ol>" + rows.map(function (x) {
        return "<li><b>" + x.place + "</b>" + rankBadge(x.tier) + "<span>" + esc(x.name) + "</span><i>" + HWRank.labelAt(x.points) + ", " + x.points + "</i></li>"; }).join("") + "</ol>"
        : '<p class="hw-col-note">No one has finished their placement games this Season yet.</p>') +
      '<button class="hw-plate-btn" id="rk-ladder-close">Close</button></div></div>';
  }
  var rankedTimers = {}, rankedNet = null;
  function findMatch() {
    ranked.error = null;
    rankedCall("queue", deckChoice({})).then(function (d) {
      if (d.match) return enterMatch(d.match);
      ranked.screen = "queue"; ranked.since = Date.now();
      render();
      clearInterval(rankedTimers.poll); clearInterval(rankedTimers.clock);
      rankedTimers.clock = setInterval(function () {
        var el = document.getElementById("rk-time"), t = Math.floor((Date.now() - ranked.since) / 1000);
        if (el) el.textContent = Math.floor(t / 60) + ":" + ("0" + t % 60).slice(-2);
      }, 500);
      rankedTimers.poll = setInterval(function () {
        rankedCall("poll").then(function (x) { if (x.match) enterMatch(x.match); }, function () {});
      }, 2500);
    }, function (e) { ranked.error = e.message; render(); });
  }
  function rankedApply(d) {
    var was = ranked.version;
    ranked.view = d.view; ranked.version = d.version; ranked.status = d.status; ranked.deadline = d.deadline; ranked.result = d.result;
    return was !== d.version;
  }
  function enterMatch(id) {
    clearInterval(rankedTimers.poll); clearInterval(rankedTimers.clock);
    if (!ranked) return;
    ranked.match = id;
    ui = { picked: null, menu: null, targeting: null, reveal: null, shownRound: 0, playLog: false, rules: false, tips: {} };
    fxLast = null;
    rankedCall("state", { match: id }).then(function (d) {
      if (!ranked) return;
      rankedApply(d);
      var fresh = d.view.phase === "mulligan";
      ranked.screen = fresh ? "versus" : "table";
      render();
      setTimeout(function () { if (ranked && ranked.screen === "versus") { ranked.screen = "table"; render(); } }, 3400);
      if (window.HWNet) { try { rankedNet = HWNet.connect("ranked-" + id, ME, { onMessage: rankedSync }); } catch (e) { rankedNet = null; } }
      rankedTimers.poll = setInterval(rankedSync, 2500);
      rankedTimers.clock = setInterval(rankedClock, 500);
    }, function (e) { toast(e.message); });
  }
  function rankedSync() {
    if (!ranked || !ranked.match || ranked.busy || ranked.status === "done") return;
    ranked.busy = true;
    rankedCall("state", { match: ranked.match }).then(function (d) {
      if (!ranked) return;
      ranked.busy = false;
      if (rankedApply(d) && ranked.screen === "table") render();
      if (d.status === "done") { clearInterval(rankedTimers.poll); clearInterval(rankedTimers.clock); }
    }, function () { if (ranked) ranked.busy = false; });
  }
  function rankedMove(intent) {
    rankedCall("move", { match: ranked.match, intent: intent }).then(function (d) { if (ranked) { rankedApply(d); render(); } }, function (e) { toast(e.message); });
  }
  function rankedClock() {
    if (!ranked || !ranked.deadline) return;
    var left = Math.max(0, Math.ceil((Date.parse(ranked.deadline) - Date.now()) / 1000));
    each(".hw-clock", function (el) { el.textContent = Math.floor(left / 60) + ":" + ("0" + left % 60).slice(-2); el.classList.toggle("hw-clock-low", left <= 15); });
  }
  function wireRankedTable(v) {
    rankedClock();
    on("menu-concede", function (e) {
      e.stopPropagation();
      if (!ui.sureConcede) { ui.sureConcede = true; render(); return; }
      ui.sureConcede = false; ui.menuOpen = false;
      rankedCall("concede", { match: ranked.match }).then(function (d) { if (ranked) { rankedApply(d); render(); } }, function (e2) { toast(e2.message); });
    });
    on("rk-again", function () { var r = ranked; r.screen = "home"; r.view = null; r.match = null; r.result = null; r.status = null; if (rankedNet) { rankedNet.close(); rankedNet = null; } rankedCall("me").then(function (d) { rankMe = d; if (ranked) render(); }, function () {}); render(); });
    on("rk-home", leaveRanked);
    if (v.phase === "over" && ui.rankShown !== ranked.match) { ui.rankShown = ranked.match; playRankResult(); }
  }
  // Both Heralds slide in from their own side, with each player's name and rank.
  function renderVersus() {
    var v = ranked.view, me = playerIn(v, ME), foe = v.players.filter(function (p) { return p.id !== ME; })[0];
    var side = function (p, cls) {
      var rk = v.ranks && v.ranks[p.id];
      return '<div class="hw-vs-side ' + cls + '"' + seatStyle(v, p) + '><img class="hw-vs-art" src="' + img("hero", p.herald) + '" alt=""><div class="hw-vs-plate">' + (rk ? rankBadge(rk.tier) : "") + "<b>" + esc(p.name) + "</b><i>" + esc(CARD[p.herald].name) + "</i></div></div>";
    };
    $app.innerHTML = stage(img("scene", v.atlas.current), '<div class="hw-vs">' + side(me, "hw-vs-me") + side(foe, "hw-vs-foe") + '<p class="hw-vs-word">Versus</p></div>', "hw-play");
    fit();
  }
  /* The result: the rank bar fills, and a new tier arrives with its badge. */
  function rankResult(v) {
    var r = ranked.result && ranked.result[ME], won = v.winner === ME, none = !v.winner;
    var how = { concede: won ? "Your rival conceded." : "You conceded.", forfeit: won ? "Your rival ran out of time." : "You ran out of time.", renown: "Dominion: " + E.RENOWN + " Clashes won.", lastlight: "Survival: the decks ran out." }[v.winBy] || "Victory: the last Herald standing.";
    var after = r ? r.after : HWRank.blank(), before = r ? r.before : after, pa = HWRank.progress(after), pb = HWRank.progress(before);
    var delta = after.points - before.points;
    return '<div class="hw-modal hw-rank-result"><div class="hw-sheet hw-rr' + (won ? " hw-rr-win" : "") + '">' +
      '<h2 class="hw-rr-title">' + (none ? "Draw" : won ? "Victory" : "Defeat") + '</h2><p class="hw-over-how">' + esc(how) + "</p>" +
      '<div class="hw-rr-badge" id="rr-badge">' + rankBadge(pb.tier.key) + "</div>" +
      '<p class="hw-rr-tier" id="rr-tier">' + pb.label + "</p>" +
      '<div class="hw-rr-bar"><u><s id="rr-bar" style="width:' + rankBar(pb) + '%"></s></u><b id="rr-points">' + before.points + "</b></div>" +
      '<p class="hw-rr-delta">' + (delta > 0 ? "+" + delta : delta) + " points</p>" +
      '<div class="hw-row"><button class="hw-plate-btn" id="rk-home">Main Menu</button><button class="hw-plate-btn hw-primary" id="rk-again">Back to Ranked</button></div></div></div>';
  }
  function playRankResult() {
    var r = ranked.result && ranked.result[ME];
    if (!r) return;
    var pa = HWRank.progress(r.after), pb = HWRank.progress(r.before), moved = pa.label !== pb.label, up = moved && r.after.points > r.before.points;
    var bar = document.getElementById("rr-bar"), num = document.getElementById("rr-points"), t0 = performance.now() + 500;
    var from = r.before.points, to = r.after.points;
    if (fxCalm) { if (num) num.textContent = to; }
    else (function tick(now) {
      var k = Math.max(0, Math.min(1, (now - t0) / 900));
      var n = document.getElementById("rr-points");
      if (n) n.textContent = Math.round(from + (to - from) * k);
      if (k < 1 && n) requestAnimationFrame(tick);
    })(performance.now());
    setTimeout(function () { var b = document.getElementById("rr-bar"); if (b) b.style.width = (moved ? (up ? 100 : 0) : rankBar(pa)) + "%"; }, 500);
    if (!moved) return;
    if (FORGE[pa.tier.key] === pb.tier.key && !fxCalm) {
      setTimeout(function () {
        rankForge(pa.tier.key, function () {  // the result underneath has already moved on when the forge lifts
          var box = document.getElementById("rr-badge"), tier = document.getElementById("rr-tier"), b = document.getElementById("rr-bar");
          if (box) box.innerHTML = rankBadge(pa.tier.key);
          if (tier) { tier.textContent = pa.label; tier.classList.add("hw-rr-new"); }
          if (b) { b.style.transition = "none"; b.style.width = rankBar(pa) + "%"; }
        });
      }, 1500);
      return;
    }
    setTimeout(function () {
      var box = document.getElementById("rr-badge"), tier = document.getElementById("rr-tier"), b = document.getElementById("rr-bar");
      if (!box) return;
      box.innerHTML = rankBadge(pa.tier.key);
      tier.textContent = pa.label;
      if (up) { box.classList.add("hw-rr-up"); tier.classList.add("hw-rr-new"); }
      if (b) { b.style.transition = "none"; b.style.width = "0"; b.offsetWidth; b.style.transition = ""; b.style.width = rankBar(pa) + "%"; }
    }, 1600);
  }

  /* The rank-up evolution (forge.js): each tier and the tier it evolves from. FORGE_ART is each tier's PSD
     layers, as in play/img/ranks/anim-<tier>-<part>.webp, bottom layer first. ?rankup=bronze on the game page
     plays one on its own. Its sound is play/audio/rankup-<tier>.wav, mixed from the CC0 sounds in
     play/audio/CREDITS.md. */
  var FORGE = { bronze: "unranked", silver: "bronze", gold: "silver", platinum: "gold", diamond: "platinum" };
  var FORGE_PARTS = { base: ["base"], frame: ["frame"], crown: ["crown"], top: ["top"] };
  var FORGE_ART = {
    unranked: { base: [6, 5, 4, 0], frame: [], crown: [3, 2, 1] },
    bronze: { base: [8], frame: [7, 6, 5], shade: 4, crown: [3, 2, 0, 1] },
    silver: FORGE_PARTS, gold: FORGE_PARTS, platinum: FORGE_PARTS, diamond: FORGE_PARTS
  };
  function forgeSpec(key) {
    var was = FORGE[key], o = FORGE_ART[was], n = FORGE_ART[key];
    var a = function (t, list) { return (list || []).map(function (p) { return img("rank", "anim-" + t + "-" + p); }); };
    return { look: key, oldOuter: a(was, o.base).concat(a(was, o.frame)), oldCore: a(was, o.crown), oldTop: a(was, o.top), oldShade: o.shade ? a(was, [o.shade])[0] : null,
      base: a(key, n.base), frame: a(key, n.frame), shade: n.shade ? a(key, [n.shade])[0] : null, crown: a(key, n.crown), top: a(key, n.top),
      audio: ASSETS ? asset("herald-audio-rankup-" + key + ".mp3") : "audio/rankup-" + key + ".mp3?" + Date.now(), name: HWRank.TIERS.filter(function (t) { return t.key === key; })[0].name };
  }
  function rankForge(key, done) {
    var box = document.createElement("div");
    box.className = "hw-forge";
    fxRoot().appendChild(box);
    HWForge.play({ host: box, spec: forgeSpec(key), done: function () {
      box.classList.add("hw-forge-out");
      if (done) done();
      setTimeout(function () { box.remove(); }, 500);
    } });
  }

  /* ---------- boot ---------- */

  // Saved decks (from the compendium's builder) that this player can take to the table.
  if (window.HWDecks) {
    HWDecks.connect().then(function () { return Promise.all([HWDecks.owned(), HWDecks.load()]); }).then(function (r) {
      myLists = r[1].filter(function (d) { return !d.deleted && !HWDecks.problem(r[0], d); });
      if (state && state.phase === "lobby") render();
    }, function () {});
  }
  if (matchMedia("(pointer: coarse)").matches) $app.classList.add("hw-touch");
  placeEmbedded();
  var rankupPreview = new URLSearchParams(location.search).get("rankup");
  if (rankupPreview && FORGE[rankupPreview]) {  // browsers only play sound after a click
    renderHome();
    var startPreview = function () { rankForge(rankupPreview, function () { addEventListener("click", startPreview, { once: true }); }); };
    toast("Click anywhere to play the rank-up.");
    addEventListener("click", startPreview, { once: true });
    return;
  }
  if (local) { startLocal(MODE); return; }
  if (room) {
    if (isHost) {
      try { state = JSON.parse(store("hw.state." + room)); } catch (e) { state = null; }
      if (!state) isHost = false;
    }
    connect();
    if (isHost) botTick();
  }
  render();
})();
